
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree9d4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree9d4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dZO8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $cce6c7f7d6f3e2a9$export$2e2bcd8739ae039);
parcelRequire("3cJ3M");
var $31QV8 = parcelRequire("31QV8");
var $36gU0 = parcelRequire("36gU0");

var $4TkSB = parcelRequire("4TkSB");
parcelRequire("1EsSH");

var $97VdX = parcelRequire("97VdX");
const $cce6c7f7d6f3e2a9$var$createCustomApp = (options)=>{
    const app = (0, $31QV8.createApp)(options);
    // install pinia
    const pinia = (0, $97VdX.createPinia)();
    app.use(pinia);
    // $api はリアクティブにする必要がないため markRaw で包む
    // (包まない場合 pinia が PINIA_R1006 の診断を出力する)
    pinia.use(()=>({
            $api: (0, $36gU0.markRaw)((0, $4TkSB.createApi)())
        }));
    return app;
};
var $cce6c7f7d6f3e2a9$export$2e2bcd8739ae039 = $cce6c7f7d6f3e2a9$var$createCustomApp;

});
parcelRegister("3cJ3M", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("jDVdF")).computed);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("jDVdF")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("jDVdF")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("jDVdF")).createElementVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("jDVdF")).createTextVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("jDVdF")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("jDVdF")).Fragment);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("jDVdF")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("jDVdF")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("jDVdF")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("36gU0")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("36gU0")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("36gU0")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("36gU0")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("jDVdF")).nextTick);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("jDVdF")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("jDVdF")).onBeforeUnmount);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("jDVdF")).openBlock);
$parcel$export(module.exports, "reactive", () => (parcelRequire("36gU0")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("36gU0")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("jDVdF")).renderList);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("36gU0")).toRaw);
$parcel$export(module.exports, "watch", () => (parcelRequire("jDVdF")).watch);
$parcel$export(module.exports, "createApp", () => (parcelRequire("31QV8")).createApp);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("36gU0")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("36gU0")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("36gU0")).onScopeDispose);
$parcel$export(module.exports, "toRef", () => (parcelRequire("36gU0")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("36gU0")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("36gU0")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("6OYxp")).toDisplayString);
/**
* vue v3.5.42
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $jDVdF = parcelRequire("jDVdF");parcelRequire("31QV8");parcelRequire("36gU0");parcelRequire("6OYxp");
function $25557208c262e7ba$var$initDev() {
    (0, $jDVdF.initCustomFormatter)();
}
const $25557208c262e7ba$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("jDVdF", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $e4ce0b703119af2d$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $e4ce0b703119af2d$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $e4ce0b703119af2d$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $e4ce0b703119af2d$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $e4ce0b703119af2d$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "inject", () => $e4ce0b703119af2d$export$a976684a0efeb93f);
$parcel$export(module.exports, "getCurrentInstance", () => $e4ce0b703119af2d$export$f13e630aa3915748);
$parcel$export(module.exports, "hasInjectionContext", () => $e4ce0b703119af2d$export$caf6761f24fc571a);
$parcel$export(module.exports, "watch", () => $e4ce0b703119af2d$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "useTransitionState", () => $e4ce0b703119af2d$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $e4ce0b703119af2d$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $e4ce0b703119af2d$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $e4ce0b703119af2d$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getTransitionRawChildren", () => $e4ce0b703119af2d$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "createCommentVNode", () => $e4ce0b703119af2d$export$49553837c7236d3c);
$parcel$export(module.exports, "resolveTransitionHooks", () => $e4ce0b703119af2d$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $e4ce0b703119af2d$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $e4ce0b703119af2d$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $e4ce0b703119af2d$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $e4ce0b703119af2d$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $e4ce0b703119af2d$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "onUnmounted", () => $e4ce0b703119af2d$export$13348a43ccacfe58);
$parcel$export(module.exports, "onUpdated", () => $e4ce0b703119af2d$export$5876c47052fb88b1);
$parcel$export(module.exports, "onBeforeMount", () => $e4ce0b703119af2d$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $e4ce0b703119af2d$export$ab91988a13872e4c);
$parcel$export(module.exports, "renderList", () => $e4ce0b703119af2d$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "openBlock", () => $e4ce0b703119af2d$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "computed", () => $e4ce0b703119af2d$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "createRenderer", () => $e4ce0b703119af2d$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $e4ce0b703119af2d$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $e4ce0b703119af2d$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $e4ce0b703119af2d$export$42098e0eaa15c48e);
$parcel$export(module.exports, "isRuntimeOnly", () => $e4ce0b703119af2d$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $e4ce0b703119af2d$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $e4ce0b703119af2d$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $e4ce0b703119af2d$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("36gU0")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("36gU0")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("36gU0")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("36gU0")).markRaw);
$parcel$export(module.exports, "reactive", () => (parcelRequire("36gU0")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("36gU0")).ref);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("36gU0")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("6OYxp")).camelize);
/**
* @vue/runtime-core v3.5.42
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $36gU0 = parcelRequire("36gU0");

var $6OYxp = parcelRequire("6OYxp");
const $e4ce0b703119af2d$var$stack = [];
function $e4ce0b703119af2d$var$pushWarningContext(vnode) {
    $e4ce0b703119af2d$var$stack.push(vnode);
}
function $e4ce0b703119af2d$var$popWarningContext() {
    $e4ce0b703119af2d$var$stack.pop();
}
let $e4ce0b703119af2d$var$isWarning = false;
function $e4ce0b703119af2d$var$warn$1(msg, ...args) {
    if ($e4ce0b703119af2d$var$isWarning) return;
    $e4ce0b703119af2d$var$isWarning = true;
    (0, $36gU0.pauseTracking)();
    const instance = $e4ce0b703119af2d$var$stack.length ? $e4ce0b703119af2d$var$stack[$e4ce0b703119af2d$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $e4ce0b703119af2d$var$getComponentTrace();
    if (appWarnHandler) $e4ce0b703119af2d$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$e4ce0b703119af2d$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$e4ce0b703119af2d$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $36gU0.resetTracking)();
    $e4ce0b703119af2d$var$isWarning = false;
}
function $e4ce0b703119af2d$var$getComponentTrace() {
    let currentVNode = $e4ce0b703119af2d$var$stack[$e4ce0b703119af2d$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $e4ce0b703119af2d$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$e4ce0b703119af2d$var$formatTraceEntry(entry));
    });
    return logs;
}
function $e4ce0b703119af2d$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$e4ce0b703119af2d$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$e4ce0b703119af2d$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $e4ce0b703119af2d$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$e4ce0b703119af2d$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $e4ce0b703119af2d$var$formatProp(key, value, raw) {
    if ((0, $6OYxp.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $36gU0.isRef)(value)) {
        value = $e4ce0b703119af2d$var$formatProp(key, (0, $36gU0.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $6OYxp.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $36gU0.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $e4ce0b703119af2d$export$dfbcecb440255e4a(val, type) {
    return;
}
const $e4ce0b703119af2d$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $e4ce0b703119af2d$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $e4ce0b703119af2d$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $e4ce0b703119af2d$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $e4ce0b703119af2d$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $6OYxp.isFunction)(fn)) {
        const res = $e4ce0b703119af2d$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $6OYxp.isPromise)(res)) res.catch((err)=>{
            $e4ce0b703119af2d$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $6OYxp.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($e4ce0b703119af2d$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $e4ce0b703119af2d$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $6OYxp.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $36gU0.pauseTracking)();
            $e4ce0b703119af2d$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $36gU0.resetTracking)();
            return;
        }
    }
    $e4ce0b703119af2d$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $e4ce0b703119af2d$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $e4ce0b703119af2d$var$queue = [];
let $e4ce0b703119af2d$var$flushIndex = -1;
const $e4ce0b703119af2d$var$pendingPostFlushCbs = [];
let $e4ce0b703119af2d$var$activePostFlushCbs = null;
let $e4ce0b703119af2d$var$postFlushIndex = 0;
const $e4ce0b703119af2d$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $e4ce0b703119af2d$var$currentFlushPromise = null;
const $e4ce0b703119af2d$var$RECURSION_LIMIT = 100;
function $e4ce0b703119af2d$export$bdd553fddd433dcb(fn) {
    const p = $e4ce0b703119af2d$var$currentFlushPromise || $e4ce0b703119af2d$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $e4ce0b703119af2d$var$findInsertionIndex(id) {
    let start = $e4ce0b703119af2d$var$flushIndex + 1;
    let end = $e4ce0b703119af2d$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $e4ce0b703119af2d$var$queue[middle];
        const middleJobId = $e4ce0b703119af2d$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $e4ce0b703119af2d$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $e4ce0b703119af2d$var$getId(job);
        const lastJob = $e4ce0b703119af2d$var$queue[$e4ce0b703119af2d$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $e4ce0b703119af2d$var$getId(lastJob)) $e4ce0b703119af2d$var$queue.push(job);
        else $e4ce0b703119af2d$var$queue.splice($e4ce0b703119af2d$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $e4ce0b703119af2d$var$queueFlush();
    }
}
function $e4ce0b703119af2d$var$queueFlush() {
    if (!$e4ce0b703119af2d$var$currentFlushPromise) $e4ce0b703119af2d$var$currentFlushPromise = $e4ce0b703119af2d$var$resolvedPromise.then($e4ce0b703119af2d$var$flushJobs);
}
function $e4ce0b703119af2d$export$59536a0199721cab(cb) {
    if (!(0, $6OYxp.isArray)(cb)) {
        if ($e4ce0b703119af2d$var$activePostFlushCbs && cb.id === -1) $e4ce0b703119af2d$var$activePostFlushCbs.splice($e4ce0b703119af2d$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $e4ce0b703119af2d$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else for(let i = 0; i < cb.length; i++)$e4ce0b703119af2d$var$pendingPostFlushCbs.push(cb[i]);
    $e4ce0b703119af2d$var$queueFlush();
}
function $e4ce0b703119af2d$var$flushPreFlushCbs(instance, seen, i = $e4ce0b703119af2d$var$flushIndex + 1) {
    for(; i < $e4ce0b703119af2d$var$queue.length; i++){
        const cb = $e4ce0b703119af2d$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $e4ce0b703119af2d$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $e4ce0b703119af2d$var$flushPostFlushCbs(seen) {
    if ($e4ce0b703119af2d$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($e4ce0b703119af2d$var$pendingPostFlushCbs)
        ].sort((a, b)=>$e4ce0b703119af2d$var$getId(a) - $e4ce0b703119af2d$var$getId(b));
        $e4ce0b703119af2d$var$pendingPostFlushCbs.length = 0;
        if ($e4ce0b703119af2d$var$activePostFlushCbs) {
            for(let i = 0; i < deduped.length; i++)$e4ce0b703119af2d$var$activePostFlushCbs.push(deduped[i]);
            return;
        }
        $e4ce0b703119af2d$var$activePostFlushCbs = deduped;
        for($e4ce0b703119af2d$var$postFlushIndex = 0; $e4ce0b703119af2d$var$postFlushIndex < $e4ce0b703119af2d$var$activePostFlushCbs.length; $e4ce0b703119af2d$var$postFlushIndex++){
            const cb = $e4ce0b703119af2d$var$activePostFlushCbs[$e4ce0b703119af2d$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $e4ce0b703119af2d$var$activePostFlushCbs = null;
        $e4ce0b703119af2d$var$postFlushIndex = 0;
    }
}
const $e4ce0b703119af2d$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $e4ce0b703119af2d$var$flushJobs(seen) {
    const check = (0, $6OYxp.NOOP);
    try {
        for($e4ce0b703119af2d$var$flushIndex = 0; $e4ce0b703119af2d$var$flushIndex < $e4ce0b703119af2d$var$queue.length; $e4ce0b703119af2d$var$flushIndex++){
            const job = $e4ce0b703119af2d$var$queue[$e4ce0b703119af2d$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $e4ce0b703119af2d$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $e4ce0b703119af2d$var$flushIndex < $e4ce0b703119af2d$var$queue.length; $e4ce0b703119af2d$var$flushIndex++){
            const job = $e4ce0b703119af2d$var$queue[$e4ce0b703119af2d$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $e4ce0b703119af2d$var$flushIndex = -1;
        $e4ce0b703119af2d$var$queue.length = 0;
        $e4ce0b703119af2d$var$flushPostFlushCbs(seen);
        $e4ce0b703119af2d$var$currentFlushPromise = null;
        if ($e4ce0b703119af2d$var$queue.length || $e4ce0b703119af2d$var$pendingPostFlushCbs.length) $e4ce0b703119af2d$var$flushJobs(seen);
    }
}
function $e4ce0b703119af2d$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $e4ce0b703119af2d$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $e4ce0b703119af2d$var$getComponentName(instance.type);
        $e4ce0b703119af2d$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $e4ce0b703119af2d$var$isHmrUpdating = false;
const $e4ce0b703119af2d$var$setHmrUpdating = (v1)=>{
    try {
        return $e4ce0b703119af2d$var$isHmrUpdating;
    } finally{
        $e4ce0b703119af2d$var$isHmrUpdating = v1;
    }
};
const $e4ce0b703119af2d$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $e4ce0b703119af2d$var$map = /* @__PURE__ */ new Map();
function $e4ce0b703119af2d$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $e4ce0b703119af2d$var$map.get(id);
    if (!record) {
        $e4ce0b703119af2d$var$createRecord(id, instance.type);
        record = $e4ce0b703119af2d$var$map.get(id);
    }
    record.instances.add(instance);
}
function $e4ce0b703119af2d$var$unregisterHMR(instance) {
    $e4ce0b703119af2d$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $e4ce0b703119af2d$var$createRecord(id, initialDef) {
    if ($e4ce0b703119af2d$var$map.has(id)) return false;
    $e4ce0b703119af2d$var$map.set(id, {
        initialDef: $e4ce0b703119af2d$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $e4ce0b703119af2d$var$normalizeClassComponent(component) {
    return $e4ce0b703119af2d$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $e4ce0b703119af2d$var$rerender(id, newRender) {
    const record = $e4ce0b703119af2d$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $e4ce0b703119af2d$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $e4ce0b703119af2d$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $e4ce0b703119af2d$var$isHmrUpdating = false;
    });
}
function $e4ce0b703119af2d$var$reload(id, newComp) {
    const record = $e4ce0b703119af2d$var$map.get(id);
    if (!record) return;
    newComp = $e4ce0b703119af2d$var$normalizeClassComponent(newComp);
    $e4ce0b703119af2d$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $e4ce0b703119af2d$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $e4ce0b703119af2d$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $e4ce0b703119af2d$var$updateComponentDef(oldComp, newComp);
            $e4ce0b703119af2d$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $e4ce0b703119af2d$var$queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                $e4ce0b703119af2d$var$isHmrUpdating = true;
                instance.parent.update();
                $e4ce0b703119af2d$var$isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $e4ce0b703119af2d$export$59536a0199721cab(()=>{
        $e4ce0b703119af2d$var$hmrDirtyComponents.clear();
    });
}
function $e4ce0b703119af2d$var$updateComponentDef(oldComp, newComp) {
    (0, $6OYxp.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $e4ce0b703119af2d$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $e4ce0b703119af2d$var$devtools$1;
let $e4ce0b703119af2d$var$buffer = [];
let $e4ce0b703119af2d$var$devtoolsNotInstalled = false;
function $e4ce0b703119af2d$var$emit$1(event, ...args) {
    if ($e4ce0b703119af2d$var$devtools$1) $e4ce0b703119af2d$var$devtools$1.emit(event, ...args);
    else if (!$e4ce0b703119af2d$var$devtoolsNotInstalled) $e4ce0b703119af2d$var$buffer.push({
        event: event,
        args: args
    });
}
function $e4ce0b703119af2d$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $e4ce0b703119af2d$var$devtools$1 = hook;
    if ($e4ce0b703119af2d$var$devtools$1) {
        $e4ce0b703119af2d$var$devtools$1.enabled = true;
        $e4ce0b703119af2d$var$buffer.forEach(({ event: event, args: args })=>$e4ce0b703119af2d$var$devtools$1.emit(event, ...args));
        $e4ce0b703119af2d$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $e4ce0b703119af2d$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$e4ce0b703119af2d$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $e4ce0b703119af2d$var$devtoolsNotInstalled = true;
                $e4ce0b703119af2d$var$buffer = [];
            }
        }, 3e3);
    } else {
        $e4ce0b703119af2d$var$devtoolsNotInstalled = true;
        $e4ce0b703119af2d$var$buffer = [];
    }
}
function $e4ce0b703119af2d$var$devtoolsInitApp(app, version) {
    $e4ce0b703119af2d$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $e4ce0b703119af2d$export$ffb0004e005737fa,
        Text: $e4ce0b703119af2d$export$5f1af8db9871e1d6,
        Comment: $e4ce0b703119af2d$export$4d299b491347818a,
        Static: $e4ce0b703119af2d$export$c1b9a1d3af45b7b6
    });
}
function $e4ce0b703119af2d$var$devtoolsUnmountApp(app) {
    $e4ce0b703119af2d$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $e4ce0b703119af2d$var$devtoolsComponentAdded = /* @__PURE__ */ $e4ce0b703119af2d$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $e4ce0b703119af2d$var$devtoolsComponentUpdated = /* @__PURE__ */ $e4ce0b703119af2d$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $e4ce0b703119af2d$var$_devtoolsComponentRemoved = /* @__PURE__ */ $e4ce0b703119af2d$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $e4ce0b703119af2d$var$devtoolsComponentRemoved = (component)=>{
    if ($e4ce0b703119af2d$var$devtools$1 && typeof $e4ce0b703119af2d$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$e4ce0b703119af2d$var$devtools$1.cleanupBuffer(component)) $e4ce0b703119af2d$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $e4ce0b703119af2d$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $e4ce0b703119af2d$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $e4ce0b703119af2d$var$devtoolsPerfStart = /* @__PURE__ */ $e4ce0b703119af2d$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $e4ce0b703119af2d$var$devtoolsPerfEnd = /* @__PURE__ */ $e4ce0b703119af2d$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $e4ce0b703119af2d$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $e4ce0b703119af2d$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $e4ce0b703119af2d$var$devtoolsComponentEmit(component, event, params) {
    $e4ce0b703119af2d$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $e4ce0b703119af2d$var$currentRenderingInstance = null;
let $e4ce0b703119af2d$var$currentScopeId = null;
function $e4ce0b703119af2d$var$setCurrentRenderingInstance(instance) {
    const prev = $e4ce0b703119af2d$var$currentRenderingInstance;
    $e4ce0b703119af2d$var$currentRenderingInstance = instance;
    $e4ce0b703119af2d$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $e4ce0b703119af2d$export$ac020265ca2cc4cd(id) {
    $e4ce0b703119af2d$var$currentScopeId = id;
}
function $e4ce0b703119af2d$export$f2dc6805dc11834e() {
    $e4ce0b703119af2d$var$currentScopeId = null;
}
const $e4ce0b703119af2d$export$15ba313e13f3dd04 = (_id)=>$e4ce0b703119af2d$export$694b237e827a3d23;
function $e4ce0b703119af2d$export$694b237e827a3d23(fn, ctx = $e4ce0b703119af2d$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $e4ce0b703119af2d$export$c20bee82f26f1e27(-1);
        const prevInstance = $e4ce0b703119af2d$var$setCurrentRenderingInstance(ctx);
        const prevStackSize = $e4ce0b703119af2d$var$blockStack.length;
        let res;
        try {
            res = fn(...args);
        } finally{
            for(let i = $e4ce0b703119af2d$var$blockStack.length; i > prevStackSize; i--)$e4ce0b703119af2d$var$closeBlock();
            $e4ce0b703119af2d$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $e4ce0b703119af2d$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $e4ce0b703119af2d$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $e4ce0b703119af2d$var$validateDirectiveName(name) {
    if ((0, $6OYxp.isBuiltInDirective)(name)) $e4ce0b703119af2d$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $e4ce0b703119af2d$export$49729353e7c1e6c5(vnode, directives) {
    if ($e4ce0b703119af2d$var$currentRenderingInstance === null) return vnode;
    const instance = $e4ce0b703119af2d$var$getComponentPublicInstance($e4ce0b703119af2d$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $6OYxp.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $6OYxp.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $36gU0.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $e4ce0b703119af2d$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $36gU0.pauseTracking)();
            $e4ce0b703119af2d$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $36gU0.resetTracking)();
        }
    }
}
function $e4ce0b703119af2d$export$abe1e183e22e10ad(key, value) {
    if ($e4ce0b703119af2d$var$currentInstance) {
        let provides = $e4ce0b703119af2d$var$currentInstance.provides;
        const parentProvides = $e4ce0b703119af2d$var$currentInstance.parent && $e4ce0b703119af2d$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $e4ce0b703119af2d$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $e4ce0b703119af2d$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $e4ce0b703119af2d$export$f13e630aa3915748();
    if (instance || $e4ce0b703119af2d$var$currentApp) {
        let provides = $e4ce0b703119af2d$var$currentApp ? $e4ce0b703119af2d$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $6OYxp.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $e4ce0b703119af2d$export$caf6761f24fc571a() {
    return !!($e4ce0b703119af2d$export$f13e630aa3915748() || $e4ce0b703119af2d$var$currentApp);
}
const $e4ce0b703119af2d$export$f2549a27e18acf2d = /* @__PURE__ */ Symbol.for("v-scx");
const $e4ce0b703119af2d$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $e4ce0b703119af2d$export$a976684a0efeb93f($e4ce0b703119af2d$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $e4ce0b703119af2d$export$ede35fc0e5500309(effect, options) {
    return $e4ce0b703119af2d$var$doWatch(effect, null, options);
}
function $e4ce0b703119af2d$export$b7f27ea67102d543(effect, options) {
    return $e4ce0b703119af2d$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $e4ce0b703119af2d$export$2035654f31b0e555(effect, options) {
    return $e4ce0b703119af2d$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $e4ce0b703119af2d$export$3db5d71bdb2d5499(source, cb, options) {
    return $e4ce0b703119af2d$var$doWatch(source, cb, options);
}
function $e4ce0b703119af2d$var$doWatch(source, cb, options = (0, $6OYxp.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $6OYxp.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($e4ce0b703119af2d$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $e4ce0b703119af2d$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $6OYxp.NOOP);
            watchStopHandle.resume = (0, $6OYxp.NOOP);
            watchStopHandle.pause = (0, $6OYxp.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $e4ce0b703119af2d$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$e4ce0b703119af2d$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $e4ce0b703119af2d$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $e4ce0b703119af2d$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $36gU0.watch)(source, cb, baseWatchOptions);
    if ($e4ce0b703119af2d$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $e4ce0b703119af2d$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $6OYxp.isString)(source) ? source.includes(".") ? $e4ce0b703119af2d$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $6OYxp.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $e4ce0b703119af2d$var$setCurrentInstance(this);
    const res = $e4ce0b703119af2d$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $e4ce0b703119af2d$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const $e4ce0b703119af2d$var$pendingMounts = /* @__PURE__ */ new WeakMap();
const $e4ce0b703119af2d$var$TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const $e4ce0b703119af2d$var$isTeleport = (type)=>type.__isTeleport;
const $e4ce0b703119af2d$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $e4ce0b703119af2d$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $e4ce0b703119af2d$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $e4ce0b703119af2d$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $e4ce0b703119af2d$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $6OYxp.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $e4ce0b703119af2d$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment, parentNode: parentNode } } = internals;
        const disabled = $e4ce0b703119af2d$var$isTeleportDisabled(n2.props);
        let { dynamicChildren: dynamicChildren } = n2;
        const mount = (vnode, container2, anchor2)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled2 = $e4ce0b703119af2d$var$isTeleportDisabled(vnode.props);
            const target = vnode.target = $e4ce0b703119af2d$var$resolveTarget(vnode.props, querySelector);
            const targetAnchor = $e4ce0b703119af2d$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $e4ce0b703119af2d$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $e4ce0b703119af2d$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled2) {
                    mount(vnode, target, targetAnchor);
                    $e4ce0b703119af2d$var$updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if ($e4ce0b703119af2d$var$pendingMounts.get(vnode) !== mountJob) return;
                $e4ce0b703119af2d$var$pendingMounts.delete(vnode);
                if ($e4ce0b703119af2d$var$isTeleportDisabled(vnode.props)) {
                    const mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    $e4ce0b703119af2d$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $e4ce0b703119af2d$var$pendingMounts.set(vnode, mountJob);
            $e4ce0b703119af2d$var$queuePostRenderEffect(mountJob, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($e4ce0b703119af2d$var$isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $e4ce0b703119af2d$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = $e4ce0b703119af2d$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 8;
                $e4ce0b703119af2d$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $e4ce0b703119af2d$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $e4ce0b703119af2d$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $e4ce0b703119af2d$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $e4ce0b703119af2d$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $e4ce0b703119af2d$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = $e4ce0b703119af2d$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) {
                        n2.target = nextTarget;
                        $e4ce0b703119af2d$var$moveTeleport(n2, nextTarget, null, internals, 0);
                    }
                } else if (wasDisabled) $e4ce0b703119af2d$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $e4ce0b703119af2d$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        const disabled = $e4ce0b703119af2d$var$isTeleportDisabled(props);
        const shouldRemove = doRemove || !disabled;
        const pendingMount = $e4ce0b703119af2d$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 8;
            $e4ce0b703119af2d$var$pendingMounts.delete(vnode);
        }
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (!pendingMount && (disabled || target) && shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $e4ce0b703119af2d$var$moveTeleport,
    hydrate: $e4ce0b703119af2d$var$hydrateTeleport
};
function $e4ce0b703119af2d$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!$e4ce0b703119af2d$var$pendingMounts.has(vnode) && (!isReorder || $e4ce0b703119af2d$var$isTeleportDisabled(props))) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $e4ce0b703119af2d$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $e4ce0b703119af2d$var$resolveTarget(vnode.props, querySelector);
    const disabled = $e4ce0b703119af2d$var$isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $e4ce0b703119af2d$var$prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $e4ce0b703119af2d$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $e4ce0b703119af2d$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $e4ce0b703119af2d$export$76d55a0304a371f4 = $e4ce0b703119af2d$var$TeleportImpl;
function $e4ce0b703119af2d$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $e4ce0b703119af2d$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$e4ce0b703119af2d$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const $e4ce0b703119af2d$var$leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const $e4ce0b703119af2d$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function $e4ce0b703119af2d$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $e4ce0b703119af2d$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $e4ce0b703119af2d$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $e4ce0b703119af2d$var$TransitionHookValidator = [
    Function,
    Array
];
const $e4ce0b703119af2d$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $e4ce0b703119af2d$var$TransitionHookValidator,
    onEnter: $e4ce0b703119af2d$var$TransitionHookValidator,
    onAfterEnter: $e4ce0b703119af2d$var$TransitionHookValidator,
    onEnterCancelled: $e4ce0b703119af2d$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $e4ce0b703119af2d$var$TransitionHookValidator,
    onLeave: $e4ce0b703119af2d$var$TransitionHookValidator,
    onAfterLeave: $e4ce0b703119af2d$var$TransitionHookValidator,
    onLeaveCancelled: $e4ce0b703119af2d$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $e4ce0b703119af2d$var$TransitionHookValidator,
    onAppear: $e4ce0b703119af2d$var$TransitionHookValidator,
    onAfterAppear: $e4ce0b703119af2d$var$TransitionHookValidator,
    onAppearCancelled: $e4ce0b703119af2d$var$TransitionHookValidator
};
const $e4ce0b703119af2d$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $e4ce0b703119af2d$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $e4ce0b703119af2d$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $e4ce0b703119af2d$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $e4ce0b703119af2d$export$f13e630aa3915748();
        const state = $e4ce0b703119af2d$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $e4ce0b703119af2d$export$a67f9b1229c7c97a(slots.default(), true);
            const child = children && children.length ? $e4ce0b703119af2d$var$findNonCommentChild(children) : // Keep explicit default-slot conditionals on the same transition path
            // as regular v-if branches, which render a comment placeholder.
            instance.subTree ? $e4ce0b703119af2d$export$49553837c7236d3c() : void 0;
            if (!child) return;
            const rawProps = (0, $36gU0.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $e4ce0b703119af2d$var$emptyPlaceholder(child);
            const innerChild = $e4ce0b703119af2d$var$getInnerChild$1(child);
            if (!innerChild) return $e4ce0b703119af2d$var$emptyPlaceholder(child);
            let enterHooks = $e4ce0b703119af2d$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $e4ce0b703119af2d$export$4d299b491347818a) $e4ce0b703119af2d$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $e4ce0b703119af2d$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $e4ce0b703119af2d$export$4d299b491347818a && !$e4ce0b703119af2d$var$isSameVNodeType(oldInnerChild, innerChild) && $e4ce0b703119af2d$var$recursiveGetSubtree(instance).type !== $e4ce0b703119af2d$export$4d299b491347818a) {
                let leavingHooks = $e4ce0b703119af2d$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $e4ce0b703119af2d$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $e4ce0b703119af2d$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $e4ce0b703119af2d$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $e4ce0b703119af2d$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $e4ce0b703119af2d$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$e4ce0b703119af2d$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$e4ce0b703119af2d$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $e4ce0b703119af2d$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $e4ce0b703119af2d$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $e4ce0b703119af2d$export$abd95b5f5e8a8837 = $e4ce0b703119af2d$var$BaseTransitionImpl;
function $e4ce0b703119af2d$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $e4ce0b703119af2d$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $e4ce0b703119af2d$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $e4ce0b703119af2d$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $6OYxp.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$e4ce0b703119af2d$var$leaveCbKey]) el[$e4ce0b703119af2d$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $e4ce0b703119af2d$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$e4ce0b703119af2d$var$leaveCbKey]) leavingVNode.el[$e4ce0b703119af2d$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!$e4ce0b703119af2d$var$isHmrUpdating && leavingVNodesCache[key] === vnode) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$e4ce0b703119af2d$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$e4ce0b703119af2d$var$enterCbKey] = void 0;
            };
            const done = el[$e4ce0b703119af2d$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$e4ce0b703119af2d$var$enterCbKey]) el[$e4ce0b703119af2d$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$e4ce0b703119af2d$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$e4ce0b703119af2d$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[$e4ce0b703119af2d$var$leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $e4ce0b703119af2d$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $e4ce0b703119af2d$var$emptyPlaceholder(vnode) {
    if ($e4ce0b703119af2d$var$isKeepAlive(vnode)) {
        vnode = $e4ce0b703119af2d$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $e4ce0b703119af2d$var$getInnerChild$1(vnode) {
    if (!$e4ce0b703119af2d$var$isKeepAlive(vnode)) {
        if ($e4ce0b703119af2d$var$isTeleport(vnode.type) && vnode.children) return $e4ce0b703119af2d$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $6OYxp.isFunction)(children.default)) return children.default();
    }
}
function $e4ce0b703119af2d$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        const subTree = vnode.component.subTree;
        $e4ce0b703119af2d$export$7770a22486565649($e4ce0b703119af2d$var$isTeleport(subTree.type) ? $e4ce0b703119af2d$var$getInnerChild$1(subTree) || subTree : subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $e4ce0b703119af2d$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $e4ce0b703119af2d$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($e4ce0b703119af2d$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $e4ce0b703119af2d$export$4d299b491347818a) ret.push(key != null ? $e4ce0b703119af2d$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
// @__NO_SIDE_EFFECTS__
function $e4ce0b703119af2d$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $6OYxp.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $6OYxp.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $e4ce0b703119af2d$export$f680877a34711e37() {
    const i = $e4ce0b703119af2d$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $e4ce0b703119af2d$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $e4ce0b703119af2d$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $e4ce0b703119af2d$export$83a5dbc1f35517ca(key) {
    const i = $e4ce0b703119af2d$export$f13e630aa3915748();
    const r = (0, $36gU0.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $6OYxp.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $e4ce0b703119af2d$var$isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const $e4ce0b703119af2d$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $e4ce0b703119af2d$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $6OYxp.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$e4ce0b703119af2d$var$setRef(r, oldRawRef && ((0, $6OYxp.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($e4ce0b703119af2d$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $e4ce0b703119af2d$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $e4ce0b703119af2d$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $6OYxp.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $36gU0.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $6OYxp.EMPTY_OBJ) ? (0, $6OYxp.NO) : (key)=>{
        if ($e4ce0b703119af2d$var$isTemplateRefKey(refs, key)) return false;
        return (0, $6OYxp.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && $e4ce0b703119af2d$var$isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $e4ce0b703119af2d$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $6OYxp.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $36gU0.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $6OYxp.isFunction)(ref)) $e4ce0b703119af2d$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $6OYxp.isString)(ref);
        const _isRef = (0, $36gU0.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $6OYxp.isArray)(existing) && (0, $6OYxp.remove)(existing, refValue);
                    else {
                        if (!(0, $6OYxp.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $e4ce0b703119af2d$var$pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                $e4ce0b703119af2d$var$pendingSetRefMap.set(rawRef, job);
                $e4ce0b703119af2d$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $e4ce0b703119af2d$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $e4ce0b703119af2d$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $e4ce0b703119af2d$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $e4ce0b703119af2d$var$pendingSetRefMap.delete(rawRef);
    }
}
let $e4ce0b703119af2d$var$hasLoggedMismatchError = false;
const $e4ce0b703119af2d$var$logMismatchError = ()=>{
    if ($e4ce0b703119af2d$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $e4ce0b703119af2d$var$hasLoggedMismatchError = true;
};
const $e4ce0b703119af2d$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $e4ce0b703119af2d$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $e4ce0b703119af2d$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($e4ce0b703119af2d$var$isSVGContainer(container)) return "svg";
    if ($e4ce0b703119af2d$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $e4ce0b703119af2d$var$isComment = (node)=>node.nodeType === 8;
function $e4ce0b703119af2d$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $e4ce0b703119af2d$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $e4ce0b703119af2d$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $e4ce0b703119af2d$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $e4ce0b703119af2d$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $6OYxp.def)(node, "__vnode", vnode, true);
            (0, $6OYxp.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $e4ce0b703119af2d$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $e4ce0b703119af2d$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $e4ce0b703119af2d$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $e4ce0b703119af2d$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $e4ce0b703119af2d$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $e4ce0b703119af2d$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($e4ce0b703119af2d$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $e4ce0b703119af2d$var$getContainerType(container), optimized);
                    if ($e4ce0b703119af2d$var$isAsyncWrapper(vnode) && !vnode.component.subTree) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $e4ce0b703119af2d$export$bf5c4cf060303d58($e4ce0b703119af2d$export$c1b9a1d3af45b7b6);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $e4ce0b703119af2d$export$22f9b5ffd89dac9("") : $e4ce0b703119af2d$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $e4ce0b703119af2d$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $e4ce0b703119af2d$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $e4ce0b703119af2d$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, dynamicProps: dynamicProps, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        const hasDynamicProps = !!dynamicProps;
        if (forcePatch || hasDynamicProps || patchFlag !== -1) {
            if (dirs) $e4ce0b703119af2d$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $e4ce0b703119af2d$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                if (next && !$e4ce0b703119af2d$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $e4ce0b703119af2d$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                    $e4ce0b703119af2d$var$logMismatchError();
                }
                while(next){
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$e4ce0b703119af2d$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $e4ce0b703119af2d$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        $e4ce0b703119af2d$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || hasDynamicProps || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    const namespace = el.namespaceURI.includes("svg") ? "svg" : el.namespaceURI.includes("MathML") ? "mathml" : void 0;
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $e4ce0b703119af2d$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $e4ce0b703119af2d$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $6OYxp.isOn)(key) && !(0, $6OYxp.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, $6OYxp.isReservedProp)(key) || dynamicProps && dynamicProps.includes(key)) {
                            if ($e4ce0b703119af2d$var$isUnchangedResourceProp(el, key, props[key])) continue;
                            patchProp(el, key, null, props[key], namespace, parentComponent);
                        }
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $36gU0.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $e4ce0b703119af2d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $e4ce0b703119af2d$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $e4ce0b703119af2d$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasCheckedMismatch = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $e4ce0b703119af2d$var$normalizeVNode(children[i]);
            const isText = vnode.type === $e4ce0b703119af2d$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $e4ce0b703119af2d$var$normalizeVNode(children[i + 1]).type === $e4ce0b703119af2d$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!hasCheckedMismatch) {
                    hasCheckedMismatch = true;
                    if (!$e4ce0b703119af2d$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $e4ce0b703119af2d$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        $e4ce0b703119af2d$var$logMismatchError();
                    }
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $e4ce0b703119af2d$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $e4ce0b703119af2d$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $e4ce0b703119af2d$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$e4ce0b703119af2d$var$isNodeMismatchAllowed(node, vnode)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $e4ce0b703119af2d$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $e4ce0b703119af2d$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $e4ce0b703119af2d$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $e4ce0b703119af2d$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $e4ce0b703119af2d$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $e4ce0b703119af2d$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
const $e4ce0b703119af2d$var$resourceProps = /* @__PURE__ */ new Set([
    "src",
    "srcset",
    "href",
    "poster"
]);
function $e4ce0b703119af2d$var$isUnchangedResourceProp(el, key, clientValue) {
    if (!$e4ce0b703119af2d$var$resourceProps.has(key)) return false;
    return el.getAttribute(key) === (clientValue == null ? null : `${clientValue}`);
}
function $e4ce0b703119af2d$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $6OYxp.normalizeClass)(clientValue);
        if (!$e4ce0b703119af2d$var$isSetEqual($e4ce0b703119af2d$var$toClassSet(actual || ""), $e4ce0b703119af2d$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $6OYxp.isString)(clientValue) ? clientValue : (0, $6OYxp.stringifyStyle)((0, $6OYxp.normalizeStyle)(clientValue));
        const actualMap = $e4ce0b703119af2d$var$toStyleMap(actual);
        const expectedMap = $e4ce0b703119af2d$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $e4ce0b703119af2d$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$e4ce0b703119af2d$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $6OYxp.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $6OYxp.isBooleanAttr)(key) || (0, $6OYxp.isKnownHtmlAttr)(key))) {
        if (key === "hidden") {
            actual = $e4ce0b703119af2d$var$normalizeHiddenValue(el.getAttribute(key));
            expected = $e4ce0b703119af2d$var$normalizeHiddenValue(clientValue);
        } else if ((0, $6OYxp.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $6OYxp.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $6OYxp.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$e4ce0b703119af2d$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$e4ce0b703119af2d$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $e4ce0b703119af2d$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $e4ce0b703119af2d$var$normalizeHiddenValue(value) {
    if (!(0, $6OYxp.isRenderableAttrValue)(value)) return false;
    if ((0, $6OYxp.isString)(value)) return value.toLowerCase() === "until-found" ? "until-found" : "";
    return (0, $6OYxp.includeBooleanAttr)(value) ? "" : false;
}
function $e4ce0b703119af2d$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $e4ce0b703119af2d$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $e4ce0b703119af2d$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $e4ce0b703119af2d$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $e4ce0b703119af2d$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $e4ce0b703119af2d$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $6OYxp.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $6OYxp.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $e4ce0b703119af2d$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $e4ce0b703119af2d$var$allowMismatchAttr = "data-allow-mismatch";
const $e4ce0b703119af2d$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $e4ce0b703119af2d$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($e4ce0b703119af2d$var$allowMismatchAttr))el = el.parentElement;
    return $e4ce0b703119af2d$var$isMismatchAllowedByAttr(el && el.getAttribute($e4ce0b703119af2d$var$allowMismatchAttr), allowedType);
}
function $e4ce0b703119af2d$var$isMismatchAllowedByAttr(allowedAttr, allowedType) {
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($e4ce0b703119af2d$var$MismatchTypeString[allowedType]);
    }
}
function $e4ce0b703119af2d$var$isNodeMismatchAllowed(node, vnode) {
    return $e4ce0b703119af2d$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ ) || $e4ce0b703119af2d$var$isMismatchAllowedByNode(node) || $e4ce0b703119af2d$var$isMismatchAllowedByVNode(vnode);
}
function $e4ce0b703119af2d$var$isMismatchAllowedByNode(node) {
    return node.nodeType === 1 && $e4ce0b703119af2d$var$isMismatchAllowedByAttr(node.getAttribute($e4ce0b703119af2d$var$allowMismatchAttr), 1 /* CHILDREN */ );
}
function $e4ce0b703119af2d$var$isMismatchAllowedByVNode({ props: props }) {
    const allowedAttr = props && props[$e4ce0b703119af2d$var$allowMismatchAttr];
    return typeof allowedAttr === "string" && $e4ce0b703119af2d$var$isMismatchAllowedByAttr(allowedAttr, 1 /* CHILDREN */ );
}
const $e4ce0b703119af2d$var$requestIdleCallback = (0, $6OYxp.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $e4ce0b703119af2d$var$cancelIdleCallback = (0, $6OYxp.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $e4ce0b703119af2d$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $e4ce0b703119af2d$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$e4ce0b703119af2d$var$cancelIdleCallback(id);
    };
function $e4ce0b703119af2d$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $e4ce0b703119af2d$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($e4ce0b703119af2d$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $e4ce0b703119af2d$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $e4ce0b703119af2d$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $6OYxp.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $e4ce0b703119af2d$var$forEachElement(node, cb) {
    if ($e4ce0b703119af2d$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($e4ce0b703119af2d$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $e4ce0b703119af2d$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function $e4ce0b703119af2d$export$d75d499b4c16cf21(source) {
    if ((0, $6OYxp.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $e4ce0b703119af2d$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const wasConnected = el.isConnected;
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                if (!el.parentNode || wasConnected && !el.isConnected) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$e4ce0b703119af2d$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $e4ce0b703119af2d$var$currentInstance;
            $e4ce0b703119af2d$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$e4ce0b703119af2d$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $e4ce0b703119af2d$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $e4ce0b703119af2d$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$e4ce0b703119af2d$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $e4ce0b703119af2d$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $36gU0.ref)(false);
            const error = (0, $36gU0.ref)();
            const delayed = (0, $36gU0.ref)(!!delay);
            let timeoutTimer;
            let delayTimer;
            $e4ce0b703119af2d$export$13348a43ccacfe58(()=>{
                if (timeoutTimer != null) clearTimeout(timeoutTimer);
                if (delayTimer != null) clearTimeout(delayTimer);
            });
            if (delay) delayTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                delayed.value = false;
            }, delay);
            if (timeout != null) timeoutTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                if (instance.isUnmounted) return;
                loaded.value = true;
                if (instance.parent && $e4ce0b703119af2d$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                if (instance.isUnmounted) {
                    pendingRequest = null;
                    return;
                }
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $e4ce0b703119af2d$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $e4ce0b703119af2d$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $e4ce0b703119af2d$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $e4ce0b703119af2d$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $e4ce0b703119af2d$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $e4ce0b703119af2d$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $e4ce0b703119af2d$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $e4ce0b703119af2d$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $e4ce0b703119af2d$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $6OYxp.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $e4ce0b703119af2d$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $e4ce0b703119af2d$var$invalidateMount(instance2.m);
            $e4ce0b703119af2d$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $e4ce0b703119af2d$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $6OYxp.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $e4ce0b703119af2d$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $e4ce0b703119af2d$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $e4ce0b703119af2d$var$getComponentName($e4ce0b703119af2d$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$e4ce0b703119af2d$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $e4ce0b703119af2d$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $e4ce0b703119af2d$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$e4ce0b703119af2d$var$matches(include, name));
            exclude && pruneCache((name)=>!$e4ce0b703119af2d$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($e4ce0b703119af2d$var$isSuspense(instance.subTree.type)) $e4ce0b703119af2d$var$queuePostRenderEffect(()=>{
                    const vnode = $e4ce0b703119af2d$var$getInnerChild(instance.subTree);
                    if (vnode.component) cache.set(pendingCacheKey, vnode);
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $e4ce0b703119af2d$var$getInnerChild(instance.subTree));
            }
        };
        $e4ce0b703119af2d$export$6d1641039221b5cb(cacheSubtree);
        $e4ce0b703119af2d$export$5876c47052fb88b1(cacheSubtree);
        $e4ce0b703119af2d$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $e4ce0b703119af2d$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $e4ce0b703119af2d$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $e4ce0b703119af2d$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$e4ce0b703119af2d$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $e4ce0b703119af2d$var$getInnerChild(rawVNode);
            if (vnode.type === $e4ce0b703119af2d$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $e4ce0b703119af2d$var$getComponentName($e4ce0b703119af2d$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$e4ce0b703119af2d$var$matches(include, name)) || exclude && name && $e4ce0b703119af2d$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $e4ce0b703119af2d$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $e4ce0b703119af2d$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $e4ce0b703119af2d$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $e4ce0b703119af2d$export$70eb8a58709972df = $e4ce0b703119af2d$var$KeepAliveImpl;
function $e4ce0b703119af2d$var$matches(pattern, name) {
    if ((0, $6OYxp.isArray)(pattern)) return pattern.some((p)=>$e4ce0b703119af2d$var$matches(p, name));
    else if ((0, $6OYxp.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $6OYxp.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $e4ce0b703119af2d$export$ba52d824b95a2154(hook, target) {
    $e4ce0b703119af2d$var$registerKeepAliveHook(hook, "a", target);
}
function $e4ce0b703119af2d$export$bf1440eeaf5fa709(hook, target) {
    $e4ce0b703119af2d$var$registerKeepAliveHook(hook, "da", target);
}
function $e4ce0b703119af2d$var$registerKeepAliveHook(hook, type, target = $e4ce0b703119af2d$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $e4ce0b703119af2d$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($e4ce0b703119af2d$var$isKeepAlive(current.parent.vnode)) $e4ce0b703119af2d$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $e4ce0b703119af2d$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $e4ce0b703119af2d$var$injectHook(type, hook, keepAliveRoot, true);
    $e4ce0b703119af2d$export$13348a43ccacfe58(()=>{
        (0, $6OYxp.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $e4ce0b703119af2d$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $e4ce0b703119af2d$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $e4ce0b703119af2d$var$injectHook(type, hook, target = $e4ce0b703119af2d$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $36gU0.pauseTracking)();
            const reset = $e4ce0b703119af2d$var$setCurrentInstance(target);
            const res = $e4ce0b703119af2d$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $36gU0.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $e4ce0b703119af2d$var$createHook = (lifecycle)=>(hook, target = $e4ce0b703119af2d$var$currentInstance)=>{
        if (!$e4ce0b703119af2d$var$isInSSRComponentSetup || lifecycle === "sp") $e4ce0b703119af2d$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $e4ce0b703119af2d$export$23b7aeb0d671f804 = $e4ce0b703119af2d$var$createHook("bm");
const $e4ce0b703119af2d$export$6d1641039221b5cb = $e4ce0b703119af2d$var$createHook("m");
const $e4ce0b703119af2d$export$ab91988a13872e4c = $e4ce0b703119af2d$var$createHook("bu");
const $e4ce0b703119af2d$export$5876c47052fb88b1 = $e4ce0b703119af2d$var$createHook("u");
const $e4ce0b703119af2d$export$40c420df62d2614 = $e4ce0b703119af2d$var$createHook("bum");
const $e4ce0b703119af2d$export$13348a43ccacfe58 = $e4ce0b703119af2d$var$createHook("um");
const $e4ce0b703119af2d$export$ebf0c601f267bceb = $e4ce0b703119af2d$var$createHook("sp");
const $e4ce0b703119af2d$export$898295a813d662eb = $e4ce0b703119af2d$var$createHook("rtg");
const $e4ce0b703119af2d$export$2b41f4235363e921 = $e4ce0b703119af2d$var$createHook("rtc");
function $e4ce0b703119af2d$export$6a3a15856e50ad19(hook, target = $e4ce0b703119af2d$var$currentInstance) {
    $e4ce0b703119af2d$var$injectHook("ec", hook, target);
}
const $e4ce0b703119af2d$var$COMPONENTS = "components";
const $e4ce0b703119af2d$var$DIRECTIVES = "directives";
function $e4ce0b703119af2d$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $e4ce0b703119af2d$var$resolveAsset($e4ce0b703119af2d$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $e4ce0b703119af2d$var$NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function $e4ce0b703119af2d$export$b44c564a05ca975(component) {
    if ((0, $6OYxp.isString)(component)) return $e4ce0b703119af2d$var$resolveAsset($e4ce0b703119af2d$var$COMPONENTS, component, false) || component;
    else return component || $e4ce0b703119af2d$var$NULL_DYNAMIC_COMPONENT;
}
function $e4ce0b703119af2d$export$a1989e995cd481be(name) {
    return $e4ce0b703119af2d$var$resolveAsset($e4ce0b703119af2d$var$DIRECTIVES, name);
}
function $e4ce0b703119af2d$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $e4ce0b703119af2d$var$currentRenderingInstance || $e4ce0b703119af2d$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $e4ce0b703119af2d$var$COMPONENTS) {
            const selfName = $e4ce0b703119af2d$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $6OYxp.camelize)(name) || selfName === (0, $6OYxp.capitalize)((0, $6OYxp.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $e4ce0b703119af2d$var$resolve(instance[type] || Component[type], name) || // global registration
        $e4ce0b703119af2d$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $e4ce0b703119af2d$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $6OYxp.camelize)(name)] || registry[(0, $6OYxp.capitalize)((0, $6OYxp.camelize)(name))]);
}
function $e4ce0b703119af2d$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $6OYxp.isArray)(source);
    if (sourceIsArray || (0, $6OYxp.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $36gU0.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $36gU0.isShallow)(source);
            isReadonlySource = (0, $36gU0.isReadonly)(source);
            source = (0, $36gU0.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $36gU0.toReadonly)((0, $36gU0.toReactive)(source[i])) : (0, $36gU0.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $6OYxp.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $e4ce0b703119af2d$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $6OYxp.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $e4ce0b703119af2d$export$4abee4c34694ada1(slots, name, props, fallback, noSlotted, branchKey) {
    if (props == null) props = {};
    if ($e4ce0b703119af2d$var$currentRenderingInstance.ce || $e4ce0b703119af2d$var$currentRenderingInstance.parent && $e4ce0b703119af2d$var$isAsyncWrapper($e4ce0b703119af2d$var$currentRenderingInstance.parent) && $e4ce0b703119af2d$var$currentRenderingInstance.parent.ce) {
        const slotProps = branchKey != null && props.key == null ? (0, $6OYxp.extend)({}, props, {
            key: branchKey
        }) : props;
        const hasProps = Object.keys(slotProps).length > 0;
        if (name !== "default") slotProps.name = name;
        return $e4ce0b703119af2d$export$e7eaa45e502fe5cc(), $e4ce0b703119af2d$export$9f2dfe8048dfb22b($e4ce0b703119af2d$export$ffb0004e005737fa, null, [
            $e4ce0b703119af2d$export$bf5c4cf060303d58("slot", slotProps, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    const prevStackSize = $e4ce0b703119af2d$var$blockStack.length;
    $e4ce0b703119af2d$export$e7eaa45e502fe5cc();
    let rendered;
    try {
        const validSlotContent = slot && $e4ce0b703119af2d$var$ensureValidVNode(slot(props));
        const slotKey = props.key || branchKey || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key;
        rendered = $e4ce0b703119af2d$export$9f2dfe8048dfb22b($e4ce0b703119af2d$export$ffb0004e005737fa, {
            key: (slotKey && !(0, $6OYxp.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
            (!validSlotContent && fallback ? "_fb" : "")
        }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    } catch (err) {
        for(let i = $e4ce0b703119af2d$var$blockStack.length; i > prevStackSize; i--)$e4ce0b703119af2d$var$closeBlock();
        throw err;
    } finally{
        if (slot && slot._c) slot._d = true;
    }
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    return rendered;
}
function $e4ce0b703119af2d$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$e4ce0b703119af2d$export$3868d13f8734ae81(child)) return true;
        if (child.type === $e4ce0b703119af2d$export$4d299b491347818a) return false;
        if (child.type === $e4ce0b703119af2d$export$ffb0004e005737fa && !$e4ce0b703119af2d$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $e4ce0b703119af2d$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $6OYxp.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $e4ce0b703119af2d$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($e4ce0b703119af2d$var$isStatefulComponent(i)) return $e4ce0b703119af2d$var$getComponentPublicInstance(i);
    return $e4ce0b703119af2d$var$getPublicInstance(i.parent);
};
const $e4ce0b703119af2d$var$resolveDevRootEl = (vnode)=>{
    let found = false;
    while(true){
        if (vnode.patchFlag > 0 && vnode.patchFlag & 2048) {
            const root = $e4ce0b703119af2d$var$filterSingleRoot(vnode.children);
            if (!root) return;
            vnode = root;
            found = true;
            continue;
        }
        const component = vnode.component;
        if (component && component.subTree) {
            vnode = component.subTree;
            continue;
        }
        const suspense = vnode.suspense;
        if (suspense && suspense.activeBranch) {
            vnode = suspense.activeBranch;
            continue;
        }
        return found ? vnode.el : void 0;
    }
};
const $e4ce0b703119af2d$var$getDevRootFragmentEl = (i)=>{
    const el = i.subTree && $e4ce0b703119af2d$var$resolveDevRootEl(i.subTree);
    return el === void 0 ? i.vnode.el : el;
};
const $e4ce0b703119af2d$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $6OYxp.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>(0, i.vnode.el),
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$e4ce0b703119af2d$var$getPublicInstance(i.parent),
    $root: (i)=>$e4ce0b703119af2d$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $e4ce0b703119af2d$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $e4ce0b703119af2d$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $e4ce0b703119af2d$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $e4ce0b703119af2d$var$instanceWatch.bind(i) : (0, $6OYxp.NOOP)
});
const $e4ce0b703119af2d$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $e4ce0b703119af2d$var$hasSetupBinding = (state, key)=>state !== (0, $6OYxp.EMPTY_OBJ) && !state.__isScriptSetup && (0, $6OYxp.hasOwn)(state, key);
const $e4ce0b703119af2d$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($e4ce0b703119af2d$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $6OYxp.EMPTY_OBJ) && (0, $6OYxp.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, $6OYxp.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $6OYxp.EMPTY_OBJ) && (0, $6OYxp.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $e4ce0b703119af2d$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $e4ce0b703119af2d$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $36gU0.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $6OYxp.EMPTY_OBJ) && (0, $6OYxp.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $6OYxp.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($e4ce0b703119af2d$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $6OYxp.EMPTY_OBJ) && (0, $6OYxp.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $6OYxp.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $6OYxp.EMPTY_OBJ) && key[0] !== "$" && (0, $6OYxp.hasOwn)(data, key) || $e4ce0b703119af2d$var$hasSetupBinding(setupState, key) || (0, $6OYxp.hasOwn)(props, key) || (0, $6OYxp.hasOwn)(ctx, key) || (0, $6OYxp.hasOwn)($e4ce0b703119af2d$var$publicPropertiesMap, key) || (0, $6OYxp.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $6OYxp.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $e4ce0b703119af2d$var$target;
const $e4ce0b703119af2d$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $6OYxp.extend)({}, $e4ce0b703119af2d$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $e4ce0b703119af2d$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $6OYxp.isGloballyAllowed)(key);
        return has;
    }
});
function $e4ce0b703119af2d$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($e4ce0b703119af2d$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$e4ce0b703119af2d$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $6OYxp.NOOP)
        });
    });
    return target;
}
function $e4ce0b703119af2d$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $6OYxp.NOOP)
        });
    });
}
function $e4ce0b703119af2d$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $36gU0.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($e4ce0b703119af2d$var$isReservedPrefix(key[0])) {
                $e4ce0b703119af2d$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $6OYxp.NOOP)
            });
        }
    });
}
const $e4ce0b703119af2d$var$warnRuntimeUsage = (method)=>$e4ce0b703119af2d$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $e4ce0b703119af2d$export$80b33eababae110e() {
    return null;
}
function $e4ce0b703119af2d$export$51ecece22fc17ddc() {
    return null;
}
function $e4ce0b703119af2d$export$da25b65ca24b518a(exposed) {}
function $e4ce0b703119af2d$export$77e79129327f3d0d(options) {}
function $e4ce0b703119af2d$export$1b3acd4bb805b712() {
    return null;
}
function $e4ce0b703119af2d$export$acd55aa037e791bb() {}
function $e4ce0b703119af2d$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $e4ce0b703119af2d$export$9203a8e84125433c() {
    return $e4ce0b703119af2d$var$getContext("useSlots").slots;
}
function $e4ce0b703119af2d$export$75e29435042cd2ea() {
    return $e4ce0b703119af2d$var$getContext("useAttrs").attrs;
}
function $e4ce0b703119af2d$var$getContext(calledFunctionName) {
    const i = $e4ce0b703119af2d$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $e4ce0b703119af2d$var$createSetupContext(i));
}
function $e4ce0b703119af2d$var$normalizePropsOrEmits(props) {
    return (0, $6OYxp.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $e4ce0b703119af2d$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $e4ce0b703119af2d$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $6OYxp.isArray)(opt) || (0, $6OYxp.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $e4ce0b703119af2d$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $6OYxp.isArray)(a) && (0, $6OYxp.isArray)(b)) return a.concat(b);
    return (0, $6OYxp.extend)({}, $e4ce0b703119af2d$var$normalizePropsOrEmits(a), $e4ce0b703119af2d$var$normalizePropsOrEmits(b));
}
function $e4ce0b703119af2d$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $e4ce0b703119af2d$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $e4ce0b703119af2d$export$f13e630aa3915748();
    const inSSRSetup = $e4ce0b703119af2d$var$isInSSRComponentSetup;
    let awaitable = getAwaitable();
    $e4ce0b703119af2d$var$unsetCurrentInstance();
    if (inSSRSetup) $e4ce0b703119af2d$var$setInSSRSetupState(false);
    const restore = ()=>{
        $e4ce0b703119af2d$var$setCurrentInstance(ctx);
        if (inSSRSetup) $e4ce0b703119af2d$var$setInSSRSetupState(true);
    };
    const cleanup = ()=>{
        if ($e4ce0b703119af2d$export$f13e630aa3915748() !== ctx) ctx.scope.off();
        $e4ce0b703119af2d$var$unsetCurrentInstance();
        if (inSSRSetup) $e4ce0b703119af2d$var$setInSSRSetupState(false);
    };
    if ((0, $6OYxp.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        restore();
        Promise.resolve().then(()=>Promise.resolve().then(cleanup));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            restore();
            Promise.resolve().then(cleanup);
        }
    ];
}
function $e4ce0b703119af2d$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $e4ce0b703119af2d$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $e4ce0b703119af2d$var$shouldCacheAccess = true;
function $e4ce0b703119af2d$var$applyOptions(instance) {
    const options = $e4ce0b703119af2d$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $e4ce0b703119af2d$var$shouldCacheAccess = false;
    if (options.beforeCreate) $e4ce0b703119af2d$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $e4ce0b703119af2d$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $6OYxp.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $6OYxp.isObject)(data)) ;
        else instance.data = (0, $36gU0.reactive)(data);
    }
    $e4ce0b703119af2d$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $6OYxp.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $6OYxp.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $6OYxp.NOOP);
        const set = !(0, $6OYxp.isFunction)(opt) && (0, $6OYxp.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $6OYxp.NOOP);
        const c = $e4ce0b703119af2d$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$e4ce0b703119af2d$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $6OYxp.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $e4ce0b703119af2d$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $e4ce0b703119af2d$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $6OYxp.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($e4ce0b703119af2d$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($e4ce0b703119af2d$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($e4ce0b703119af2d$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($e4ce0b703119af2d$export$5876c47052fb88b1, updated);
    registerLifecycleHook($e4ce0b703119af2d$export$ba52d824b95a2154, activated);
    registerLifecycleHook($e4ce0b703119af2d$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($e4ce0b703119af2d$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($e4ce0b703119af2d$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($e4ce0b703119af2d$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($e4ce0b703119af2d$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($e4ce0b703119af2d$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($e4ce0b703119af2d$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $6OYxp.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $6OYxp.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $e4ce0b703119af2d$var$markAsyncBoundary(instance);
}
function $e4ce0b703119af2d$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $6OYxp.NOOP)) {
    if ((0, $6OYxp.isArray)(injectOptions)) injectOptions = $e4ce0b703119af2d$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $6OYxp.isObject)(opt)) {
            if ("default" in opt) injected = $e4ce0b703119af2d$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $e4ce0b703119af2d$export$a976684a0efeb93f(opt.from || key);
        } else injected = $e4ce0b703119af2d$export$a976684a0efeb93f(opt);
        if ((0, $36gU0.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $e4ce0b703119af2d$var$callHook(hook, instance, type) {
    $e4ce0b703119af2d$export$dae85862a8d94378((0, $6OYxp.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $e4ce0b703119af2d$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $e4ce0b703119af2d$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $6OYxp.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $6OYxp.isFunction)(handler)) $e4ce0b703119af2d$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $6OYxp.isFunction)(raw)) $e4ce0b703119af2d$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $6OYxp.isObject)(raw)) {
        if ((0, $6OYxp.isArray)(raw)) raw.forEach((r)=>$e4ce0b703119af2d$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $6OYxp.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $6OYxp.isFunction)(handler)) $e4ce0b703119af2d$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $e4ce0b703119af2d$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$e4ce0b703119af2d$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $e4ce0b703119af2d$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $6OYxp.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $e4ce0b703119af2d$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $e4ce0b703119af2d$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$e4ce0b703119af2d$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $e4ce0b703119af2d$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $e4ce0b703119af2d$var$internalOptionMergeStrats = {
    data: $e4ce0b703119af2d$var$mergeDataFn,
    props: $e4ce0b703119af2d$var$mergeEmitsOrPropsOptions,
    emits: $e4ce0b703119af2d$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $e4ce0b703119af2d$var$mergeObjectOptions,
    computed: $e4ce0b703119af2d$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $e4ce0b703119af2d$var$mergeAsArray,
    created: $e4ce0b703119af2d$var$mergeAsArray,
    beforeMount: $e4ce0b703119af2d$var$mergeAsArray,
    mounted: $e4ce0b703119af2d$var$mergeAsArray,
    beforeUpdate: $e4ce0b703119af2d$var$mergeAsArray,
    updated: $e4ce0b703119af2d$var$mergeAsArray,
    beforeDestroy: $e4ce0b703119af2d$var$mergeAsArray,
    beforeUnmount: $e4ce0b703119af2d$var$mergeAsArray,
    destroyed: $e4ce0b703119af2d$var$mergeAsArray,
    unmounted: $e4ce0b703119af2d$var$mergeAsArray,
    activated: $e4ce0b703119af2d$var$mergeAsArray,
    deactivated: $e4ce0b703119af2d$var$mergeAsArray,
    errorCaptured: $e4ce0b703119af2d$var$mergeAsArray,
    serverPrefetch: $e4ce0b703119af2d$var$mergeAsArray,
    // assets
    components: $e4ce0b703119af2d$var$mergeObjectOptions,
    directives: $e4ce0b703119af2d$var$mergeObjectOptions,
    // watch
    watch: $e4ce0b703119af2d$var$mergeWatchOptions,
    // provide / inject
    provide: $e4ce0b703119af2d$var$mergeDataFn,
    inject: $e4ce0b703119af2d$var$mergeInject
};
function $e4ce0b703119af2d$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $6OYxp.extend)((0, $6OYxp.isFunction)(to) ? to.call(this, this) : to, (0, $6OYxp.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $e4ce0b703119af2d$var$mergeInject(to, from) {
    return $e4ce0b703119af2d$var$mergeObjectOptions($e4ce0b703119af2d$var$normalizeInject(to), $e4ce0b703119af2d$var$normalizeInject(from));
}
function $e4ce0b703119af2d$var$normalizeInject(raw) {
    if ((0, $6OYxp.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $e4ce0b703119af2d$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $e4ce0b703119af2d$var$mergeObjectOptions(to, from) {
    return to ? (0, $6OYxp.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $e4ce0b703119af2d$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $6OYxp.isArray)(to) && (0, $6OYxp.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $6OYxp.extend)(/* @__PURE__ */ Object.create(null), $e4ce0b703119af2d$var$normalizePropsOrEmits(to), $e4ce0b703119af2d$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $e4ce0b703119af2d$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $6OYxp.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $e4ce0b703119af2d$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $e4ce0b703119af2d$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $6OYxp.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $e4ce0b703119af2d$var$uid$1 = 0;
function $e4ce0b703119af2d$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $6OYxp.isFunction)(rootComponent)) rootComponent = (0, $6OYxp.extend)({}, rootComponent);
        if (rootProps != null && !(0, $6OYxp.isObject)(rootProps)) rootProps = null;
        const context = $e4ce0b703119af2d$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $e4ce0b703119af2d$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $e4ce0b703119af2d$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $6OYxp.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $6OYxp.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $e4ce0b703119af2d$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $e4ce0b703119af2d$var$devtoolsInitApp(app, $e4ce0b703119af2d$export$83d89fbfd8236492);
                    }
                    return $e4ce0b703119af2d$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $e4ce0b703119af2d$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $e4ce0b703119af2d$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $e4ce0b703119af2d$var$currentApp;
                $e4ce0b703119af2d$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $e4ce0b703119af2d$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $e4ce0b703119af2d$var$currentApp = null;
function $e4ce0b703119af2d$export$fb78bd113157f1a1(props, name, options = (0, $6OYxp.EMPTY_OBJ)) {
    const i = $e4ce0b703119af2d$export$f13e630aa3915748();
    const camelizedName = (0, $6OYxp.camelize)(name);
    const hyphenatedName = (0, $6OYxp.hyphenate)(name);
    const modifiers = $e4ce0b703119af2d$var$getModelModifiers(props, camelizedName);
    const res = (0, $36gU0.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $6OYxp.EMPTY_OBJ);
        let prevEmittedValue;
        $e4ce0b703119af2d$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $6OYxp.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $6OYxp.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $6OYxp.EMPTY_OBJ) && (0, $6OYxp.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                const hasVModel = !!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps));
                if (!hasVModel) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $6OYxp.hasChanged)(value, prevSetValue) && ((0, $6OYxp.hasChanged)(value, emittedValue) && !(0, $6OYxp.hasChanged)(emittedValue, prevEmittedValue) || // #13524: browsers differ in when they flush microtasks between
                // event listeners. If a v-model listener emits an intermediate value
                // and a following listener restores the model to its previous prop
                // value before parent updates are flushed, the parent render can be
                // deduped as having no prop change. Force a local update so DOM state
                // such as an input's value is synchronized back to the current model.
                hasVModel && prevSetValue !== (0, $6OYxp.EMPTY_OBJ) && !(0, $6OYxp.hasChanged)(emittedValue, localValue))) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $6OYxp.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $e4ce0b703119af2d$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $6OYxp.camelize)(modelName)}Modifiers`] || props[`${(0, $6OYxp.hyphenate)(modelName)}Modifiers`];
};
function $e4ce0b703119af2d$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $6OYxp.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $e4ce0b703119af2d$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $6OYxp.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = args.map((0, $6OYxp.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $e4ce0b703119af2d$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $6OYxp.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $6OYxp.toHandlerKey)((0, $6OYxp.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $6OYxp.toHandlerKey)((0, $6OYxp.hyphenate)(event))];
    if (handler) $e4ce0b703119af2d$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $e4ce0b703119af2d$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
const $e4ce0b703119af2d$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $e4ce0b703119af2d$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $e4ce0b703119af2d$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $6OYxp.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $e4ce0b703119af2d$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $6OYxp.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $6OYxp.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $6OYxp.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $6OYxp.extend)(normalized, raw);
    if ((0, $6OYxp.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $e4ce0b703119af2d$var$isEmitListener(options, key) {
    if (!options || !(0, $6OYxp.isOn)(key)) return false;
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return (0, $6OYxp.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $6OYxp.hasOwn)(options, (0, $6OYxp.hyphenate)(key)) || (0, $6OYxp.hasOwn)(options, key);
}
let $e4ce0b703119af2d$var$accessedAttrs = false;
function $e4ce0b703119af2d$var$markAttrsAccessed() {
    $e4ce0b703119af2d$var$accessedAttrs = true;
}
function $e4ce0b703119af2d$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $e4ce0b703119af2d$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $e4ce0b703119af2d$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $e4ce0b703119af2d$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $e4ce0b703119af2d$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $e4ce0b703119af2d$var$blockStack.length = 0;
        $e4ce0b703119af2d$export$d3da1ecaf1206c58(err, instance, 1);
        result = $e4ce0b703119af2d$export$bf5c4cf060303d58($e4ce0b703119af2d$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $6OYxp.isModelListener))) fallthroughAttrs = $e4ce0b703119af2d$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $e4ce0b703119af2d$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $e4ce0b703119af2d$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        const child = $e4ce0b703119af2d$var$isTeleport(root.type) ? $e4ce0b703119af2d$var$getInnerChild$1(root) || root : root;
        $e4ce0b703119af2d$export$7770a22486565649(child, vnode.transition);
    }
    result = root;
    $e4ce0b703119af2d$var$setCurrentRenderingInstance(prev);
    return result;
}
const $e4ce0b703119af2d$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $e4ce0b703119af2d$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $e4ce0b703119af2d$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $e4ce0b703119af2d$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($e4ce0b703119af2d$export$3868d13f8734ae81(child)) {
            if (child.type !== $e4ce0b703119af2d$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $e4ce0b703119af2d$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $6OYxp.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $e4ce0b703119af2d$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $6OYxp.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $e4ce0b703119af2d$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $e4ce0b703119af2d$export$4d299b491347818a;
};
function $e4ce0b703119af2d$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $e4ce0b703119af2d$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($e4ce0b703119af2d$var$hasPropValueChanged(nextProps, prevProps, key) && !$e4ce0b703119af2d$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $e4ce0b703119af2d$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $e4ce0b703119af2d$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if ($e4ce0b703119af2d$var$hasPropValueChanged(nextProps, prevProps, key) && !$e4ce0b703119af2d$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $e4ce0b703119af2d$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $6OYxp.isObject)(nextProp) && (0, $6OYxp.isObject)(prevProp)) return !(0, $6OYxp.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $e4ce0b703119af2d$var$updateHOCHostEl({ vnode: vnode, parent: parent, suspense: suspense }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
const $e4ce0b703119af2d$var$internalObjectProto = {};
const $e4ce0b703119af2d$var$createInternalObject = ()=>Object.create($e4ce0b703119af2d$var$internalObjectProto);
const $e4ce0b703119af2d$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $e4ce0b703119af2d$var$internalObjectProto;
function $e4ce0b703119af2d$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $e4ce0b703119af2d$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $e4ce0b703119af2d$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $36gU0.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $e4ce0b703119af2d$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $e4ce0b703119af2d$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $36gU0.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($e4ce0b703119af2d$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $6OYxp.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $6OYxp.camelize)(key);
                        props[camelizedKey] = $e4ce0b703119af2d$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($e4ce0b703119af2d$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $6OYxp.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $6OYxp.hyphenate)(key)) === key || !(0, $6OYxp.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $e4ce0b703119af2d$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $6OYxp.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $36gU0.trigger)(instance.attrs, "set", "");
}
function $e4ce0b703119af2d$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $6OYxp.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $6OYxp.hasOwn)(options, camelKey = (0, $6OYxp.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$e4ce0b703119af2d$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $36gU0.toRaw)(props);
        const castValues = rawCastValues || (0, $6OYxp.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $e4ce0b703119af2d$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $6OYxp.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $e4ce0b703119af2d$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $6OYxp.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $6OYxp.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $e4ce0b703119af2d$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $6OYxp.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $e4ce0b703119af2d$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $e4ce0b703119af2d$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $e4ce0b703119af2d$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $6OYxp.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $e4ce0b703119af2d$var$normalizePropsOptions(raw2, appContext, true);
            (0, $6OYxp.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $6OYxp.isObject)(comp)) cache.set(comp, (0, $6OYxp.EMPTY_ARR));
        return 0, $6OYxp.EMPTY_ARR;
    }
    if ((0, $6OYxp.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $6OYxp.camelize)(raw[i]);
        if ($e4ce0b703119af2d$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $6OYxp.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $6OYxp.camelize)(key);
        if ($e4ce0b703119af2d$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $6OYxp.isArray)(opt) || (0, $6OYxp.isFunction)(opt) ? {
                type: opt
            } : (0, $6OYxp.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $6OYxp.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $6OYxp.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $6OYxp.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $6OYxp.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $6OYxp.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $e4ce0b703119af2d$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $6OYxp.isReservedProp)(key)) return true;
    return false;
}
function $e4ce0b703119af2d$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $e4ce0b703119af2d$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $36gU0.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $6OYxp.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $e4ce0b703119af2d$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $e4ce0b703119af2d$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $e4ce0b703119af2d$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $6OYxp.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $e4ce0b703119af2d$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $e4ce0b703119af2d$var$warn$1($e4ce0b703119af2d$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $e4ce0b703119af2d$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $e4ce0b703119af2d$var$isSimpleType = /* @__PURE__ */ (0, $6OYxp.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $e4ce0b703119af2d$var$assertType(value, type) {
    let valid;
    const expectedType = $e4ce0b703119af2d$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($e4ce0b703119af2d$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $6OYxp.isObject)(value);
    else if (expectedType === "Array") valid = (0, $6OYxp.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $e4ce0b703119af2d$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $6OYxp.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $6OYxp.toRawType)(value);
    const expectedValue = $e4ce0b703119af2d$var$styleValue(value, expectedType);
    const receivedValue = $e4ce0b703119af2d$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $e4ce0b703119af2d$var$isExplicable(expectedType) && $e4ce0b703119af2d$var$isCoercible(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($e4ce0b703119af2d$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $e4ce0b703119af2d$var$styleValue(value, type) {
    if ((0, $6OYxp.isSymbol)(value)) return value.toString();
    else if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $e4ce0b703119af2d$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $e4ce0b703119af2d$var$isCoercible(...args) {
    return args.every((elem)=>{
        const value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
const $e4ce0b703119af2d$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $e4ce0b703119af2d$var$normalizeSlotValue = (value)=>(0, $6OYxp.isArray)(value) ? value.map($e4ce0b703119af2d$var$normalizeVNode) : [
        $e4ce0b703119af2d$var$normalizeVNode(value)
    ];
const $e4ce0b703119af2d$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $e4ce0b703119af2d$export$694b237e827a3d23((...args)=>{
        return $e4ce0b703119af2d$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $e4ce0b703119af2d$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($e4ce0b703119af2d$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $6OYxp.isFunction)(value)) slots[key] = $e4ce0b703119af2d$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $e4ce0b703119af2d$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $e4ce0b703119af2d$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $e4ce0b703119af2d$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $e4ce0b703119af2d$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$e4ce0b703119af2d$var$isInternalKey(key)) slots[key] = children[key];
};
const $e4ce0b703119af2d$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $e4ce0b703119af2d$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $e4ce0b703119af2d$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $6OYxp.def)(slots, "_", type, true);
        } else $e4ce0b703119af2d$var$normalizeObjectSlots(children, slots);
    } else if (children) $e4ce0b703119af2d$var$normalizeVNodeSlots(instance, children);
};
const $e4ce0b703119af2d$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $6OYxp.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $e4ce0b703119af2d$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $e4ce0b703119af2d$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $e4ce0b703119af2d$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$e4ce0b703119af2d$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $e4ce0b703119af2d$var$supported;
let $e4ce0b703119af2d$var$perf;
function $e4ce0b703119af2d$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $e4ce0b703119af2d$var$isSupported()) $e4ce0b703119af2d$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $e4ce0b703119af2d$var$devtoolsPerfStart(instance, type, $e4ce0b703119af2d$var$isSupported() ? $e4ce0b703119af2d$var$perf.now() : Date.now());
}
function $e4ce0b703119af2d$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $e4ce0b703119af2d$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$e4ce0b703119af2d$var$formatComponentName(instance, instance.type)}> ${type}`;
        $e4ce0b703119af2d$var$perf.mark(endTag);
        $e4ce0b703119af2d$var$perf.measure(measureName, startTag, endTag);
        $e4ce0b703119af2d$var$perf.clearMeasures(measureName);
        $e4ce0b703119af2d$var$perf.clearMarks(startTag);
        $e4ce0b703119af2d$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $e4ce0b703119af2d$var$devtoolsPerfEnd(instance, type, $e4ce0b703119af2d$var$isSupported() ? $e4ce0b703119af2d$var$perf.now() : Date.now());
}
function $e4ce0b703119af2d$var$isSupported() {
    if ($e4ce0b703119af2d$var$supported !== void 0) return $e4ce0b703119af2d$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $e4ce0b703119af2d$var$supported = true;
        $e4ce0b703119af2d$var$perf = window.performance;
    } else $e4ce0b703119af2d$var$supported = false;
    return $e4ce0b703119af2d$var$supported;
}
function $e4ce0b703119af2d$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $6OYxp.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $6OYxp.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $6OYxp.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $e4ce0b703119af2d$var$queuePostRenderEffect = $e4ce0b703119af2d$var$queueEffectWithSuspense;
function $e4ce0b703119af2d$export$53ae2f996c64e9a(options) {
    return $e4ce0b703119af2d$var$baseCreateRenderer(options);
}
function $e4ce0b703119af2d$export$200524cf0d997ff0(options) {
    return $e4ce0b703119af2d$var$baseCreateRenderer(options, $e4ce0b703119af2d$var$createHydrationFunctions);
}
function $e4ce0b703119af2d$var$baseCreateRenderer(options, createHydrationFns) {
    $e4ce0b703119af2d$var$initFeatureFlags();
    const target = (0, $6OYxp.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $e4ce0b703119af2d$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $6OYxp.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$e4ce0b703119af2d$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $e4ce0b703119af2d$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $e4ce0b703119af2d$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $e4ce0b703119af2d$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $e4ce0b703119af2d$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $e4ce0b703119af2d$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $e4ce0b703119af2d$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $e4ce0b703119af2d$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $e4ce0b703119af2d$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $6OYxp.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $6OYxp.def)(el, "__vnode", vnode, true);
            (0, $6OYxp.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $e4ce0b703119af2d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $e4ce0b703119af2d$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            const isHmr = false;
            $e4ce0b703119af2d$var$queuePostRenderEffect(()=>{
                let prev;
                vnodeHook && $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $e4ce0b703119af2d$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $e4ce0b703119af2d$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $e4ce0b703119af2d$var$cloneIfMounted(children[i]) : $e4ce0b703119af2d$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $6OYxp.EMPTY_OBJ);
        const newProps = n2.props || (0, $6OYxp.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $e4ce0b703119af2d$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $e4ce0b703119af2d$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $e4ce0b703119af2d$var$toggleRecurse(parentComponent, true);
        if (// #6385 the old vnode may be a user-wrapped non-isomorphic block
        // Force full diff when block metadata is unstable.
        dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $e4ce0b703119af2d$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $e4ce0b703119af2d$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $e4ce0b703119af2d$var$queuePostRenderEffect(()=>{
            vnodeHook && $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $e4ce0b703119af2d$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $e4ce0b703119af2d$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$e4ce0b703119af2d$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $6OYxp.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $6OYxp.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $6OYxp.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $e4ce0b703119af2d$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $e4ce0b703119af2d$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($e4ce0b703119af2d$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $e4ce0b703119af2d$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $e4ce0b703119af2d$export$bf5c4cf060303d58($e4ce0b703119af2d$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($e4ce0b703119af2d$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $e4ce0b703119af2d$var$isAsyncWrapper(initialVNode);
                $e4ce0b703119af2d$var$toggleRecurse(instance, false);
                if (bm) (0, $6OYxp.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $e4ce0b703119af2d$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $e4ce0b703119af2d$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = $e4ce0b703119af2d$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $e4ce0b703119af2d$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $e4ce0b703119af2d$var$queuePostRenderEffect(()=>$e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $e4ce0b703119af2d$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $e4ce0b703119af2d$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $e4ce0b703119af2d$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $e4ce0b703119af2d$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $e4ce0b703119af2d$var$queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $e4ce0b703119af2d$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $6OYxp.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $e4ce0b703119af2d$var$toggleRecurse(instance, true);
                const nextTree = $e4ce0b703119af2d$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $e4ce0b703119af2d$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $e4ce0b703119af2d$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $e4ce0b703119af2d$var$queuePostRenderEffect(()=>$e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $e4ce0b703119af2d$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $36gU0.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$e4ce0b703119af2d$var$queueJob(job);
        $e4ce0b703119af2d$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $e4ce0b703119af2d$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $e4ce0b703119af2d$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $36gU0.pauseTracking)();
        $e4ce0b703119af2d$var$flushPreFlushCbs(instance);
        (0, $36gU0.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $6OYxp.EMPTY_ARR);
        c2 = c2 || (0, $6OYxp.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $e4ce0b703119af2d$var$cloneIfMounted(c2[i]) : $e4ce0b703119af2d$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $e4ce0b703119af2d$var$cloneIfMounted(c2[i]) : $e4ce0b703119af2d$var$normalizeVNode(c2[i]);
            if ($e4ce0b703119af2d$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $e4ce0b703119af2d$var$cloneIfMounted(c2[e2]) : $e4ce0b703119af2d$var$normalizeVNode(c2[e2]);
            if ($e4ce0b703119af2d$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $e4ce0b703119af2d$var$cloneIfMounted(c2[i]) : $e4ce0b703119af2d$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $e4ce0b703119af2d$var$cloneIfMounted(c2[i]) : $e4ce0b703119af2d$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $e4ce0b703119af2d$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $e4ce0b703119af2d$var$getSequence(newIndexToOldIndexMap) : (0, $6OYxp.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || $e4ce0b703119af2d$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $e4ce0b703119af2d$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $e4ce0b703119af2d$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                if (transition.persisted && !el[$e4ce0b703119af2d$var$leaveCbKey]) hostInsert(el, container, anchor);
                else {
                    transition.beforeEnter(el);
                    hostInsert(el, container, anchor);
                    $e4ce0b703119af2d$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
                }
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    const wasLeaving = el._isLeaving || !!el[$e4ce0b703119af2d$var$leaveCbKey];
                    if (el._isLeaving) el[$e4ce0b703119af2d$var$leaveCbKey](true);
                    if (transition.persisted && !wasLeaving) remove2();
                    else leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex, memo: memo } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $36gU0.pauseTracking)();
            $e4ce0b703119af2d$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $36gU0.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$e4ce0b703119af2d$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $e4ce0b703119af2d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $e4ce0b703119af2d$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $e4ce0b703119af2d$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $e4ce0b703119af2d$var$queuePostRenderEffect(()=>{
            vnodeHook && $e4ce0b703119af2d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $e4ce0b703119af2d$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $e4ce0b703119af2d$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $e4ce0b703119af2d$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $e4ce0b703119af2d$var$invalidateMount(m);
        $e4ce0b703119af2d$var$invalidateMount(a);
        if (bum) (0, $6OYxp.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $e4ce0b703119af2d$var$queuePostRenderEffect(um, parentSuspense);
        $e4ce0b703119af2d$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $e4ce0b703119af2d$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$e4ce0b703119af2d$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        let instance;
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
                instance = container._vnode.component;
            }
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $e4ce0b703119af2d$var$flushPreFlushCbs(instance);
            $e4ce0b703119af2d$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $e4ce0b703119af2d$var$createAppAPI(render, hydrate)
    };
}
function $e4ce0b703119af2d$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $e4ce0b703119af2d$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $e4ce0b703119af2d$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $e4ce0b703119af2d$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $6OYxp.isArray)(ch1) && (0, $6OYxp.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $e4ce0b703119af2d$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $e4ce0b703119af2d$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $e4ce0b703119af2d$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $e4ce0b703119af2d$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $e4ce0b703119af2d$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $e4ce0b703119af2d$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $e4ce0b703119af2d$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $e4ce0b703119af2d$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $e4ce0b703119af2d$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function $e4ce0b703119af2d$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $e4ce0b703119af2d$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const $e4ce0b703119af2d$var$isSuspense = (type)=>type.__isSuspense;
let $e4ce0b703119af2d$var$suspenseId = 0;
const $e4ce0b703119af2d$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $e4ce0b703119af2d$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $e4ce0b703119af2d$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $e4ce0b703119af2d$var$hydrateSuspense,
    normalize: $e4ce0b703119af2d$var$normalizeSuspenseChildren
};
const $e4ce0b703119af2d$export$74bf444e3cd11ea5 = $e4ce0b703119af2d$var$SuspenseImpl;
function $e4ce0b703119af2d$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $6OYxp.isFunction)(eventListener)) eventListener();
}
function $e4ce0b703119af2d$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $e4ce0b703119af2d$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $e4ce0b703119af2d$var$triggerEvent(vnode, "onPending");
        $e4ce0b703119af2d$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $e4ce0b703119af2d$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $e4ce0b703119af2d$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($e4ce0b703119af2d$var$isSameVNodeType(pendingBranch, newBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating && !suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $e4ce0b703119af2d$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $e4ce0b703119af2d$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else if (!suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $e4ce0b703119af2d$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $e4ce0b703119af2d$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $e4ce0b703119af2d$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $e4ce0b703119af2d$var$setActiveBranch(suspense, newBranch);
    } else {
        $e4ce0b703119af2d$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $e4ce0b703119af2d$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $e4ce0b703119af2d$var$hasWarned = false;
function $e4ce0b703119af2d$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $e4ce0b703119af2d$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $6OYxp.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $e4ce0b703119af2d$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                let hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0);
                        $e4ce0b703119af2d$export$59536a0199721cab(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container2) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) $e4ce0b703119af2d$var$queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            suspense.isFallbackMountPending = false;
            $e4ce0b703119af2d$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    for(let i = 0; i < effects.length; i++)parent.effects.push(effects[i]);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $e4ce0b703119af2d$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $e4ce0b703119af2d$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $e4ce0b703119af2d$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                const latestFallback = suspense.vnode.ssFallback;
                patch(null, latestFallback, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $e4ce0b703119af2d$var$setActiveBranch(suspense, latestFallback);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $e4ce0b703119af2d$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $e4ce0b703119af2d$var$unsetCurrentInstance();
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $e4ce0b703119af2d$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                $e4ce0b703119af2d$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $e4ce0b703119af2d$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $e4ce0b703119af2d$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $e4ce0b703119af2d$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $e4ce0b703119af2d$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $e4ce0b703119af2d$var$normalizeSuspenseSlot(children.fallback) : $e4ce0b703119af2d$export$bf5c4cf060303d58($e4ce0b703119af2d$export$4d299b491347818a);
}
function $e4ce0b703119af2d$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $6OYxp.isFunction)(s)) {
        const trackBlock = $e4ce0b703119af2d$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $e4ce0b703119af2d$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $e4ce0b703119af2d$var$currentBlock;
            $e4ce0b703119af2d$var$closeBlock();
        }
    }
    if ((0, $6OYxp.isArray)(s)) {
        const singleChild = $e4ce0b703119af2d$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $e4ce0b703119af2d$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $e4ce0b703119af2d$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $6OYxp.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $e4ce0b703119af2d$export$59536a0199721cab(fn);
}
function $e4ce0b703119af2d$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $e4ce0b703119af2d$var$updateHOCHostEl(parentComponent, el);
    }
}
function $e4ce0b703119af2d$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $e4ce0b703119af2d$export$ffb0004e005737fa = /* @__PURE__ */ Symbol.for("v-fgt");
const $e4ce0b703119af2d$export$5f1af8db9871e1d6 = /* @__PURE__ */ Symbol.for("v-txt");
const $e4ce0b703119af2d$export$4d299b491347818a = /* @__PURE__ */ Symbol.for("v-cmt");
const $e4ce0b703119af2d$export$c1b9a1d3af45b7b6 = /* @__PURE__ */ Symbol.for("v-stc");
const $e4ce0b703119af2d$var$blockStack = [];
let $e4ce0b703119af2d$var$currentBlock = null;
function $e4ce0b703119af2d$export$e7eaa45e502fe5cc(disableTracking = false) {
    $e4ce0b703119af2d$var$blockStack.push($e4ce0b703119af2d$var$currentBlock = disableTracking ? null : []);
}
function $e4ce0b703119af2d$var$closeBlock() {
    $e4ce0b703119af2d$var$blockStack.pop();
    $e4ce0b703119af2d$var$currentBlock = $e4ce0b703119af2d$var$blockStack[$e4ce0b703119af2d$var$blockStack.length - 1] || null;
}
let $e4ce0b703119af2d$var$isBlockTreeEnabled = 1;
function $e4ce0b703119af2d$export$c20bee82f26f1e27(value, inVOnce = false) {
    $e4ce0b703119af2d$var$isBlockTreeEnabled += value;
    if (value < 0 && $e4ce0b703119af2d$var$currentBlock && inVOnce) $e4ce0b703119af2d$var$currentBlock.hasOnce = true;
}
function $e4ce0b703119af2d$var$setupBlock(vnode) {
    vnode.dynamicChildren = $e4ce0b703119af2d$var$isBlockTreeEnabled > 0 ? $e4ce0b703119af2d$var$currentBlock || (0, $6OYxp.EMPTY_ARR) : null;
    $e4ce0b703119af2d$var$closeBlock();
    if ($e4ce0b703119af2d$var$isBlockTreeEnabled > 0 && $e4ce0b703119af2d$var$currentBlock) $e4ce0b703119af2d$var$currentBlock.push(vnode);
    return vnode;
}
function $e4ce0b703119af2d$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $e4ce0b703119af2d$var$setupBlock($e4ce0b703119af2d$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $e4ce0b703119af2d$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $e4ce0b703119af2d$var$setupBlock($e4ce0b703119af2d$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $e4ce0b703119af2d$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $e4ce0b703119af2d$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $e4ce0b703119af2d$var$vnodeArgsTransformer;
function $e4ce0b703119af2d$export$83beccd3afeeb809(transformer) {
    $e4ce0b703119af2d$var$vnodeArgsTransformer = transformer;
}
const $e4ce0b703119af2d$var$createVNodeWithArgsTransform = (...args)=>{
    return $e4ce0b703119af2d$var$_createVNode(...$e4ce0b703119af2d$var$vnodeArgsTransformer ? $e4ce0b703119af2d$var$vnodeArgsTransformer(args, $e4ce0b703119af2d$var$currentRenderingInstance) : args);
};
const $e4ce0b703119af2d$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $e4ce0b703119af2d$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $6OYxp.isString)(ref) || (0, $36gU0.isRef)(ref) || (0, $6OYxp.isFunction)(ref) ? {
        i: $e4ce0b703119af2d$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $e4ce0b703119af2d$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $e4ce0b703119af2d$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $e4ce0b703119af2d$var$normalizeKey(props),
        ref: props && $e4ce0b703119af2d$var$normalizeRef(props),
        scopeId: $e4ce0b703119af2d$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $e4ce0b703119af2d$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $e4ce0b703119af2d$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $6OYxp.isString)(children) ? 8 : 16;
    if ($e4ce0b703119af2d$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $e4ce0b703119af2d$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $e4ce0b703119af2d$var$currentBlock.push(vnode);
    return vnode;
}
function $e4ce0b703119af2d$var$hasContentChildren(children) {
    if ((0, $6OYxp.isString)(children)) return children !== "";
    if ((0, $6OYxp.isArray)(children)) return children.length > 0;
    return false;
}
const $e4ce0b703119af2d$export$bf5c4cf060303d58 = $e4ce0b703119af2d$var$_createVNode;
function $e4ce0b703119af2d$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $e4ce0b703119af2d$var$NULL_DYNAMIC_COMPONENT) type = $e4ce0b703119af2d$export$4d299b491347818a;
    if ($e4ce0b703119af2d$export$3868d13f8734ae81(type)) {
        const cloned = $e4ce0b703119af2d$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $e4ce0b703119af2d$var$normalizeChildren(cloned, children);
        if ($e4ce0b703119af2d$var$isBlockTreeEnabled > 0 && !isBlockNode && $e4ce0b703119af2d$var$currentBlock) {
            if (cloned.shapeFlag & 6) $e4ce0b703119af2d$var$currentBlock[$e4ce0b703119af2d$var$currentBlock.indexOf(type)] = cloned;
            else $e4ce0b703119af2d$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($e4ce0b703119af2d$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $e4ce0b703119af2d$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $6OYxp.isString)(klass)) props.class = (0, $6OYxp.normalizeClass)(klass);
        if ((0, $6OYxp.isObject)(style)) {
            if ((0, $36gU0.isProxy)(style) && !(0, $6OYxp.isArray)(style)) style = (0, $6OYxp.extend)({}, style);
            props.style = (0, $6OYxp.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $6OYxp.isString)(type) ? 1 : $e4ce0b703119af2d$var$isSuspense(type) ? 128 : $e4ce0b703119af2d$var$isTeleport(type) ? 64 : (0, $6OYxp.isObject)(type) ? 4 : (0, $6OYxp.isFunction)(type) ? 2 : 0;
    return $e4ce0b703119af2d$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $e4ce0b703119af2d$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $36gU0.isProxy)(props) || $e4ce0b703119af2d$var$isInternalObject(props) ? (0, $6OYxp.extend)({}, props) : props;
}
function $e4ce0b703119af2d$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $e4ce0b703119af2d$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $e4ce0b703119af2d$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $6OYxp.isArray)(ref) ? ref.concat($e4ce0b703119af2d$var$normalizeRef(extraProps)) : [
            ref,
            $e4ce0b703119af2d$var$normalizeRef(extraProps)
        ] : $e4ce0b703119af2d$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $e4ce0b703119af2d$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $e4ce0b703119af2d$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $e4ce0b703119af2d$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $e4ce0b703119af2d$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $e4ce0b703119af2d$var$deepCloneVNode(vnode) {
    const cloned = $e4ce0b703119af2d$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $6OYxp.isArray)(vnode.children)) cloned.children = vnode.children.map($e4ce0b703119af2d$var$deepCloneVNode);
    return cloned;
}
function $e4ce0b703119af2d$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $e4ce0b703119af2d$export$bf5c4cf060303d58($e4ce0b703119af2d$export$5f1af8db9871e1d6, null, text, flag);
}
function $e4ce0b703119af2d$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $e4ce0b703119af2d$export$bf5c4cf060303d58($e4ce0b703119af2d$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $e4ce0b703119af2d$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($e4ce0b703119af2d$export$e7eaa45e502fe5cc(), $e4ce0b703119af2d$export$9f2dfe8048dfb22b($e4ce0b703119af2d$export$4d299b491347818a, null, text)) : $e4ce0b703119af2d$export$bf5c4cf060303d58($e4ce0b703119af2d$export$4d299b491347818a, null, text);
}
function $e4ce0b703119af2d$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $e4ce0b703119af2d$export$bf5c4cf060303d58($e4ce0b703119af2d$export$4d299b491347818a);
    else if ((0, $6OYxp.isArray)(child)) return $e4ce0b703119af2d$export$bf5c4cf060303d58($e4ce0b703119af2d$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($e4ce0b703119af2d$export$3868d13f8734ae81(child)) return $e4ce0b703119af2d$var$cloneIfMounted(child);
    else return $e4ce0b703119af2d$export$bf5c4cf060303d58($e4ce0b703119af2d$export$5f1af8db9871e1d6, null, String(child));
}
function $e4ce0b703119af2d$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $e4ce0b703119af2d$export$ee4f9e12c0a92a1a(child);
}
function $e4ce0b703119af2d$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $6OYxp.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $e4ce0b703119af2d$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$e4ce0b703119af2d$var$isInternalObject(children)) children._ctx = $e4ce0b703119af2d$var$currentRenderingInstance;
            else if (slotFlag === 3 && $e4ce0b703119af2d$var$currentRenderingInstance) {
                if ($e4ce0b703119af2d$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $6OYxp.isFunction)(children)) {
        if (shapeFlag & 65) {
            $e4ce0b703119af2d$var$normalizeChildren(vnode, {
                default: children
            });
            return;
        }
        children = {
            default: children,
            _ctx: $e4ce0b703119af2d$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $e4ce0b703119af2d$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $e4ce0b703119af2d$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $6OYxp.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $6OYxp.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $6OYxp.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $6OYxp.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
                else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
                // the model listener.
                !(0, $6OYxp.isModelListener)(key)) ret[key] = incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $e4ce0b703119af2d$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $e4ce0b703119af2d$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $e4ce0b703119af2d$var$emptyAppContext = $e4ce0b703119af2d$var$createAppContext();
let $e4ce0b703119af2d$var$uid = 0;
function $e4ce0b703119af2d$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $e4ce0b703119af2d$var$emptyAppContext;
    const instance = {
        uid: $e4ce0b703119af2d$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $36gU0.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $e4ce0b703119af2d$var$normalizePropsOptions(type, appContext),
        emitsOptions: $e4ce0b703119af2d$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $6OYxp.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $6OYxp.EMPTY_OBJ),
        data: (0, $6OYxp.EMPTY_OBJ),
        props: (0, $6OYxp.EMPTY_OBJ),
        attrs: (0, $6OYxp.EMPTY_OBJ),
        slots: (0, $6OYxp.EMPTY_OBJ),
        refs: (0, $6OYxp.EMPTY_OBJ),
        setupState: (0, $6OYxp.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $e4ce0b703119af2d$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $e4ce0b703119af2d$var$currentInstance = null;
const $e4ce0b703119af2d$export$f13e630aa3915748 = ()=>$e4ce0b703119af2d$var$currentInstance || $e4ce0b703119af2d$var$currentRenderingInstance;
let $e4ce0b703119af2d$var$internalSetCurrentInstance;
let $e4ce0b703119af2d$var$setInSSRSetupState;
{
    const g = (0, $6OYxp.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $e4ce0b703119af2d$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$e4ce0b703119af2d$var$currentInstance = v1);
    $e4ce0b703119af2d$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$e4ce0b703119af2d$var$isInSSRComponentSetup = v1);
}const $e4ce0b703119af2d$var$setCurrentInstance = (instance)=>{
    const prev = $e4ce0b703119af2d$var$currentInstance;
    $e4ce0b703119af2d$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $e4ce0b703119af2d$var$internalSetCurrentInstance(prev);
    };
};
const $e4ce0b703119af2d$var$unsetCurrentInstance = ()=>{
    $e4ce0b703119af2d$var$currentInstance && $e4ce0b703119af2d$var$currentInstance.scope.off();
    $e4ce0b703119af2d$var$internalSetCurrentInstance(null);
};
const $e4ce0b703119af2d$var$isBuiltInTag = /* @__PURE__ */ (0, $6OYxp.makeMap)("slot,component");
function $e4ce0b703119af2d$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($e4ce0b703119af2d$var$isBuiltInTag(name) || isNativeTag(name)) $e4ce0b703119af2d$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $e4ce0b703119af2d$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $e4ce0b703119af2d$var$isInSSRComponentSetup = false;
function $e4ce0b703119af2d$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $e4ce0b703119af2d$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $e4ce0b703119af2d$var$isStatefulComponent(instance);
    $e4ce0b703119af2d$var$initProps(instance, props, isStateful, isSSR);
    $e4ce0b703119af2d$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $e4ce0b703119af2d$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $e4ce0b703119af2d$var$setInSSRSetupState(false);
    return setupResult;
}
function $e4ce0b703119af2d$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $e4ce0b703119af2d$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $36gU0.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $e4ce0b703119af2d$var$createSetupContext(instance) : null;
        const reset = $e4ce0b703119af2d$var$setCurrentInstance(instance);
        const setupResult = $e4ce0b703119af2d$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $6OYxp.isPromise)(setupResult);
        (0, $36gU0.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$e4ce0b703119af2d$var$isAsyncWrapper(instance)) $e4ce0b703119af2d$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($e4ce0b703119af2d$var$unsetCurrentInstance, $e4ce0b703119af2d$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $e4ce0b703119af2d$var$setInSSRSetupState(true);
                try {
                    $e4ce0b703119af2d$var$handleSetupResult(instance, resolvedResult, isSSR);
                } finally{
                    $e4ce0b703119af2d$var$setInSSRSetupState(false);
                }
            }).catch((e)=>{
                $e4ce0b703119af2d$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $e4ce0b703119af2d$var$handleSetupResult(instance, setupResult, isSSR);
    } else $e4ce0b703119af2d$var$finishComponentSetup(instance, isSSR);
}
function $e4ce0b703119af2d$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $6OYxp.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $6OYxp.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $36gU0.proxyRefs)(setupResult);
    }
    $e4ce0b703119af2d$var$finishComponentSetup(instance, isSSR);
}
let $e4ce0b703119af2d$var$compile;
let $e4ce0b703119af2d$var$installWithProxy;
function $e4ce0b703119af2d$export$667bb5a67822b941(_compile) {
    $e4ce0b703119af2d$var$compile = _compile;
    $e4ce0b703119af2d$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $e4ce0b703119af2d$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $e4ce0b703119af2d$export$c93a9c496c5211fa = ()=>!$e4ce0b703119af2d$var$compile;
function $e4ce0b703119af2d$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $e4ce0b703119af2d$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $e4ce0b703119af2d$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $6OYxp.extend)((0, $6OYxp.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $e4ce0b703119af2d$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $6OYxp.NOOP);
        if ($e4ce0b703119af2d$var$installWithProxy) $e4ce0b703119af2d$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $e4ce0b703119af2d$var$setCurrentInstance(instance);
        (0, $36gU0.pauseTracking)();
        try {
            $e4ce0b703119af2d$var$applyOptions(instance);
        } finally{
            (0, $36gU0.resetTracking)();
            reset();
        }
    }
}
const $e4ce0b703119af2d$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $36gU0.track)(target, "get", "");
        return target[key];
    }
};
function $e4ce0b703119af2d$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $36gU0.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $e4ce0b703119af2d$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $e4ce0b703119af2d$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $e4ce0b703119af2d$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $36gU0.proxyRefs)((0, $36gU0.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $e4ce0b703119af2d$var$publicPropertiesMap) return $e4ce0b703119af2d$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $e4ce0b703119af2d$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $e4ce0b703119af2d$var$classifyRE = /(?:^|[-_])\w/g;
const $e4ce0b703119af2d$var$classify = (str)=>str.replace($e4ce0b703119af2d$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $e4ce0b703119af2d$var$getComponentName(Component, includeInferred = true) {
    return (0, $6OYxp.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $e4ce0b703119af2d$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $e4ce0b703119af2d$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $e4ce0b703119af2d$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $e4ce0b703119af2d$var$isClassComponent(value) {
    return (0, $6OYxp.isFunction)(value) && "__vccOpts" in value;
}
const $e4ce0b703119af2d$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $36gU0.computed)(getterOrOptions, debugOptions, $e4ce0b703119af2d$var$isInSSRComponentSetup);
    return c;
};
function $e4ce0b703119af2d$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $e4ce0b703119af2d$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $6OYxp.isObject)(propsOrChildren) && !(0, $6OYxp.isArray)(propsOrChildren)) {
                if ($e4ce0b703119af2d$export$3868d13f8734ae81(propsOrChildren)) return $e4ce0b703119af2d$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $e4ce0b703119af2d$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $e4ce0b703119af2d$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $e4ce0b703119af2d$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $e4ce0b703119af2d$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $e4ce0b703119af2d$export$c20bee82f26f1e27(1);
    }
}
function $e4ce0b703119af2d$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $36gU0.toRaw)(instance.props)));
        if (instance.setupState !== (0, $6OYxp.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $6OYxp.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $36gU0.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $6OYxp.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $6OYxp.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $36gU0.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $6OYxp.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $6OYxp.isArray)(opts) && opts.includes(key) || (0, $6OYxp.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $36gU0.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $e4ce0b703119af2d$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $e4ce0b703119af2d$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $e4ce0b703119af2d$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $6OYxp.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($e4ce0b703119af2d$var$isBlockTreeEnabled > 0 && $e4ce0b703119af2d$var$currentBlock) $e4ce0b703119af2d$var$currentBlock.push(cached);
    return true;
}
const $e4ce0b703119af2d$export$83d89fbfd8236492 = "3.5.42";
const $e4ce0b703119af2d$export$c106dd0671a0fc2d = (0, $6OYxp.NOOP);
const $e4ce0b703119af2d$export$795e0ad4a0e2ed30 = $e4ce0b703119af2d$var$ErrorTypeStrings$1;
const $e4ce0b703119af2d$export$6922d3b3a607469e = $e4ce0b703119af2d$var$devtools$1;
const $e4ce0b703119af2d$export$b0c258b32c26c785 = $e4ce0b703119af2d$var$setDevtoolsHook$1;
const $e4ce0b703119af2d$var$_ssrUtils = {
    createComponentInstance: $e4ce0b703119af2d$var$createComponentInstance,
    setupComponent: $e4ce0b703119af2d$var$setupComponent,
    renderComponentRoot: $e4ce0b703119af2d$var$renderComponentRoot,
    setCurrentRenderingInstance: $e4ce0b703119af2d$var$setCurrentRenderingInstance,
    isVNode: $e4ce0b703119af2d$export$3868d13f8734ae81,
    normalizeVNode: $e4ce0b703119af2d$var$normalizeVNode,
    getComponentPublicInstance: $e4ce0b703119af2d$var$getComponentPublicInstance,
    ensureValidVNode: $e4ce0b703119af2d$var$ensureValidVNode,
    pushWarningContext: $e4ce0b703119af2d$var$pushWarningContext,
    popWarningContext: $e4ce0b703119af2d$var$popWarningContext
};
const $e4ce0b703119af2d$export$a9679033567b336d = $e4ce0b703119af2d$var$_ssrUtils;
const $e4ce0b703119af2d$export$83cf26e06ea620e1 = null;
const $e4ce0b703119af2d$export$dc678eddf276286e = null;
const $e4ce0b703119af2d$export$22072a82865312f6 = null;

});
parcelRegister("36gU0", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $241f0b10d238dbe8$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $241f0b10d238dbe8$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $241f0b10d238dbe8$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $241f0b10d238dbe8$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $241f0b10d238dbe8$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $241f0b10d238dbe8$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $241f0b10d238dbe8$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $241f0b10d238dbe8$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $241f0b10d238dbe8$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $241f0b10d238dbe8$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $241f0b10d238dbe8$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $241f0b10d238dbe8$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $241f0b10d238dbe8$export$5eb48af14254449e);
$parcel$export(module.exports, "isReadonly", () => $241f0b10d238dbe8$export$92d09b48637741e7);
$parcel$export(module.exports, "isReactive", () => $241f0b10d238dbe8$export$352205f445242f02);
$parcel$export(module.exports, "toReadonly", () => $241f0b10d238dbe8$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "isProxy", () => $241f0b10d238dbe8$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $241f0b10d238dbe8$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $241f0b10d238dbe8$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $241f0b10d238dbe8$export$8d81cefd22d22260);
$parcel$export(module.exports, "markRaw", () => $241f0b10d238dbe8$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $241f0b10d238dbe8$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $241f0b10d238dbe8$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $241f0b10d238dbe8$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $241f0b10d238dbe8$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $241f0b10d238dbe8$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $241f0b10d238dbe8$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $241f0b10d238dbe8$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "computed", () => $241f0b10d238dbe8$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $241f0b10d238dbe8$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $241f0b10d238dbe8$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.42
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $6OYxp = parcelRequire("6OYxp");
function $241f0b10d238dbe8$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $241f0b10d238dbe8$var$activeEffectScope;
class $241f0b10d238dbe8$export$1168ed9dbc71ddbd {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this._warnOnRun = true;
        this.__v_skip = true;
        if (!detached && $241f0b10d238dbe8$var$activeEffectScope) {
            if ($241f0b10d238dbe8$var$activeEffectScope.active) {
                this.parent = $241f0b10d238dbe8$var$activeEffectScope;
                this.index = ($241f0b10d238dbe8$var$activeEffectScope.scopes || ($241f0b10d238dbe8$var$activeEffectScope.scopes = [])).push(this) - 1;
            } else {
                this._active = false;
                this._warnOnRun = false;
            }
        }
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].pause();
            }
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) {
                    const scopes = this.scopes.slice();
                    for(i = 0, l = scopes.length; i < l; i++)scopes[i].resume();
                }
                const effects = this.effects.slice();
                for(i = 0, l = effects.length; i < l; i++)effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $241f0b10d238dbe8$var$activeEffectScope;
            try {
                $241f0b10d238dbe8$var$activeEffectScope = this;
                return fn();
            } finally{
                $241f0b10d238dbe8$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $241f0b10d238dbe8$var$activeEffectScope;
            $241f0b10d238dbe8$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            if ($241f0b10d238dbe8$var$activeEffectScope === this) $241f0b10d238dbe8$var$activeEffectScope = this.prevScope;
            else {
                let current = $241f0b10d238dbe8$var$activeEffectScope;
                while(current){
                    if (current.prevScope === this) {
                        current.prevScope = this.prevScope;
                        break;
                    }
                    current = current.prevScope;
                }
            }
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $241f0b10d238dbe8$export$7056603ea81600be(detached) {
    return new $241f0b10d238dbe8$export$1168ed9dbc71ddbd(detached);
}
function $241f0b10d238dbe8$export$c7be4b0125a10cba() {
    return $241f0b10d238dbe8$var$activeEffectScope;
}
function $241f0b10d238dbe8$export$a780418acd4762da(fn, failSilently = false) {
    if ($241f0b10d238dbe8$var$activeEffectScope) $241f0b10d238dbe8$var$activeEffectScope.cleanups.push(fn);
}
let $241f0b10d238dbe8$var$activeSub;
const $241f0b10d238dbe8$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $241f0b10d238dbe8$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $241f0b10d238dbe8$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($241f0b10d238dbe8$var$activeEffectScope) {
            if ($241f0b10d238dbe8$var$activeEffectScope.active) $241f0b10d238dbe8$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($241f0b10d238dbe8$var$pausedQueueEffects.has(this)) {
                $241f0b10d238dbe8$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $241f0b10d238dbe8$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $241f0b10d238dbe8$var$cleanupEffect(this);
        $241f0b10d238dbe8$var$prepareDeps(this);
        const prevEffect = $241f0b10d238dbe8$var$activeSub;
        const prevShouldTrack = $241f0b10d238dbe8$var$shouldTrack;
        $241f0b10d238dbe8$var$activeSub = this;
        $241f0b10d238dbe8$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $241f0b10d238dbe8$var$cleanupDeps(this);
            $241f0b10d238dbe8$var$activeSub = prevEffect;
            $241f0b10d238dbe8$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$241f0b10d238dbe8$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $241f0b10d238dbe8$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $241f0b10d238dbe8$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($241f0b10d238dbe8$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $241f0b10d238dbe8$var$isDirty(this);
    }
}
let $241f0b10d238dbe8$var$batchDepth = 0;
let $241f0b10d238dbe8$var$batchedSub;
let $241f0b10d238dbe8$var$batchedComputed;
function $241f0b10d238dbe8$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $241f0b10d238dbe8$var$batchedComputed;
        $241f0b10d238dbe8$var$batchedComputed = sub;
        return;
    }
    sub.next = $241f0b10d238dbe8$var$batchedSub;
    $241f0b10d238dbe8$var$batchedSub = sub;
}
function $241f0b10d238dbe8$var$startBatch() {
    $241f0b10d238dbe8$var$batchDepth++;
}
function $241f0b10d238dbe8$var$endBatch() {
    if (--$241f0b10d238dbe8$var$batchDepth > 0) return;
    if ($241f0b10d238dbe8$var$batchedComputed) {
        let e = $241f0b10d238dbe8$var$batchedComputed;
        $241f0b10d238dbe8$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($241f0b10d238dbe8$var$batchedSub){
        let e = $241f0b10d238dbe8$var$batchedSub;
        $241f0b10d238dbe8$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $241f0b10d238dbe8$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $241f0b10d238dbe8$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $241f0b10d238dbe8$var$removeSub(link);
            $241f0b10d238dbe8$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $241f0b10d238dbe8$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($241f0b10d238dbe8$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $241f0b10d238dbe8$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $241f0b10d238dbe8$var$globalVersion) return;
    computed.globalVersion = $241f0b10d238dbe8$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$241f0b10d238dbe8$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $241f0b10d238dbe8$var$activeSub;
    const prevShouldTrack = $241f0b10d238dbe8$var$shouldTrack;
    $241f0b10d238dbe8$var$activeSub = computed;
    $241f0b10d238dbe8$var$shouldTrack = true;
    try {
        $241f0b10d238dbe8$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $6OYxp.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $241f0b10d238dbe8$var$activeSub = prevSub;
        $241f0b10d238dbe8$var$shouldTrack = prevShouldTrack;
        $241f0b10d238dbe8$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $241f0b10d238dbe8$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$241f0b10d238dbe8$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $241f0b10d238dbe8$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $241f0b10d238dbe8$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $241f0b10d238dbe8$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $241f0b10d238dbe8$export$28352bb4dd362521(fn);
    if (options) (0, $6OYxp.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $241f0b10d238dbe8$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $241f0b10d238dbe8$var$shouldTrack = true;
const $241f0b10d238dbe8$var$trackStack = [];
function $241f0b10d238dbe8$export$938a971395fef855() {
    $241f0b10d238dbe8$var$trackStack.push($241f0b10d238dbe8$var$shouldTrack);
    $241f0b10d238dbe8$var$shouldTrack = false;
}
function $241f0b10d238dbe8$export$1f8ffc6fd33b1d16() {
    $241f0b10d238dbe8$var$trackStack.push($241f0b10d238dbe8$var$shouldTrack);
    $241f0b10d238dbe8$var$shouldTrack = true;
}
function $241f0b10d238dbe8$export$c39176b1babaa8b8() {
    const last = $241f0b10d238dbe8$var$trackStack.pop();
    $241f0b10d238dbe8$var$shouldTrack = last === void 0 ? true : last;
}
function $241f0b10d238dbe8$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($241f0b10d238dbe8$var$activeSub instanceof $241f0b10d238dbe8$export$28352bb4dd362521) $241f0b10d238dbe8$var$activeSub.cleanup = fn;
}
function $241f0b10d238dbe8$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $241f0b10d238dbe8$var$activeSub;
        $241f0b10d238dbe8$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $241f0b10d238dbe8$var$activeSub = prevSub;
        }
    }
}
let $241f0b10d238dbe8$var$globalVersion = 0;
class $241f0b10d238dbe8$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $241f0b10d238dbe8$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$241f0b10d238dbe8$var$activeSub || !$241f0b10d238dbe8$var$shouldTrack || $241f0b10d238dbe8$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $241f0b10d238dbe8$var$activeSub) {
            link = this.activeLink = new $241f0b10d238dbe8$var$Link($241f0b10d238dbe8$var$activeSub, this);
            if (!$241f0b10d238dbe8$var$activeSub.deps) $241f0b10d238dbe8$var$activeSub.deps = $241f0b10d238dbe8$var$activeSub.depsTail = link;
            else {
                link.prevDep = $241f0b10d238dbe8$var$activeSub.depsTail;
                $241f0b10d238dbe8$var$activeSub.depsTail.nextDep = link;
                $241f0b10d238dbe8$var$activeSub.depsTail = link;
            }
            $241f0b10d238dbe8$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $241f0b10d238dbe8$var$activeSub.depsTail;
                link.nextDep = void 0;
                $241f0b10d238dbe8$var$activeSub.depsTail.nextDep = link;
                $241f0b10d238dbe8$var$activeSub.depsTail = link;
                if ($241f0b10d238dbe8$var$activeSub.deps === link) $241f0b10d238dbe8$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $241f0b10d238dbe8$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $241f0b10d238dbe8$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $241f0b10d238dbe8$var$endBatch();
        }
    }
}
function $241f0b10d238dbe8$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$241f0b10d238dbe8$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $241f0b10d238dbe8$var$targetMap = /* @__PURE__ */ new WeakMap();
const $241f0b10d238dbe8$export$3c41b1a4e06acc14 = /* @__PURE__ */ Symbol("");
const $241f0b10d238dbe8$export$49093fa1cddcb78d = /* @__PURE__ */ Symbol("");
const $241f0b10d238dbe8$export$4f926f0baab682cd = /* @__PURE__ */ Symbol("");
function $241f0b10d238dbe8$export$6b2a7d5132615086(target, type, key) {
    if ($241f0b10d238dbe8$var$shouldTrack && $241f0b10d238dbe8$var$activeSub) {
        let depsMap = $241f0b10d238dbe8$var$targetMap.get(target);
        if (!depsMap) $241f0b10d238dbe8$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $241f0b10d238dbe8$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $241f0b10d238dbe8$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $241f0b10d238dbe8$var$targetMap.get(target);
    if (!depsMap) {
        $241f0b10d238dbe8$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $241f0b10d238dbe8$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $6OYxp.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $6OYxp.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $241f0b10d238dbe8$export$4f926f0baab682cd || !(0, $6OYxp.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($241f0b10d238dbe8$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($241f0b10d238dbe8$export$3c41b1a4e06acc14));
                        if ((0, $6OYxp.isMap)(target)) run(depsMap.get($241f0b10d238dbe8$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($241f0b10d238dbe8$export$3c41b1a4e06acc14));
                        if ((0, $6OYxp.isMap)(target)) run(depsMap.get($241f0b10d238dbe8$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $6OYxp.isMap)(target)) run(depsMap.get($241f0b10d238dbe8$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $241f0b10d238dbe8$var$endBatch();
}
function $241f0b10d238dbe8$var$getDepFromReactive(object, key) {
    const depMap = $241f0b10d238dbe8$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $241f0b10d238dbe8$export$1544eab4943788e4(array) {
    const raw = $241f0b10d238dbe8$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $241f0b10d238dbe8$export$6b2a7d5132615086(raw, "iterate", $241f0b10d238dbe8$export$4f926f0baab682cd);
    return $241f0b10d238dbe8$export$7f3fe6025abfa26e(array) ? raw : raw.map($241f0b10d238dbe8$export$45c769cf449a508c);
}
function $241f0b10d238dbe8$export$5eb48af14254449e(arr) {
    $241f0b10d238dbe8$export$6b2a7d5132615086(arr = $241f0b10d238dbe8$export$ab18938b9fc5f28e(arr), "iterate", $241f0b10d238dbe8$export$4f926f0baab682cd);
    return arr;
}
function $241f0b10d238dbe8$var$toWrapped(target, item) {
    if ($241f0b10d238dbe8$export$92d09b48637741e7(target)) return $241f0b10d238dbe8$export$352205f445242f02(target) ? $241f0b10d238dbe8$export$4a78e7a2a4fb689f($241f0b10d238dbe8$export$45c769cf449a508c(item)) : $241f0b10d238dbe8$export$4a78e7a2a4fb689f(item);
    return $241f0b10d238dbe8$export$45c769cf449a508c(item);
}
const $241f0b10d238dbe8$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $241f0b10d238dbe8$var$iterator(this, Symbol.iterator, (item)=>$241f0b10d238dbe8$var$toWrapped(this, item));
    },
    concat (...args) {
        return $241f0b10d238dbe8$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $6OYxp.isArray)(x) ? $241f0b10d238dbe8$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $241f0b10d238dbe8$var$iterator(this, "entries", (value)=>{
            value[1] = $241f0b10d238dbe8$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $241f0b10d238dbe8$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $241f0b10d238dbe8$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$241f0b10d238dbe8$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $241f0b10d238dbe8$var$apply(this, "find", fn, thisArg, (item)=>$241f0b10d238dbe8$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $241f0b10d238dbe8$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $241f0b10d238dbe8$var$apply(this, "findLast", fn, thisArg, (item)=>$241f0b10d238dbe8$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $241f0b10d238dbe8$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $241f0b10d238dbe8$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $241f0b10d238dbe8$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $241f0b10d238dbe8$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $241f0b10d238dbe8$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $241f0b10d238dbe8$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $241f0b10d238dbe8$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $241f0b10d238dbe8$var$noTracking(this, "pop");
    },
    push (...args) {
        return $241f0b10d238dbe8$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $241f0b10d238dbe8$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $241f0b10d238dbe8$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $241f0b10d238dbe8$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $241f0b10d238dbe8$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $241f0b10d238dbe8$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $241f0b10d238dbe8$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $241f0b10d238dbe8$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $241f0b10d238dbe8$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $241f0b10d238dbe8$var$noTracking(this, "unshift", args);
    },
    values () {
        return $241f0b10d238dbe8$var$iterator(this, "values", (item)=>$241f0b10d238dbe8$var$toWrapped(this, item));
    }
};
function $241f0b10d238dbe8$var$iterator(self, method, wrapValue) {
    const arr = $241f0b10d238dbe8$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$241f0b10d238dbe8$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $241f0b10d238dbe8$var$arrayProto = Array.prototype;
function $241f0b10d238dbe8$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $241f0b10d238dbe8$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$241f0b10d238dbe8$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $241f0b10d238dbe8$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $241f0b10d238dbe8$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $241f0b10d238dbe8$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $241f0b10d238dbe8$var$reduce(self, method, fn, args) {
    const arr = $241f0b10d238dbe8$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$241f0b10d238dbe8$export$7f3fe6025abfa26e(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $241f0b10d238dbe8$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $241f0b10d238dbe8$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $241f0b10d238dbe8$var$toWrapped(self, result) : result;
}
function $241f0b10d238dbe8$var$searchProxy(self, method, args) {
    const arr = $241f0b10d238dbe8$export$ab18938b9fc5f28e(self);
    $241f0b10d238dbe8$export$6b2a7d5132615086(arr, "iterate", $241f0b10d238dbe8$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $241f0b10d238dbe8$export$5f3ca29d057519b3(args[0])) {
        args[0] = $241f0b10d238dbe8$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $241f0b10d238dbe8$var$noTracking(self, method, args = []) {
    $241f0b10d238dbe8$export$938a971395fef855();
    $241f0b10d238dbe8$var$startBatch();
    const res = $241f0b10d238dbe8$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $241f0b10d238dbe8$var$endBatch();
    $241f0b10d238dbe8$export$c39176b1babaa8b8();
    return res;
}
const $241f0b10d238dbe8$var$isNonTrackableKeys = /* @__PURE__ */ (0, $6OYxp.makeMap)(`__proto__,__v_isRef,__isVue`);
const $241f0b10d238dbe8$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $6OYxp.isSymbol)));
function $241f0b10d238dbe8$var$hasOwnProperty(key) {
    if (!(0, $6OYxp.isSymbol)(key)) key = String(key);
    const obj = $241f0b10d238dbe8$export$ab18938b9fc5f28e(this);
    $241f0b10d238dbe8$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $241f0b10d238dbe8$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $241f0b10d238dbe8$var$shallowReadonlyMap : $241f0b10d238dbe8$var$readonlyMap : isShallow2 ? $241f0b10d238dbe8$var$shallowReactiveMap : $241f0b10d238dbe8$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $6OYxp.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $241f0b10d238dbe8$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $241f0b10d238dbe8$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $241f0b10d238dbe8$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $6OYxp.isSymbol)(key) ? $241f0b10d238dbe8$var$builtInSymbols.has(key) : $241f0b10d238dbe8$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $241f0b10d238dbe8$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($241f0b10d238dbe8$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $6OYxp.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, $6OYxp.isObject)(value) ? $241f0b10d238dbe8$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $6OYxp.isObject)(res)) return isReadonly2 ? $241f0b10d238dbe8$export$6ec456bd5b7b3c51(res) : $241f0b10d238dbe8$export$90a44edba14e47be(res);
        return res;
    }
}
class $241f0b10d238dbe8$var$MutableReactiveHandler extends $241f0b10d238dbe8$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $6OYxp.isArray)(target) && (0, $6OYxp.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $241f0b10d238dbe8$export$92d09b48637741e7(oldValue);
            if (!$241f0b10d238dbe8$export$7f3fe6025abfa26e(value) && !$241f0b10d238dbe8$export$92d09b48637741e7(value)) {
                oldValue = $241f0b10d238dbe8$export$ab18938b9fc5f28e(oldValue);
                value = $241f0b10d238dbe8$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && $241f0b10d238dbe8$export$4f9f5282de18fc69(oldValue) && !$241f0b10d238dbe8$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $6OYxp.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $241f0b10d238dbe8$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $241f0b10d238dbe8$export$ab18938b9fc5f28e(receiver) && result) {
            if (!hadKey) $241f0b10d238dbe8$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $6OYxp.hasChanged)(value, oldValue)) $241f0b10d238dbe8$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $6OYxp.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $241f0b10d238dbe8$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $6OYxp.isSymbol)(key) || !$241f0b10d238dbe8$var$builtInSymbols.has(key)) $241f0b10d238dbe8$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $241f0b10d238dbe8$export$6b2a7d5132615086(target, "iterate", (0, $6OYxp.isArray)(target) ? "length" : $241f0b10d238dbe8$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $241f0b10d238dbe8$var$ReadonlyReactiveHandler extends $241f0b10d238dbe8$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $241f0b10d238dbe8$var$mutableHandlers = /* @__PURE__ */ new $241f0b10d238dbe8$var$MutableReactiveHandler();
const $241f0b10d238dbe8$var$readonlyHandlers = /* @__PURE__ */ new $241f0b10d238dbe8$var$ReadonlyReactiveHandler();
const $241f0b10d238dbe8$var$shallowReactiveHandlers = /* @__PURE__ */ new $241f0b10d238dbe8$var$MutableReactiveHandler(true);
const $241f0b10d238dbe8$var$shallowReadonlyHandlers = /* @__PURE__ */ new $241f0b10d238dbe8$var$ReadonlyReactiveHandler(true);
const $241f0b10d238dbe8$var$toShallow = (value)=>value;
const $241f0b10d238dbe8$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $241f0b10d238dbe8$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $241f0b10d238dbe8$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $6OYxp.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $241f0b10d238dbe8$var$toShallow : isReadonly2 ? $241f0b10d238dbe8$export$4a78e7a2a4fb689f : $241f0b10d238dbe8$export$45c769cf449a508c;
        !isReadonly2 && $241f0b10d238dbe8$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $241f0b10d238dbe8$export$49093fa1cddcb78d : $241f0b10d238dbe8$export$3c41b1a4e06acc14);
        return (0, $6OYxp.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $241f0b10d238dbe8$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $241f0b10d238dbe8$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $241f0b10d238dbe8$export$ab18938b9fc5f28e(target);
            const rawKey = $241f0b10d238dbe8$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $6OYxp.hasChanged)(key, rawKey)) $241f0b10d238dbe8$export$6b2a7d5132615086(rawTarget, "get", key);
                $241f0b10d238dbe8$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $241f0b10d238dbe8$var$getProto(rawTarget);
            const wrap = shallow ? $241f0b10d238dbe8$var$toShallow : readonly ? $241f0b10d238dbe8$export$4a78e7a2a4fb689f : $241f0b10d238dbe8$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $241f0b10d238dbe8$export$6b2a7d5132615086($241f0b10d238dbe8$export$ab18938b9fc5f28e(target), "iterate", $241f0b10d238dbe8$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $241f0b10d238dbe8$export$ab18938b9fc5f28e(target);
            const rawKey = $241f0b10d238dbe8$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $6OYxp.hasChanged)(key, rawKey)) $241f0b10d238dbe8$export$6b2a7d5132615086(rawTarget, "has", key);
                $241f0b10d238dbe8$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $241f0b10d238dbe8$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $241f0b10d238dbe8$var$toShallow : readonly ? $241f0b10d238dbe8$export$4a78e7a2a4fb689f : $241f0b10d238dbe8$export$45c769cf449a508c;
            !readonly && $241f0b10d238dbe8$export$6b2a7d5132615086(rawTarget, "iterate", $241f0b10d238dbe8$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $6OYxp.extend)(instrumentations, readonly ? {
        add: $241f0b10d238dbe8$var$createReadonlyMethod("add"),
        set: $241f0b10d238dbe8$var$createReadonlyMethod("set"),
        delete: $241f0b10d238dbe8$var$createReadonlyMethod("delete"),
        clear: $241f0b10d238dbe8$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $241f0b10d238dbe8$export$ab18938b9fc5f28e(this);
            const proto = $241f0b10d238dbe8$var$getProto(target);
            const rawValue = $241f0b10d238dbe8$export$ab18938b9fc5f28e(value);
            const valueToAdd = !shallow && !$241f0b10d238dbe8$export$7f3fe6025abfa26e(value) && !$241f0b10d238dbe8$export$92d09b48637741e7(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || (0, $6OYxp.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $6OYxp.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $241f0b10d238dbe8$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$241f0b10d238dbe8$export$7f3fe6025abfa26e(value) && !$241f0b10d238dbe8$export$92d09b48637741e7(value)) value = $241f0b10d238dbe8$export$ab18938b9fc5f28e(value);
            const target = $241f0b10d238dbe8$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $241f0b10d238dbe8$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $241f0b10d238dbe8$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $241f0b10d238dbe8$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $6OYxp.hasChanged)(value, oldValue)) $241f0b10d238dbe8$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $241f0b10d238dbe8$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $241f0b10d238dbe8$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $241f0b10d238dbe8$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $241f0b10d238dbe8$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $241f0b10d238dbe8$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $241f0b10d238dbe8$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $241f0b10d238dbe8$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $241f0b10d238dbe8$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $241f0b10d238dbe8$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $6OYxp.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $241f0b10d238dbe8$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $241f0b10d238dbe8$var$createInstrumentationGetter(false, false)
};
const $241f0b10d238dbe8$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $241f0b10d238dbe8$var$createInstrumentationGetter(false, true)
};
const $241f0b10d238dbe8$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $241f0b10d238dbe8$var$createInstrumentationGetter(true, false)
};
const $241f0b10d238dbe8$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $241f0b10d238dbe8$var$createInstrumentationGetter(true, true)
};
function $241f0b10d238dbe8$var$checkIdentityKeys(target, has, key) {
    const rawKey = $241f0b10d238dbe8$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $6OYxp.toRawType)(target);
        $241f0b10d238dbe8$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $241f0b10d238dbe8$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $241f0b10d238dbe8$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $241f0b10d238dbe8$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $241f0b10d238dbe8$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $241f0b10d238dbe8$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $241f0b10d238dbe8$export$92d09b48637741e7(target)) return target;
    return $241f0b10d238dbe8$var$createReactiveObject(target, false, $241f0b10d238dbe8$var$mutableHandlers, $241f0b10d238dbe8$var$mutableCollectionHandlers, $241f0b10d238dbe8$var$reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$8d81cefd22d22260(target) {
    return $241f0b10d238dbe8$var$createReactiveObject(target, false, $241f0b10d238dbe8$var$shallowReactiveHandlers, $241f0b10d238dbe8$var$shallowCollectionHandlers, $241f0b10d238dbe8$var$shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$6ec456bd5b7b3c51(target) {
    return $241f0b10d238dbe8$var$createReactiveObject(target, true, $241f0b10d238dbe8$var$readonlyHandlers, $241f0b10d238dbe8$var$readonlyCollectionHandlers, $241f0b10d238dbe8$var$readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$7c4b5f2b50f09f6b(target) {
    return $241f0b10d238dbe8$var$createReactiveObject(target, true, $241f0b10d238dbe8$var$shallowReadonlyHandlers, $241f0b10d238dbe8$var$shallowReadonlyCollectionHandlers, $241f0b10d238dbe8$var$shallowReadonlyMap);
}
function $241f0b10d238dbe8$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $6OYxp.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $241f0b10d238dbe8$var$targetTypeMap((0, $6OYxp.toRawType)(target));
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $241f0b10d238dbe8$export$92d09b48637741e7(value)) return /* @__PURE__ */ $241f0b10d238dbe8$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $241f0b10d238dbe8$export$ab18938b9fc5f28e(raw) : observed;
}
function $241f0b10d238dbe8$export$995ab8b13ad7a9d0(value) {
    if (!(0, $6OYxp.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $6OYxp.def)(value, "__v_skip", true);
    return value;
}
const $241f0b10d238dbe8$export$45c769cf449a508c = (value)=>(0, $6OYxp.isObject)(value) ? /* @__PURE__ */ $241f0b10d238dbe8$export$90a44edba14e47be(value) : value;
const $241f0b10d238dbe8$export$4a78e7a2a4fb689f = (value)=>(0, $6OYxp.isObject)(value) ? /* @__PURE__ */ $241f0b10d238dbe8$export$6ec456bd5b7b3c51(value) : value;
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$eff4d24c3ff7876e(value) {
    return $241f0b10d238dbe8$var$createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$9b7bc5fe3b17c8b3(value) {
    return $241f0b10d238dbe8$var$createRef(value, true);
}
function $241f0b10d238dbe8$var$createRef(rawValue, shallow) {
    if (/* @__PURE__ */ $241f0b10d238dbe8$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $241f0b10d238dbe8$var$RefImpl(rawValue, shallow);
}
class $241f0b10d238dbe8$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $241f0b10d238dbe8$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $241f0b10d238dbe8$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $241f0b10d238dbe8$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $241f0b10d238dbe8$export$7f3fe6025abfa26e(newValue) || $241f0b10d238dbe8$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $241f0b10d238dbe8$export$ab18938b9fc5f28e(newValue);
        if ((0, $6OYxp.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $241f0b10d238dbe8$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $241f0b10d238dbe8$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $241f0b10d238dbe8$export$a239a76781616204(ref2) {
    return /* @__PURE__ */ $241f0b10d238dbe8$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $241f0b10d238dbe8$export$30bdcc2218aa9458(source) {
    return (0, $6OYxp.isFunction)(source) ? source() : $241f0b10d238dbe8$export$a239a76781616204(source);
}
const $241f0b10d238dbe8$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $241f0b10d238dbe8$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $241f0b10d238dbe8$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $241f0b10d238dbe8$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $241f0b10d238dbe8$export$f353fd1b97db3fa0(objectWithRefs) {
    return $241f0b10d238dbe8$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $241f0b10d238dbe8$var$shallowUnwrapHandlers);
}
class $241f0b10d238dbe8$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $241f0b10d238dbe8$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $241f0b10d238dbe8$export$a20c2dd6199824cb(factory) {
    return new $241f0b10d238dbe8$var$CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$2e9533675e5e70e0(object) {
    const ret = (0, $6OYxp.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $241f0b10d238dbe8$var$propertyToRef(object, key);
    return ret;
}
class $241f0b10d238dbe8$var$ObjectRefImpl {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $6OYxp.isSymbol)(key) ? key : String(key);
        this._raw = $241f0b10d238dbe8$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $6OYxp.isArray)(_object) || (0, $6OYxp.isSymbol)(this._key) || !(0, $6OYxp.isIntegerKey)(this._key)) do shallow = !$241f0b10d238dbe8$export$5f3ca29d057519b3(obj) || $241f0b10d238dbe8$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $241f0b10d238dbe8$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $241f0b10d238dbe8$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $241f0b10d238dbe8$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $241f0b10d238dbe8$var$getDepFromReactive(this._raw, this._key);
    }
}
class $241f0b10d238dbe8$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $241f0b10d238dbe8$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $6OYxp.isFunction)(source)) return new $241f0b10d238dbe8$var$GetterRefImpl(source);
    else if ((0, $6OYxp.isObject)(source) && arguments.length > 1) return $241f0b10d238dbe8$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $241f0b10d238dbe8$export$eff4d24c3ff7876e(source);
}
function $241f0b10d238dbe8$var$propertyToRef(source, key, defaultValue) {
    return new $241f0b10d238dbe8$var$ObjectRefImpl(source, key, defaultValue);
}
class $241f0b10d238dbe8$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $241f0b10d238dbe8$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $241f0b10d238dbe8$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $241f0b10d238dbe8$var$activeSub !== this) {
            $241f0b10d238dbe8$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $241f0b10d238dbe8$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function $241f0b10d238dbe8$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $6OYxp.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $241f0b10d238dbe8$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $241f0b10d238dbe8$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $241f0b10d238dbe8$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $241f0b10d238dbe8$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $241f0b10d238dbe8$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $241f0b10d238dbe8$var$INITIAL_WATCHER_VALUE = {};
const $241f0b10d238dbe8$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $241f0b10d238dbe8$var$activeWatcher = void 0;
function $241f0b10d238dbe8$export$2532f7acfca7c82d() {
    return $241f0b10d238dbe8$var$activeWatcher;
}
function $241f0b10d238dbe8$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $241f0b10d238dbe8$var$activeWatcher) {
    if (owner) {
        let cleanups = $241f0b10d238dbe8$var$cleanupMap.get(owner);
        if (!cleanups) $241f0b10d238dbe8$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $241f0b10d238dbe8$export$3db5d71bdb2d5499(source, cb, options = (0, $6OYxp.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $241f0b10d238dbe8$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($241f0b10d238dbe8$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $241f0b10d238dbe8$export$df3f009e3d155b20(source2, 1);
        return $241f0b10d238dbe8$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($241f0b10d238dbe8$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $241f0b10d238dbe8$export$7f3fe6025abfa26e(source);
    } else if ($241f0b10d238dbe8$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $6OYxp.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$241f0b10d238dbe8$export$352205f445242f02(s) || $241f0b10d238dbe8$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($241f0b10d238dbe8$export$4f9f5282de18fc69(s)) return s.value;
                else if ($241f0b10d238dbe8$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $6OYxp.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $6OYxp.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $241f0b10d238dbe8$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $241f0b10d238dbe8$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $241f0b10d238dbe8$var$activeWatcher;
            $241f0b10d238dbe8$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $241f0b10d238dbe8$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $6OYxp.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$241f0b10d238dbe8$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $241f0b10d238dbe8$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $6OYxp.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            const res = _cb(...args);
            watchHandle();
            return res;
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($241f0b10d238dbe8$var$INITIAL_WATCHER_VALUE) : $241f0b10d238dbe8$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $6OYxp.hasChanged)(v, oldValue[i])) : (0, $6OYxp.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $241f0b10d238dbe8$var$activeWatcher;
                $241f0b10d238dbe8$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $241f0b10d238dbe8$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $241f0b10d238dbe8$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $241f0b10d238dbe8$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $241f0b10d238dbe8$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$241f0b10d238dbe8$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $241f0b10d238dbe8$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $241f0b10d238dbe8$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $241f0b10d238dbe8$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $6OYxp.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if ($241f0b10d238dbe8$export$4f9f5282de18fc69(value)) $241f0b10d238dbe8$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $6OYxp.isArray)(value)) for(let i = 0; i < value.length; i++)$241f0b10d238dbe8$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $6OYxp.isSet)(value) || (0, $6OYxp.isMap)(value)) value.forEach((v)=>{
        $241f0b10d238dbe8$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $6OYxp.isPlainObject)(value)) {
        for(const key in value)$241f0b10d238dbe8$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $241f0b10d238dbe8$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("6OYxp", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $4f765f1fc1699297$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $4f765f1fc1699297$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $4f765f1fc1699297$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $4f765f1fc1699297$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $4f765f1fc1699297$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $4f765f1fc1699297$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $4f765f1fc1699297$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $4f765f1fc1699297$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $4f765f1fc1699297$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $4f765f1fc1699297$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $4f765f1fc1699297$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $4f765f1fc1699297$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $4f765f1fc1699297$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $4f765f1fc1699297$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $4f765f1fc1699297$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $4f765f1fc1699297$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $4f765f1fc1699297$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $4f765f1fc1699297$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $4f765f1fc1699297$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $4f765f1fc1699297$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $4f765f1fc1699297$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $4f765f1fc1699297$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $4f765f1fc1699297$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $4f765f1fc1699297$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $4f765f1fc1699297$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $4f765f1fc1699297$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $4f765f1fc1699297$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $4f765f1fc1699297$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $4f765f1fc1699297$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $4f765f1fc1699297$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $4f765f1fc1699297$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $4f765f1fc1699297$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $4f765f1fc1699297$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $4f765f1fc1699297$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $4f765f1fc1699297$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $4f765f1fc1699297$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $4f765f1fc1699297$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $4f765f1fc1699297$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $4f765f1fc1699297$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $4f765f1fc1699297$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $4f765f1fc1699297$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $4f765f1fc1699297$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $4f765f1fc1699297$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $4f765f1fc1699297$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $4f765f1fc1699297$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $4f765f1fc1699297$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $4f765f1fc1699297$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $4f765f1fc1699297$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $4f765f1fc1699297$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $4f765f1fc1699297$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $4f765f1fc1699297$export$b5b1545233b45293);
$parcel$export(module.exports, "normalizeCssVarValue", () => $4f765f1fc1699297$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.42
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $4f765f1fc1699297$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $4f765f1fc1699297$export$cf583d23ab39677c = {};
const $4f765f1fc1699297$export$6bd8558f433f1cc1 = [];
const $4f765f1fc1699297$export$5702a91a6f42969f = ()=>{};
const $4f765f1fc1699297$export$c01351c0af048e39 = ()=>false;
const $4f765f1fc1699297$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $4f765f1fc1699297$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $4f765f1fc1699297$export$8b58be045bf06082 = Object.assign;
const $4f765f1fc1699297$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $4f765f1fc1699297$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $4f765f1fc1699297$export$b5a638e9b3fff9f3 = (val, key)=>$4f765f1fc1699297$var$hasOwnProperty.call(val, key);
const $4f765f1fc1699297$export$43bee75e5e14138e = Array.isArray;
const $4f765f1fc1699297$export$5c90113a285f2241 = (val)=>$4f765f1fc1699297$export$1dccc787cc36538b(val) === "[object Map]";
const $4f765f1fc1699297$export$6750766a7c7ec627 = (val)=>$4f765f1fc1699297$export$1dccc787cc36538b(val) === "[object Set]";
const $4f765f1fc1699297$export$871608497c498473 = (val)=>$4f765f1fc1699297$export$1dccc787cc36538b(val) === "[object Date]";
const $4f765f1fc1699297$export$49841c62b9eff15 = (val)=>$4f765f1fc1699297$export$1dccc787cc36538b(val) === "[object RegExp]";
const $4f765f1fc1699297$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $4f765f1fc1699297$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $4f765f1fc1699297$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $4f765f1fc1699297$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $4f765f1fc1699297$export$4369c812aac99591 = (val)=>{
    return ($4f765f1fc1699297$export$a6cdc56e425d0d0a(val) || $4f765f1fc1699297$export$f6e2535fb5126e54(val)) && $4f765f1fc1699297$export$f6e2535fb5126e54(val.then) && $4f765f1fc1699297$export$f6e2535fb5126e54(val.catch);
};
const $4f765f1fc1699297$export$830c053460e5ddf6 = Object.prototype.toString;
const $4f765f1fc1699297$export$1dccc787cc36538b = (value)=>$4f765f1fc1699297$export$830c053460e5ddf6.call(value);
const $4f765f1fc1699297$export$5ad0a3c360b8fbb5 = (value)=>{
    return $4f765f1fc1699297$export$1dccc787cc36538b(value).slice(8, -1);
};
const $4f765f1fc1699297$export$53b83ca8eaab0383 = (val)=>$4f765f1fc1699297$export$1dccc787cc36538b(val) === "[object Object]";
const $4f765f1fc1699297$export$e2a2b93446ec9fe = (key)=>$4f765f1fc1699297$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $4f765f1fc1699297$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $4f765f1fc1699297$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $4f765f1fc1699297$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $4f765f1fc1699297$var$camelizeRE = /-\w/g;
const $4f765f1fc1699297$export$161d051f5dd25de7 = $4f765f1fc1699297$var$cacheStringFunction((str)=>{
    return str.replace($4f765f1fc1699297$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $4f765f1fc1699297$var$hyphenateRE = /\B([A-Z])/g;
const $4f765f1fc1699297$export$6e6a0a3676c4b8bb = $4f765f1fc1699297$var$cacheStringFunction((str)=>str.replace($4f765f1fc1699297$var$hyphenateRE, "-$1").toLowerCase());
const $4f765f1fc1699297$export$9a00dee1beb8f576 = $4f765f1fc1699297$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $4f765f1fc1699297$export$8c022799eeaaefcd = $4f765f1fc1699297$var$cacheStringFunction((str)=>{
    const s = str ? `on${$4f765f1fc1699297$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $4f765f1fc1699297$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $4f765f1fc1699297$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $4f765f1fc1699297$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $4f765f1fc1699297$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $4f765f1fc1699297$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $4f765f1fc1699297$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $4f765f1fc1699297$var$_globalThis;
const $4f765f1fc1699297$export$ff5f2eeb11fc7e14 = ()=>{
    return $4f765f1fc1699297$var$_globalThis || ($4f765f1fc1699297$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $4f765f1fc1699297$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $4f765f1fc1699297$export$53d5e12f9a1d3cde(name) {
    return $4f765f1fc1699297$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $4f765f1fc1699297$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $4f765f1fc1699297$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $4f765f1fc1699297$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $4f765f1fc1699297$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $4f765f1fc1699297$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $4f765f1fc1699297$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $4f765f1fc1699297$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $4f765f1fc1699297$export$f73b8c13b7f97ebf = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8($4f765f1fc1699297$var$GLOBALS_ALLOWED);
const $4f765f1fc1699297$export$d6571a1911e4f27e = $4f765f1fc1699297$export$f73b8c13b7f97ebf;
const $4f765f1fc1699297$var$range = 2;
function $4f765f1fc1699297$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $4f765f1fc1699297$var$range; j <= i + $4f765f1fc1699297$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $4f765f1fc1699297$export$8756898546458274(value) {
    if ($4f765f1fc1699297$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $4f765f1fc1699297$export$844ec244b1367d54(item) ? $4f765f1fc1699297$export$76a205ce979d066a(item) : $4f765f1fc1699297$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($4f765f1fc1699297$export$844ec244b1367d54(value) || $4f765f1fc1699297$export$a6cdc56e425d0d0a(value)) return value;
}
const $4f765f1fc1699297$var$listDelimiterRE = /;(?![^(]*\))/g;
const $4f765f1fc1699297$var$propertyDelimiterRE = /:([^]+)/;
const $4f765f1fc1699297$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $4f765f1fc1699297$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($4f765f1fc1699297$var$styleCommentRE, "").split($4f765f1fc1699297$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($4f765f1fc1699297$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $4f765f1fc1699297$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($4f765f1fc1699297$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($4f765f1fc1699297$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $4f765f1fc1699297$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $4f765f1fc1699297$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($4f765f1fc1699297$export$844ec244b1367d54(value)) res = value;
    else if ($4f765f1fc1699297$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $4f765f1fc1699297$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($4f765f1fc1699297$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $4f765f1fc1699297$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$4f765f1fc1699297$export$844ec244b1367d54(klass)) props.class = $4f765f1fc1699297$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $4f765f1fc1699297$export$8756898546458274(style);
    return props;
}
const $4f765f1fc1699297$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $4f765f1fc1699297$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $4f765f1fc1699297$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $4f765f1fc1699297$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $4f765f1fc1699297$export$1ccf854a0984f890 = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8($4f765f1fc1699297$var$HTML_TAGS);
const $4f765f1fc1699297$export$6328ce7565ea1049 = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8($4f765f1fc1699297$var$SVG_TAGS);
const $4f765f1fc1699297$export$4a46ca4c5be17b20 = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8($4f765f1fc1699297$var$MATH_TAGS);
const $4f765f1fc1699297$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8($4f765f1fc1699297$var$VOID_TAGS);
const $4f765f1fc1699297$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $4f765f1fc1699297$export$d186f5eb2e810715 = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8($4f765f1fc1699297$var$specialBooleanAttrs);
const $4f765f1fc1699297$export$f763ba3b84e9cd8c = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8($4f765f1fc1699297$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $4f765f1fc1699297$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $4f765f1fc1699297$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u000d\u0020]/;
const $4f765f1fc1699297$var$attrValidationCache = {};
function $4f765f1fc1699297$export$d55ef77660f30d12(name) {
    if ($4f765f1fc1699297$var$attrValidationCache.hasOwnProperty(name)) return $4f765f1fc1699297$var$attrValidationCache[name];
    const isUnsafe = $4f765f1fc1699297$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $4f765f1fc1699297$var$attrValidationCache[name] = !isUnsafe;
}
const $4f765f1fc1699297$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $4f765f1fc1699297$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $4f765f1fc1699297$export$80da416f43933831 = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $4f765f1fc1699297$export$fc0748a8e0014066 = /* @__PURE__ */ $4f765f1fc1699297$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $4f765f1fc1699297$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $4f765f1fc1699297$var$escapeRE = /["'&<>]/;
function $4f765f1fc1699297$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $4f765f1fc1699297$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $4f765f1fc1699297$var$commentStripRE = /^(?:-?>)+|<!--|-->|--!>|<!-$/g;
function $4f765f1fc1699297$export$7b105034a53bde5f(src) {
    let prev;
    do {
        prev = src;
        src = src.replace($4f765f1fc1699297$var$commentStripRE, "");
    }while (src !== prev);
    return src;
}
const $4f765f1fc1699297$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $4f765f1fc1699297$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($4f765f1fc1699297$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $4f765f1fc1699297$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $4f765f1fc1699297$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $4f765f1fc1699297$var$looseCompareCollections(a, b) {
    if (a.size !== b.size) return false;
    const candidates = Array.from(b);
    const matched = new Uint8Array(candidates.length);
    for (const item of a){
        let index = -1;
        for(let i = 0; i < candidates.length; i++)if (!matched[i] && $4f765f1fc1699297$export$ae8015769846262c(item, candidates[i])) {
            index = i;
            break;
        }
        if (index < 0) return false;
        matched[index] = 1;
    }
    return true;
}
function $4f765f1fc1699297$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $4f765f1fc1699297$export$871608497c498473(a);
    let bValidType = $4f765f1fc1699297$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $4f765f1fc1699297$export$a244864fd9645c7f(a);
    bValidType = $4f765f1fc1699297$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $4f765f1fc1699297$export$43bee75e5e14138e(a);
    bValidType = $4f765f1fc1699297$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $4f765f1fc1699297$var$looseCompareArrays(a, b) : false;
    aValidType = $4f765f1fc1699297$export$a6cdc56e425d0d0a(a);
    bValidType = $4f765f1fc1699297$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        aValidType = $4f765f1fc1699297$export$5c90113a285f2241(a);
        bValidType = $4f765f1fc1699297$export$5c90113a285f2241(b);
        if (aValidType || bValidType) return aValidType && bValidType ? $4f765f1fc1699297$var$looseCompareCollections(a, b) : false;
        aValidType = $4f765f1fc1699297$export$6750766a7c7ec627(a);
        bValidType = $4f765f1fc1699297$export$6750766a7c7ec627(b);
        if (aValidType || bValidType) return aValidType && bValidType ? $4f765f1fc1699297$var$looseCompareCollections(a, b) : false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$4f765f1fc1699297$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $4f765f1fc1699297$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$4f765f1fc1699297$export$ae8015769846262c(item, val));
}
const $4f765f1fc1699297$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $4f765f1fc1699297$export$b5b1545233b45293 = (val)=>{
    return $4f765f1fc1699297$export$844ec244b1367d54(val) ? val : val == null ? "" : $4f765f1fc1699297$export$43bee75e5e14138e(val) || $4f765f1fc1699297$export$a6cdc56e425d0d0a(val) && (val.toString === $4f765f1fc1699297$export$830c053460e5ddf6 || !$4f765f1fc1699297$export$f6e2535fb5126e54(val.toString)) ? $4f765f1fc1699297$var$isRef(val) ? $4f765f1fc1699297$export$b5b1545233b45293(val.value) : JSON.stringify(val, $4f765f1fc1699297$var$replacer, 2) : String(val);
};
const $4f765f1fc1699297$var$replacer = (_key, val)=>{
    if ($4f765f1fc1699297$var$isRef(val)) return $4f765f1fc1699297$var$replacer(_key, val.value);
    else if ($4f765f1fc1699297$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$4f765f1fc1699297$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($4f765f1fc1699297$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$4f765f1fc1699297$var$stringifySymbol(v))
    };
    else if ($4f765f1fc1699297$export$a244864fd9645c7f(val)) return $4f765f1fc1699297$var$stringifySymbol(val);
    else if ($4f765f1fc1699297$export$a6cdc56e425d0d0a(val) && !$4f765f1fc1699297$export$43bee75e5e14138e(val) && !$4f765f1fc1699297$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $4f765f1fc1699297$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $4f765f1fc1699297$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $4f765f1fc1699297$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("31QV8", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("jDVdF")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("jDVdF")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("jDVdF")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("6OYxp")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("jDVdF")).computed);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("jDVdF")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("jDVdF")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("jDVdF")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("jDVdF")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("jDVdF")).createRenderer);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("jDVdF")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("jDVdF")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("jDVdF")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("jDVdF")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("jDVdF")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("jDVdF")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("jDVdF")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("jDVdF")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("jDVdF")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("jDVdF")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("36gU0")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("36gU0")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("36gU0")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("jDVdF")).isRuntimeOnly);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("36gU0")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("jDVdF")).nextTick);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("jDVdF")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("jDVdF")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("jDVdF")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("jDVdF")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("jDVdF")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("jDVdF")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("jDVdF")).openBlock);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("jDVdF")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("36gU0")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("36gU0")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("jDVdF")).renderList);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("jDVdF")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("jDVdF")).setTransitionHooks);
$parcel$export(module.exports, "Static", () => (parcelRequire("jDVdF")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("36gU0")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("jDVdF")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("jDVdF")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("jDVdF")).watch);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("36gU0")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("36gU0")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("36gU0")).onScopeDispose);
$parcel$export(module.exports, "toRef", () => (parcelRequire("36gU0")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("36gU0")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("36gU0")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("6OYxp")).toDisplayString);

$parcel$export(module.exports, "createApp", () => $234a83ffffcaead5$export$4e373c34abfa8c68);
/**
* @vue/runtime-dom v3.5.42
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $jDVdF = parcelRequire("jDVdF");
var $6OYxp = parcelRequire("6OYxp");
var $36gU0 = parcelRequire("36gU0");
var $36gU0 = parcelRequire("36gU0");parcelRequire("6OYxp");

var $6OYxp = parcelRequire("6OYxp");
let $234a83ffffcaead5$var$policy = void 0;
const $234a83ffffcaead5$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($234a83ffffcaead5$var$tt) try {
    $234a83ffffcaead5$var$policy = /* @__PURE__ */ $234a83ffffcaead5$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $234a83ffffcaead5$var$unsafeToTrustedHTML = $234a83ffffcaead5$var$policy ? (val)=>$234a83ffffcaead5$var$policy.createHTML(val) : (val)=>val;
const $234a83ffffcaead5$var$svgNS = "http://www.w3.org/2000/svg";
const $234a83ffffcaead5$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $234a83ffffcaead5$var$doc = typeof document !== "undefined" ? document : null;
const $234a83ffffcaead5$var$templateContainer = $234a83ffffcaead5$var$doc && /* @__PURE__ */ $234a83ffffcaead5$var$doc.createElement("template");
const $234a83ffffcaead5$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $234a83ffffcaead5$var$doc.createElementNS($234a83ffffcaead5$var$svgNS, tag) : namespace === "mathml" ? $234a83ffffcaead5$var$doc.createElementNS($234a83ffffcaead5$var$mathmlNS, tag) : is ? $234a83ffffcaead5$var$doc.createElement(tag, {
            is: is
        }) : $234a83ffffcaead5$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$234a83ffffcaead5$var$doc.createTextNode(text),
    createComment: (text)=>$234a83ffffcaead5$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$234a83ffffcaead5$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $234a83ffffcaead5$var$templateContainer.innerHTML = $234a83ffffcaead5$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $234a83ffffcaead5$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $234a83ffffcaead5$var$TRANSITION = "transition";
const $234a83ffffcaead5$var$ANIMATION = "animation";
const $234a83ffffcaead5$var$vtcKey = /* @__PURE__ */ Symbol("_vtc");
const $234a83ffffcaead5$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $234a83ffffcaead5$var$TransitionPropsValidators = /* @__PURE__ */ (0, $6OYxp.extend)({}, (0, $jDVdF.BaseTransitionPropsValidators), $234a83ffffcaead5$var$DOMTransitionPropsValidators);
const $234a83ffffcaead5$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $234a83ffffcaead5$var$TransitionPropsValidators;
    return t;
};
const $234a83ffffcaead5$export$be58926105124dd4 = /* @__PURE__ */ $234a83ffffcaead5$var$decorate$1((props, { slots: slots })=>(0, $jDVdF.h)((0, $jDVdF.BaseTransition), $234a83ffffcaead5$var$resolveTransitionProps(props), slots));
const $234a83ffffcaead5$var$callHook = (hook, args = [])=>{
    if ((0, $6OYxp.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $234a83ffffcaead5$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $6OYxp.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $234a83ffffcaead5$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $234a83ffffcaead5$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $234a83ffffcaead5$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $234a83ffffcaead5$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $234a83ffffcaead5$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $234a83ffffcaead5$var$removeTransitionClass(el, leaveFromClass);
        $234a83ffffcaead5$var$removeTransitionClass(el, leaveToClass);
        $234a83ffffcaead5$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $234a83ffffcaead5$var$callHook(hook, [
                el,
                resolve
            ]);
            $234a83ffffcaead5$var$nextFrame(()=>{
                $234a83ffffcaead5$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $234a83ffffcaead5$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$234a83ffffcaead5$var$hasExplicitCallback(hook)) $234a83ffffcaead5$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $6OYxp.extend)(baseProps, {
        onBeforeEnter (el) {
            $234a83ffffcaead5$var$callHook(onBeforeEnter, [
                el
            ]);
            $234a83ffffcaead5$var$addTransitionClass(el, enterFromClass);
            $234a83ffffcaead5$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $234a83ffffcaead5$var$callHook(onBeforeAppear, [
                el
            ]);
            $234a83ffffcaead5$var$addTransitionClass(el, appearFromClass);
            $234a83ffffcaead5$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $234a83ffffcaead5$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $234a83ffffcaead5$var$forceReflow(el);
                $234a83ffffcaead5$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $234a83ffffcaead5$var$addTransitionClass(el, leaveActiveClass);
                $234a83ffffcaead5$var$forceReflow(el);
            }
            $234a83ffffcaead5$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $234a83ffffcaead5$var$removeTransitionClass(el, leaveFromClass);
                $234a83ffffcaead5$var$addTransitionClass(el, leaveToClass);
                if (!$234a83ffffcaead5$var$hasExplicitCallback(onLeave)) $234a83ffffcaead5$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $234a83ffffcaead5$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $234a83ffffcaead5$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $234a83ffffcaead5$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $234a83ffffcaead5$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $234a83ffffcaead5$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $6OYxp.isObject)(duration)) return [
        $234a83ffffcaead5$var$NumberOf(duration.enter),
        $234a83ffffcaead5$var$NumberOf(duration.leave)
    ];
    else {
        const n = $234a83ffffcaead5$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $234a83ffffcaead5$var$NumberOf(val) {
    const res = (0, $6OYxp.toNumber)(val);
    return res;
}
function $234a83ffffcaead5$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$234a83ffffcaead5$var$vtcKey] || (el[$234a83ffffcaead5$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $234a83ffffcaead5$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$234a83ffffcaead5$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$234a83ffffcaead5$var$vtcKey] = void 0;
    }
}
function $234a83ffffcaead5$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $234a83ffffcaead5$var$endId = 0;
function $234a83ffffcaead5$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$234a83ffffcaead5$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $234a83ffffcaead5$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $234a83ffffcaead5$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$234a83ffffcaead5$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$234a83ffffcaead5$var$TRANSITION}Duration`);
    const transitionTimeout = $234a83ffffcaead5$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$234a83ffffcaead5$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$234a83ffffcaead5$var$ANIMATION}Duration`);
    const animationTimeout = $234a83ffffcaead5$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $234a83ffffcaead5$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $234a83ffffcaead5$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $234a83ffffcaead5$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $234a83ffffcaead5$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $234a83ffffcaead5$var$TRANSITION : $234a83ffffcaead5$var$ANIMATION : null;
        propCount = type ? type === $234a83ffffcaead5$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $234a83ffffcaead5$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$234a83ffffcaead5$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $234a83ffffcaead5$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$234a83ffffcaead5$var$toMs(d) + $234a83ffffcaead5$var$toMs(delays[i])));
}
function $234a83ffffcaead5$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $234a83ffffcaead5$var$forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $234a83ffffcaead5$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$234a83ffffcaead5$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $234a83ffffcaead5$var$vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const $234a83ffffcaead5$var$vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const $234a83ffffcaead5$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$234a83ffffcaead5$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $234a83ffffcaead5$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $234a83ffffcaead5$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $234a83ffffcaead5$var$setDisplay(el, false);
            });
        } else $234a83ffffcaead5$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $234a83ffffcaead5$var$setDisplay(el, value);
    }
};
function $234a83ffffcaead5$var$setDisplay(el, value) {
    el.style.display = value ? el[$234a83ffffcaead5$var$vShowOriginalDisplay] : "none";
    el[$234a83ffffcaead5$var$vShowHidden] = !value;
}
function $234a83ffffcaead5$var$initVShowForSSR() {
    $234a83ffffcaead5$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $234a83ffffcaead5$var$CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function $234a83ffffcaead5$export$ef28b76f07940108(getter) {
    const instance = (0, $jDVdF.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$234a83ffffcaead5$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $234a83ffffcaead5$var$setVarsOnNode(instance.ce, vars);
        else $234a83ffffcaead5$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $jDVdF.onBeforeUpdate)(()=>{
        (0, $jDVdF.queuePostFlushCb)(setVars);
    });
    (0, $jDVdF.onMounted)(()=>{
        (0, $jDVdF.watch)(setVars, (0, $6OYxp.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $jDVdF.onUnmounted)(()=>ob.disconnect());
    });
}
function $234a83ffffcaead5$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $234a83ffffcaead5$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $234a83ffffcaead5$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $jDVdF.Fragment)) vnode.children.forEach((c)=>$234a83ffffcaead5$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $jDVdF.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $234a83ffffcaead5$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $234a83ffffcaead5$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $6OYxp.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$234a83ffffcaead5$var$CSS_VAR_TEXT] = cssText;
    }
}
const $234a83ffffcaead5$var$displayRE = /(?:^|;)\s*display\s*:/;
function $234a83ffffcaead5$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $6OYxp.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $6OYxp.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $234a83ffffcaead5$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $234a83ffffcaead5$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            const value = next[key];
            if (value != null) {
                if (!$234a83ffffcaead5$var$shouldPreserveTextareaResizeStyle(el, key, !(0, $6OYxp.isString)(prev) && prev ? prev[key] : void 0, value)) $234a83ffffcaead5$var$setStyle(style, key, value);
            } else $234a83ffffcaead5$var$setStyle(style, key, "");
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$234a83ffffcaead5$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $234a83ffffcaead5$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($234a83ffffcaead5$var$vShowOriginalDisplay in el) {
        el[$234a83ffffcaead5$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$234a83ffffcaead5$var$vShowHidden]) style.display = "none";
    }
}
const $234a83ffffcaead5$var$semicolonRE = /[^\\];\s*$/;
const $234a83ffffcaead5$var$importantRE = /\s*!important$/;
function $234a83ffffcaead5$var$setStyle(style, name, val) {
    if ((0, $6OYxp.isArray)(val)) val.forEach((v)=>$234a83ffffcaead5$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) {
            if ($234a83ffffcaead5$var$importantRE.test(val)) style.setProperty(name, val.replace($234a83ffffcaead5$var$importantRE, ""), "important");
            else style.setProperty(name, val);
        } else {
            const prefixed = $234a83ffffcaead5$var$autoPrefix(style, name);
            if ($234a83ffffcaead5$var$importantRE.test(val)) style.setProperty((0, $6OYxp.hyphenate)(prefixed), val.replace($234a83ffffcaead5$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $234a83ffffcaead5$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $234a83ffffcaead5$var$prefixCache = {};
function $234a83ffffcaead5$var$autoPrefix(style, rawName) {
    const cached = $234a83ffffcaead5$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $6OYxp.camelize)(rawName);
    if (name !== "filter" && name in style) return $234a83ffffcaead5$var$prefixCache[rawName] = name;
    name = (0, $6OYxp.capitalize)(name);
    for(let i = 0; i < $234a83ffffcaead5$var$prefixes.length; i++){
        const prefixed = $234a83ffffcaead5$var$prefixes[i] + name;
        if (prefixed in style) return $234a83ffffcaead5$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
function $234a83ffffcaead5$var$shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, $6OYxp.isString)(next) && prev === next;
}
const $234a83ffffcaead5$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $234a83ffffcaead5$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $6OYxp.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($234a83ffffcaead5$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($234a83ffffcaead5$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $6OYxp.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $6OYxp.isSymbol)(value) ? String(value) : value);
}
function $234a83ffffcaead5$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $234a83ffffcaead5$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $6OYxp.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $234a83ffffcaead5$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $234a83ffffcaead5$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $234a83ffffcaead5$var$veiKey = /* @__PURE__ */ Symbol("_vei");
function $234a83ffffcaead5$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$234a83ffffcaead5$var$veiKey] || (el[$234a83ffffcaead5$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $234a83ffffcaead5$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $234a83ffffcaead5$var$createInvoker(nextValue, instance);
            $234a83ffffcaead5$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $234a83ffffcaead5$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $234a83ffffcaead5$var$optionsModifierRE = /(Once|Passive|Capture)$/;
const $234a83ffffcaead5$var$optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
function $234a83ffffcaead5$var$parseName(name) {
    let options;
    let m;
    while((m = name.match($234a83ffffcaead5$var$optionsModifierRE)) && !$234a83ffffcaead5$var$optionsModifierEventRE.test(name)){
        if (!options) options = {};
        name = name.slice(0, name.length - m[1].length);
        options[m[1].toLowerCase()] = true;
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $6OYxp.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $234a83ffffcaead5$var$cachedNow = 0;
const $234a83ffffcaead5$var$p = /* @__PURE__ */ Promise.resolve();
const $234a83ffffcaead5$var$getNow = ()=>$234a83ffffcaead5$var$cachedNow || ($234a83ffffcaead5$var$p.then(()=>$234a83ffffcaead5$var$cachedNow = 0), $234a83ffffcaead5$var$cachedNow = Date.now());
function $234a83ffffcaead5$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        const value = invoker.value;
        if ((0, $6OYxp.isArray)(value)) {
            const originalStop = e.stopImmediatePropagation;
            e.stopImmediatePropagation = ()=>{
                originalStop.call(e);
                e._stopped = true;
            };
            const handlers = value.slice();
            const args = [
                e
            ];
            for(let i = 0; i < handlers.length; i++){
                if (e._stopped) break;
                const handler = handlers[i];
                if (handler) (0, $jDVdF.callWithAsyncErrorHandling)(handler, instance, 5, args);
            }
        } else (0, $jDVdF.callWithAsyncErrorHandling)(value, instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $234a83ffffcaead5$var$getNow();
    return invoker;
}
function $234a83ffffcaead5$var$sanitizeEventValue(value, propName) {
    if ((0, $6OYxp.isFunction)(value) || (0, $6OYxp.isArray)(value)) return value;
    (0, $jDVdF.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $6OYxp.NOOP;
}
const $234a83ffffcaead5$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $234a83ffffcaead5$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $234a83ffffcaead5$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $234a83ffffcaead5$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $6OYxp.isOn)(key)) {
        if (!(0, $6OYxp.isModelListener)(key)) $234a83ffffcaead5$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $234a83ffffcaead5$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $234a83ffffcaead5$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $234a83ffffcaead5$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && // #12408 check if it's declared prop or it's async custom element
    ($234a83ffffcaead5$var$shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
    el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $6OYxp.isString)(nextValue)))) $234a83ffffcaead5$var$patchDOMProp(el, (0, $6OYxp.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $234a83ffffcaead5$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $234a83ffffcaead5$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $234a83ffffcaead5$var$isNativeOn(key) && (0, $6OYxp.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($234a83ffffcaead5$var$isNativeOn(key) && (0, $6OYxp.isString)(value)) return false;
    return key in el;
}
function $234a83ffffcaead5$var$shouldSetAsPropForVueCE(el, key) {
    const props = // @ts-expect-error _def is private
    el._def.props;
    if (!props) return false;
    const camelKey = (0, $6OYxp.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, $6OYxp.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, $6OYxp.camelize)(prop) === camelKey);
}
const $234a83ffffcaead5$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $234a83ffffcaead5$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $jDVdF.defineComponent)(options, extraOptions);
    if ((0, $6OYxp.isPlainObject)(Comp)) Comp = (0, $6OYxp.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $234a83ffffcaead5$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $234a83ffffcaead5$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $234a83ffffcaead5$export$a00e2346eabbdbef(options, extraOptions, $234a83ffffcaead5$export$35800275c0037383);
};
const $234a83ffffcaead5$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $234a83ffffcaead5$export$b337c1a55163dbe3 extends $234a83ffffcaead5$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $234a83ffffcaead5$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $234a83ffffcaead5$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, $6OYxp.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && // #12479 should check assignedSlot first to get correct parent
        (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof $234a83ffffcaead5$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                if (this.isConnected) return this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $jDVdF.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return this._pendingResolve;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $6OYxp.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $6OYxp.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $6OYxp.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) {
            this._pendingResolve = asyncDef().then((def)=>{
                def.configureApp = this._def.configureApp;
                resolve(this._def = def, true);
            });
            return this._pendingResolve;
        } else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $6OYxp.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $36gU0.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $6OYxp.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $6OYxp.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $234a83ffffcaead5$var$REMOVAL;
        const camelKey = (0, $6OYxp.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $6OYxp.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $234a83ffffcaead5$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $6OYxp.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $6OYxp.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $6OYxp.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $234a83ffffcaead5$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $jDVdF.createVNode)(this._def, (0, $6OYxp.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $6OYxp.isPlainObject)(args[0]) ? (0, $6OYxp.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $6OYxp.hyphenate)(event) !== event) dispatch((0, $6OYxp.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $234a83ffffcaead5$export$da5acfe93a94e37d(caller) {
    const instance = (0, $jDVdF.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $jDVdF.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $jDVdF.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $234a83ffffcaead5$export$64d45095031fa749() {
    const el = $234a83ffffcaead5$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $234a83ffffcaead5$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $jDVdF.getCurrentInstance)();
        if (!instance) return 0, $6OYxp.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $6OYxp.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $6OYxp.EMPTY_OBJ;
        return mod;
    }
}
const $234a83ffffcaead5$var$positionMap = /* @__PURE__ */ new WeakMap();
const $234a83ffffcaead5$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $234a83ffffcaead5$var$moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const $234a83ffffcaead5$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const $234a83ffffcaead5$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $234a83ffffcaead5$var$TransitionGroupImpl = /* @__PURE__ */ $234a83ffffcaead5$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $6OYxp.extend)({}, $234a83ffffcaead5$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $jDVdF.getCurrentInstance)();
        const state = (0, $jDVdF.useTransitionState)();
        let prevChildren;
        let children;
        (0, $jDVdF.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$234a83ffffcaead5$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($234a83ffffcaead5$var$callPendingCbs);
            prevChildren.forEach($234a83ffffcaead5$var$recordPosition);
            const movedChildren = prevChildren.filter($234a83ffffcaead5$var$applyTranslation);
            $234a83ffffcaead5$var$forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $234a83ffffcaead5$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$234a83ffffcaead5$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$234a83ffffcaead5$var$moveCbKey] = null;
                        $234a83ffffcaead5$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $36gU0.toRaw)(props);
            const cssTransitionProps = $234a83ffffcaead5$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $jDVdF.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
                !child.el[$234a83ffffcaead5$var$vShowHidden]) {
                    prevChildren.push(child);
                    (0, $jDVdF.setTransitionHooks)(child, (0, $jDVdF.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $234a83ffffcaead5$var$positionMap.set(child, $234a83ffffcaead5$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $jDVdF.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $jDVdF.setTransitionHooks)(child, (0, $jDVdF.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $jDVdF.createVNode)(tag, null, children);
        };
    }
});
const $234a83ffffcaead5$export$19ffa8f511f7bc2e = $234a83ffffcaead5$var$TransitionGroupImpl;
function $234a83ffffcaead5$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$234a83ffffcaead5$var$moveCbKey]) el[$234a83ffffcaead5$var$moveCbKey]();
    if (el[$234a83ffffcaead5$var$enterCbKey]) el[$234a83ffffcaead5$var$enterCbKey]();
}
function $234a83ffffcaead5$var$recordPosition(c) {
    $234a83ffffcaead5$var$newPositionMap.set(c, $234a83ffffcaead5$var$getPosition(c.el));
}
function $234a83ffffcaead5$var$applyTranslation(c) {
    const oldPos = $234a83ffffcaead5$var$positionMap.get(c);
    const newPos = $234a83ffffcaead5$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $234a83ffffcaead5$var$getPosition(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top
    };
}
function $234a83ffffcaead5$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$234a83ffffcaead5$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $234a83ffffcaead5$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $234a83ffffcaead5$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $6OYxp.isArray)(fn) ? (value)=>(0, $6OYxp.invokeArrayFns)(fn, value) : fn;
};
function $234a83ffffcaead5$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $234a83ffffcaead5$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $234a83ffffcaead5$var$assignKey = /* @__PURE__ */ Symbol("_assign");
const $234a83ffffcaead5$var$initialValueKey = /* @__PURE__ */ Symbol("_initialValue");
function $234a83ffffcaead5$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $6OYxp.looseToNumber)(value);
    return value;
}
const $234a83ffffcaead5$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        if (el.parentNode) {
            if (el.type === "text") el[$234a83ffffcaead5$var$initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
            else if (el.type === "textarea") el[$234a83ffffcaead5$var$initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
        }
        el[$234a83ffffcaead5$var$assignKey] = $234a83ffffcaead5$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $234a83ffffcaead5$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[$234a83ffffcaead5$var$assignKey]($234a83ffffcaead5$var$castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) $234a83ffffcaead5$var$addEventListener(el, "change", ()=>{
            el.value = $234a83ffffcaead5$var$castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            $234a83ffffcaead5$var$addEventListener(el, "compositionstart", $234a83ffffcaead5$var$onCompositionStart);
            $234a83ffffcaead5$var$addEventListener(el, "compositionend", $234a83ffffcaead5$var$onCompositionEnd);
            $234a83ffffcaead5$var$addEventListener(el, "change", $234a83ffffcaead5$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value, modifiers: { trim: trim, number: number } }) {
        const newValue = value == null ? "" : value;
        const initialValue = el[$234a83ffffcaead5$var$initialValueKey];
        delete el[$234a83ffffcaead5$var$initialValueKey];
        if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) el[$234a83ffffcaead5$var$assignKey]($234a83ffffcaead5$var$castValue(el.value, trim, number));
        else el.value = newValue;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$234a83ffffcaead5$var$assignKey] = $234a83ffffcaead5$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $6OYxp.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        const rootNode = el.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $234a83ffffcaead5$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$234a83ffffcaead5$var$assignKey] = $234a83ffffcaead5$var$getModelAssigner(vnode);
        $234a83ffffcaead5$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $234a83ffffcaead5$var$getValue(el);
            const checked = el.checked;
            const assign = el[$234a83ffffcaead5$var$assignKey];
            if ((0, $6OYxp.isArray)(modelValue)) {
                const index = (0, $6OYxp.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $6OYxp.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($234a83ffffcaead5$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $234a83ffffcaead5$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$234a83ffffcaead5$var$assignKey] = $234a83ffffcaead5$var$getModelAssigner(vnode);
        $234a83ffffcaead5$var$setChecked(el, binding, vnode);
    }
};
function $234a83ffffcaead5$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $6OYxp.isArray)(value)) checked = (0, $6OYxp.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $6OYxp.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $6OYxp.looseEqual)(value, $234a83ffffcaead5$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $234a83ffffcaead5$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $6OYxp.looseEqual)(value, vnode.props.value);
        el[$234a83ffffcaead5$var$assignKey] = $234a83ffffcaead5$var$getModelAssigner(vnode);
        $234a83ffffcaead5$var$addEventListener(el, "change", ()=>{
            el[$234a83ffffcaead5$var$assignKey]($234a83ffffcaead5$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$234a83ffffcaead5$var$assignKey] = $234a83ffffcaead5$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $6OYxp.looseEqual)(value, vnode.props.value);
    }
};
const $234a83ffffcaead5$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        el._modelValue = value;
        $234a83ffffcaead5$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $6OYxp.looseToNumber)($234a83ffffcaead5$var$getValue(o)) : $234a83ffffcaead5$var$getValue(o));
            const multiple = el.multiple;
            const assignedValue = multiple ? (0, $6OYxp.isSet)(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0];
            const pending = el._pendingValue = [
                multiple,
                multiple ? (0, $6OYxp.isArray)(assignedValue) ? selectedVal.slice() : selectedVal : assignedValue
            ];
            try {
                el[$234a83ffffcaead5$var$assignKey](assignedValue);
            } finally{
                (0, $jDVdF.nextTick)(()=>{
                    if (el._pendingValue === pending) el._pendingValue = void 0;
                });
            }
        });
        el[$234a83ffffcaead5$var$assignKey] = $234a83ffffcaead5$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $234a83ffffcaead5$var$setSelected(el, value);
    },
    beforeUpdate (el, { value: value }, vnode) {
        el._modelValue = value;
        el[$234a83ffffcaead5$var$assignKey] = $234a83ffffcaead5$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        const pending = el._pendingValue;
        el._pendingValue = void 0;
        if (!pending || pending[0] !== el.multiple || !$234a83ffffcaead5$var$isSameSelectValue(value, pending[1], pending[0])) $234a83ffffcaead5$var$setSelected(el, value);
    }
};
function $234a83ffffcaead5$var$isSameSelectValue(value, assignedValue, multiple) {
    if (!multiple) return (0, $6OYxp.looseEqual)(value, assignedValue);
    if ((0, $6OYxp.isArray)(value)) return (0, $6OYxp.looseEqual)(value, assignedValue);
    if ((0, $6OYxp.isSet)(value)) {
        if (value.size !== assignedValue.length) return false;
        for (const item of assignedValue){
            if (!value.has(item)) return false;
        }
        return true;
    }
    return false;
}
function $234a83ffffcaead5$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $6OYxp.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $6OYxp.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $234a83ffffcaead5$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $6OYxp.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $6OYxp.looseEqual)($234a83ffffcaead5$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $234a83ffffcaead5$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $234a83ffffcaead5$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $234a83ffffcaead5$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $234a83ffffcaead5$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $234a83ffffcaead5$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $234a83ffffcaead5$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $234a83ffffcaead5$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $234a83ffffcaead5$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $234a83ffffcaead5$export$87d227567b51ca39;
        case "TEXTAREA":
            return $234a83ffffcaead5$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $234a83ffffcaead5$export$8847c2e532b35714;
                case "radio":
                    return $234a83ffffcaead5$export$b4356c59b38b7aa9;
                default:
                    return $234a83ffffcaead5$export$f1f88689f5728478;
            }
    }
}
function $234a83ffffcaead5$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $234a83ffffcaead5$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $234a83ffffcaead5$var$initVModelForSSR() {
    $234a83ffffcaead5$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $234a83ffffcaead5$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $6OYxp.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $234a83ffffcaead5$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $6OYxp.isArray)(value)) {
            if (vnode.props && (0, $6OYxp.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $6OYxp.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $234a83ffffcaead5$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $234a83ffffcaead5$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $234a83ffffcaead5$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $234a83ffffcaead5$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$234a83ffffcaead5$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $234a83ffffcaead5$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $234a83ffffcaead5$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $234a83ffffcaead5$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $234a83ffffcaead5$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $6OYxp.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $234a83ffffcaead5$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $234a83ffffcaead5$var$rendererOptions = /* @__PURE__ */ (0, $6OYxp.extend)({
    patchProp: $234a83ffffcaead5$export$cd4aa0842d13df8b
}, $234a83ffffcaead5$export$de4fb7f5030605d3);
let $234a83ffffcaead5$var$renderer;
let $234a83ffffcaead5$var$enabledHydration = false;
function $234a83ffffcaead5$var$ensureRenderer() {
    return $234a83ffffcaead5$var$renderer || ($234a83ffffcaead5$var$renderer = (0, $jDVdF.createRenderer)($234a83ffffcaead5$var$rendererOptions));
}
function $234a83ffffcaead5$var$ensureHydrationRenderer() {
    $234a83ffffcaead5$var$renderer = $234a83ffffcaead5$var$enabledHydration ? $234a83ffffcaead5$var$renderer : (0, $jDVdF.createHydrationRenderer)($234a83ffffcaead5$var$rendererOptions);
    $234a83ffffcaead5$var$enabledHydration = true;
    return $234a83ffffcaead5$var$renderer;
}
const $234a83ffffcaead5$export$b3890eb0ae9dca99 = (...args)=>{
    $234a83ffffcaead5$var$ensureRenderer().render(...args);
};
const $234a83ffffcaead5$export$fa8d919ba61d84db = (...args)=>{
    $234a83ffffcaead5$var$ensureHydrationRenderer().hydrate(...args);
};
const $234a83ffffcaead5$export$4e373c34abfa8c68 = (...args)=>{
    const app = $234a83ffffcaead5$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $234a83ffffcaead5$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $6OYxp.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $234a83ffffcaead5$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $234a83ffffcaead5$export$35800275c0037383 = (...args)=>{
    const app = $234a83ffffcaead5$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $234a83ffffcaead5$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $234a83ffffcaead5$var$resolveRootNamespace(container));
    };
    return app;
};
function $234a83ffffcaead5$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $234a83ffffcaead5$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $6OYxp.isHTMLTag)(tag) || (0, $6OYxp.isSVGTag)(tag) || (0, $6OYxp.isMathMLTag)(tag),
        writable: false
    });
}
function $234a83ffffcaead5$var$injectCompilerOptionsCheck(app) {
    if ((0, $jDVdF.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $jDVdF.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $jDVdF.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $jDVdF.warn)(msg);
            }
        });
    }
}
function $234a83ffffcaead5$var$normalizeContainer(container) {
    if ((0, $6OYxp.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $234a83ffffcaead5$var$ssrDirectiveInitialized = false;
const $234a83ffffcaead5$export$800b28255aa678d9 = ()=>{
    if (!$234a83ffffcaead5$var$ssrDirectiveInitialized) {
        $234a83ffffcaead5$var$ssrDirectiveInitialized = true;
        $234a83ffffcaead5$var$initVModelForSSR();
        $234a83ffffcaead5$var$initVShowForSSR();
    }
};

});


parcelRegister("4TkSB", function(module, exports) {

$parcel$export(module.exports, "createApi", () => $b99b31bad30daf17$export$9cdc2b9a8d94c842);

var $2woe1 = parcelRequire("2woe1");

var $tL0U5 = parcelRequire("tL0U5");

var $jThV5 = parcelRequire("jThV5");
function $b99b31bad30daf17$export$9cdc2b9a8d94c842() {
    const client = (0, $2woe1.default)({
        baseUrl: (0, $jThV5.config).apiUrl
    });
    return (0, $tL0U5.createApiRepository)(client);
}

});
parcelRegister("2woe1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fb546c649c3665$export$2e2bcd8739ae039);
const $44fb546c649c3665$var$PATH_PARAM_RE = /\{[^{}]+\}/g;
const $44fb546c649c3665$var$supportsRequestInitExt = ()=>{
    return false;
};
function $44fb546c649c3665$export$ddcec56dc3db7f2c() {
    return Math.random().toString(36).slice(2, 11);
}
function $44fb546c649c3665$export$2e2bcd8739ae039(clientOptions) {
    let { baseUrl: baseUrl = "", Request: CustomRequest = globalThis.Request, fetch: baseFetch = globalThis.fetch, querySerializer: globalQuerySerializer, bodySerializer: globalBodySerializer, pathSerializer: globalPathSerializer, headers: baseHeaders, requestInitExt: requestInitExt, ...baseOptions } = {
        ...clientOptions
    };
    requestInitExt = $44fb546c649c3665$var$supportsRequestInitExt() ? requestInitExt : void 0;
    baseUrl = $44fb546c649c3665$export$b6d465111d914331(baseUrl);
    const globalMiddlewares = [];
    async function coreFetch(schemaPath, fetchOptions) {
        const { baseUrl: localBaseUrl, fetch: fetch = baseFetch, Request: Request = CustomRequest, headers: headers, params: params = {}, parseAs: parseAs = "json", querySerializer: requestQuerySerializer, bodySerializer: bodySerializer = globalBodySerializer ?? $44fb546c649c3665$export$75a86642fb2d79a0, pathSerializer: requestPathSerializer, body: body, middleware: requestMiddlewares = [], ...init } = fetchOptions || {};
        let finalBaseUrl = baseUrl;
        if (localBaseUrl) finalBaseUrl = $44fb546c649c3665$export$b6d465111d914331(localBaseUrl) ?? baseUrl;
        let querySerializer = typeof globalQuerySerializer === "function" ? globalQuerySerializer : $44fb546c649c3665$export$db5dd4577326922e(globalQuerySerializer);
        if (requestQuerySerializer) querySerializer = typeof requestQuerySerializer === "function" ? requestQuerySerializer : $44fb546c649c3665$export$db5dd4577326922e({
            ...typeof globalQuerySerializer === "object" ? globalQuerySerializer : {},
            ...requestQuerySerializer
        });
        const pathSerializer = requestPathSerializer || globalPathSerializer || $44fb546c649c3665$export$8d266d20a1e70eef;
        const serializedBody = body === void 0 ? void 0 : bodySerializer(body, // Note: we declare mergeHeaders() both here and below because it’s a bit of a chicken-or-egg situation:
        // bodySerializer() needs all headers so we aren’t dropping ones set by the user, however,
        // the result of this ALSO sets the lowest-priority content-type header. So we re-merge below,
        // setting the content-type at the very beginning to be overwritten.
        // Lastly, based on the way headers work, it’s not a simple “present-or-not” check becauase null intentionally un-sets headers.
        $44fb546c649c3665$export$eee1781d075786ae(baseHeaders, headers, params.header));
        const finalHeaders = $44fb546c649c3665$export$eee1781d075786ae(// with no body, we should not to set Content-Type
        serializedBody === void 0 || // if serialized body is FormData; browser will correctly set Content-Type & boundary expression
        serializedBody instanceof FormData ? {} : {
            "Content-Type": "application/json"
        }, baseHeaders, headers, params.header);
        const finalMiddlewares = [
            ...globalMiddlewares,
            ...requestMiddlewares
        ];
        const requestInit = {
            redirect: "follow",
            ...baseOptions,
            ...init,
            body: serializedBody,
            headers: finalHeaders
        };
        let id;
        let options;
        let request = new Request($44fb546c649c3665$export$da8b2e6360cc2092(schemaPath, {
            baseUrl: finalBaseUrl,
            params: params,
            querySerializer: querySerializer,
            pathSerializer: pathSerializer
        }), requestInit);
        let response;
        for(const key in init)if (!(key in request)) request[key] = init[key];
        if (finalMiddlewares.length) {
            id = $44fb546c649c3665$export$ddcec56dc3db7f2c();
            options = Object.freeze({
                baseUrl: finalBaseUrl,
                fetch: fetch,
                parseAs: parseAs,
                querySerializer: querySerializer,
                bodySerializer: bodySerializer,
                pathSerializer: pathSerializer
            });
            for (const m of finalMiddlewares)if (m && typeof m === "object" && typeof m.onRequest === "function") {
                const result = await m.onRequest({
                    request: request,
                    schemaPath: schemaPath,
                    params: params,
                    options: options,
                    id: id
                });
                if (result) {
                    if (result instanceof Request) request = result;
                    else if (result instanceof Response) {
                        response = result;
                        break;
                    } else throw new Error("onRequest: must return new Request() or Response() when modifying the request");
                }
            }
        }
        if (!response) {
            try {
                response = await fetch(request, requestInitExt);
            } catch (error2) {
                let errorAfterMiddleware = error2;
                if (finalMiddlewares.length) for(let i = finalMiddlewares.length - 1; i >= 0; i--){
                    const m = finalMiddlewares[i];
                    if (m && typeof m === "object" && typeof m.onError === "function") {
                        const result = await m.onError({
                            request: request,
                            error: errorAfterMiddleware,
                            schemaPath: schemaPath,
                            params: params,
                            options: options,
                            id: id
                        });
                        if (result) {
                            if (result instanceof Response) {
                                errorAfterMiddleware = void 0;
                                response = result;
                                break;
                            }
                            if (result instanceof Error) {
                                errorAfterMiddleware = result;
                                continue;
                            }
                            throw new Error("onError: must return new Response() or instance of Error");
                        }
                    }
                }
                if (errorAfterMiddleware) throw errorAfterMiddleware;
            }
            if (finalMiddlewares.length) for(let i = finalMiddlewares.length - 1; i >= 0; i--){
                const m = finalMiddlewares[i];
                if (m && typeof m === "object" && typeof m.onResponse === "function") {
                    const result = await m.onResponse({
                        request: request,
                        response: response,
                        schemaPath: schemaPath,
                        params: params,
                        options: options,
                        id: id
                    });
                    if (result) {
                        if (!(result instanceof Response)) throw new Error("onResponse: must return new Response() when modifying the response");
                        response = result;
                    }
                }
            }
        }
        const contentLength = response.headers.get("Content-Length");
        if (response.status === 204 || request.method === "HEAD" || contentLength === "0" && !response.headers.get("Transfer-Encoding")?.includes("chunked")) return response.ok ? {
            data: void 0,
            response: response
        } : {
            error: void 0,
            response: response
        };
        if (response.ok) {
            const getResponseData = async ()=>{
                if (parseAs === "stream") return response.body;
                if (parseAs === "json" && !contentLength) {
                    const raw = await response.text();
                    return raw ? JSON.parse(raw) : void 0;
                }
                return await response[parseAs]();
            };
            return {
                data: await getResponseData(),
                response: response
            };
        }
        let error = await response.text();
        try {
            error = JSON.parse(error);
        } catch  {}
        return {
            error: error,
            response: response
        };
    }
    return {
        request (method, url, init) {
            return coreFetch(url, {
                ...init,
                method: method.toUpperCase()
            });
        },
        /** Call a GET endpoint */ GET (url, init) {
            return coreFetch(url, {
                ...init,
                method: "GET"
            });
        },
        /** Call a PUT endpoint */ PUT (url, init) {
            return coreFetch(url, {
                ...init,
                method: "PUT"
            });
        },
        /** Call a POST endpoint */ POST (url, init) {
            return coreFetch(url, {
                ...init,
                method: "POST"
            });
        },
        /** Call a DELETE endpoint */ DELETE (url, init) {
            return coreFetch(url, {
                ...init,
                method: "DELETE"
            });
        },
        /** Call a OPTIONS endpoint */ OPTIONS (url, init) {
            return coreFetch(url, {
                ...init,
                method: "OPTIONS"
            });
        },
        /** Call a HEAD endpoint */ HEAD (url, init) {
            return coreFetch(url, {
                ...init,
                method: "HEAD"
            });
        },
        /** Call a PATCH endpoint */ PATCH (url, init) {
            return coreFetch(url, {
                ...init,
                method: "PATCH"
            });
        },
        /** Call a TRACE endpoint */ TRACE (url, init) {
            return coreFetch(url, {
                ...init,
                method: "TRACE"
            });
        },
        /** Register middleware */ use (...middleware) {
            for (const m of middleware){
                if (!m) continue;
                if (typeof m !== "object" || !("onRequest" in m || "onResponse" in m || "onError" in m)) throw new Error("Middleware must be an object with one of `onRequest()`, `onResponse() or `onError()`");
                globalMiddlewares.push(m);
            }
        },
        /** Unregister middleware */ eject (...middleware) {
            for (const m of middleware){
                const i = globalMiddlewares.indexOf(m);
                if (i !== -1) globalMiddlewares.splice(i, 1);
            }
        }
    };
}
class $44fb546c649c3665$var$PathCallForwarder {
    constructor(client, url){
        this.client = client;
        this.url = url;
    }
    GET = (init)=>{
        return this.client.GET(this.url, init);
    };
    PUT = (init)=>{
        return this.client.PUT(this.url, init);
    };
    POST = (init)=>{
        return this.client.POST(this.url, init);
    };
    DELETE = (init)=>{
        return this.client.DELETE(this.url, init);
    };
    OPTIONS = (init)=>{
        return this.client.OPTIONS(this.url, init);
    };
    HEAD = (init)=>{
        return this.client.HEAD(this.url, init);
    };
    PATCH = (init)=>{
        return this.client.PATCH(this.url, init);
    };
    TRACE = (init)=>{
        return this.client.TRACE(this.url, init);
    };
}
class $44fb546c649c3665$var$PathClientProxyHandler {
    constructor(){
        this.client = null;
    }
    // Assume the property is an URL.
    get(coreClient, url) {
        const forwarder = new $44fb546c649c3665$var$PathCallForwarder(coreClient, url);
        this.client[url] = forwarder;
        return forwarder;
    }
}
function $44fb546c649c3665$export$7635eeb3e012a2cf(coreClient) {
    const handler = new $44fb546c649c3665$var$PathClientProxyHandler();
    const proxy = new Proxy(coreClient, handler);
    function Client() {}
    Client.prototype = proxy;
    const client = new Client();
    handler.client = client;
    return client;
}
function $44fb546c649c3665$export$290577a5816c1e9a(clientOptions) {
    return $44fb546c649c3665$export$7635eeb3e012a2cf($44fb546c649c3665$export$2e2bcd8739ae039(clientOptions));
}
function $44fb546c649c3665$export$8e146cb7ee7a6316(name, value, options) {
    if (value === void 0 || value === null) return "";
    if (typeof value === "object") throw new Error("Deeply-nested arrays/objects aren\u2019t supported. Provide your own `querySerializer()` to handle these.");
    return `${name}=${options?.allowReserved === true ? value : encodeURIComponent(value)}`;
}
function $44fb546c649c3665$export$43d270033295e41a(name, value, options) {
    if (!value || typeof value !== "object") return "";
    const values = [];
    const joiner = {
        simple: ",",
        label: ".",
        matrix: ";"
    }[options.style] || "&";
    if (options.style !== "deepObject" && options.explode === false) {
        for(const k in value)values.push(k, options.allowReserved === true ? value[k] : encodeURIComponent(value[k]));
        const final2 = values.join(",");
        switch(options.style){
            case "form":
                return `${name}=${final2}`;
            case "label":
                return `.${final2}`;
            case "matrix":
                return `;${name}=${final2}`;
            default:
                return final2;
        }
    }
    for(const k in value){
        const finalName = options.style === "deepObject" ? `${name}[${k}]` : k;
        values.push($44fb546c649c3665$export$8e146cb7ee7a6316(finalName, value[k], options));
    }
    const final = values.join(joiner);
    return options.style === "label" || options.style === "matrix" ? `${joiner}${final}` : final;
}
function $44fb546c649c3665$export$ad3322bbc3b60542(name, value, options) {
    if (!Array.isArray(value)) return "";
    if (options.explode === false) {
        const joiner2 = {
            form: ",",
            spaceDelimited: "%20",
            pipeDelimited: "|"
        }[options.style] || ",";
        const final = (options.allowReserved === true ? value : value.map((v)=>encodeURIComponent(v))).join(joiner2);
        switch(options.style){
            case "simple":
                return final;
            case "label":
                return `.${final}`;
            case "matrix":
                return `;${name}=${final}`;
            // case "spaceDelimited":
            // case "pipeDelimited":
            default:
                return `${name}=${final}`;
        }
    }
    const joiner = {
        simple: ",",
        label: ".",
        matrix: ";"
    }[options.style] || "&";
    const values = [];
    for (const v of value)if (options.style === "simple" || options.style === "label") values.push(options.allowReserved === true ? v : encodeURIComponent(v));
    else values.push($44fb546c649c3665$export$8e146cb7ee7a6316(name, v, options));
    return options.style === "label" || options.style === "matrix" ? `${joiner}${values.join(joiner)}` : values.join(joiner);
}
function $44fb546c649c3665$export$db5dd4577326922e(options) {
    return function querySerializer(queryParams) {
        const search = [];
        if (queryParams && typeof queryParams === "object") for(const name in queryParams){
            const value = queryParams[name];
            if (value === void 0 || value === null) continue;
            if (Array.isArray(value)) {
                if (value.length === 0) continue;
                search.push($44fb546c649c3665$export$ad3322bbc3b60542(name, value, {
                    style: "form",
                    explode: true,
                    ...options?.array,
                    allowReserved: options?.allowReserved || false
                }));
                continue;
            }
            if (typeof value === "object") {
                search.push($44fb546c649c3665$export$43d270033295e41a(name, value, {
                    style: "deepObject",
                    explode: true,
                    ...options?.object,
                    allowReserved: options?.allowReserved || false
                }));
                continue;
            }
            search.push($44fb546c649c3665$export$8e146cb7ee7a6316(name, value, options));
        }
        return search.join("&");
    };
}
function $44fb546c649c3665$export$8d266d20a1e70eef(pathname, pathParams) {
    let nextURL = pathname;
    for (const match of pathname.match($44fb546c649c3665$var$PATH_PARAM_RE) ?? []){
        let name = match.substring(1, match.length - 1);
        let explode = false;
        let style = "simple";
        if (name.endsWith("*")) {
            explode = true;
            name = name.substring(0, name.length - 1);
        }
        if (name.startsWith(".")) {
            style = "label";
            name = name.substring(1);
        } else if (name.startsWith(";")) {
            style = "matrix";
            name = name.substring(1);
        }
        if (!pathParams || pathParams[name] === void 0 || pathParams[name] === null) continue;
        const value = pathParams[name];
        if (Array.isArray(value)) {
            nextURL = nextURL.replace(match, $44fb546c649c3665$export$ad3322bbc3b60542(name, value, {
                style: style,
                explode: explode
            }));
            continue;
        }
        if (typeof value === "object") {
            nextURL = nextURL.replace(match, $44fb546c649c3665$export$43d270033295e41a(name, value, {
                style: style,
                explode: explode
            }));
            continue;
        }
        if (style === "matrix") {
            nextURL = nextURL.replace(match, `;${$44fb546c649c3665$export$8e146cb7ee7a6316(name, value)}`);
            continue;
        }
        nextURL = nextURL.replace(match, style === "label" ? `.${encodeURIComponent(value)}` : encodeURIComponent(value));
    }
    return nextURL;
}
function $44fb546c649c3665$export$75a86642fb2d79a0(body, headers) {
    if (body instanceof FormData) return body;
    if (headers) {
        const contentType = headers.get instanceof Function ? headers.get("Content-Type") ?? headers.get("content-type") : headers["Content-Type"] ?? headers["content-type"];
        if (contentType === "application/x-www-form-urlencoded") return new URLSearchParams(body).toString();
    }
    return JSON.stringify(body);
}
function $44fb546c649c3665$export$da8b2e6360cc2092(pathname, options) {
    let finalURL = `${options.baseUrl}${pathname}`;
    if (options.params?.path) finalURL = options.pathSerializer(finalURL, options.params.path);
    let search = options.querySerializer(options.params.query ?? {});
    if (search.startsWith("?")) search = search.substring(1);
    if (search) finalURL += `?${search}`;
    return finalURL;
}
function $44fb546c649c3665$export$eee1781d075786ae(...allHeaders) {
    const finalHeaders = new Headers();
    for (const h of allHeaders){
        if (!h || typeof h !== "object") continue;
        const iterator = h instanceof Headers ? h.entries() : Object.entries(h);
        for (const [k, v] of iterator){
            if (v === null) finalHeaders.delete(k);
            else if (Array.isArray(v)) for (const v2 of v)finalHeaders.append(k, v2);
            else if (v !== void 0) finalHeaders.set(k, v);
        }
    }
    return finalHeaders;
}
function $44fb546c649c3665$export$b6d465111d914331(url) {
    if (url.endsWith("/")) return url.substring(0, url.length - 1);
    return url;
}

});

parcelRegister("tL0U5", function(module, exports) {

$parcel$export(module.exports, "createApiRepository", () => $bbd230e5ce70aa2a$export$47c9400c9cbbd3f7);

var $i805f = parcelRequire("i805f");

var $03l8b = parcelRequire("03l8b");
function $bbd230e5ce70aa2a$export$47c9400c9cbbd3f7(client) {
    return {
        topApi: (0, $i805f.createTopApi)(client),
        medicalInstitutionsApi: (0, $03l8b.createMedicalInstitutionsApi)(client)
    };
}

});
parcelRegister("i805f", function(module, exports) {

$parcel$export(module.exports, "createTopApi", () => $82e4ec08f1d6669f$export$21f6b6f4ed680f72);

var $frgor = parcelRequire("frgor");
function $82e4ec08f1d6669f$export$21f6b6f4ed680f72(client) {
    return {
        getTop () {
            return (0, $frgor.request)(client.GET('/top'));
        }
    };
}

});
parcelRegister("frgor", function(module, exports) {

$parcel$export(module.exports, "request", () => $a64b507923ba822c$export$b5fe3f66a567bec0);
class $a64b507923ba822c$export$f2e832acab1bdd79 extends Error {
    response;
    constructor(status, data, headers){
        super(`Request failed with status code ${status}`);
        this.name = 'ApiError';
        this.response = {
            status: status,
            data: data,
            headers: headers
        };
    }
}
async function $a64b507923ba822c$export$b5fe3f66a567bec0(result) {
    const { data: data, error: error, response: response } = await result;
    if (response.ok) return {
        status: response.status,
        data: data,
        headers: response.headers
    };
    throw new $a64b507923ba822c$export$f2e832acab1bdd79(response.status, error, response.headers);
}
async function $a64b507923ba822c$export$8383bac957b11f95(result) {
    const { error: error, response: response } = await result;
    if (response.ok) return {
        status: response.status,
        data: undefined,
        headers: response.headers
    };
    throw new $a64b507923ba822c$export$f2e832acab1bdd79(response.status, error, response.headers);
}

});


parcelRegister("03l8b", function(module, exports) {

$parcel$export(module.exports, "createMedicalInstitutionsApi", () => $a2c459e5c8d26b88$export$28779340611d415a);

var $frgor = parcelRequire("frgor");
function $a2c459e5c8d26b88$export$28779340611d415a(client) {
    return {
        getMedicalInstitutions () {
            return (0, $frgor.request)(client.GET('/medical_institutions'));
        }
    };
}

});


parcelRegister("jThV5", function(module, exports) {

$parcel$export(module.exports, "config", () => $75ffcf0f1a364f37$export$e506a1d27d1eaa20);
const $75ffcf0f1a364f37$export$e506a1d27d1eaa20 = (()=>{
    const env = "production" ?? 'development';
    switch(env){
        case 'production':
            return {
                env: 'production',
                host: 'https://yakubato.jp',
                apiUrl: 'https://patient-api.yakubato.jp/lp'
            };
        case 'staging':
            return {
                env: 'staging',
                host: 'https://stg.yakubato.jp',
                apiUrl: 'https://stg-patient-api.yakubato.jp/lp'
            };
        case 'test':
            return {
                env: 'test',
                host: '',
                apiUrl: ''
            };
        default:
            return {
                env: 'development',
                host: '',
                apiUrl: 'http://patient-api.yakubato.localhost/lp'
            };
    }
})();

});


parcelRegister("1EsSH", function(module, exports) {

var $ix70k = parcelRequire("ix70k");

var $4Fhll = parcelRequire("4Fhll");
function $d1c945ac00e682a7$export$8c87867db9bed1e1() {
    return {
        topApi: (0, $ix70k.default),
        medicalInstitutionsApi: (0, $4Fhll.default)
    };
}

});
parcelRegister("ix70k", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb4a54d085017b6$export$2e2bcd8739ae039);

var $iYCOx = parcelRequire("iYCOx");

var $1glr6 = parcelRequire("1glr6");

var $1qyAQ = parcelRequire("1qyAQ");
var $7bb4a54d085017b6$export$2e2bcd8739ae039 = {
    async getTop () {
        await (0, $1glr6.sleep)();
        return new Promise((resolve)=>{
            return resolve((0, $iYCOx.response)((0, $1qyAQ.createTopMock)()));
        });
    }
};

});
parcelRegister("iYCOx", function(module, exports) {

$parcel$export(module.exports, "response", () => $4a1dfa0284af112c$export$785bb8ef7fad1f74);
function $4a1dfa0284af112c$export$785bb8ef7fad1f74(data, status = 200, headers = new Headers({
    'x-csrf-token': 'mock-csrf-token'
})) {
    return {
        data: JSON.parse(JSON.stringify(data)),
        status: status,
        headers: headers
    };
}

});

parcelRegister("1glr6", function(module, exports) {

$parcel$export(module.exports, "sleep", () => $a87cc363b86e0a0e$export$e772c8ff12451969);
function $a87cc363b86e0a0e$export$e772c8ff12451969() {
    return new Promise((resolve)=>setTimeout(resolve, 300));
}

});

parcelRegister("1qyAQ", function(module, exports) {

$parcel$export(module.exports, "createTopMock", () => $34e591490ae3564a$export$36bde834a3bc1540);
const $34e591490ae3564a$export$36bde834a3bc1540 = (overwrite)=>{
    return {
        medicalInstitutions: $34e591490ae3564a$export$754ec74260bb04d3(),
        ...overwrite
    };
};
const $34e591490ae3564a$export$754ec74260bb04d3 = (count = 10)=>{
    return Array(count).fill(0).map((_, index)=>$34e591490ae3564a$var$createMedicalInstitutionMock({
            slug: `test-slug-${index}`,
            name: `\u{3084}\u{304F}\u{3070}\u{3068}\u{533B}\u{7642}\u{6A5F}\u{95A2} ${index}`,
            lpLogoImageUrl: index % 2 ? `https://dummyimage.com/170x30/000000/ffffff&text=logo${index}` : `https://dummyimage.com/170x300/000000/ffffff&text=logo${index}`
        }));
};
const $34e591490ae3564a$var$createMedicalInstitutionMock = (overwrite)=>{
    return {
        slug: 'test-slug',
        name: "\u3084\u304F\u3070\u3068\u533B\u7642\u6A5F\u95A2",
        lpLogoImageUrl: 'https://dummyimage.com/600x400/000000/ffffff&text=logo',
        ...overwrite
    };
};

});


parcelRegister("4Fhll", function(module, exports) {

$parcel$export(module.exports, "default", () => $70c0ad2462048796$export$2e2bcd8739ae039);

var $iYCOx = parcelRequire("iYCOx");

var $1glr6 = parcelRequire("1glr6");

var $8a2ZI = parcelRequire("8a2ZI");
var $70c0ad2462048796$export$2e2bcd8739ae039 = {
    async getMedicalInstitutions () {
        await (0, $1glr6.sleep)();
        return new Promise((resolve)=>{
            return resolve((0, $iYCOx.response)((0, $8a2ZI.createMedicalInstitutionsMock)()));
        });
    }
};

});
parcelRegister("8a2ZI", function(module, exports) {

$parcel$export(module.exports, "createMedicalInstitutionsMock", () => $412314f169bb516d$export$65414dfa2798266f);
const $412314f169bb516d$export$65414dfa2798266f = (overwrite)=>{
    return {
        lastUpdatedAt: '2023-09-22',
        medicalInstitutions: Array(20).fill(0).map((_, index)=>$412314f169bb516d$var$createMedicalInstitutionMock({
                slug: `test-slug-${index}`,
                name: `\u{3084}\u{304F}\u{3070}\u{3068}\u{533B}\u{7642}\u{6A5F}\u{95A2} ${index}`,
                enableMedicalAppointment: index % 2 === 0,
                enablePharmacyReservation: index % 2 !== 0 || index % 3 !== 0,
                zipCode1: '100',
                zipCode2: '0001',
                prefecture: [
                    "\u6771\u4EAC\u90FD",
                    "\u5343\u8449\u770C",
                    "\u795E\u5948\u5DDD\u770C"
                ][index % 3],
                address: `\u{30C0}\u{30DF}\u{30FC}\u{6771}\u{4EAC}\u{90FD}\u{5343}\u{4EE3}\u{7530}\u{533A}\u{5343}\u{4EE3}\u{7530}1-${index}`
            })),
        ...overwrite
    };
};
const $412314f169bb516d$var$createMedicalInstitutionMock = (overwrite)=>{
    return {
        slug: 'test-slug',
        name: "\u3084\u304F\u3070\u3068\u533B\u7642\u6A5F\u95A2",
        enableMedicalAppointment: true,
        enablePharmacyReservation: true,
        zipCode1: '100',
        zipCode2: '0001',
        prefecture: "\u6771\u4EAC\u90FD",
        address: "\u6771\u4EAC\u90FD\u5343\u4EE3\u7530\u533A\u5343\u4EE3\u75301-1",
        ...overwrite
    };
};

});



parcelRegister("97VdX", function(module, exports) {

$parcel$export(module.exports, "createPinia", () => $6a5128069d3b56bc$export$4b9f6a0748623d44);
$parcel$export(module.exports, "defineStore", () => $6a5128069d3b56bc$export$5061c4f75bbcb4a);
/*!
 * pinia v4.0.3
 * (c) 2026 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("3cJ3M");
var $36gU0 = parcelRequire("36gU0");
var $jDVdF = parcelRequire("jDVdF");

var $lsPkV = parcelRequire("lsPkV");

var $2B7NK = parcelRequire("2B7NK");
//#region src/env.ts
const $6a5128069d3b56bc$var$IS_CLIENT = typeof window !== "undefined";
//#endregion
//#region src/diagnostics.ts
/**
* Catalog of user-facing Pinia diagnostics. Each handle builds a diagnostic
* and runs the reporters. All call sites are dev-only (`__DEV__` guarded or
* HMR), so production builds drop the calls and tree-shake this catalog.
*/ const $6a5128069d3b56bc$var$diagnostics = /*#__PURE__*/ (0, $lsPkV.defineDiagnostics)({
    reporters: [
        /*#__PURE__*/ (0, $lsPkV.createConsoleReporter)()
    ],
    codes: {
        PINIA_R1001: {
            why: "Directly pass all stores to \"mapStores()\" without putting them in an array. This will fail in production.",
            fix: "Replace mapStores([useAuthStore, useCartStore]) with mapStores(useAuthStore, useCartStore).",
            docs: "https://pinia.vuejs.org/cookbook/options-api.html#Giving-access-to-the-whole-store"
        },
        PINIA_R1002: {
            why: (p)=>`A getter cannot have the same name as another state property. Found "${p.name}" in store "${p.id}".`,
            fix: "Rename either the getter or the state property.",
            docs: "https://pinia.vuejs.org/core-concepts/getters.html#Accessing-other-getters"
        },
        PINIA_R1003: {
            why: (p)=>`The "state" must be a plain object. Found in store "${p.id}".`,
            fix: "Return a plain object, e.g. avoid state: () => new MyClass().",
            docs: "https://pinia.vuejs.org/core-concepts/state.html#State"
        },
        PINIA_R1004: {
            why: "Pinia instance not found in context. This falls back to the global activePinia, which exposes you to cross-request pollution on the server.",
            fix: "\"useStore()\" is a composable and follows the same rules: call it at the top of setup() (or another composable), or pass the pinia instance explicitly when used outside of a component.",
            docs: "https://pinia.vuejs.org/ssr/#Using-the-store-outside-of-setup-"
        },
        PINIA_R1005: {
            why: (p)=>`The store id changed from "${p.from}" to "${p.to}", forcing a reload.`,
            docs: "https://pinia.vuejs.org/cookbook/hot-module-replacement.html#HMR-Hot-Module-Replacement-"
        },
        PINIA_R1006: {
            why: (p)=>`Property "${p.key}" of store "${p.id}" is not reactive (not a ref, reactive object, or shallowRef), so storeToRefs() ignores it.`,
            fix: "If it should be reactive state, wrap it with ref(), reactive(), or shallowRef(). If it is an intentional non-reactive property, wrap it with markRaw() so storeToRefs() skips it explicitly.",
            docs: "https://pinia.vuejs.org/core-concepts/plugins.html#Adding-new-external-properties"
        },
        PINIA_R1007: {
            why: (p)=>`The same callback was passed to "$subscribe()" of store "${p.id}" more than once. Subscriptions are deduplicated, so the duplicate is ignored.`,
            fix: "Subscribe each callback only once. If you need to resubscribe, call the returned function to remove the previous subscription first, or create a new function.",
            docs: "https://pinia.vuejs.org/core-concepts/state.html#Subscribing-to-the-state"
        }
    }
});
//#endregion
//#region src/rootStore.ts
/**
* setActivePinia must be called to handle SSR at the top of functions like
* `fetch`, `setup`, `serverPrefetch` and others
*/ let $6a5128069d3b56bc$var$activePinia;
/**
* Sets or unsets the active pinia. Used in SSR and internally when calling
* actions and getters
*
* @param pinia - Pinia instance
*/ const $6a5128069d3b56bc$export$89ffb8149ccd46af = (pinia)=>$6a5128069d3b56bc$var$activePinia = pinia;
/**
* Get the currently active pinia if there is any.
*/ const $6a5128069d3b56bc$export$d0cc41ca14a2d060 = ()=>(0, $jDVdF.hasInjectionContext)() && (0, $jDVdF.inject)($6a5128069d3b56bc$export$4a047152797c504d) || $6a5128069d3b56bc$var$activePinia;
/**
* Symbol used to provide/inject the pinia instance in the app. Used internally
* and exposed for testing purposes and edge cases like storybook. Could break
* in a minor, **USE AT YOUR OWN RISK**.
*
* For context, see:
* - https://github.com/vuejs/pinia/issues/870
* - https://github.com/vuejs/pinia/pull/2973
*
* @internal
*/ const $6a5128069d3b56bc$export$4a047152797c504d = /* istanbul ignore next */ Symbol();
//#endregion
//#region src/types.ts
function $6a5128069d3b56bc$var$isPlainObject(o) {
    return o && typeof o === "object" && Object.prototype.toString.call(o) === "[object Object]" && typeof o.toJSON !== "function";
}
/**
* Possible types for SubscriptionCallback
*/ let $6a5128069d3b56bc$export$d97371ba8df8c539 = /* @__PURE__ */ function(MutationType) {
    /**
	* Direct mutation of the state:
	*
	* - `store.name = 'new name'`
	* - `store.$state.name = 'new name'`
	* - `store.list.push('new item')`
	*/ MutationType["direct"] = "direct";
    /**
	* Mutated the state with `$patch` and an object
	*
	* - `store.$patch({ name: 'newName' })`
	*/ MutationType["patchObject"] = "patch object";
    /**
	* Mutated the state with `$patch` and a function
	*
	* - `store.$patch(state => state.name = 'newName')`
	*/ MutationType["patchFunction"] = "patch function";
    return MutationType;
}({});
//#endregion
//#region src/devtools/file-saver.ts
const $6a5128069d3b56bc$var$_global = /*#__PURE__*/ (()=>typeof window === "object" && window.window === window ? window : typeof self === "object" && self.self === self ? self : typeof $parcel$global === "object" && $parcel$global.global === $parcel$global ? $parcel$global : typeof globalThis === "object" ? globalThis : {
        HTMLElement: null
    })();
function $6a5128069d3b56bc$var$bom(blob, { autoBom: autoBom = false } = {}) {
    if (autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
        String.fromCharCode(65279),
        blob
    ], {
        type: blob.type
    });
    return blob;
}
function $6a5128069d3b56bc$var$download(url, name, opts) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.onload = function() {
        $6a5128069d3b56bc$var$saveAs(xhr.response, name, opts);
    };
    xhr.onerror = function() {
        console.error("could not download file");
    };
    xhr.send();
}
function $6a5128069d3b56bc$var$corsEnabled(url) {
    const xhr = new XMLHttpRequest();
    xhr.open("HEAD", url, false);
    try {
        xhr.send();
    } catch (e) {}
    return xhr.status >= 200 && xhr.status <= 299;
}
function $6a5128069d3b56bc$var$click(node) {
    try {
        node.dispatchEvent(new MouseEvent("click"));
    } catch (e) {
        const evt = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
            detail: 0,
            screenX: 80,
            screenY: 20,
            clientX: 80,
            clientY: 20,
            ctrlKey: false,
            altKey: false,
            shiftKey: false,
            metaKey: false,
            button: 0,
            relatedTarget: null
        });
        node.dispatchEvent(evt);
    }
}
const $6a5128069d3b56bc$var$_navigator = typeof navigator === "object" ? navigator : {
    userAgent: ""
};
const $6a5128069d3b56bc$var$isMacOSWebView = /*#__PURE__*/ (()=>/Macintosh/.test($6a5128069d3b56bc$var$_navigator.userAgent) && /AppleWebKit/.test($6a5128069d3b56bc$var$_navigator.userAgent) && !/Safari/.test($6a5128069d3b56bc$var$_navigator.userAgent))();
const $6a5128069d3b56bc$var$saveAs = !$6a5128069d3b56bc$var$IS_CLIENT ? ()=>{} : typeof HTMLAnchorElement !== "undefined" && "download" in HTMLAnchorElement.prototype && !$6a5128069d3b56bc$var$isMacOSWebView ? $6a5128069d3b56bc$var$downloadSaveAs : "msSaveOrOpenBlob" in $6a5128069d3b56bc$var$_navigator ? $6a5128069d3b56bc$var$msSaveAs : $6a5128069d3b56bc$var$fileSaverSaveAs;
function $6a5128069d3b56bc$var$downloadSaveAs(blob, name = "download", opts) {
    const a = document.createElement("a");
    a.download = name;
    a.rel = "noopener";
    if (typeof blob === "string") {
        a.href = blob;
        if (a.origin !== location.origin) {
            if ($6a5128069d3b56bc$var$corsEnabled(a.href)) $6a5128069d3b56bc$var$download(blob, name, opts);
            else {
                a.target = "_blank";
                $6a5128069d3b56bc$var$click(a);
            }
        } else $6a5128069d3b56bc$var$click(a);
    } else {
        a.href = URL.createObjectURL(blob);
        setTimeout(function() {
            URL.revokeObjectURL(a.href);
        }, 4e4);
        setTimeout(function() {
            $6a5128069d3b56bc$var$click(a);
        }, 0);
    }
}
function $6a5128069d3b56bc$var$msSaveAs(blob, name = "download", opts) {
    if (typeof blob === "string") {
        if ($6a5128069d3b56bc$var$corsEnabled(blob)) $6a5128069d3b56bc$var$download(blob, name, opts);
        else {
            const a = document.createElement("a");
            a.href = blob;
            a.target = "_blank";
            setTimeout(function() {
                $6a5128069d3b56bc$var$click(a);
            });
        }
    } else navigator.msSaveOrOpenBlob($6a5128069d3b56bc$var$bom(blob, opts), name);
}
function $6a5128069d3b56bc$var$fileSaverSaveAs(blob, name, opts, popup) {
    popup = popup || open("", "_blank");
    if (popup) popup.document.title = popup.document.body.innerText = "downloading...";
    if (typeof blob === "string") return $6a5128069d3b56bc$var$download(blob, name, opts);
    const force = blob.type === "application/octet-stream";
    const isSafari = /constructor/i.test(String($6a5128069d3b56bc$var$_global.HTMLElement)) || "safari" in $6a5128069d3b56bc$var$_global;
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((isChromeIOS || force && isSafari || $6a5128069d3b56bc$var$isMacOSWebView) && typeof FileReader !== "undefined") {
        const reader = new FileReader();
        reader.onloadend = function() {
            let url = reader.result;
            if (typeof url !== "string") {
                popup = null;
                throw new Error("Wrong reader.result type");
            }
            url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, "data:attachment/file;");
            if (popup) popup.location.href = url;
            else location.assign(url);
            popup = null;
        };
        reader.readAsDataURL(blob);
    } else {
        const url = URL.createObjectURL(blob);
        if (popup) popup.location.assign(url);
        else location.href = url;
        popup = null;
        setTimeout(function() {
            URL.revokeObjectURL(url);
        }, 4e4);
    }
}
//#endregion
//#region src/devtools/utils.ts
/**
* Shows a toast or console.log
*
* @param message - message to log
* @param type - different color of the tooltip
*/ function $6a5128069d3b56bc$var$toastMessage(message, type) {
    const piniaMessage = "\uD83C\uDF4D " + message;
    if (type === "error") console.error(piniaMessage);
    else if (type === "warn") console.warn(piniaMessage);
    else console.debug(piniaMessage);
}
function $6a5128069d3b56bc$var$isPinia(o) {
    return "_a" in o && "install" in o;
}
/**
* Detects if a store getter is a writable computed (has a setter) so it can be
* edited from devtools.
*/ function $6a5128069d3b56bc$var$isWritableComputed(store, key) {
    const rawProp = (0, $36gU0.toRaw)(store)[key];
    return (0, $36gU0.isRef)(rawProp) && !(0, $36gU0.isReadonly)(rawProp);
}
//#endregion
//#region src/devtools/actions.ts
/**
* This file contain devtools actions, they are not Pinia actions.
*/ function $6a5128069d3b56bc$var$checkClipboardAccess() {
    if (!("clipboard" in navigator)) {
        $6a5128069d3b56bc$var$toastMessage(`Your browser doesn't support the Clipboard API`, "error");
        return true;
    }
}
function $6a5128069d3b56bc$var$checkNotFocusedError(error) {
    if (error instanceof Error && error.message.toLowerCase().includes("document is not focused")) {
        $6a5128069d3b56bc$var$toastMessage("You need to activate the \"Emulate a focused page\" setting in the \"Rendering\" panel of devtools.", "warn");
        return true;
    }
    return false;
}
async function $6a5128069d3b56bc$var$actionGlobalCopyState(pinia) {
    if ($6a5128069d3b56bc$var$checkClipboardAccess()) return;
    try {
        await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        $6a5128069d3b56bc$var$toastMessage("Global state copied to clipboard.");
    } catch (error) {
        if ($6a5128069d3b56bc$var$checkNotFocusedError(error)) return;
        $6a5128069d3b56bc$var$toastMessage(`Failed to serialize the state. Check the console for more details.`, "error");
        console.error(error);
    }
}
async function $6a5128069d3b56bc$var$actionGlobalPasteState(pinia) {
    if ($6a5128069d3b56bc$var$checkClipboardAccess()) return;
    try {
        $6a5128069d3b56bc$var$loadStoresState(pinia, JSON.parse(await navigator.clipboard.readText()));
        $6a5128069d3b56bc$var$toastMessage("Global state pasted from clipboard.");
    } catch (error) {
        if ($6a5128069d3b56bc$var$checkNotFocusedError(error)) return;
        $6a5128069d3b56bc$var$toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, "error");
        console.error(error);
    }
}
async function $6a5128069d3b56bc$var$actionGlobalSaveState(pinia) {
    try {
        $6a5128069d3b56bc$var$saveAs(new Blob([
            JSON.stringify(pinia.state.value)
        ], {
            type: "text/plain;charset=utf-8"
        }), "pinia-state.json");
    } catch (error) {
        $6a5128069d3b56bc$var$toastMessage(`Failed to export the state as JSON. Check the console for more details.`, "error");
        console.error(error);
    }
}
let $6a5128069d3b56bc$var$fileInput;
function $6a5128069d3b56bc$var$getFileOpener() {
    if (!$6a5128069d3b56bc$var$fileInput) {
        $6a5128069d3b56bc$var$fileInput = document.createElement("input");
        $6a5128069d3b56bc$var$fileInput.type = "file";
        $6a5128069d3b56bc$var$fileInput.accept = ".json";
    }
    function openFile() {
        return new Promise((resolve, reject)=>{
            $6a5128069d3b56bc$var$fileInput.onchange = async ()=>{
                const files = $6a5128069d3b56bc$var$fileInput.files;
                if (!files) return resolve(null);
                const file = files.item(0);
                if (!file) return resolve(null);
                return resolve({
                    text: await file.text(),
                    file: file
                });
            };
            $6a5128069d3b56bc$var$fileInput.oncancel = ()=>resolve(null);
            $6a5128069d3b56bc$var$fileInput.onerror = reject;
            $6a5128069d3b56bc$var$fileInput.click();
        });
    }
    return openFile;
}
async function $6a5128069d3b56bc$var$actionGlobalOpenStateFile(pinia) {
    try {
        const result = await $6a5128069d3b56bc$var$getFileOpener()();
        if (!result) return;
        const { text: text, file: file } = result;
        $6a5128069d3b56bc$var$loadStoresState(pinia, JSON.parse(text));
        $6a5128069d3b56bc$var$toastMessage(`Global state imported from "${file.name}".`);
    } catch (error) {
        $6a5128069d3b56bc$var$toastMessage(`Failed to import the state from JSON. Check the console for more details.`, "error");
        console.error(error);
    }
}
function $6a5128069d3b56bc$var$loadStoresState(pinia, state) {
    for(const key in state){
        const storeState = pinia.state.value[key];
        if (storeState) Object.assign(storeState, state[key]);
        else pinia.state.value[key] = state[key];
    }
}
//#endregion
//#region src/devtools/formatting.ts
function $6a5128069d3b56bc$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
const $6a5128069d3b56bc$var$PINIA_ROOT_LABEL = "\uD83C\uDF4D Pinia (root)";
const $6a5128069d3b56bc$var$PINIA_ROOT_ID = "_root";
function $6a5128069d3b56bc$var$formatStoreForInspectorTree(store) {
    return $6a5128069d3b56bc$var$isPinia(store) ? {
        id: $6a5128069d3b56bc$var$PINIA_ROOT_ID,
        label: $6a5128069d3b56bc$var$PINIA_ROOT_LABEL
    } : {
        id: store.$id,
        label: store.$id
    };
}
function $6a5128069d3b56bc$var$formatStoreForInspectorState(store) {
    if ($6a5128069d3b56bc$var$isPinia(store)) {
        const storeNames = Array.from(store._s.keys());
        const storeMap = store._s;
        return {
            state: storeNames.map((storeId)=>({
                    editable: true,
                    key: storeId,
                    value: store.state.value[storeId]
                })),
            getters: storeNames.filter((id)=>storeMap.get(id)._getters).map((id)=>{
                const store = storeMap.get(id);
                return {
                    editable: false,
                    key: id,
                    value: store._getters.reduce((getters, key)=>{
                        getters[key] = store[key];
                        return getters;
                    }, {})
                };
            })
        };
    }
    const state = {
        state: Object.keys(store.$state).map((key)=>({
                editable: true,
                key: key,
                value: store.$state[key]
            }))
    };
    if (store._getters && store._getters.length) state.getters = store._getters.map((getterName)=>({
            editable: $6a5128069d3b56bc$var$isWritableComputed(store, getterName),
            key: getterName,
            value: store[getterName]
        }));
    if (store._customProperties.size) state.customProperties = Array.from(store._customProperties).map((key)=>({
            editable: true,
            key: key,
            value: store[key]
        }));
    return state;
}
function $6a5128069d3b56bc$var$formatEventData(events) {
    if (!events) return {};
    if (Array.isArray(events)) return events.reduce((data, event)=>{
        data.keys.push(event.key);
        data.operations.push(event.type);
        data.oldValue[event.key] = event.oldValue;
        data.newValue[event.key] = event.newValue;
        return data;
    }, {
        oldValue: {},
        keys: [],
        operations: [],
        newValue: {}
    });
    else return {
        operation: $6a5128069d3b56bc$var$formatDisplay(events.type),
        key: $6a5128069d3b56bc$var$formatDisplay(events.key),
        oldValue: events.oldValue,
        newValue: events.newValue
    };
}
function $6a5128069d3b56bc$var$formatMutationType(type) {
    switch(type){
        case "direct":
            return "mutation";
        case "patch function":
            return "$patch";
        case "patch object":
            return "$patch";
        default:
            return "unknown";
    }
}
//#endregion
//#region src/devtools/plugin.ts
let $6a5128069d3b56bc$var$isTimelineActive = true;
const $6a5128069d3b56bc$var$componentStateTypes = [];
const $6a5128069d3b56bc$var$MUTATIONS_LAYER_ID = "pinia:mutations";
const $6a5128069d3b56bc$var$INSPECTOR_ID = "pinia";
const { assign: $6a5128069d3b56bc$var$assign$1 } = Object;
/**
* Gets the displayed name of a store in devtools
*
* @param id - id of the store
* @returns a formatted string
*/ const $6a5128069d3b56bc$var$getStoreType = (id)=>"\uD83C\uDF4D " + id;
/**
* Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
* as soon as it is added to the application.
*
* @param app - Vue application
* @param pinia - pinia instance
*/ function $6a5128069d3b56bc$var$registerPiniaDevtools(app, pinia) {
    (0, $2B7NK.setupDevToolsPlugin)({
        id: "dev.esm.pinia",
        label: "Pinia \uD83C\uDF4D",
        logo: "https://pinia.vuejs.org/logo.svg",
        packageName: "pinia",
        homepage: "https://pinia.vuejs.org",
        componentStateTypes: $6a5128069d3b56bc$var$componentStateTypes,
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") $6a5128069d3b56bc$var$toastMessage("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        api.addTimelineLayer({
            id: $6a5128069d3b56bc$var$MUTATIONS_LAYER_ID,
            label: `Pinia \u{1F34D}`,
            color: 15064968
        });
        api.addInspector({
            id: $6a5128069d3b56bc$var$INSPECTOR_ID,
            label: "Pinia \uD83C\uDF4D",
            icon: "storage",
            treeFilterPlaceholder: "Search stores",
            actions: [
                {
                    icon: "content_copy",
                    action: ()=>{
                        $6a5128069d3b56bc$var$actionGlobalCopyState(pinia);
                    },
                    tooltip: "Serialize and copy the state"
                },
                {
                    icon: "content_paste",
                    action: async ()=>{
                        await $6a5128069d3b56bc$var$actionGlobalPasteState(pinia);
                        api.sendInspectorTree($6a5128069d3b56bc$var$INSPECTOR_ID);
                        api.sendInspectorState($6a5128069d3b56bc$var$INSPECTOR_ID);
                    },
                    tooltip: "Replace the state with the content of your clipboard"
                },
                {
                    icon: "save",
                    action: ()=>{
                        $6a5128069d3b56bc$var$actionGlobalSaveState(pinia);
                    },
                    tooltip: "Save the state as a JSON file"
                },
                {
                    icon: "folder_open",
                    action: async ()=>{
                        await $6a5128069d3b56bc$var$actionGlobalOpenStateFile(pinia);
                        api.sendInspectorTree($6a5128069d3b56bc$var$INSPECTOR_ID);
                        api.sendInspectorState($6a5128069d3b56bc$var$INSPECTOR_ID);
                    },
                    tooltip: "Import the state from a JSON file"
                }
            ],
            nodeActions: [
                {
                    icon: "restore",
                    tooltip: "Reset the state (with \"$reset\")",
                    action: (nodeId)=>{
                        const store = pinia._s.get(nodeId);
                        if (!store) $6a5128069d3b56bc$var$toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, "warn");
                        else if (typeof store.$reset !== "function") $6a5128069d3b56bc$var$toastMessage(`Cannot reset "${nodeId}" store because it doesn't have a "$reset" method implemented.`, "warn");
                        else {
                            store.$reset();
                            $6a5128069d3b56bc$var$toastMessage(`Store "${nodeId}" reset.`);
                        }
                    }
                }
            ]
        });
        api.on.inspectComponent((payload)=>{
            const proxy = payload.componentInstance && payload.componentInstance.proxy;
            if (proxy && proxy._pStores) {
                const piniaStores = payload.componentInstance.proxy._pStores;
                Object.values(piniaStores).forEach((store)=>{
                    payload.instanceData.state.push({
                        type: $6a5128069d3b56bc$var$getStoreType(store.$id),
                        key: "state",
                        editable: true,
                        value: store._isOptionsAPI ? {
                            _custom: {
                                value: (0, $36gU0.toRaw)(store.$state),
                                actions: [
                                    {
                                        icon: "restore",
                                        tooltip: "Reset the state of this store",
                                        action: ()=>store.$reset()
                                    }
                                ]
                            }
                        } : Object.keys(store.$state).reduce((state, key)=>{
                            state[key] = store.$state[key];
                            return state;
                        }, {})
                    });
                    if (store._getters && store._getters.length) payload.instanceData.state.push({
                        type: $6a5128069d3b56bc$var$getStoreType(store.$id),
                        key: "getters",
                        editable: false,
                        value: store._getters.reduce((getters, key)=>{
                            try {
                                getters[key] = store[key];
                            } catch (error) {
                                getters[key] = error;
                            }
                            return getters;
                        }, {})
                    });
                });
            }
        });
        api.on.getInspectorTree((payload)=>{
            if (payload.app === app && payload.inspectorId === $6a5128069d3b56bc$var$INSPECTOR_ID) {
                let stores = [
                    pinia
                ];
                stores = stores.concat(Array.from(pinia._s.values()));
                payload.rootNodes = (payload.filter ? stores.filter((store)=>"$id" in store ? store.$id.toLowerCase().includes(payload.filter.toLowerCase()) : $6a5128069d3b56bc$var$PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase())) : stores).map($6a5128069d3b56bc$var$formatStoreForInspectorTree);
            }
        });
        globalThis.$pinia = pinia;
        api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $6a5128069d3b56bc$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === "_root" ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) return;
                if (inspectedStore) {
                    if (payload.nodeId !== "_root") globalThis.$store = (0, $36gU0.toRaw)(inspectedStore);
                    payload.state = $6a5128069d3b56bc$var$formatStoreForInspectorState(inspectedStore);
                }
            }
        });
        api.on.editInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $6a5128069d3b56bc$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === "_root" ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) return $6a5128069d3b56bc$var$toastMessage(`store "${payload.nodeId}" not found`, "error");
                const { path: path } = payload;
                if (!$6a5128069d3b56bc$var$isPinia(inspectedStore)) {
                    if (path.length !== 1 || !inspectedStore._customProperties.has(path[0]) && !$6a5128069d3b56bc$var$isWritableComputed(inspectedStore, path[0]) || path[0] in inspectedStore.$state) path.unshift("$state");
                } else path.unshift("state");
                $6a5128069d3b56bc$var$isTimelineActive = false;
                payload.set(inspectedStore, path, payload.state.value);
                $6a5128069d3b56bc$var$isTimelineActive = true;
            }
        });
        api.on.editComponentState((payload)=>{
            if (payload.type.startsWith("\uD83C\uDF4D")) {
                const storeId = payload.type.replace(/^🍍\s*/, "");
                const store = pinia._s.get(storeId);
                if (!store) return $6a5128069d3b56bc$var$toastMessage(`store "${storeId}" not found`, "error");
                const { path: path } = payload;
                if (path[0] !== "state") return $6a5128069d3b56bc$var$toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
                path[0] = "$state";
                $6a5128069d3b56bc$var$isTimelineActive = false;
                payload.set(store, path, payload.state.value);
                $6a5128069d3b56bc$var$isTimelineActive = true;
            }
        });
    });
}
function $6a5128069d3b56bc$var$addStoreToDevtools(app, store) {
    if (!$6a5128069d3b56bc$var$componentStateTypes.includes($6a5128069d3b56bc$var$getStoreType(store.$id))) $6a5128069d3b56bc$var$componentStateTypes.push($6a5128069d3b56bc$var$getStoreType(store.$id));
    (0, $2B7NK.setupDevToolsPlugin)({
        id: "dev.esm.pinia",
        label: "Pinia \uD83C\uDF4D",
        logo: "https://pinia.vuejs.org/logo.svg",
        packageName: "pinia",
        homepage: "https://pinia.vuejs.org",
        componentStateTypes: $6a5128069d3b56bc$var$componentStateTypes,
        app: app,
        settings: {
            logStoreChanges: {
                label: "Notify about new/deleted stores",
                type: "boolean",
                defaultValue: true
            }
        }
    }, (api)=>{
        const now = typeof api.now === "function" ? api.now.bind(api) : Date.now;
        store.$onAction(({ after: after, onError: onError, name: name, args: args })=>{
            const groupId = $6a5128069d3b56bc$var$runningActionId++;
            api.addTimelineEvent({
                layerId: $6a5128069d3b56bc$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDEEB " + name,
                    subtitle: "start",
                    data: {
                        store: $6a5128069d3b56bc$var$formatDisplay(store.$id),
                        action: $6a5128069d3b56bc$var$formatDisplay(name),
                        args: args
                    },
                    groupId: groupId
                }
            });
            after((result)=>{
                $6a5128069d3b56bc$var$activeAction = void 0;
                api.addTimelineEvent({
                    layerId: $6a5128069d3b56bc$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "\uD83D\uDEEC " + name,
                        subtitle: "end",
                        data: {
                            store: $6a5128069d3b56bc$var$formatDisplay(store.$id),
                            action: $6a5128069d3b56bc$var$formatDisplay(name),
                            args: args,
                            result: result
                        },
                        groupId: groupId
                    }
                });
            });
            onError((error)=>{
                $6a5128069d3b56bc$var$activeAction = void 0;
                api.addTimelineEvent({
                    layerId: $6a5128069d3b56bc$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        logType: "error",
                        title: "\uD83D\uDCA5 " + name,
                        subtitle: "end",
                        data: {
                            store: $6a5128069d3b56bc$var$formatDisplay(store.$id),
                            action: $6a5128069d3b56bc$var$formatDisplay(name),
                            args: args,
                            error: error
                        },
                        groupId: groupId
                    }
                });
            });
        }, true);
        store._customProperties.forEach((name)=>{
            (0, $36gU0.watch)(()=>(0, $36gU0.unref)(store[name]), (newValue, oldValue)=>{
                api.notifyComponentUpdate();
                api.sendInspectorState($6a5128069d3b56bc$var$INSPECTOR_ID);
                if ($6a5128069d3b56bc$var$isTimelineActive) api.addTimelineEvent({
                    layerId: $6a5128069d3b56bc$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "Change",
                        subtitle: name,
                        data: {
                            newValue: newValue,
                            oldValue: oldValue
                        },
                        groupId: $6a5128069d3b56bc$var$activeAction
                    }
                });
            }, {
                deep: true
            });
        });
        store.$subscribe(({ events: events, type: type }, state)=>{
            api.notifyComponentUpdate();
            api.sendInspectorState($6a5128069d3b56bc$var$INSPECTOR_ID);
            if (!$6a5128069d3b56bc$var$isTimelineActive) return;
            const eventData = {
                time: now(),
                title: $6a5128069d3b56bc$var$formatMutationType(type),
                data: $6a5128069d3b56bc$var$assign$1({
                    store: $6a5128069d3b56bc$var$formatDisplay(store.$id)
                }, $6a5128069d3b56bc$var$formatEventData(events)),
                groupId: $6a5128069d3b56bc$var$activeAction
            };
            if (type === "patch function") eventData.subtitle = "\u2935\uFE0F";
            else if (type === "patch object") eventData.subtitle = "\uD83E\uDDE9";
            else if (events && !Array.isArray(events)) eventData.subtitle = events.type;
            if (events) eventData.data["rawEvent(s)"] = {
                _custom: {
                    display: "DebuggerEvent",
                    type: "object",
                    tooltip: "raw DebuggerEvent[]",
                    value: events
                }
            };
            api.addTimelineEvent({
                layerId: $6a5128069d3b56bc$var$MUTATIONS_LAYER_ID,
                event: eventData
            });
        }, {
            detached: true,
            flush: "sync"
        });
        const hotUpdate = store._hotUpdate;
        store._hotUpdate = (0, $36gU0.markRaw)((newStore)=>{
            hotUpdate(newStore);
            api.addTimelineEvent({
                layerId: $6a5128069d3b56bc$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDD25 " + store.$id,
                    subtitle: "HMR update",
                    data: {
                        store: $6a5128069d3b56bc$var$formatDisplay(store.$id),
                        info: $6a5128069d3b56bc$var$formatDisplay(`HMR update`)
                    }
                }
            });
            api.notifyComponentUpdate();
            api.sendInspectorTree($6a5128069d3b56bc$var$INSPECTOR_ID);
            api.sendInspectorState($6a5128069d3b56bc$var$INSPECTOR_ID);
        });
        const { $dispose: $dispose } = store;
        store.$dispose = ()=>{
            $dispose();
            api.notifyComponentUpdate();
            api.sendInspectorTree($6a5128069d3b56bc$var$INSPECTOR_ID);
            api.sendInspectorState($6a5128069d3b56bc$var$INSPECTOR_ID);
            api.getSettings().logStoreChanges && $6a5128069d3b56bc$var$toastMessage(`Disposed "${store.$id}" store \u{1F5D1}`);
        };
        api.notifyComponentUpdate();
        api.sendInspectorTree($6a5128069d3b56bc$var$INSPECTOR_ID);
        api.sendInspectorState($6a5128069d3b56bc$var$INSPECTOR_ID);
        api.getSettings().logStoreChanges && $6a5128069d3b56bc$var$toastMessage(`"${store.$id}" store installed \u{1F195}`);
    });
}
let $6a5128069d3b56bc$var$runningActionId = 0;
let $6a5128069d3b56bc$var$activeAction;
/**
* Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
* context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
* mutation to the action.
*
* @param store - store to patch
* @param actionNames - list of actionst to patch
*/ function $6a5128069d3b56bc$var$patchActionForGrouping(store, actionNames, wrapWithProxy) {
    const actions = actionNames.reduce((storeActions, actionName)=>{
        storeActions[actionName] = (0, $36gU0.toRaw)(store)[actionName];
        return storeActions;
    }, {});
    for(const actionName in actions)store[actionName] = function() {
        const _actionId = $6a5128069d3b56bc$var$runningActionId;
        const trackedStore = wrapWithProxy ? new Proxy(store, {
            get (...args) {
                $6a5128069d3b56bc$var$activeAction = _actionId;
                return Reflect.get(...args);
            },
            set (...args) {
                $6a5128069d3b56bc$var$activeAction = _actionId;
                return Reflect.set(...args);
            }
        }) : store;
        $6a5128069d3b56bc$var$activeAction = _actionId;
        const retValue = actions[actionName].apply(trackedStore, arguments);
        $6a5128069d3b56bc$var$activeAction = void 0;
        return retValue;
    };
}
/**
* pinia.use(devtoolsPlugin)
*/ function $6a5128069d3b56bc$var$devtoolsPlugin({ app: app, store: store, options: options }) {
    if (store.$id.startsWith("__hot:")) return;
    store._isOptionsAPI = !!options.state;
    if (!store._p._testing) {
        $6a5128069d3b56bc$var$patchActionForGrouping(store, Object.keys(options.actions), store._isOptionsAPI);
        const originalHotUpdate = store._hotUpdate;
        (0, $36gU0.toRaw)(store)._hotUpdate = function(newStore) {
            originalHotUpdate.apply(this, arguments);
            $6a5128069d3b56bc$var$patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions), !!store._isOptionsAPI);
        };
    }
    $6a5128069d3b56bc$var$addStoreToDevtools(app, store);
}
//#endregion
//#region src/createPinia.ts
/**
* Creates a Pinia instance to be used by the application
*/ function $6a5128069d3b56bc$export$4b9f6a0748623d44() {
    const scope = (0, $36gU0.effectScope)(true);
    const state = scope.run(()=>(0, $36gU0.ref)({}));
    let _p = [];
    let toBeInstalled = [];
    const pinia = (0, $36gU0.markRaw)({
        install (app) {
            $6a5128069d3b56bc$export$89ffb8149ccd46af(pinia);
            pinia._a = app;
            app.provide($6a5128069d3b56bc$export$4a047152797c504d, pinia);
            app.config.globalProperties.$pinia = pinia;
            /* istanbul ignore else */ if (typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && $6a5128069d3b56bc$var$IS_CLIENT) $6a5128069d3b56bc$var$registerPiniaDevtools(app, pinia);
            toBeInstalled.forEach((plugin)=>_p.push(plugin));
            toBeInstalled = [];
        },
        use (plugin) {
            if (!this._a) toBeInstalled.push(plugin);
            else _p.push(plugin);
            return this;
        },
        _p: _p,
        _a: null,
        _e: scope,
        _s: /* @__PURE__ */ new Map(),
        state: state
    });
    if (typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && $6a5128069d3b56bc$var$IS_CLIENT && typeof Proxy !== "undefined") pinia.use($6a5128069d3b56bc$var$devtoolsPlugin);
    return pinia;
}
/**
* Dispose a Pinia instance by stopping its effectScope and removing the state, plugins and stores. This is mostly
* useful in tests, with both a testing pinia or a regular pinia and in applications that use multiple pinia instances.
* Once disposed, the pinia instance cannot be used anymore.
*
* @param pinia - pinia instance
*/ function $6a5128069d3b56bc$export$75b0179c67a9344e(pinia) {
    pinia._e.stop();
    pinia._s.clear();
    pinia._p.splice(0);
    pinia.state.value = {};
    pinia._a = null;
}
//#endregion
//#region src/hmr.ts
/**
* Checks if a function is a `StoreDefinition`.
*
* @param fn - object to test
* @returns true if `fn` is a StoreDefinition
*/ const $6a5128069d3b56bc$var$isUseStore = (fn)=>{
    return typeof fn === "function" && typeof fn.$id === "string";
};
/**
* Mutates in place `newState` with `oldState` to _hot update_ it. It will
* remove any key not existing in `newState` and recursively merge plain
* objects.
*
* @param newState - new state object to be patched
* @param oldState - old state that should be used to patch newState
* @returns - newState
*/ function $6a5128069d3b56bc$var$patchObject(newState, oldState) {
    for(const key in oldState){
        const subPatch = oldState[key];
        if (!(key in newState)) continue;
        const targetValue = newState[key];
        if ($6a5128069d3b56bc$var$isPlainObject(targetValue) && $6a5128069d3b56bc$var$isPlainObject(subPatch) && !(0, $36gU0.isRef)(subPatch) && !(0, $36gU0.isReactive)(subPatch)) newState[key] = $6a5128069d3b56bc$var$patchObject(targetValue, subPatch);
        else newState[key] = subPatch;
    }
    return newState;
}
/**
* Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
*
* @example
* ```js
* const useUser = defineStore(...)
* if (import.meta.hot) {
*   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
* }
* ```
*
* @param initialUseStore - return of the defineStore to hot update
* @param hot - `import.meta.hot`
*/ function $6a5128069d3b56bc$export$d3530ca2abd36d5e(initialUseStore, hot) {
    var newModule;
    return ()=>{};
}
//#endregion
//#region src/subscriptions.ts
const $6a5128069d3b56bc$var$noop = ()=>{};
function $6a5128069d3b56bc$var$addSubscription(subscriptions, callback, detached, onCleanup = $6a5128069d3b56bc$var$noop) {
    subscriptions.add(callback);
    const removeSubscription = ()=>{
        subscriptions.delete(callback) && onCleanup();
    };
    if (!detached && (0, $36gU0.getCurrentScope)()) (0, $36gU0.onScopeDispose)(removeSubscription);
    return removeSubscription;
}
function $6a5128069d3b56bc$var$triggerSubscriptions(subscriptions, ...args) {
    subscriptions.forEach((callback)=>{
        callback(...args);
    });
}
//#endregion
//#region src/store.ts
const $6a5128069d3b56bc$var$fallbackRunWithContext = (fn)=>fn();
/**
* Marks a function as an action for `$onAction`
* @internal
*/ const $6a5128069d3b56bc$var$ACTION_MARKER = Symbol();
/**
* Action name symbol. Allows to add a name to an action after defining it
* @internal
*/ const $6a5128069d3b56bc$var$ACTION_NAME = Symbol();
function $6a5128069d3b56bc$var$mergeReactiveObjects(target, patchToApply) {
    if (target instanceof Map && patchToApply instanceof Map) patchToApply.forEach((value, key)=>target.set(key, value));
    else if (target instanceof Set && patchToApply instanceof Set) patchToApply.forEach(target.add, target);
    for(const key in patchToApply){
        if (!Object.hasOwn(patchToApply, key)) continue;
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if ($6a5128069d3b56bc$var$isPlainObject(targetValue) && $6a5128069d3b56bc$var$isPlainObject(subPatch) && Object.hasOwn(target, key) && !(0, $36gU0.isRef)(subPatch) && !(0, $36gU0.isReactive)(subPatch)) target[key] = $6a5128069d3b56bc$var$mergeReactiveObjects(targetValue, subPatch);
        else target[key] = subPatch;
    }
    return target;
}
const $6a5128069d3b56bc$var$skipHydrateSymbol = /* istanbul ignore next */ Symbol();
/**
* Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
* stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
*
* @param obj - target object
* @returns obj
*/ function $6a5128069d3b56bc$export$dbb88672ab248e88(obj) {
    return Object.defineProperty(obj, $6a5128069d3b56bc$var$skipHydrateSymbol, {});
}
/**
* Returns whether a value should be hydrated
*
* @param obj - target variable
* @returns true if `obj` should be hydrated
*/ function $6a5128069d3b56bc$export$bdc3d2e33d3136e5(obj) {
    return !obj || typeof obj !== "object" || !Object.hasOwn(obj, $6a5128069d3b56bc$var$skipHydrateSymbol);
}
const { assign: $6a5128069d3b56bc$var$assign } = Object;
function $6a5128069d3b56bc$var$isComputed(o) {
    return !!((0, $36gU0.isRef)(o) && o.effect);
}
function $6a5128069d3b56bc$var$createOptionsStore(id, options, pinia, hot) {
    const { state: state, actions: actions, getters: getters } = options;
    const initialState = pinia.state.value[id];
    let store;
    function setup() {
        if (!initialState && true) /* istanbul ignore if */ pinia.state.value[id] = state ? state() : {};
        const localState = (0, $36gU0.toRefs)(pinia.state.value[id]);
        return $6a5128069d3b56bc$var$assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name)=>{
            computedGetters[name] = (0, $36gU0.markRaw)((0, $36gU0.computed)(()=>{
                $6a5128069d3b56bc$export$89ffb8149ccd46af(pinia);
                const store = pinia._s.get(id);
                return getters[name].call(store, store);
            }));
            return computedGetters;
        }, {}));
    }
    store = $6a5128069d3b56bc$var$createSetupStore(id, setup, options, pinia, hot, true);
    return store;
}
function $6a5128069d3b56bc$var$createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = $6a5128069d3b56bc$var$assign({
        actions: {}
    }, options);
    const $subscribeOptions = {
        deep: true
    };
    var event;
    let isListening;
    let isSyncListening;
    let subscriptions = /* @__PURE__ */ new Set();
    let actionSubscriptions = /* @__PURE__ */ new Set();
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    if (!isOptionsStore && !initialState && true) /* istanbul ignore if */ pinia.state.value[$id] = {};
    const hotState = /*#__PURE__*/ (0, $36gU0.ref)({});
    let activeListener;
    function $patch(partialStateOrMutator) {
        let subscriptionMutation;
        isListening = isSyncListening = false;
        if (typeof partialStateOrMutator === "function") {
            partialStateOrMutator(pinia.state.value[$id]);
            subscriptionMutation = {
                type: "patch function",
                storeId: $id,
                events: debuggerEvents
            };
        } else {
            $6a5128069d3b56bc$var$mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
            subscriptionMutation = {
                type: "patch object",
                payload: partialStateOrMutator,
                storeId: $id,
                events: debuggerEvents
            };
        }
        const myListenerId = activeListener = Symbol();
        (0, $jDVdF.nextTick)().then(()=>{
            if (activeListener === myListenerId) isListening = true;
        });
        isSyncListening = true;
        $6a5128069d3b56bc$var$triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    const $reset = isOptionsStore ? function $reset() {
        const { state: state } = options;
        const newState = state ? state() : {};
        this.$patch(($state)=>{
            $6a5128069d3b56bc$var$assign($state, newState);
        });
    } : $6a5128069d3b56bc$var$noop;
    function $dispose() {
        scope.stop();
        subscriptions.clear();
        actionSubscriptions.clear();
        pinia._s.delete($id);
    }
    /**
	* Helper that wraps function so it can be tracked with $onAction
	* @param fn - action to wrap
	* @param name - name of the action
	*/ const action = (fn, name = "")=>{
        if ($6a5128069d3b56bc$var$ACTION_MARKER in fn) {
            fn[$6a5128069d3b56bc$var$ACTION_NAME] = name;
            return fn;
        }
        const wrappedAction = function() {
            $6a5128069d3b56bc$export$89ffb8149ccd46af(pinia);
            const args = Array.from(arguments);
            const afterCallbackSet = /* @__PURE__ */ new Set();
            const onErrorCallbackSet = /* @__PURE__ */ new Set();
            function after(callback) {
                afterCallbackSet.add(callback);
            }
            function onError(callback) {
                onErrorCallbackSet.add(callback);
            }
            $6a5128069d3b56bc$var$triggerSubscriptions(actionSubscriptions, {
                args: args,
                name: wrappedAction[$6a5128069d3b56bc$var$ACTION_NAME],
                store: store,
                after: after,
                onError: onError
            });
            let ret;
            try {
                ret = fn.apply(this && this.$id === $id ? this : store, args);
            } catch (error) {
                $6a5128069d3b56bc$var$triggerSubscriptions(onErrorCallbackSet, error);
                throw error;
            }
            if (ret instanceof Promise) return ret.then((value)=>{
                $6a5128069d3b56bc$var$triggerSubscriptions(afterCallbackSet, value);
                return value;
            }).catch((error)=>{
                $6a5128069d3b56bc$var$triggerSubscriptions(onErrorCallbackSet, error);
                return Promise.reject(error);
            });
            $6a5128069d3b56bc$var$triggerSubscriptions(afterCallbackSet, ret);
            return ret;
        };
        wrappedAction[$6a5128069d3b56bc$var$ACTION_MARKER] = true;
        wrappedAction[$6a5128069d3b56bc$var$ACTION_NAME] = name;
        return wrappedAction;
    };
    const _hmrPayload = /*#__PURE__*/ (0, $36gU0.markRaw)({
        actions: {},
        getters: {},
        state: [],
        hotState: hotState
    });
    const partialStore = {
        _p: pinia,
        $id: $id,
        $onAction: $6a5128069d3b56bc$var$addSubscription.bind(null, actionSubscriptions),
        $patch: $patch,
        $reset: $reset,
        $subscribe (callback, options = {}) {
            if (subscriptions.has(callback)) return $6a5128069d3b56bc$var$noop;
            const removeSubscription = $6a5128069d3b56bc$var$addSubscription(subscriptions, callback, options.detached, ()=>stopWatcher());
            const stopWatcher = scope.run(()=>(0, $36gU0.watch)(()=>pinia.state.value[$id], (state)=>{
                    if (options.flush === "sync" ? isSyncListening : isListening) callback({
                        storeId: $id,
                        type: "direct",
                        events: debuggerEvents
                    }, state);
                }, $6a5128069d3b56bc$var$assign({}, $subscribeOptions, options)));
            return removeSubscription;
        },
        $dispose: $dispose
    };
    const store = (0, $36gU0.reactive)(typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && $6a5128069d3b56bc$var$IS_CLIENT ? $6a5128069d3b56bc$var$assign({
        _hmrPayload: _hmrPayload,
        _customProperties: (0, $36gU0.markRaw)(/* @__PURE__ */ new Set())
    }, partialStore) : partialStore);
    pinia._s.set($id, store);
    const setupStore = (pinia._a && pinia._a.runWithContext || $6a5128069d3b56bc$var$fallbackRunWithContext)(()=>pinia._e.run(()=>(scope = (0, $36gU0.effectScope)()).run(()=>setup({
                    action: action
                }))));
    for(const key in setupStore){
        const prop = setupStore[key];
        if ((0, $36gU0.isRef)(prop) && !$6a5128069d3b56bc$var$isComputed(prop) || (0, $36gU0.isReactive)(prop)) {
            if (!isOptionsStore) {
                if (initialState && $6a5128069d3b56bc$export$bdc3d2e33d3136e5(prop)) {
                    if ((0, $36gU0.isRef)(prop)) prop.value = initialState[key];
                    else {
                        if (prop instanceof Set || prop instanceof Map) prop.clear();
                        $6a5128069d3b56bc$var$mergeReactiveObjects(prop, initialState[key]);
                    }
                }
                pinia.state.value[$id][key] = prop;
            }
        } else if (typeof prop === "function") {
            setupStore[key] = action(prop, key);
            optionsForPlugin.actions[key] = prop;
        }
    }
    /* istanbul ignore if */ $6a5128069d3b56bc$var$assign(store, setupStore);
    $6a5128069d3b56bc$var$assign((0, $36gU0.toRaw)(store), setupStore);
    Object.defineProperty(store, "$state", {
        get: ()=>(0, pinia.state.value[$id]),
        set: (state)=>{
            $patch(($state)=>{
                $6a5128069d3b56bc$var$assign($state, state);
            });
        }
    });
    var newStore, stateKey, stateKey1, key, key1;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && $6a5128069d3b56bc$var$IS_CLIENT) {
        const nonEnumerable = {
            writable: true,
            configurable: true,
            enumerable: false
        };
        [
            "_p",
            "_hmrPayload",
            "_getters",
            "_customProperties"
        ].forEach((p)=>{
            Object.defineProperty(store, p, $6a5128069d3b56bc$var$assign({
                value: store[p]
            }, nonEnumerable));
        });
    }
    pinia._p.forEach((extender)=>{
        const extensions = scope.run(()=>extender({
                store: store,
                app: pinia._a,
                pinia: pinia,
                options: optionsForPlugin
            }));
        /* istanbul ignore else */ if (typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && $6a5128069d3b56bc$var$IS_CLIENT) Object.keys(extensions || {}).forEach((key)=>store._customProperties.add(key));
        $6a5128069d3b56bc$var$assign(store, extensions);
    });
    if (initialState && isOptionsStore && options.hydrate) options.hydrate(store.$state, initialState);
    isListening = true;
    isSyncListening = true;
    return store;
}
/*! #__NO_SIDE_EFFECTS__ */ function $6a5128069d3b56bc$export$5061c4f75bbcb4a(id, setup, setupOptions) {
    let options;
    const isSetupStore = typeof setup === "function";
    options = isSetupStore ? setupOptions : setup;
    function useStore(pinia, hot) {
        const hasContext = (0, $jDVdF.hasInjectionContext)();
        pinia = pinia || (hasContext ? (0, $jDVdF.inject)($6a5128069d3b56bc$export$4a047152797c504d, null) : null);
        if (pinia) $6a5128069d3b56bc$export$89ffb8149ccd46af(pinia);
        pinia = $6a5128069d3b56bc$var$activePinia;
        if (!pinia._s.has(id)) {
            if (isSetupStore) $6a5128069d3b56bc$var$createSetupStore(id, setup, options, pinia);
            else $6a5128069d3b56bc$var$createOptionsStore(id, options, pinia);
        }
        const store = pinia._s.get(id);
        return store;
    }
    useStore.$id = id;
    return useStore;
}
//#endregion
//#region src/mapHelpers.ts
let $6a5128069d3b56bc$var$mapStoreSuffix = "Store";
/**
* Changes the suffix added by `mapStores()`. Can be set to an empty string.
* Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
* interface if you are using TypeScript.
*
* @param suffix - new suffix
*/ function $6a5128069d3b56bc$export$3c0d0850ffd38177(suffix) {
    $6a5128069d3b56bc$var$mapStoreSuffix = suffix;
}
/**
* Allows using stores without the composition API (`setup()`) by generating an
* object to be spread in the `computed` field of a component. It accepts a list
* of store definitions.
*
* @example
* ```js
* export default {
*   computed: {
*     // other computed properties
*     ...mapStores(useUserStore, useCartStore)
*   },
*
*   created() {
*     this.userStore // store with id "user"
*     this.cartStore // store with id "cart"
*   }
* }
* ```
*
* @param stores - list of stores to map to an object
*/ function $6a5128069d3b56bc$export$4701f243feba9f88(...stores) {
    return stores.reduce((reduced, useStore)=>{
        reduced[useStore.$id + $6a5128069d3b56bc$var$mapStoreSuffix] = function() {
            return useStore(this.$pinia);
        };
        return reduced;
    }, {});
}
/**
* Allows using state and getters from one store without using the composition
* API (`setup()`) by generating an object to be spread in the `computed` field
* of a component.
*
* @param useStore - store to map from
* @param keysOrMapper - array or object
*/ function $6a5128069d3b56bc$export$a337c713bdba072(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = function() {
            return useStore(this.$pinia)[key];
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        reduced[key] = function() {
            const store = useStore(this.$pinia);
            const storeKey = keysOrMapper[key];
            return typeof storeKey === "function" ? storeKey.call(this, store) : store[storeKey];
        };
        return reduced;
    }, {});
}
/**
* Alias for `mapState()`. You should use `mapState()` instead.
* @deprecated use `mapState()` instead.
*/ const $6a5128069d3b56bc$export$74d9085e6d5a97cb = $6a5128069d3b56bc$export$a337c713bdba072;
/**
* Allows directly using actions from your store without using the composition
* API (`setup()`) by generating an object to be spread in the `methods` field
* of a component.
*
* @param useStore - store to map from
* @param keysOrMapper - array or object
*/ function $6a5128069d3b56bc$export$1d73b9b98821f6dc(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = function(...args) {
            return useStore(this.$pinia)[key](...args);
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        reduced[key] = function(...args) {
            return useStore(this.$pinia)[keysOrMapper[key]](...args);
        };
        return reduced;
    }, {});
}
/**
* Allows using state and getters from one store without using the composition
* API (`setup()`) by generating an object to be spread in the `computed` field
* of a component.
*
* @param useStore - store to map from
* @param keysOrMapper - array or object
*/ function $6a5128069d3b56bc$export$c069310e76f1a3e7(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[key];
            },
            set (value) {
                return useStore(this.$pinia)[key] = value;
            }
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[keysOrMapper[key]];
            },
            set (value) {
                return useStore(this.$pinia)[keysOrMapper[key]] = value;
            }
        };
        return reduced;
    }, {});
}
//#endregion
//#region src/storeToRefs.ts
/**
* Creates an object of references with all the state, getters, and plugin-added
* state properties of the store. Similar to `toRefs()` but specifically
* designed for Pinia stores so methods and non reactive properties are
* completely ignored.
*
* @param store - store to extract the refs from
*/ function $6a5128069d3b56bc$export$586af8bd019552de(store) {
    const rawStore = (0, $36gU0.toRaw)(store);
    const refs = {};
    for(const key in rawStore){
        const value = rawStore[key];
        if (value?.effect) refs[key] = (0, $36gU0.computed)({
            get: ()=>store[key],
            set (value) {
                store[key] = value;
            }
        });
        else if ((0, $36gU0.isRef)(value) || (0, $36gU0.isReactive)(value)) refs[key] = (0, $36gU0.toRef)(store, key);
    }
    return refs;
}

});
parcelRegister("lsPkV", function(module, exports) {

$parcel$export(module.exports, "createConsoleReporter", () => $fef74d94d6d6adda$export$28961117abab257d);
$parcel$export(module.exports, "defineDiagnostics", () => $fef74d94d6d6adda$export$1656dc1696afae07);
//#region src/formatters/plain.ts
/**
* Renders a diagnostic into a multi-line, unicode-decorated string suitable
* for terminal output. The first line is `[<name>] <message>`; optional
* details (`fix`, `sources`, `docs`) follow with `├▶`/`╰▶` connectors.
*/ function $fef74d94d6d6adda$export$332cab4fc85226b5(diagnostic) {
    const header = `[${diagnostic.name}] ${diagnostic.message}`;
    const details = [];
    if (diagnostic.fix) details.push(`fix: ${diagnostic.fix}`);
    if (diagnostic.sources?.length) details.push(`sources: ${diagnostic.sources.join(", ")}`);
    if (diagnostic.docs) details.push(`see: ${diagnostic.docs}`);
    if (details.length === 0) return header;
    return [
        header,
        ...details.map((detail, i)=>{
            return `${i < details.length - 1 ? "\u251C\u25B6" : "\u2570\u25B6"} ${detail}`;
        })
    ].join("\n");
}
//#endregion
//#region src/utils.ts
/**
* Transforms a value or a function that returns a value to a value.
*
* @param valFn either a value or a function that returns a value
* @param args  arguments to pass to the function if `valFn` is a function
*
* @internal
*/ function $fef74d94d6d6adda$var$toValueWithArgs(valFn, ...args) {
    return typeof valFn === "function" ? valFn(...args) : valFn;
}
//#endregion
//#region src/diagnostic.ts
/**
* Creates a console reporter that renders each diagnostic with `formatter` and
* prints the result via `console[method]`. Both default sensibly (`'warn'` and
* {@link formatDiagnostic}); `method` can also be overridden per call through
* the reporter options.
*/ /* @__NO_SIDE_EFFECTS__ */ function $fef74d94d6d6adda$export$28961117abab257d({ method: defaultMethod = "warn", formatter: formatter = $fef74d94d6d6adda$export$332cab4fc85226b5 } = {}) {
    return (diagnostic, { method: method = defaultMethod } = {})=>{
        console[method](formatter(diagnostic));
    };
}
const $fef74d94d6d6adda$var$captureStackTrace = Error.captureStackTrace;
var $fef74d94d6d6adda$export$d3ee506da1643804 = class Diagnostic extends Error {
    name;
    /**
	* The diagnostic code, e.g. `MATH_E001`.
	* Also appears as the `name` property.
	*/ code;
    /**
	* URL to extended documentation for this diagnostic code.
	* Auto-generated from {@link DefineDiagnosticsOptions.docsBase}.
	*/ docs;
    /**
	* Optional actionable instructions on how to resolve the problem.
	*/ fix;
    /**
	* Locations in user code that contributed to this diagnostic, in
	* `file:line:column` format. Relevant when the stack trace doesn't reflect
	* the user's source (e.g. compilers, bundlers), otherwise redundant with the
	* stack and should be omitted.
	*/ sources;
    /**
	* Alias for {@link Error.message}: the reason this diagnostic was raised.
	*/ get why() {
        return this.message;
    }
    /**
	* @param init        structured initializer; `why` is required
	* @param captureFrom V8 stack-cutoff frame. Defaults to {@link Diagnostic}
	* so the top of the trace is the `new Diagnostic(...)` call site.
	* `defineDiagnostics` passes its action method to strip its own frames too.
	* Ignored on engines without `Error.captureStackTrace`.
	*/ constructor(init, captureFrom = Diagnostic){
        super(init.why, {
            cause: init.cause
        });
        this.code = this.name = init.code;
        this.fix = init.fix;
        this.docs = init.docs;
        this.sources = init.sources;
        $fef74d94d6d6adda$var$captureStackTrace?.(this, captureFrom);
    }
    /**
	* Converts the diagnostic into a serializable structured object.
	*/ toJSON() {
        return {
            name: this.name,
            why: this.why,
            fix: this.fix,
            docs: this.docs,
            sources: this.sources,
            cause: this.cause,
            stack: this.stack
        };
    }
};
/**
* Resolves the docs URL for a code from a `docsBase` (string template or
* resolver function). Shared by {@link defineDiagnostics} and
* {@link defineProdDiagnostics}. Per-code `docs` overrides are handled by the
* caller; this only covers the `docsBase`-derived case.
*
* @internal
*/ function $fef74d94d6d6adda$var$deriveDocs(docsBase, code) {
    return typeof docsBase === "string" ? `${docsBase}/${code.toLowerCase()}` : docsBase?.(code);
}
/**
* Creates a typed diagnostics object from a set of code definitions. Each
* code becomes a callable {@link DiagnosticHandle}: invoke to report, or
* `throw` the result to raise. No `new` required, no proxy.
*/ /* @__NO_SIDE_EFFECTS__ */ function $fef74d94d6d6adda$export$1656dc1696afae07(options) {
    const reporters = options.reporters ?? [];
    const result = {};
    const { docsBase: docsBase } = options;
    for (const code of Object.keys(options.codes)){
        const def = options.codes[code];
        const docs = def.docs === false ? void 0 : def.docs || $fef74d94d6d6adda$var$deriveDocs(docsBase, code);
        const handle = (params = {}, reporterOptions = {})=>{
            const diagnostic = new $fef74d94d6d6adda$export$d3ee506da1643804({
                code: code,
                why: $fef74d94d6d6adda$var$toValueWithArgs(def.why, params),
                fix: $fef74d94d6d6adda$var$toValueWithArgs(def.fix, params),
                docs: docs,
                cause: params.cause,
                sources: params.sources
            }, handle);
            for (const reporter of reporters)reporter(diagnostic, reporterOptions);
            return diagnostic;
        };
        result[code] = handle;
    }
    return result;
}
//#endregion
//#region src/prod-diagnostics.ts
/**
* Production counterpart to {@link defineDiagnostics}. Returns a `Proxy` that
* builds a minimal {@link Diagnostic} for any accessed code: the code becomes
* the instance `name`, `docs` is derived from `docsBase`, and `why` points to
* the docs URL when one exists (empty otherwise, so the thrown header is just
* the code). It carries no catalog text, so it stays tiny in a bundle.
*
* The strip plugin (`@nostics/unplugin`) can rewrite a `defineDiagnostics()`
* call into a `process.env.NODE_ENV === 'production'` ternary that selects this
* factory in production, dropping every `why`/`fix` string from the bundle.
*
* @example
* ```ts
* const diagnostics = defineProdDiagnostics({ docsBase: 'https://docs.example.com' })
* throw diagnostics.NUXT_B2011() // NUXT_B2011: https://docs.example.com/nuxt_b2011
* ```
*/ /* @__NO_SIDE_EFFECTS__ */ function $fef74d94d6d6adda$export$5deacc2d4b351bec(options = {}) {
    const { docsBase: docsBase, reporters: reporters = [] } = options;
    return new Proxy({}, {
        get (_target, code) {
            if (typeof code !== "string") return void 0;
            const handle = (params = {}, reporterOptions = {})=>{
                const docs = $fef74d94d6d6adda$var$deriveDocs(docsBase, code);
                const diagnostic = new $fef74d94d6d6adda$export$d3ee506da1643804({
                    code: code,
                    why: docs ?? "",
                    docs: docs,
                    cause: params.cause,
                    sources: params.sources
                }, handle);
                for (const reporter of reporters)reporter(diagnostic, reporterOptions);
                return diagnostic;
            };
            return handle;
        }
    });
}

});

parcelRegister("2B7NK", function(module, exports) {

$parcel$export(module.exports, "setupDevToolsPlugin", () => $1e4516afffd1665d$export$1f0daed17c8e64f);

var $7vMoz = parcelRequire("7vMoz");

var $aZyT4 = parcelRequire("aZyT4");

var $kFbbN = parcelRequire("kFbbN");

var $kN14I = parcelRequire("kN14I");
//#region \0rolldown/runtime.js
var $1e4516afffd1665d$var$__create = Object.create;
var $1e4516afffd1665d$var$__defProp = Object.defineProperty;
var $1e4516afffd1665d$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $1e4516afffd1665d$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $1e4516afffd1665d$var$__getProtoOf = Object.getPrototypeOf;
var $1e4516afffd1665d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1e4516afffd1665d$var$__commonJSMin = (cb, mod)=>()=>(mod || cb((mod = {
            exports: {}
        }).exports, mod), mod.exports);
var $1e4516afffd1665d$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") for(var keys = $1e4516afffd1665d$var$__getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++){
        key = keys[i];
        if (!$1e4516afffd1665d$var$__hasOwnProp.call(to, key) && key !== except) $1e4516afffd1665d$var$__defProp(to, key, {
            get: ((k)=>from[k]).bind(null, key),
            enumerable: !(desc = $1e4516afffd1665d$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $1e4516afffd1665d$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $1e4516afffd1665d$var$__create($1e4516afffd1665d$var$__getProtoOf(mod)) : {}, $1e4516afffd1665d$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $1e4516afffd1665d$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
//#endregion
//#region src/compat/index.ts
function $1e4516afffd1665d$var$onLegacyDevToolsPluginApiAvailable(cb) {
    if ((0, $7vMoz.target).__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__) {
        cb();
        return;
    }
    Object.defineProperty((0, $7vMoz.target), "__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__", {
        set (value) {
            if (value) cb();
        },
        configurable: true
    });
}
//#endregion
//#region src/core/component/utils/index.ts
function $1e4516afffd1665d$var$getComponentTypeName(options) {
    if (typeof options === "function") return options.displayName || options.name || options.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || "";
    const name = options.name || options._componentTag || options.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || options.__name;
    if (name === "index" && options.__file?.endsWith("index.vue")) return "";
    return name;
}
function $1e4516afffd1665d$var$getComponentFileName(options) {
    const file = options.__file;
    if (file) return (0, $7vMoz.classify)((0, $7vMoz.basename)(file, ".vue"));
}
function $1e4516afffd1665d$var$getComponentName(options) {
    const name = options.displayName || options.name || options._componentTag;
    if (name) return name;
    return $1e4516afffd1665d$var$getComponentFileName(options);
}
function $1e4516afffd1665d$var$saveComponentGussedName(instance, name) {
    instance.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = name;
    return name;
}
function $1e4516afffd1665d$var$getAppRecord(instance) {
    if (instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__) return instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    else if (instance.root) return instance.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
}
async function $1e4516afffd1665d$var$getComponentId(options) {
    const { app: app, uid: uid, instance: instance } = options;
    try {
        if (instance.__VUE_DEVTOOLS_NEXT_UID__) return instance.__VUE_DEVTOOLS_NEXT_UID__;
        const appRecord = await $1e4516afffd1665d$var$getAppRecord(app);
        if (!appRecord) return null;
        const isRoot = appRecord.rootInstance === instance;
        return `${appRecord.id}:${isRoot ? "root" : uid}`;
    } catch (e) {}
}
function $1e4516afffd1665d$var$isFragment(instance) {
    const subTreeType = instance.subTree?.type;
    const appRecord = $1e4516afffd1665d$var$getAppRecord(instance);
    if (appRecord) return appRecord?.types?.Fragment === subTreeType;
    return false;
}
function $1e4516afffd1665d$var$isBeingDestroyed(instance) {
    return instance._isBeingDestroyed || instance.isUnmounted;
}
/**
* Get the appropriate display name for an instance.
*
* @param {Vue} instance
* @return {string}
*/ function $1e4516afffd1665d$var$getInstanceName(instance) {
    const name = $1e4516afffd1665d$var$getComponentTypeName(instance?.type || {});
    if (name) return name;
    if (instance?.root === instance) return "Root";
    for(const key in instance.parent?.type?.components)if (instance.parent.type.components[key] === instance?.type) return $1e4516afffd1665d$var$saveComponentGussedName(instance, key);
    for(const key in instance.appContext?.components)if (instance.appContext.components[key] === instance?.type) return $1e4516afffd1665d$var$saveComponentGussedName(instance, key);
    const fileName = $1e4516afffd1665d$var$getComponentFileName(instance?.type || {});
    if (fileName) return fileName;
    return "Anonymous Component";
}
/**
* Returns a devtools unique id for instance.
* @param {Vue} instance
*/ function $1e4516afffd1665d$var$getUniqueComponentId(instance) {
    return `${instance?.appContext?.app?.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ ?? 0}:${instance === instance?.root ? "root" : instance.uid}`;
}
function $1e4516afffd1665d$var$getRenderKey(value) {
    if (value == null) return "";
    if (typeof value === "number") return value;
    else if (typeof value === "string") return `'${value}'`;
    else if (Array.isArray(value)) return "Array";
    else return "Object";
}
function $1e4516afffd1665d$var$returnError(cb) {
    try {
        return cb();
    } catch (e) {
        return e;
    }
}
function $1e4516afffd1665d$var$getComponentInstance(appRecord, instanceId) {
    instanceId = instanceId || `${appRecord.id}:root`;
    return appRecord.instanceMap.get(instanceId) || appRecord.instanceMap.get(":root");
}
function $1e4516afffd1665d$var$ensurePropertyExists(obj, key, skipObjCheck = false) {
    return skipObjCheck ? key in obj : typeof obj === "object" && obj !== null ? key in obj : false;
}
//#endregion
//#region src/core/component/state/bounding-rect.ts
function $1e4516afffd1665d$var$createRect() {
    const rect = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        get width () {
            return rect.right - rect.left;
        },
        get height () {
            return rect.bottom - rect.top;
        }
    };
    return rect;
}
let $1e4516afffd1665d$var$range;
function $1e4516afffd1665d$var$getTextRect(node) {
    if (!$1e4516afffd1665d$var$range) $1e4516afffd1665d$var$range = document.createRange();
    $1e4516afffd1665d$var$range.selectNode(node);
    return $1e4516afffd1665d$var$range.getBoundingClientRect();
}
function $1e4516afffd1665d$var$getFragmentRect(vnode) {
    const rect = $1e4516afffd1665d$var$createRect();
    if (!vnode.children) return rect;
    for(let i = 0, l = vnode.children.length; i < l; i++){
        const childVnode = vnode.children[i];
        let childRect;
        if (childVnode.component) childRect = $1e4516afffd1665d$var$getComponentBoundingRect(childVnode.component);
        else if (childVnode.el) {
            const el = childVnode.el;
            if (el.nodeType === 1 || el.getBoundingClientRect) childRect = el.getBoundingClientRect();
            else if (el.nodeType === 3 && el.data.trim()) childRect = $1e4516afffd1665d$var$getTextRect(el);
        }
        if (childRect) $1e4516afffd1665d$var$mergeRects(rect, childRect);
    }
    return rect;
}
function $1e4516afffd1665d$var$mergeRects(a, b) {
    if (!a.top || b.top < a.top) a.top = b.top;
    if (!a.bottom || b.bottom > a.bottom) a.bottom = b.bottom;
    if (!a.left || b.left < a.left) a.left = b.left;
    if (!a.right || b.right > a.right) a.right = b.right;
    return a;
}
const $1e4516afffd1665d$var$DEFAULT_RECT = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
};
function $1e4516afffd1665d$var$getComponentBoundingRect(instance) {
    const el = instance.subTree.el;
    if (typeof window === "undefined") return $1e4516afffd1665d$var$DEFAULT_RECT;
    if ($1e4516afffd1665d$var$isFragment(instance)) return $1e4516afffd1665d$var$getFragmentRect(instance.subTree);
    else if (el?.nodeType === 1) return el?.getBoundingClientRect();
    else if (instance.subTree.component) return $1e4516afffd1665d$var$getComponentBoundingRect(instance.subTree.component);
    else return $1e4516afffd1665d$var$DEFAULT_RECT;
}
//#endregion
//#region src/core/component/tree/el.ts
function $1e4516afffd1665d$var$getRootElementsFromComponentInstance(instance) {
    if ($1e4516afffd1665d$var$isFragment(instance)) return $1e4516afffd1665d$var$getFragmentRootElements(instance.subTree);
    if (!instance.subTree) return [];
    return [
        instance.subTree.el
    ];
}
function $1e4516afffd1665d$var$getFragmentRootElements(vnode) {
    if (!vnode.children) return [];
    const list = [];
    vnode.children.forEach((childVnode)=>{
        if (childVnode.component) list.push(...$1e4516afffd1665d$var$getRootElementsFromComponentInstance(childVnode.component));
        else if (childVnode?.el) list.push(childVnode.el);
    });
    return list;
}
//#endregion
//#region src/core/component-highlighter/index.ts
const $1e4516afffd1665d$var$CONTAINER_ELEMENT_ID = "__vue-devtools-component-inspector__";
const $1e4516afffd1665d$var$CARD_ELEMENT_ID = "__vue-devtools-component-inspector__card__";
const $1e4516afffd1665d$var$COMPONENT_NAME_ELEMENT_ID = "__vue-devtools-component-inspector__name__";
const $1e4516afffd1665d$var$INDICATOR_ELEMENT_ID = "__vue-devtools-component-inspector__indicator__";
const $1e4516afffd1665d$var$containerStyles = {
    display: "block",
    zIndex: 2147483640,
    position: "fixed",
    backgroundColor: "#42b88325",
    border: "1px solid #42b88350",
    borderRadius: "5px",
    transition: "all 0.1s ease-in",
    pointerEvents: "none"
};
const $1e4516afffd1665d$var$cardStyles = {
    fontFamily: "Arial, Helvetica, sans-serif",
    padding: "5px 8px",
    borderRadius: "4px",
    textAlign: "left",
    position: "absolute",
    left: 0,
    color: "#e9e9e9",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    backgroundColor: "#42b883",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)"
};
const $1e4516afffd1665d$var$indicatorStyles = {
    display: "inline-block",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    opacity: .7
};
function $1e4516afffd1665d$var$getContainerElement() {
    return document.getElementById($1e4516afffd1665d$var$CONTAINER_ELEMENT_ID);
}
function $1e4516afffd1665d$var$getCardElement() {
    return document.getElementById($1e4516afffd1665d$var$CARD_ELEMENT_ID);
}
function $1e4516afffd1665d$var$getIndicatorElement() {
    return document.getElementById($1e4516afffd1665d$var$INDICATOR_ELEMENT_ID);
}
function $1e4516afffd1665d$var$getNameElement() {
    return document.getElementById($1e4516afffd1665d$var$COMPONENT_NAME_ELEMENT_ID);
}
function $1e4516afffd1665d$var$getStyles(bounds) {
    return {
        left: `${Math.round(bounds.left * 100) / 100}px`,
        top: `${Math.round(bounds.top * 100) / 100}px`,
        width: `${Math.round(bounds.width * 100) / 100}px`,
        height: `${Math.round(bounds.height * 100) / 100}px`
    };
}
function $1e4516afffd1665d$var$create(options) {
    const containerEl = document.createElement("div");
    containerEl.id = options.elementId ?? $1e4516afffd1665d$var$CONTAINER_ELEMENT_ID;
    Object.assign(containerEl.style, {
        ...$1e4516afffd1665d$var$containerStyles,
        ...$1e4516afffd1665d$var$getStyles(options.bounds),
        ...options.style
    });
    const cardEl = document.createElement("span");
    cardEl.id = $1e4516afffd1665d$var$CARD_ELEMENT_ID;
    Object.assign(cardEl.style, {
        ...$1e4516afffd1665d$var$cardStyles,
        top: options.bounds.top < 35 ? 0 : "-35px"
    });
    const nameEl = document.createElement("span");
    nameEl.id = $1e4516afffd1665d$var$COMPONENT_NAME_ELEMENT_ID;
    nameEl.innerHTML = `&lt;${options.name}&gt;&nbsp;&nbsp;`;
    const indicatorEl = document.createElement("i");
    indicatorEl.id = $1e4516afffd1665d$var$INDICATOR_ELEMENT_ID;
    indicatorEl.innerHTML = `${Math.round(options.bounds.width * 100) / 100} x ${Math.round(options.bounds.height * 100) / 100}`;
    Object.assign(indicatorEl.style, $1e4516afffd1665d$var$indicatorStyles);
    cardEl.appendChild(nameEl);
    cardEl.appendChild(indicatorEl);
    containerEl.appendChild(cardEl);
    document.body.appendChild(containerEl);
    return containerEl;
}
function $1e4516afffd1665d$var$update(options) {
    const containerEl = $1e4516afffd1665d$var$getContainerElement();
    const cardEl = $1e4516afffd1665d$var$getCardElement();
    const nameEl = $1e4516afffd1665d$var$getNameElement();
    const indicatorEl = $1e4516afffd1665d$var$getIndicatorElement();
    if (containerEl) {
        Object.assign(containerEl.style, {
            ...$1e4516afffd1665d$var$containerStyles,
            ...$1e4516afffd1665d$var$getStyles(options.bounds)
        });
        Object.assign(cardEl.style, {
            top: options.bounds.top < 35 ? 0 : "-35px"
        });
        nameEl.innerHTML = `&lt;${options.name}&gt;&nbsp;&nbsp;`;
        indicatorEl.innerHTML = `${Math.round(options.bounds.width * 100) / 100} x ${Math.round(options.bounds.height * 100) / 100}`;
    }
}
function $1e4516afffd1665d$var$highlight(instance) {
    const bounds = $1e4516afffd1665d$var$getComponentBoundingRect(instance);
    if (!bounds.width && !bounds.height) return;
    const name = $1e4516afffd1665d$var$getInstanceName(instance);
    $1e4516afffd1665d$var$getContainerElement() ? $1e4516afffd1665d$var$update({
        bounds: bounds,
        name: name
    }) : $1e4516afffd1665d$var$create({
        bounds: bounds,
        name: name
    });
}
function $1e4516afffd1665d$var$unhighlight() {
    const el = $1e4516afffd1665d$var$getContainerElement();
    if (el) el.style.display = "none";
}
let $1e4516afffd1665d$var$inspectInstance = null;
function $1e4516afffd1665d$var$inspectFn(e) {
    const target = e.target;
    if (target) {
        const instance = target.__vueParentComponent;
        if (instance) {
            $1e4516afffd1665d$var$inspectInstance = instance;
            if (instance.vnode.el) {
                const bounds = $1e4516afffd1665d$var$getComponentBoundingRect(instance);
                const name = $1e4516afffd1665d$var$getInstanceName(instance);
                $1e4516afffd1665d$var$getContainerElement() ? $1e4516afffd1665d$var$update({
                    bounds: bounds,
                    name: name
                }) : $1e4516afffd1665d$var$create({
                    bounds: bounds,
                    name: name
                });
            }
        }
    }
}
function $1e4516afffd1665d$var$selectComponentFn(e, cb) {
    e.preventDefault();
    e.stopPropagation();
    if ($1e4516afffd1665d$var$inspectInstance) cb($1e4516afffd1665d$var$getUniqueComponentId($1e4516afffd1665d$var$inspectInstance));
}
let $1e4516afffd1665d$var$inspectComponentHighLighterSelectFn = null;
function $1e4516afffd1665d$var$cancelInspectComponentHighLighter() {
    $1e4516afffd1665d$var$unhighlight();
    window.removeEventListener("mouseover", $1e4516afffd1665d$var$inspectFn);
    window.removeEventListener("click", $1e4516afffd1665d$var$inspectComponentHighLighterSelectFn, true);
    $1e4516afffd1665d$var$inspectComponentHighLighterSelectFn = null;
}
function $1e4516afffd1665d$var$inspectComponentHighLighter() {
    window.addEventListener("mouseover", $1e4516afffd1665d$var$inspectFn);
    return new Promise((resolve)=>{
        function onSelect(e) {
            e.preventDefault();
            e.stopPropagation();
            $1e4516afffd1665d$var$selectComponentFn(e, (id)=>{
                window.removeEventListener("click", onSelect, true);
                $1e4516afffd1665d$var$inspectComponentHighLighterSelectFn = null;
                window.removeEventListener("mouseover", $1e4516afffd1665d$var$inspectFn);
                const el = $1e4516afffd1665d$var$getContainerElement();
                if (el) el.style.display = "none";
                resolve(JSON.stringify({
                    id: id
                }));
            });
        }
        $1e4516afffd1665d$var$inspectComponentHighLighterSelectFn = onSelect;
        window.addEventListener("click", onSelect, true);
    });
}
function $1e4516afffd1665d$var$scrollToComponent(options) {
    const instance = $1e4516afffd1665d$var$getComponentInstance($1e4516afffd1665d$export$162128841a7f2877.value, options.id);
    if (instance) {
        const [el] = $1e4516afffd1665d$var$getRootElementsFromComponentInstance(instance);
        if (typeof el.scrollIntoView === "function") el.scrollIntoView({
            behavior: "smooth"
        });
        else {
            const bounds = $1e4516afffd1665d$var$getComponentBoundingRect(instance);
            const scrollTarget = document.createElement("div");
            const styles = {
                ...$1e4516afffd1665d$var$getStyles(bounds),
                position: "absolute"
            };
            Object.assign(scrollTarget.style, styles);
            document.body.appendChild(scrollTarget);
            scrollTarget.scrollIntoView({
                behavior: "smooth"
            });
            setTimeout(()=>{
                document.body.removeChild(scrollTarget);
            }, 2e3);
        }
        setTimeout(()=>{
            const bounds = $1e4516afffd1665d$var$getComponentBoundingRect(instance);
            if (bounds.width || bounds.height) {
                const name = $1e4516afffd1665d$var$getInstanceName(instance);
                const el = $1e4516afffd1665d$var$getContainerElement();
                el ? $1e4516afffd1665d$var$update({
                    ...options,
                    name: name,
                    bounds: bounds
                }) : $1e4516afffd1665d$var$create({
                    ...options,
                    name: name,
                    bounds: bounds
                });
                setTimeout(()=>{
                    if (el) el.style.display = "none";
                }, 1500);
            }
        }, 1200);
    }
}
//#endregion
//#region src/core/component-inspector/index.ts
(0, $7vMoz.target).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ ??= true;
function $1e4516afffd1665d$export$56455f68fb6e3b63(enabled) {
    (0, $7vMoz.target).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = enabled;
}
function $1e4516afffd1665d$var$waitForInspectorInit(cb) {
    let total = 0;
    const timer = setInterval(()=>{
        if ((0, $7vMoz.target).__VUE_INSPECTOR__) {
            clearInterval(timer);
            total += 30;
            cb();
        }
        if (total >= 5e3) clearInterval(timer);
    }, 30);
}
function $1e4516afffd1665d$var$setupInspector() {
    const inspector = (0, $7vMoz.target).__VUE_INSPECTOR__;
    const _openInEditor = inspector.openInEditor;
    inspector.openInEditor = async (...params)=>{
        inspector.disable();
        _openInEditor(...params);
    };
}
function $1e4516afffd1665d$var$getComponentInspector() {
    return new Promise((resolve)=>{
        function setup() {
            $1e4516afffd1665d$var$setupInspector();
            resolve((0, $7vMoz.target).__VUE_INSPECTOR__);
        }
        if (!(0, $7vMoz.target).__VUE_INSPECTOR__) $1e4516afffd1665d$var$waitForInspectorInit(()=>{
            setup();
        });
        else setup();
    });
}
//#endregion
//#region src/shared/stub-vue.ts
/**
* To prevent include a **HUGE** vue package in the final bundle of chrome ext / electron
* we stub the necessary vue module.
* This implementation is based on the 1c3327a0fa5983aa9078e3f7bb2330f572435425 commit
*/ /**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/constants.ts#L17-L23)
*/ let $1e4516afffd1665d$var$ReactiveFlags = /* @__PURE__ */ function(ReactiveFlags) {
    ReactiveFlags["SKIP"] = "__v_skip";
    ReactiveFlags["IS_REACTIVE"] = "__v_isReactive";
    ReactiveFlags["IS_READONLY"] = "__v_isReadonly";
    ReactiveFlags["IS_SHALLOW"] = "__v_isShallow";
    ReactiveFlags["RAW"] = "__v_raw";
    return ReactiveFlags;
}({});
/**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/reactive.ts#L330-L332)
*/ function $1e4516afffd1665d$var$isReadonly(value) {
    return !!(value && value[$1e4516afffd1665d$var$ReactiveFlags.IS_READONLY]);
}
/**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/reactive.ts#L312-L317)
*/ function $1e4516afffd1665d$var$isReactive$1(value) {
    if ($1e4516afffd1665d$var$isReadonly(value)) return $1e4516afffd1665d$var$isReactive$1(value[$1e4516afffd1665d$var$ReactiveFlags.RAW]);
    return !!(value && value[$1e4516afffd1665d$var$ReactiveFlags.IS_REACTIVE]);
}
function $1e4516afffd1665d$var$isRef$1(r) {
    return !!(r && r.__v_isRef === true);
}
/**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/reactive.ts#L372-L375)
*/ function $1e4516afffd1665d$var$toRaw$1(observed) {
    const raw = observed && observed[$1e4516afffd1665d$var$ReactiveFlags.RAW];
    return raw ? $1e4516afffd1665d$var$toRaw$1(raw) : observed;
}
//#endregion
//#region src/core/component/state/editor.ts
var $1e4516afffd1665d$var$StateEditor = class {
    constructor(){
        this.refEditor = new $1e4516afffd1665d$var$RefStateEditor();
    }
    set(object, path, value, cb) {
        const sections = Array.isArray(path) ? path : path.split(".");
        while(sections.length > 1){
            const section = sections.shift();
            if (object instanceof Map) object = object.get(section);
            else if (object instanceof Set) object = Array.from(object.values())[section];
            else object = object[section];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
        }
        const field = sections[0];
        const item = this.refEditor.get(object)[field];
        if (cb) cb(object, field, value);
        else if (this.refEditor.isRef(item)) this.refEditor.set(item, value);
        else object[field] = value;
    }
    get(object, path) {
        const sections = Array.isArray(path) ? path : path.split(".");
        for(let i = 0; i < sections.length; i++){
            if (object instanceof Map) object = object.get(sections[i]);
            else object = object[sections[i]];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
            if (!object) return void 0;
        }
        return object;
    }
    has(object, path, parent = false) {
        if (typeof object === "undefined") return false;
        const sections = Array.isArray(path) ? path.slice() : path.split(".");
        const size = !parent ? 1 : 2;
        while(object && sections.length > size){
            const section = sections.shift();
            object = object[section];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
        }
        return object != null && Object.prototype.hasOwnProperty.call(object, sections[0]);
    }
    createDefaultSetCallback(state) {
        return (object, field, value)=>{
            if (state.remove || state.newKey) {
                if (Array.isArray(object)) object.splice(field, 1);
                else if ($1e4516afffd1665d$var$toRaw$1(object) instanceof Map) object.delete(field);
                else if ($1e4516afffd1665d$var$toRaw$1(object) instanceof Set) object.delete(Array.from(object.values())[field]);
                else Reflect.deleteProperty(object, field);
            }
            if (!state.remove) {
                const target = object[state.newKey || field];
                if (this.refEditor.isRef(target)) this.refEditor.set(target, value);
                else if ($1e4516afffd1665d$var$toRaw$1(object) instanceof Map) object.set(state.newKey || field, value);
                else if ($1e4516afffd1665d$var$toRaw$1(object) instanceof Set) object.add(value);
                else object[state.newKey || field] = value;
            }
        };
    }
};
var $1e4516afffd1665d$var$RefStateEditor = class {
    set(ref, value) {
        if ($1e4516afffd1665d$var$isRef$1(ref)) ref.value = value;
        else {
            if (ref instanceof Set && Array.isArray(value)) {
                ref.clear();
                value.forEach((v)=>ref.add(v));
                return;
            }
            const currentKeys = Object.keys(value);
            if (ref instanceof Map) {
                const previousKeysSet = new Set(ref.keys());
                currentKeys.forEach((key)=>{
                    ref.set(key, Reflect.get(value, key));
                    previousKeysSet.delete(key);
                });
                previousKeysSet.forEach((key)=>ref.delete(key));
                return;
            }
            const previousKeysSet = new Set(Object.keys(ref));
            currentKeys.forEach((key)=>{
                Reflect.set(ref, key, Reflect.get(value, key));
                previousKeysSet.delete(key);
            });
            previousKeysSet.forEach((key)=>Reflect.deleteProperty(ref, key));
        }
    }
    get(ref) {
        return $1e4516afffd1665d$var$isRef$1(ref) ? ref.value : ref;
    }
    isRef(ref) {
        return $1e4516afffd1665d$var$isRef$1(ref) || $1e4516afffd1665d$var$isReactive$1(ref);
    }
};
async function $1e4516afffd1665d$var$editComponentState(payload, stateEditor) {
    const { path: path, nodeId: nodeId, state: state, type: type } = payload;
    const instance = $1e4516afffd1665d$var$getComponentInstance($1e4516afffd1665d$export$162128841a7f2877.value, nodeId);
    if (!instance) return;
    const targetPath = path.slice();
    let target;
    if (Object.keys(instance.props).includes(path[0])) target = instance.props;
    else if (instance.devtoolsRawSetupState && Object.keys(instance.devtoolsRawSetupState).includes(path[0])) target = instance.devtoolsRawSetupState;
    else if (instance.data && Object.keys(instance.data).includes(path[0])) target = instance.data;
    else target = instance.proxy;
    if (target && targetPath) {
        state.type === "object" && type;
        stateEditor.set(target, targetPath, state.value, stateEditor.createDefaultSetCallback(state));
    }
}
const $1e4516afffd1665d$var$stateEditor = new $1e4516afffd1665d$var$StateEditor();
async function $1e4516afffd1665d$var$editState(payload) {
    $1e4516afffd1665d$var$editComponentState(payload, $1e4516afffd1665d$var$stateEditor);
}
//#endregion
//#region src/core/timeline/storage.ts
const $1e4516afffd1665d$var$TIMELINE_LAYERS_STATE_STORAGE_ID = "__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__";
function $1e4516afffd1665d$var$addTimelineLayersStateToStorage(state) {
    if (!(0, $7vMoz.isBrowser) || typeof localStorage === "undefined" || localStorage === null) return;
    localStorage.setItem($1e4516afffd1665d$var$TIMELINE_LAYERS_STATE_STORAGE_ID, JSON.stringify(state));
}
function $1e4516afffd1665d$var$getTimelineLayersStateFromStorage() {
    if (typeof window === "undefined" || !(0, $7vMoz.isBrowser) || typeof localStorage === "undefined" || localStorage === null) return {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
    const state = typeof localStorage.getItem !== "undefined" ? localStorage.getItem($1e4516afffd1665d$var$TIMELINE_LAYERS_STATE_STORAGE_ID) : null;
    return state ? JSON.parse(state) : {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
}
//#endregion
//#region src/ctx/timeline.ts
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS ??= [];
const $1e4516afffd1665d$var$devtoolsTimelineLayers = new Proxy((0, $7vMoz.target).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
    get (target, prop, receiver) {
        return Reflect.get(target, prop, receiver);
    }
});
function $1e4516afffd1665d$var$addTimelineLayer(options, descriptor) {
    $1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState[descriptor.id] = false;
    $1e4516afffd1665d$var$devtoolsTimelineLayers.push({
        ...options,
        descriptorId: descriptor.id,
        appRecord: $1e4516afffd1665d$var$getAppRecord(descriptor.app)
    });
}
function $1e4516afffd1665d$export$736910b7e8839d93(state) {
    const updatedState = {
        ...$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState,
        ...state
    };
    $1e4516afffd1665d$var$addTimelineLayersStateToStorage(updatedState);
    $1e4516afffd1665d$export$ee22a7aaf6b41ce2({
        timelineLayersState: updatedState
    });
}
//#endregion
//#region src/ctx/inspector.ts
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_INSPECTOR__ ??= [];
const $1e4516afffd1665d$export$996e3c8abad0143f = new Proxy((0, $7vMoz.target).__VUE_DEVTOOLS_KIT_INSPECTOR__, {
    get (target, prop, receiver) {
        return Reflect.get(target, prop, receiver);
    }
});
const $1e4516afffd1665d$export$17f8005932e80cc0 = (0, $aZyT4.debounce)(()=>{
    $1e4516afffd1665d$export$4f1904c03898171b.hooks.callHook($1e4516afffd1665d$export$12aa7e661bddec80.SEND_INSPECTOR_TO_CLIENT, $1e4516afffd1665d$export$2844c7432ba9d166());
});
function $1e4516afffd1665d$export$e863e3b6c2ff029b(inspector, descriptor) {
    $1e4516afffd1665d$export$996e3c8abad0143f.push({
        options: inspector,
        descriptor: descriptor,
        treeFilterPlaceholder: inspector.treeFilterPlaceholder ?? "Search tree...",
        stateFilterPlaceholder: inspector.stateFilterPlaceholder ?? "Search state...",
        treeFilter: "",
        selectedNodeId: "",
        appRecord: $1e4516afffd1665d$var$getAppRecord(descriptor.app)
    });
    $1e4516afffd1665d$export$17f8005932e80cc0();
}
function $1e4516afffd1665d$export$2844c7432ba9d166() {
    return $1e4516afffd1665d$export$996e3c8abad0143f.filter((inspector)=>inspector.descriptor.app === $1e4516afffd1665d$export$162128841a7f2877.value.app).filter((inspector)=>inspector.descriptor.id !== "components").map((inspector)=>{
        const descriptor = inspector.descriptor;
        const options = inspector.options;
        return {
            id: options.id,
            label: options.label,
            logo: descriptor.logo,
            icon: `custom-ic-baseline-${options?.icon?.replace(/_/g, "-")}`,
            packageName: descriptor.packageName,
            homepage: descriptor.homepage,
            pluginId: descriptor.id
        };
    });
}
function $1e4516afffd1665d$export$5042bdc6f02e4304(id) {
    const inspector = $1e4516afffd1665d$export$aa4140d0f5ce4bbe(id, $1e4516afffd1665d$export$162128841a7f2877.value.app);
    if (!inspector) return;
    const descriptor = inspector.descriptor;
    const options = inspector.options;
    const timelineLayers = $1e4516afffd1665d$var$devtoolsTimelineLayers.filter((layer)=>layer.descriptorId === descriptor.id).map((item)=>({
            id: item.id,
            label: item.label,
            color: item.color
        }));
    return {
        id: options.id,
        label: options.label,
        logo: descriptor.logo,
        packageName: descriptor.packageName,
        homepage: descriptor.homepage,
        timelineLayers: timelineLayers,
        treeFilterPlaceholder: inspector.treeFilterPlaceholder,
        stateFilterPlaceholder: inspector.stateFilterPlaceholder
    };
}
function $1e4516afffd1665d$export$aa4140d0f5ce4bbe(id, app) {
    return $1e4516afffd1665d$export$996e3c8abad0143f.find((inspector)=>inspector.options.id === id && (app ? inspector.descriptor.app === app : true));
}
function $1e4516afffd1665d$export$54eb86d2eca92815(id) {
    return $1e4516afffd1665d$export$aa4140d0f5ce4bbe(id)?.options.actions;
}
function $1e4516afffd1665d$export$eebdca42b352a0b2(id) {
    return $1e4516afffd1665d$export$aa4140d0f5ce4bbe(id)?.options.nodeActions;
}
//#endregion
//#region src/ctx/hook.ts
let $1e4516afffd1665d$export$3936435a794cb908 = /* @__PURE__ */ function(DevToolsV6PluginAPIHookKeys) {
    DevToolsV6PluginAPIHookKeys["VISIT_COMPONENT_TREE"] = "visitComponentTree";
    DevToolsV6PluginAPIHookKeys["INSPECT_COMPONENT"] = "inspectComponent";
    DevToolsV6PluginAPIHookKeys["EDIT_COMPONENT_STATE"] = "editComponentState";
    DevToolsV6PluginAPIHookKeys["GET_INSPECTOR_TREE"] = "getInspectorTree";
    DevToolsV6PluginAPIHookKeys["GET_INSPECTOR_STATE"] = "getInspectorState";
    DevToolsV6PluginAPIHookKeys["EDIT_INSPECTOR_STATE"] = "editInspectorState";
    DevToolsV6PluginAPIHookKeys["INSPECT_TIMELINE_EVENT"] = "inspectTimelineEvent";
    DevToolsV6PluginAPIHookKeys["TIMELINE_CLEARED"] = "timelineCleared";
    DevToolsV6PluginAPIHookKeys["SET_PLUGIN_SETTINGS"] = "setPluginSettings";
    return DevToolsV6PluginAPIHookKeys;
}({});
let $1e4516afffd1665d$export$4c35c03df042a977 = /* @__PURE__ */ function(DevToolsContextHookKeys) {
    DevToolsContextHookKeys["ADD_INSPECTOR"] = "addInspector";
    DevToolsContextHookKeys["SEND_INSPECTOR_TREE"] = "sendInspectorTree";
    DevToolsContextHookKeys["SEND_INSPECTOR_STATE"] = "sendInspectorState";
    DevToolsContextHookKeys["CUSTOM_INSPECTOR_SELECT_NODE"] = "customInspectorSelectNode";
    DevToolsContextHookKeys["TIMELINE_LAYER_ADDED"] = "timelineLayerAdded";
    DevToolsContextHookKeys["TIMELINE_EVENT_ADDED"] = "timelineEventAdded";
    DevToolsContextHookKeys["GET_COMPONENT_INSTANCES"] = "getComponentInstances";
    DevToolsContextHookKeys["GET_COMPONENT_BOUNDS"] = "getComponentBounds";
    DevToolsContextHookKeys["GET_COMPONENT_NAME"] = "getComponentName";
    DevToolsContextHookKeys["COMPONENT_HIGHLIGHT"] = "componentHighlight";
    DevToolsContextHookKeys["COMPONENT_UNHIGHLIGHT"] = "componentUnhighlight";
    return DevToolsContextHookKeys;
}({});
let $1e4516afffd1665d$export$12aa7e661bddec80 = /* @__PURE__ */ function(DevToolsMessagingHookKeys) {
    DevToolsMessagingHookKeys["SEND_INSPECTOR_TREE_TO_CLIENT"] = "sendInspectorTreeToClient";
    DevToolsMessagingHookKeys["SEND_INSPECTOR_STATE_TO_CLIENT"] = "sendInspectorStateToClient";
    DevToolsMessagingHookKeys["SEND_TIMELINE_EVENT_TO_CLIENT"] = "sendTimelineEventToClient";
    DevToolsMessagingHookKeys["SEND_INSPECTOR_TO_CLIENT"] = "sendInspectorToClient";
    DevToolsMessagingHookKeys["SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT"] = "sendActiveAppUpdatedToClient";
    DevToolsMessagingHookKeys["DEVTOOLS_STATE_UPDATED"] = "devtoolsStateUpdated";
    DevToolsMessagingHookKeys["DEVTOOLS_CONNECTED_UPDATED"] = "devtoolsConnectedUpdated";
    DevToolsMessagingHookKeys["ROUTER_INFO_UPDATED"] = "routerInfoUpdated";
    return DevToolsMessagingHookKeys;
}({});
function $1e4516afffd1665d$export$73be3ac6032ad9bb() {
    const hooks = (0, $kFbbN.createHooks)();
    hooks.hook($1e4516afffd1665d$export$4c35c03df042a977.ADD_INSPECTOR, ({ inspector: inspector, plugin: plugin })=>{
        $1e4516afffd1665d$export$e863e3b6c2ff029b(inspector, plugin.descriptor);
    });
    const debounceSendInspectorTree = (0, $aZyT4.debounce)(async ({ inspectorId: inspectorId, plugin: plugin })=>{
        if (!inspectorId || !plugin?.descriptor?.app || $1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $1e4516afffd1665d$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        const _payload = {
            app: plugin.descriptor.app,
            inspectorId: inspectorId,
            filter: inspector?.treeFilter || "",
            rootNodes: []
        };
        await new Promise((resolve)=>{
            hooks.callHookWith(async (callbacks)=>{
                await Promise.all(callbacks.map((cb)=>cb(_payload)));
                resolve();
            }, $1e4516afffd1665d$export$3936435a794cb908.GET_INSPECTOR_TREE);
        });
        hooks.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb({
                    inspectorId: inspectorId,
                    rootNodes: _payload.rootNodes
                })));
        }, $1e4516afffd1665d$export$12aa7e661bddec80.SEND_INSPECTOR_TREE_TO_CLIENT);
    }, 120);
    hooks.hook($1e4516afffd1665d$export$4c35c03df042a977.SEND_INSPECTOR_TREE, debounceSendInspectorTree);
    const debounceSendInspectorState = (0, $aZyT4.debounce)(async ({ inspectorId: inspectorId, plugin: plugin })=>{
        if (!inspectorId || !plugin?.descriptor?.app || $1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $1e4516afffd1665d$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        const _payload = {
            app: plugin.descriptor.app,
            inspectorId: inspectorId,
            nodeId: inspector?.selectedNodeId || "",
            state: null
        };
        const ctx = {
            currentTab: `custom-inspector:${inspectorId}`
        };
        if (_payload.nodeId) await new Promise((resolve)=>{
            hooks.callHookWith(async (callbacks)=>{
                await Promise.all(callbacks.map((cb)=>cb(_payload, ctx)));
                resolve();
            }, $1e4516afffd1665d$export$3936435a794cb908.GET_INSPECTOR_STATE);
        });
        hooks.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb({
                    inspectorId: inspectorId,
                    nodeId: _payload.nodeId,
                    state: _payload.state
                })));
        }, $1e4516afffd1665d$export$12aa7e661bddec80.SEND_INSPECTOR_STATE_TO_CLIENT);
    }, 120);
    hooks.hook($1e4516afffd1665d$export$4c35c03df042a977.SEND_INSPECTOR_STATE, debounceSendInspectorState);
    hooks.hook($1e4516afffd1665d$export$4c35c03df042a977.CUSTOM_INSPECTOR_SELECT_NODE, ({ inspectorId: inspectorId, nodeId: nodeId, plugin: plugin })=>{
        const inspector = $1e4516afffd1665d$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        if (!inspector) return;
        inspector.selectedNodeId = nodeId;
    });
    hooks.hook($1e4516afffd1665d$export$4c35c03df042a977.TIMELINE_LAYER_ADDED, ({ options: options, plugin: plugin })=>{
        $1e4516afffd1665d$var$addTimelineLayer(options, plugin.descriptor);
    });
    hooks.hook($1e4516afffd1665d$export$4c35c03df042a977.TIMELINE_EVENT_ADDED, ({ options: options, plugin: plugin })=>{
        if ($1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled || !$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState?.[plugin.descriptor.id] && ![
            "performance",
            "component-event",
            "keyboard",
            "mouse"
        ].includes(options.layerId)) return;
        hooks.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb(options)));
        }, $1e4516afffd1665d$export$12aa7e661bddec80.SEND_TIMELINE_EVENT_TO_CLIENT);
    });
    hooks.hook($1e4516afffd1665d$export$4c35c03df042a977.GET_COMPONENT_INSTANCES, async ({ app: app })=>{
        const appRecord = app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
        if (!appRecord) return null;
        const appId = appRecord.id.toString();
        return [
            ...appRecord.instanceMap
        ].filter(([key])=>key.split(":")[0] === appId).map(([, instance])=>instance);
    });
    hooks.hook($1e4516afffd1665d$export$4c35c03df042a977.GET_COMPONENT_BOUNDS, async ({ instance: instance })=>{
        return $1e4516afffd1665d$var$getComponentBoundingRect(instance);
    });
    hooks.hook($1e4516afffd1665d$export$4c35c03df042a977.GET_COMPONENT_NAME, ({ instance: instance })=>{
        return $1e4516afffd1665d$var$getInstanceName(instance);
    });
    hooks.hook($1e4516afffd1665d$export$4c35c03df042a977.COMPONENT_HIGHLIGHT, ({ uid: uid })=>{
        const instance = $1e4516afffd1665d$export$162128841a7f2877.value.instanceMap.get(uid);
        if (instance) $1e4516afffd1665d$var$highlight(instance);
    });
    hooks.hook($1e4516afffd1665d$export$4c35c03df042a977.COMPONENT_UNHIGHLIGHT, ()=>{
        $1e4516afffd1665d$var$unhighlight();
    });
    return hooks;
}
//#endregion
//#region src/ctx/state.ts
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__ ??= [];
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ ??= {};
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ ??= "";
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ ??= [];
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ ??= [];
const $1e4516afffd1665d$var$STATE_KEY = "__VUE_DEVTOOLS_KIT_GLOBAL_STATE__";
function $1e4516afffd1665d$var$initStateFactory() {
    return {
        connected: false,
        clientConnected: false,
        vitePluginDetected: true,
        appRecords: [],
        activeAppRecordId: "",
        tabs: [],
        commands: [],
        highPerfModeEnabled: true,
        devtoolsClientDetected: {},
        perfUniqueGroupId: 0,
        timelineLayersState: $1e4516afffd1665d$var$getTimelineLayersStateFromStorage()
    };
}
(0, $7vMoz.target)[$1e4516afffd1665d$var$STATE_KEY] ??= $1e4516afffd1665d$var$initStateFactory();
const $1e4516afffd1665d$export$ff4fc651602b9735 = (0, $aZyT4.debounce)((state)=>{
    $1e4516afffd1665d$export$4f1904c03898171b.hooks.callHook($1e4516afffd1665d$export$12aa7e661bddec80.DEVTOOLS_STATE_UPDATED, {
        state: state
    });
});
const $1e4516afffd1665d$export$ce292af96ab94f7c = (0, $aZyT4.debounce)((state, oldState)=>{
    $1e4516afffd1665d$export$4f1904c03898171b.hooks.callHook($1e4516afffd1665d$export$12aa7e661bddec80.DEVTOOLS_CONNECTED_UPDATED, {
        state: state,
        oldState: oldState
    });
});
const $1e4516afffd1665d$export$d3c0473489b1d63b = new Proxy((0, $7vMoz.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
    get (_target, prop, receiver) {
        if (prop === "value") return (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__;
        return (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__[prop];
    }
});
const $1e4516afffd1665d$export$c1761479e1420543 = (app)=>{
    (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = [
        ...(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__,
        app
    ];
};
const $1e4516afffd1665d$export$4d20c72f1da170ba = (app)=>{
    (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = $1e4516afffd1665d$export$d3c0473489b1d63b.value.filter((record)=>record.app !== app);
};
const $1e4516afffd1665d$export$162128841a7f2877 = new Proxy((0, $7vMoz.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
    get (_target, prop, receiver) {
        if (prop === "value") return (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__;
        else if (prop === "id") return (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__;
        return (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[prop];
    }
});
function $1e4516afffd1665d$var$updateAllStates() {
    $1e4516afffd1665d$export$ff4fc651602b9735({
        ...(0, $7vMoz.target)[$1e4516afffd1665d$var$STATE_KEY],
        appRecords: $1e4516afffd1665d$export$d3c0473489b1d63b.value,
        activeAppRecordId: $1e4516afffd1665d$export$162128841a7f2877.id,
        tabs: (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
        commands: (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
    });
}
function $1e4516afffd1665d$export$1574774def61bdf9(app) {
    (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = app;
    $1e4516afffd1665d$var$updateAllStates();
}
function $1e4516afffd1665d$export$1a7804ab8d8511d1(id) {
    (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = id;
    $1e4516afffd1665d$var$updateAllStates();
}
const $1e4516afffd1665d$export$a67dd585df937baa = new Proxy((0, $7vMoz.target)[$1e4516afffd1665d$var$STATE_KEY], {
    get (target$3, property) {
        if (property === "appRecords") return $1e4516afffd1665d$export$d3c0473489b1d63b;
        else if (property === "activeAppRecordId") return $1e4516afffd1665d$export$162128841a7f2877.id;
        else if (property === "tabs") return (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
        else if (property === "commands") return (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
        return (0, $7vMoz.target)[$1e4516afffd1665d$var$STATE_KEY][property];
    },
    deleteProperty (target, property) {
        delete target[property];
        return true;
    },
    set (target$4, property, value) {
        target$4[property] = value;
        (0, $7vMoz.target)[$1e4516afffd1665d$var$STATE_KEY][property] = value;
        return true;
    }
});
function $1e4516afffd1665d$export$ed70a0f71250535e() {
    Object.assign((0, $7vMoz.target)[$1e4516afffd1665d$var$STATE_KEY], $1e4516afffd1665d$var$initStateFactory());
}
function $1e4516afffd1665d$export$ee22a7aaf6b41ce2(state) {
    const oldState = {
        ...(0, $7vMoz.target)[$1e4516afffd1665d$var$STATE_KEY],
        appRecords: $1e4516afffd1665d$export$d3c0473489b1d63b.value,
        activeAppRecordId: $1e4516afffd1665d$export$162128841a7f2877.id
    };
    if (oldState.connected !== state.connected && state.connected || oldState.clientConnected !== state.clientConnected && state.clientConnected) $1e4516afffd1665d$export$ce292af96ab94f7c((0, $7vMoz.target)[$1e4516afffd1665d$var$STATE_KEY], oldState);
    Object.assign((0, $7vMoz.target)[$1e4516afffd1665d$var$STATE_KEY], state);
    $1e4516afffd1665d$var$updateAllStates();
}
function $1e4516afffd1665d$export$814e9e34f2c01770(fn) {
    return new Promise((resolve)=>{
        if ($1e4516afffd1665d$export$a67dd585df937baa.connected) {
            fn();
            resolve();
        }
        $1e4516afffd1665d$export$4f1904c03898171b.hooks.hook($1e4516afffd1665d$export$12aa7e661bddec80.DEVTOOLS_CONNECTED_UPDATED, ({ state: state })=>{
            if (state.connected) {
                fn();
                resolve();
            }
        });
    });
}
const $1e4516afffd1665d$var$resolveIcon = (icon)=>{
    if (!icon) return;
    if (icon.startsWith("baseline-")) return `custom-ic-${icon}`;
    if (icon.startsWith("i-") || (0, $7vMoz.isUrlString)(icon)) return icon;
    return `custom-ic-baseline-${icon}`;
};
function $1e4516afffd1665d$export$9ce008646970742b(tab) {
    const tabs = (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
    if (tabs.some((t)=>t.name === tab.name)) return;
    tabs.push({
        ...tab,
        icon: $1e4516afffd1665d$var$resolveIcon(tab.icon)
    });
    $1e4516afffd1665d$var$updateAllStates();
}
function $1e4516afffd1665d$export$faa8225e4ad5293(action) {
    const commands = (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    if (commands.some((t)=>t.id === action.id)) return;
    commands.push({
        ...action,
        icon: $1e4516afffd1665d$var$resolveIcon(action.icon),
        children: action.children ? action.children.map((child)=>({
                ...child,
                icon: $1e4516afffd1665d$var$resolveIcon(child.icon)
            })) : void 0
    });
    $1e4516afffd1665d$var$updateAllStates();
}
function $1e4516afffd1665d$export$8791c0d68ff21044(actionId) {
    const commands = (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    const index = commands.findIndex((t)=>t.id === actionId);
    if (index === -1) return;
    commands.splice(index, 1);
    $1e4516afffd1665d$var$updateAllStates();
}
function $1e4516afffd1665d$export$b2de3679515b1d6b(state) {
    $1e4516afffd1665d$export$ee22a7aaf6b41ce2({
        clientConnected: state
    });
}
//#endregion
//#region src/core/open-in-editor/index.ts
function $1e4516afffd1665d$export$d4398ad178564033(url) {
    (0, $7vMoz.target).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__ = url;
}
function $1e4516afffd1665d$var$openInEditor(options = {}) {
    const { file: file, host: host, baseUrl: baseUrl = window.location.origin, line: line = 0, column: column = 0 } = options;
    if (file) {
        if (host === "chrome-extension") {
            const fileName = file.replace(/\\/g, "\\\\");
            const _baseUrl = window.VUE_DEVTOOLS_CONFIG?.openInEditorHost ?? "/";
            fetch(`${_baseUrl}__open-in-editor?file=${encodeURI(file)}`).then((response)=>{
                if (!response.ok) {
                    const msg = `Opening component ${fileName} failed`;
                    console.log(`%c${msg}`, "color:red");
                }
            });
        } else if ($1e4516afffd1665d$export$a67dd585df937baa.vitePluginDetected) {
            const _baseUrl = (0, $7vMoz.target).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__ ?? baseUrl;
            (0, $7vMoz.target).__VUE_INSPECTOR__.openInEditor(_baseUrl, file, line, column);
        }
    }
}
//#endregion
//#region src/ctx/plugin.ts
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ ??= [];
const $1e4516afffd1665d$export$df02dcb86618c10f = new Proxy((0, $7vMoz.target).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
    get (target, prop, receiver) {
        return Reflect.get(target, prop, receiver);
    }
});
function $1e4516afffd1665d$export$5158df7771943590(pluginDescriptor, setupFn) {
    $1e4516afffd1665d$export$df02dcb86618c10f.push([
        pluginDescriptor,
        setupFn
    ]);
}
//#endregion
//#region src/core/plugin/plugin-settings.ts
function $1e4516afffd1665d$var$_getSettings(settings) {
    const _settings = {};
    Object.keys(settings).forEach((key)=>{
        _settings[key] = settings[key].defaultValue;
    });
    return _settings;
}
function $1e4516afffd1665d$var$getPluginLocalKey(pluginId) {
    return `__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__${pluginId}__`;
}
function $1e4516afffd1665d$var$getPluginSettingsOptions(pluginId) {
    return ($1e4516afffd1665d$export$df02dcb86618c10f.find((item)=>item[0].id === pluginId && !!item[0]?.settings)?.[0] ?? null)?.settings ?? null;
}
function $1e4516afffd1665d$var$getPluginSettings(pluginId, fallbackValue) {
    const localKey = $1e4516afffd1665d$var$getPluginLocalKey(pluginId);
    if (localKey) {
        const localSettings = localStorage.getItem(localKey);
        if (localSettings) return JSON.parse(localSettings);
    }
    if (pluginId) return $1e4516afffd1665d$var$_getSettings(($1e4516afffd1665d$export$df02dcb86618c10f.find((item)=>item[0].id === pluginId)?.[0] ?? null)?.settings ?? {});
    return $1e4516afffd1665d$var$_getSettings(fallbackValue);
}
function $1e4516afffd1665d$var$initPluginSettings(pluginId, settings) {
    const localKey = $1e4516afffd1665d$var$getPluginLocalKey(pluginId);
    if (!localStorage.getItem(localKey)) localStorage.setItem(localKey, JSON.stringify($1e4516afffd1665d$var$_getSettings(settings)));
}
function $1e4516afffd1665d$var$setPluginSettings(pluginId, key, value) {
    const localKey = $1e4516afffd1665d$var$getPluginLocalKey(pluginId);
    const localSettings = localStorage.getItem(localKey);
    const parsedLocalSettings = JSON.parse(localSettings || "{}");
    const updated = {
        ...parsedLocalSettings,
        [key]: value
    };
    localStorage.setItem(localKey, JSON.stringify(updated));
    $1e4516afffd1665d$export$4f1904c03898171b.hooks.callHookWith((callbacks)=>{
        callbacks.forEach((cb)=>cb({
                pluginId: pluginId,
                key: key,
                oldValue: parsedLocalSettings[key],
                newValue: value,
                settings: updated
            }));
    }, $1e4516afffd1665d$export$3936435a794cb908.SET_PLUGIN_SETTINGS);
}
//#endregion
//#region src/types/hook.ts
let $1e4516afffd1665d$var$DevToolsHooks = /* @__PURE__ */ function(DevToolsHooks) {
    DevToolsHooks["APP_INIT"] = "app:init";
    DevToolsHooks["APP_UNMOUNT"] = "app:unmount";
    DevToolsHooks["COMPONENT_UPDATED"] = "component:updated";
    DevToolsHooks["COMPONENT_ADDED"] = "component:added";
    DevToolsHooks["COMPONENT_REMOVED"] = "component:removed";
    DevToolsHooks["COMPONENT_EMIT"] = "component:emit";
    DevToolsHooks["PERFORMANCE_START"] = "perf:start";
    DevToolsHooks["PERFORMANCE_END"] = "perf:end";
    DevToolsHooks["ADD_ROUTE"] = "router:add-route";
    DevToolsHooks["REMOVE_ROUTE"] = "router:remove-route";
    DevToolsHooks["RENDER_TRACKED"] = "render:tracked";
    DevToolsHooks["RENDER_TRIGGERED"] = "render:triggered";
    DevToolsHooks["APP_CONNECTED"] = "app:connected";
    DevToolsHooks["SETUP_DEVTOOLS_PLUGIN"] = "devtools-plugin:setup";
    return DevToolsHooks;
}({});
//#endregion
//#region src/hook/index.ts
const $1e4516afffd1665d$var$devtoolsHooks = (0, $7vMoz.target).__VUE_DEVTOOLS_HOOK ??= (0, $kFbbN.createHooks)();
const $1e4516afffd1665d$var$on = {
    vueAppInit (fn) {
        $1e4516afffd1665d$var$devtoolsHooks.hook($1e4516afffd1665d$var$DevToolsHooks.APP_INIT, fn);
    },
    vueAppUnmount (fn) {
        $1e4516afffd1665d$var$devtoolsHooks.hook($1e4516afffd1665d$var$DevToolsHooks.APP_UNMOUNT, fn);
    },
    vueAppConnected (fn) {
        $1e4516afffd1665d$var$devtoolsHooks.hook($1e4516afffd1665d$var$DevToolsHooks.APP_CONNECTED, fn);
    },
    componentAdded (fn) {
        return $1e4516afffd1665d$var$devtoolsHooks.hook($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_ADDED, fn);
    },
    componentEmit (fn) {
        return $1e4516afffd1665d$var$devtoolsHooks.hook($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_EMIT, fn);
    },
    componentUpdated (fn) {
        return $1e4516afffd1665d$var$devtoolsHooks.hook($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_UPDATED, fn);
    },
    componentRemoved (fn) {
        return $1e4516afffd1665d$var$devtoolsHooks.hook($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_REMOVED, fn);
    },
    setupDevtoolsPlugin (fn) {
        $1e4516afffd1665d$var$devtoolsHooks.hook($1e4516afffd1665d$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, fn);
    },
    perfStart (fn) {
        return $1e4516afffd1665d$var$devtoolsHooks.hook($1e4516afffd1665d$var$DevToolsHooks.PERFORMANCE_START, fn);
    },
    perfEnd (fn) {
        return $1e4516afffd1665d$var$devtoolsHooks.hook($1e4516afffd1665d$var$DevToolsHooks.PERFORMANCE_END, fn);
    }
};
function $1e4516afffd1665d$var$createDevToolsHook() {
    return {
        id: "vue-devtools-next",
        devtoolsVersion: "7.0",
        enabled: false,
        appRecords: [],
        apps: [],
        events: /* @__PURE__ */ new Map(),
        on (event, fn) {
            if (!this.events.has(event)) this.events.set(event, []);
            this.events.get(event)?.push(fn);
            return ()=>this.off(event, fn);
        },
        once (event, fn) {
            const onceFn = (...args)=>{
                this.off(event, onceFn);
                fn(...args);
            };
            this.on(event, onceFn);
            return [
                event,
                onceFn
            ];
        },
        off (event, fn) {
            if (this.events.has(event)) {
                const eventCallbacks = this.events.get(event);
                const index = eventCallbacks.indexOf(fn);
                if (index !== -1) eventCallbacks.splice(index, 1);
            }
        },
        emit (event, ...payload) {
            if (this.events.has(event)) this.events.get(event).forEach((fn)=>fn(...payload));
        }
    };
}
function $1e4516afffd1665d$var$subscribeDevToolsHook(hook) {
    hook.on($1e4516afffd1665d$var$DevToolsHooks.APP_INIT, (app, version, types)=>{
        if (app?._instance?.type?.devtools?.hide) return;
        $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.APP_INIT, app, version, types);
    });
    hook.on($1e4516afffd1665d$var$DevToolsHooks.APP_UNMOUNT, (app)=>{
        $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.APP_UNMOUNT, app);
    });
    hook.on($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_ADDED, async (app, uid, parentUid, component)=>{
        if (app?._instance?.type?.devtools?.hide || $1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        if (!app || typeof uid !== "number" && !uid || !component) return;
        $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_ADDED, app, uid, parentUid, component);
    });
    hook.on($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_UPDATED, (app, uid, parentUid, component)=>{
        if (!app || typeof uid !== "number" && !uid || !component || $1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_UPDATED, app, uid, parentUid, component);
    });
    hook.on($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_REMOVED, async (app, uid, parentUid, component)=>{
        if (!app || typeof uid !== "number" && !uid || !component || $1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_REMOVED, app, uid, parentUid, component);
    });
    hook.on($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_EMIT, async (app, instance, event, params)=>{
        if (!app || !instance || $1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_EMIT, app, instance, event, params);
    });
    hook.on($1e4516afffd1665d$var$DevToolsHooks.PERFORMANCE_START, (app, uid, vm, type, time)=>{
        if (!app || $1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.PERFORMANCE_START, app, uid, vm, type, time);
    });
    hook.on($1e4516afffd1665d$var$DevToolsHooks.PERFORMANCE_END, (app, uid, vm, type, time)=>{
        if (!app || $1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.PERFORMANCE_END, app, uid, vm, type, time);
    });
    hook.on($1e4516afffd1665d$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, (pluginDescriptor, setupFn, options)=>{
        if (options?.target === "legacy") return;
        $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, pluginDescriptor, setupFn);
    });
}
const $1e4516afffd1665d$var$hook = {
    on: $1e4516afffd1665d$var$on,
    setupDevToolsPlugin (pluginDescriptor, setupFn) {
        return $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, pluginDescriptor, setupFn);
    }
};
//#endregion
//#region src/api/v6/index.ts
var $1e4516afffd1665d$var$DevToolsV6PluginAPI = class {
    constructor({ plugin: plugin, ctx: ctx }){
        this.hooks = ctx.hooks;
        this.plugin = plugin;
    }
    get on() {
        return {
            visitComponentTree: (handler)=>{
                this.hooks.hook($1e4516afffd1665d$export$3936435a794cb908.VISIT_COMPONENT_TREE, handler);
            },
            inspectComponent: (handler)=>{
                this.hooks.hook($1e4516afffd1665d$export$3936435a794cb908.INSPECT_COMPONENT, handler);
            },
            editComponentState: (handler)=>{
                this.hooks.hook($1e4516afffd1665d$export$3936435a794cb908.EDIT_COMPONENT_STATE, handler);
            },
            getInspectorTree: (handler)=>{
                this.hooks.hook($1e4516afffd1665d$export$3936435a794cb908.GET_INSPECTOR_TREE, handler);
            },
            getInspectorState: (handler)=>{
                this.hooks.hook($1e4516afffd1665d$export$3936435a794cb908.GET_INSPECTOR_STATE, handler);
            },
            editInspectorState: (handler)=>{
                this.hooks.hook($1e4516afffd1665d$export$3936435a794cb908.EDIT_INSPECTOR_STATE, handler);
            },
            inspectTimelineEvent: (handler)=>{
                this.hooks.hook($1e4516afffd1665d$export$3936435a794cb908.INSPECT_TIMELINE_EVENT, handler);
            },
            timelineCleared: (handler)=>{
                this.hooks.hook($1e4516afffd1665d$export$3936435a794cb908.TIMELINE_CLEARED, handler);
            },
            setPluginSettings: (handler)=>{
                this.hooks.hook($1e4516afffd1665d$export$3936435a794cb908.SET_PLUGIN_SETTINGS, handler);
            }
        };
    }
    notifyComponentUpdate(instance) {
        if ($1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $1e4516afffd1665d$export$2844c7432ba9d166().find((i)=>i.packageName === this.plugin.descriptor.packageName);
        if (inspector?.id) {
            if (instance) {
                const args = [
                    instance.appContext.app,
                    instance.uid,
                    instance.parent?.uid,
                    instance
                ];
                $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_UPDATED, ...args);
            } else $1e4516afffd1665d$var$devtoolsHooks.callHook($1e4516afffd1665d$var$DevToolsHooks.COMPONENT_UPDATED);
            this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.SEND_INSPECTOR_STATE, {
                inspectorId: inspector.id,
                plugin: this.plugin
            });
        }
    }
    addInspector(options) {
        this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.ADD_INSPECTOR, {
            inspector: options,
            plugin: this.plugin
        });
        if (this.plugin.descriptor.settings) $1e4516afffd1665d$var$initPluginSettings(options.id, this.plugin.descriptor.settings);
    }
    sendInspectorTree(inspectorId) {
        if ($1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.SEND_INSPECTOR_TREE, {
            inspectorId: inspectorId,
            plugin: this.plugin
        });
    }
    sendInspectorState(inspectorId) {
        if ($1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.SEND_INSPECTOR_STATE, {
            inspectorId: inspectorId,
            plugin: this.plugin
        });
    }
    selectInspectorNode(inspectorId, nodeId) {
        this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.CUSTOM_INSPECTOR_SELECT_NODE, {
            inspectorId: inspectorId,
            nodeId: nodeId,
            plugin: this.plugin
        });
    }
    visitComponentTree(payload) {
        return this.hooks.callHook($1e4516afffd1665d$export$3936435a794cb908.VISIT_COMPONENT_TREE, payload);
    }
    now() {
        if ($1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return 0;
        return Date.now();
    }
    addTimelineLayer(options) {
        this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.TIMELINE_LAYER_ADDED, {
            options: options,
            plugin: this.plugin
        });
    }
    addTimelineEvent(options) {
        if ($1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.TIMELINE_EVENT_ADDED, {
            options: options,
            plugin: this.plugin
        });
    }
    getSettings(pluginId) {
        return $1e4516afffd1665d$var$getPluginSettings(pluginId ?? this.plugin.descriptor.id, this.plugin.descriptor.settings);
    }
    getComponentInstances(app) {
        return this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.GET_COMPONENT_INSTANCES, {
            app: app
        });
    }
    getComponentBounds(instance) {
        return this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.GET_COMPONENT_BOUNDS, {
            instance: instance
        });
    }
    getComponentName(instance) {
        return this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.GET_COMPONENT_NAME, {
            instance: instance
        });
    }
    highlightElement(instance) {
        const uid = instance.__VUE_DEVTOOLS_NEXT_UID__;
        return this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.COMPONENT_HIGHLIGHT, {
            uid: uid
        });
    }
    unhighlightElement() {
        return this.hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.COMPONENT_UNHIGHLIGHT);
    }
};
//#endregion
//#region src/api/index.ts
const $1e4516afffd1665d$var$DevToolsPluginAPI = $1e4516afffd1665d$var$DevToolsV6PluginAPI;
//#endregion
//#region src/core/component/state/constants.ts
const $1e4516afffd1665d$var$vueBuiltins = new Set([
    "nextTick",
    "defineComponent",
    "defineAsyncComponent",
    "defineCustomElement",
    "ref",
    "computed",
    "reactive",
    "readonly",
    "watchEffect",
    "watchPostEffect",
    "watchSyncEffect",
    "watch",
    "isRef",
    "unref",
    "toRef",
    "toRefs",
    "isProxy",
    "isReactive",
    "isReadonly",
    "shallowRef",
    "triggerRef",
    "customRef",
    "shallowReactive",
    "shallowReadonly",
    "toRaw",
    "markRaw",
    "effectScope",
    "getCurrentScope",
    "onScopeDispose",
    "onMounted",
    "onUpdated",
    "onUnmounted",
    "onBeforeMount",
    "onBeforeUpdate",
    "onBeforeUnmount",
    "onErrorCaptured",
    "onRenderTracked",
    "onRenderTriggered",
    "onActivated",
    "onDeactivated",
    "onServerPrefetch",
    "provide",
    "inject",
    "h",
    "mergeProps",
    "cloneVNode",
    "isVNode",
    "resolveComponent",
    "resolveDirective",
    "withDirectives",
    "withModifiers"
]);
const $1e4516afffd1665d$var$symbolRE = /^\[native Symbol Symbol\((.*)\)\]$/;
const $1e4516afffd1665d$var$rawTypeRE = /^\[object (\w+)\]$/;
const $1e4516afffd1665d$var$specialTypeRE = /^\[native (\w+) (.*?)(<>(([\s\S])*))?\]$/;
const $1e4516afffd1665d$var$fnTypeRE = /^(?:function|class) (\w+)/;
const $1e4516afffd1665d$var$MAX_STRING_SIZE = 1e4;
const $1e4516afffd1665d$var$MAX_ARRAY_SIZE = 5e3;
const $1e4516afffd1665d$export$6db089fe7b26f5b6 = "__vue_devtool_undefined__";
const $1e4516afffd1665d$export$b4bf424ed968e242 = "__vue_devtool_infinity__";
const $1e4516afffd1665d$export$95cb88e357cbada8 = "__vue_devtool_negative_infinity__";
const $1e4516afffd1665d$export$d7ae0f70ebb9e144 = "__vue_devtool_nan__";
const $1e4516afffd1665d$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "&": "&amp;"
};
//#endregion
//#region src/core/component/state/is.ts
function $1e4516afffd1665d$var$isVueInstance(value) {
    if (!$1e4516afffd1665d$var$ensurePropertyExists(value, "_")) return false;
    if (!$1e4516afffd1665d$export$53b83ca8eaab0383(value._)) return false;
    return Object.keys(value._).includes("vnode");
}
function $1e4516afffd1665d$export$53b83ca8eaab0383(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
function $1e4516afffd1665d$var$isPrimitive$1(data) {
    if (data == null) return true;
    const type = typeof data;
    return type === "string" || type === "number" || type === "boolean";
}
function $1e4516afffd1665d$var$isRef(raw) {
    return !!raw.__v_isRef;
}
function $1e4516afffd1665d$var$isComputed(raw) {
    return $1e4516afffd1665d$var$isRef(raw) && !!raw.effect;
}
function $1e4516afffd1665d$var$isReactive(raw) {
    return !!raw.__v_isReactive;
}
function $1e4516afffd1665d$var$isReadOnly(raw) {
    return !!raw.__v_isReadonly;
}
//#endregion
//#region src/core/component/state/util.ts
const $1e4516afffd1665d$var$tokenMap = {
    [$1e4516afffd1665d$export$6db089fe7b26f5b6]: "undefined",
    [$1e4516afffd1665d$export$d7ae0f70ebb9e144]: "NaN",
    [$1e4516afffd1665d$export$b4bf424ed968e242]: "Infinity",
    [$1e4516afffd1665d$export$95cb88e357cbada8]: "-Infinity"
};
const $1e4516afffd1665d$var$reversedTokenMap = Object.entries($1e4516afffd1665d$var$tokenMap).reduce((acc, [key, value])=>{
    acc[value] = key;
    return acc;
}, {});
function $1e4516afffd1665d$var$internalStateTokenToString(value) {
    if (value === null) return "null";
    return typeof value === "string" && $1e4516afffd1665d$var$tokenMap[value] || false;
}
function $1e4516afffd1665d$var$replaceTokenToString(value) {
    const replaceRegex = new RegExp(`"(${Object.keys($1e4516afffd1665d$var$tokenMap).join("|")})"`, "g");
    return value.replace(replaceRegex, (_, g1)=>$1e4516afffd1665d$var$tokenMap[g1]);
}
function $1e4516afffd1665d$var$replaceStringToToken(value) {
    const literalValue = $1e4516afffd1665d$var$reversedTokenMap[value.trim()];
    if (literalValue) return `"${literalValue}"`;
    const replaceRegex = new RegExp(`:\\s*(${Object.keys($1e4516afffd1665d$var$reversedTokenMap).join("|")})`, "g");
    return value.replace(replaceRegex, (_, g1)=>`:"${$1e4516afffd1665d$var$reversedTokenMap[g1]}"`);
}
/**
* Convert prop type constructor to string.
*/ function $1e4516afffd1665d$var$getPropType(type) {
    if (Array.isArray(type)) return type.map((t)=>$1e4516afffd1665d$var$getPropType(t)).join(" or ");
    if (type == null) return "null";
    const match = type.toString().match($1e4516afffd1665d$var$fnTypeRE);
    return typeof type === "function" ? match && match[1] || "any" : "any";
}
/**
* Sanitize data to be posted to the other side.
* Since the message posted is sent with structured clone,
* we need to filter out any types that might cause an error.
*/ function $1e4516afffd1665d$var$sanitize(data) {
    if (!$1e4516afffd1665d$var$isPrimitive$1(data) && !Array.isArray(data) && !$1e4516afffd1665d$export$53b83ca8eaab0383(data)) return Object.prototype.toString.call(data);
    else return data;
}
function $1e4516afffd1665d$var$getSetupStateType(raw) {
    try {
        return {
            ref: $1e4516afffd1665d$var$isRef(raw),
            computed: $1e4516afffd1665d$var$isComputed(raw),
            reactive: $1e4516afffd1665d$var$isReactive(raw),
            readonly: $1e4516afffd1665d$var$isReadOnly(raw)
        };
    } catch  {
        return {
            ref: false,
            computed: false,
            reactive: false,
            readonly: false
        };
    }
}
function $1e4516afffd1665d$var$toRaw(value) {
    if (value?.__v_raw) return value.__v_raw;
    return value;
}
function $1e4516afffd1665d$export$4e7f196112fea3c5(s) {
    return s.replace(/[<>"&]/g, (s)=>{
        return $1e4516afffd1665d$var$ESC[s] || s;
    });
}
//#endregion
//#region src/core/component/state/process.ts
function $1e4516afffd1665d$var$mergeOptions(to, from, instance) {
    if (typeof from === "function") from = from.options;
    if (!from) return to;
    const { mixins: mixins, extends: extendsOptions } = from;
    extendsOptions && $1e4516afffd1665d$var$mergeOptions(to, extendsOptions, instance);
    mixins && mixins.forEach((m)=>$1e4516afffd1665d$var$mergeOptions(to, m, instance));
    for (const key of [
        "computed",
        "inject"
    ])if (Object.prototype.hasOwnProperty.call(from, key)) {
        to[key] ??= {};
        Object.assign(to[key], from[key]);
    }
    return to;
}
function $1e4516afffd1665d$var$resolveMergedOptions(instance) {
    const raw = instance?.type;
    if (!raw) return {};
    const { mixins: mixins, extends: extendsOptions } = raw;
    const globalMixins = instance.appContext.mixins;
    if (!globalMixins.length && !mixins && !extendsOptions) return raw;
    const options = {};
    globalMixins.forEach((m)=>$1e4516afffd1665d$var$mergeOptions(options, m, instance));
    $1e4516afffd1665d$var$mergeOptions(options, raw, instance);
    return options;
}
/**
* Process the props of an instance.
* Make sure return a plain object because window.postMessage()
* will throw an Error if the passed object contains Functions.
*
*/ function $1e4516afffd1665d$var$processProps(instance) {
    const props = [];
    const propDefinitions = instance?.type?.props;
    for(const key in instance?.props){
        const propDefinition = propDefinitions ? propDefinitions[key] : null;
        const camelizeKey = (0, $7vMoz.camelize)(key);
        props.push({
            type: "props",
            key: camelizeKey,
            value: $1e4516afffd1665d$var$returnError(()=>instance.props[key]),
            editable: true,
            meta: propDefinition ? {
                type: propDefinition.type ? $1e4516afffd1665d$var$getPropType(propDefinition.type) : "any",
                required: !!propDefinition.required,
                ...propDefinition.default ? {
                    default: propDefinition.default.toString()
                } : {}
            } : {
                type: "invalid"
            }
        });
    }
    return props;
}
/**
* Process state, filtering out props and "clean" the result
* with a JSON dance. This removes functions which can cause
* errors during structured clone used by window.postMessage.
*
*/ function $1e4516afffd1665d$var$processState(instance) {
    const type = instance.type;
    const props = type?.props;
    const getters = type.vuex && type.vuex.getters;
    const computedDefs = type.computed;
    const data = {
        ...instance.data,
        ...instance.renderContext
    };
    return Object.keys(data).filter((key)=>!(props && key in props) && !(getters && key in getters) && !(computedDefs && key in computedDefs)).map((key)=>({
            key: key,
            type: "data",
            value: $1e4516afffd1665d$var$returnError(()=>data[key]),
            editable: true
        }));
}
function $1e4516afffd1665d$var$getStateTypeAndName(info) {
    const stateType = info.computed ? "computed" : info.ref ? "ref" : info.reactive ? "reactive" : null;
    return {
        stateType: stateType,
        stateTypeName: stateType ? `${stateType.charAt(0).toUpperCase()}${stateType.slice(1)}` : null
    };
}
function $1e4516afffd1665d$var$processSetupState(instance) {
    const raw = instance.devtoolsRawSetupState || {};
    return Object.keys(instance.setupState).filter((key)=>!$1e4516afffd1665d$var$vueBuiltins.has(key) && key.split(/(?=[A-Z])/)[0] !== "use").map((key)=>{
        const value = $1e4516afffd1665d$var$returnError(()=>$1e4516afffd1665d$var$toRaw(instance.setupState[key]));
        const accessError = value instanceof Error;
        const rawData = raw[key];
        let result;
        let isOtherType = accessError || typeof value === "function" || $1e4516afffd1665d$var$ensurePropertyExists(value, "render") && typeof value.render === "function" || $1e4516afffd1665d$var$ensurePropertyExists(value, "__asyncLoader") && typeof value.__asyncLoader === "function" || typeof value === "object" && value && ("setup" in value || "props" in value) || /^v[A-Z]/.test(key);
        if (rawData && !accessError) {
            const info = $1e4516afffd1665d$var$getSetupStateType(rawData);
            const { stateType: stateType, stateTypeName: stateTypeName } = $1e4516afffd1665d$var$getStateTypeAndName(info);
            const isState = info.ref || info.computed || info.reactive;
            const raw = $1e4516afffd1665d$var$ensurePropertyExists(rawData, "effect") ? rawData.effect?.raw?.toString() || rawData.effect?.fn?.toString() : null;
            if (stateType) isOtherType = false;
            result = {
                ...stateType ? {
                    stateType: stateType,
                    stateTypeName: stateTypeName
                } : {},
                ...raw ? {
                    raw: raw
                } : {},
                editable: isState && !info.readonly
            };
        }
        return {
            key: key,
            value: value,
            type: isOtherType ? "setup (other)" : "setup",
            ...result
        };
    });
}
/**
* Process the computed properties of an instance.
*/ function $1e4516afffd1665d$var$processComputed(instance, mergedType) {
    const type = mergedType;
    const computed = [];
    const defs = type.computed || {};
    for(const key in defs){
        const def = defs[key];
        const type = typeof def === "function" && def.vuex ? "vuex bindings" : "computed";
        computed.push({
            type: type,
            key: key,
            value: $1e4516afffd1665d$var$returnError(()=>instance?.proxy?.[key]),
            editable: typeof def.set === "function"
        });
    }
    return computed;
}
function $1e4516afffd1665d$var$processAttrs(instance) {
    return Object.keys(instance.attrs).map((key)=>({
            type: "attrs",
            key: key,
            value: $1e4516afffd1665d$var$returnError(()=>instance.attrs[key])
        }));
}
function $1e4516afffd1665d$var$processProvide(instance) {
    return Reflect.ownKeys(instance.provides).map((key)=>({
            type: "provided",
            key: key.toString(),
            value: $1e4516afffd1665d$var$returnError(()=>instance.provides[key])
        }));
}
const $1e4516afffd1665d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $1e4516afffd1665d$var$hasOwn = (val, key)=>$1e4516afffd1665d$var$hasOwnProperty.call(val, key);
function $1e4516afffd1665d$var$processInject(instance, mergedType) {
    if (!mergedType?.inject) return [];
    let keys;
    if (Array.isArray(mergedType.inject)) keys = mergedType.inject.map((key)=>({
            key: key,
            originalKey: key
        }));
    else keys = Reflect.ownKeys(mergedType.inject).map((key)=>{
        const value = mergedType.inject[key];
        let originalKey;
        if (typeof value === "string" || typeof value === "symbol") originalKey = value;
        else originalKey = value.from ?? key;
        return {
            key: key,
            originalKey: originalKey
        };
    });
    return keys.map(({ key: key, originalKey: originalKey })=>({
            type: "injected",
            key: key !== originalKey ? `${String(originalKey)} \u{279E} ${String(key)}` : String(key),
            value: $1e4516afffd1665d$var$returnError(()=>$1e4516afffd1665d$var$hasOwn(instance.ctx, key) ? instance.ctx[key] : void 0)
        }));
}
function $1e4516afffd1665d$var$processRefs(instance) {
    return Object.keys(instance.refs).map((key)=>({
            type: "template refs",
            key: key,
            value: $1e4516afffd1665d$var$returnError(()=>instance.refs[key])
        }));
}
const $1e4516afffd1665d$var$vnodeEvents = new Set([
    "vnode-before-mount",
    "vnode-mounted",
    "vnode-before-update",
    "vnode-updated",
    "vnode-before-unmount",
    "vnode-unmounted"
]);
function $1e4516afffd1665d$var$processEventListeners(instance) {
    const emitsDefinition = instance.type.emits;
    const declaredEmits = Array.isArray(emitsDefinition) ? emitsDefinition : Object.keys(emitsDefinition ?? {});
    const keys = Object.keys(instance?.vnode?.props ?? {});
    const result = [];
    for (const key of keys){
        const [prefix, ...eventNameParts] = key.split(/(?=[A-Z])/);
        if (prefix === "on") {
            const eventName = eventNameParts.join("-").toLowerCase();
            const isBuiltIn = $1e4516afffd1665d$var$vnodeEvents.has(eventName);
            const isDeclared = declaredEmits.includes(eventName) || declaredEmits.includes((0, $7vMoz.camelize)(eventName));
            const text = isBuiltIn ? "\u2705 Built-in" : isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared";
            result.push({
                type: "event listeners",
                key: eventName,
                value: {
                    _custom: {
                        displayText: text,
                        key: text,
                        value: text,
                        tooltipText: isBuiltIn ? `The event <code>${$1e4516afffd1665d$export$4e7f196112fea3c5(eventName)}</code> is part of Vue and doesn't need to be declared by the component` : !isDeclared ? `The event <code>${$1e4516afffd1665d$export$4e7f196112fea3c5(eventName)}</code> is not declared in the <code>emits</code> option. It will leak into the component's attributes (<code>$attrs</code>).` : null
                    }
                }
            });
        }
    }
    return result;
}
function $1e4516afffd1665d$var$processInstanceState(instance) {
    const mergedType = $1e4516afffd1665d$var$resolveMergedOptions(instance);
    return $1e4516afffd1665d$var$processProps(instance).concat($1e4516afffd1665d$var$processState(instance), $1e4516afffd1665d$var$processSetupState(instance), $1e4516afffd1665d$var$processComputed(instance, mergedType), $1e4516afffd1665d$var$processAttrs(instance), $1e4516afffd1665d$var$processProvide(instance), $1e4516afffd1665d$var$processInject(instance, mergedType), $1e4516afffd1665d$var$processRefs(instance), $1e4516afffd1665d$var$processEventListeners(instance));
}
//#endregion
//#region src/core/component/state/index.ts
function $1e4516afffd1665d$var$getInstanceState(params) {
    const instance = $1e4516afffd1665d$var$getComponentInstance($1e4516afffd1665d$export$162128841a7f2877.value, params.instanceId);
    return {
        id: $1e4516afffd1665d$var$getUniqueComponentId(instance),
        name: $1e4516afffd1665d$var$getInstanceName(instance),
        file: instance?.type?.__file,
        state: $1e4516afffd1665d$var$processInstanceState(instance),
        instance: instance
    };
}
//#endregion
//#region src/core/component/tree/filter.ts
var $1e4516afffd1665d$var$ComponentFilter = class {
    constructor(filter){
        this.filter = filter || "";
    }
    /**
	* Check if an instance is qualified.
	*
	* @param {Vue|Vnode} instance
	* @return {boolean}
	*/ isQualified(instance) {
        const name = $1e4516afffd1665d$var$getInstanceName(instance);
        return (0, $7vMoz.classify)(name).toLowerCase().includes(this.filter) || (0, $7vMoz.kebabize)(name).toLowerCase().includes(this.filter);
    }
};
function $1e4516afffd1665d$var$createComponentFilter(filterText) {
    return new $1e4516afffd1665d$var$ComponentFilter(filterText);
}
//#endregion
//#region src/core/component/tree/walker.ts
var $1e4516afffd1665d$var$ComponentWalker = class {
    constructor(options){
        this.captureIds = /* @__PURE__ */ new Map();
        const { filterText: filterText = "", maxDepth: maxDepth, recursively: recursively, api: api } = options;
        this.componentFilter = $1e4516afffd1665d$var$createComponentFilter(filterText);
        this.maxDepth = maxDepth;
        this.recursively = recursively;
        this.api = api;
    }
    getComponentTree(instance) {
        this.captureIds = /* @__PURE__ */ new Map();
        return this.findQualifiedChildren(instance, 0);
    }
    getComponentParents(instance) {
        this.captureIds = /* @__PURE__ */ new Map();
        const parents = [];
        this.captureId(instance);
        let parent = instance;
        while(parent = parent.parent){
            this.captureId(parent);
            parents.push(parent);
        }
        return parents;
    }
    captureId(instance) {
        if (!instance) return null;
        const id = instance.__VUE_DEVTOOLS_NEXT_UID__ != null ? instance.__VUE_DEVTOOLS_NEXT_UID__ : $1e4516afffd1665d$var$getUniqueComponentId(instance);
        instance.__VUE_DEVTOOLS_NEXT_UID__ = id;
        if (this.captureIds.has(id)) return null;
        else this.captureIds.set(id, void 0);
        this.mark(instance);
        return id;
    }
    /**
	* Capture the meta information of an instance. (recursive)
	*
	* @param {Vue} instance
	* @return {object}
	*/ async capture(instance, depth) {
        if (!instance) return null;
        const id = this.captureId(instance);
        const name = $1e4516afffd1665d$var$getInstanceName(instance);
        const children = this.getInternalInstanceChildren(instance.subTree).filter((child)=>!$1e4516afffd1665d$var$isBeingDestroyed(child));
        const parents = this.getComponentParents(instance) || [];
        const inactive = !!instance.isDeactivated || parents.some((parent)=>parent.isDeactivated);
        const treeNode = {
            uid: instance.uid,
            id: id,
            name: name,
            renderKey: $1e4516afffd1665d$var$getRenderKey(instance.vnode ? instance.vnode.key : null),
            inactive: inactive,
            children: [],
            hasChildren: !!children.length,
            isFragment: $1e4516afffd1665d$var$isFragment(instance),
            tags: typeof instance.type !== "function" ? [] : [
                {
                    label: "functional",
                    textColor: 5592405,
                    backgroundColor: 15658734
                }
            ],
            autoOpen: this.recursively,
            file: instance.type.__file || ""
        };
        if (depth < this.maxDepth || instance.type.__isKeepAlive || parents.some((parent)=>parent.type.__isKeepAlive)) treeNode.children = await Promise.all(children.map((child)=>this.capture(child, depth + 1)).filter(Boolean));
        if (this.isKeepAlive(instance)) {
            const cachedComponents = this.getKeepAliveCachedInstances(instance);
            const childrenIds = children.map((child)=>child.__VUE_DEVTOOLS_NEXT_UID__);
            for (const cachedChild of cachedComponents)if (!childrenIds.includes(cachedChild.__VUE_DEVTOOLS_NEXT_UID__)) {
                const node = await this.capture({
                    ...cachedChild,
                    isDeactivated: true
                }, depth + 1);
                if (node) treeNode.children.push(node);
            }
        }
        const firstElement = $1e4516afffd1665d$var$getRootElementsFromComponentInstance(instance)[0];
        if (firstElement?.parentElement) {
            const parentInstance = instance.parent;
            const parentRootElements = parentInstance ? $1e4516afffd1665d$var$getRootElementsFromComponentInstance(parentInstance) : [];
            let el = firstElement;
            const indexList = [];
            do {
                indexList.push(Array.from(el.parentElement.childNodes).indexOf(el));
                el = el.parentElement;
            }while (el.parentElement && parentRootElements.length && !parentRootElements.includes(el));
            treeNode.domOrder = indexList.reverse();
        } else treeNode.domOrder = [
            -1
        ];
        if (instance.suspense?.suspenseKey) {
            treeNode.tags.push({
                label: instance.suspense.suspenseKey,
                backgroundColor: 14979812,
                textColor: 16777215
            });
            this.mark(instance, true);
        }
        this.api.visitComponentTree({
            treeNode: treeNode,
            componentInstance: instance,
            app: instance.appContext.app,
            filter: this.componentFilter.filter
        });
        return treeNode;
    }
    /**
	* Find qualified children from a single instance.
	* If the instance itself is qualified, just return itself.
	* This is ok because [].concat works in both cases.
	*
	* @param {Vue|Vnode} instance
	* @return {Vue|Array}
	*/ async findQualifiedChildren(instance, depth) {
        if (this.componentFilter.isQualified(instance) && !instance.type.devtools?.hide) return [
            await this.capture(instance, depth)
        ];
        else if (instance.subTree) {
            const list = this.isKeepAlive(instance) ? this.getKeepAliveCachedInstances(instance) : this.getInternalInstanceChildren(instance.subTree);
            return this.findQualifiedChildrenFromList(list, depth);
        } else return [];
    }
    /**
	* Iterate through an array of instances and flatten it into
	* an array of qualified instances. This is a depth-first
	* traversal - e.g. if an instance is not matched, we will
	* recursively go deeper until a qualified child is found.
	*
	* @param {Array} instances
	* @return {Array}
	*/ async findQualifiedChildrenFromList(instances, depth) {
        instances = instances.filter((child)=>!$1e4516afffd1665d$var$isBeingDestroyed(child) && !child.type.devtools?.hide);
        if (!this.componentFilter.filter) return Promise.all(instances.map((child)=>this.capture(child, depth)));
        else return Array.prototype.concat.apply([], await Promise.all(instances.map((i)=>this.findQualifiedChildren(i, depth))));
    }
    /**
	* Get children from a component instance.
	*/ getInternalInstanceChildren(subTree, suspense = null) {
        const list = [];
        if (subTree) {
            if (subTree.component) !suspense ? list.push(subTree.component) : list.push({
                ...subTree.component,
                suspense: suspense
            });
            else if (subTree.suspense) {
                const suspenseKey = !subTree.suspense.isInFallback ? "suspense default" : "suspense fallback";
                list.push(...this.getInternalInstanceChildren(subTree.suspense.activeBranch, {
                    ...subTree.suspense,
                    suspenseKey: suspenseKey
                }));
            } else if (Array.isArray(subTree.children)) subTree.children.forEach((childSubTree)=>{
                if (childSubTree.component) !suspense ? list.push(childSubTree.component) : list.push({
                    ...childSubTree.component,
                    suspense: suspense
                });
                else list.push(...this.getInternalInstanceChildren(childSubTree, suspense));
            });
        }
        return list.filter((child)=>!$1e4516afffd1665d$var$isBeingDestroyed(child) && !child.type.devtools?.hide);
    }
    /**
	* Mark an instance as captured and store it in the instance map.
	*
	* @param {Vue} instance
	*/ mark(instance, force = false) {
        const instanceMap = $1e4516afffd1665d$var$getAppRecord(instance).instanceMap;
        if (force || !instanceMap.has(instance.__VUE_DEVTOOLS_NEXT_UID__)) {
            instanceMap.set(instance.__VUE_DEVTOOLS_NEXT_UID__, instance);
            $1e4516afffd1665d$export$162128841a7f2877.value.instanceMap = instanceMap;
        }
    }
    isKeepAlive(instance) {
        return instance.type.__isKeepAlive && instance.__v_cache;
    }
    getKeepAliveCachedInstances(instance) {
        return Array.from(instance.__v_cache.values()).map((vnode)=>vnode.component).filter(Boolean);
    }
};
//#endregion
//#region src/core/timeline/perf.ts
const $1e4516afffd1665d$var$markEndQueue = /* @__PURE__ */ new Map();
const $1e4516afffd1665d$var$PERFORMANCE_EVENT_LAYER_ID = "performance";
async function $1e4516afffd1665d$var$performanceMarkStart(api, app, uid, vm, type, time) {
    const appRecord = await $1e4516afffd1665d$var$getAppRecord(app);
    if (!appRecord) return;
    const componentName = $1e4516afffd1665d$var$getInstanceName(vm) || "Unknown Component";
    const groupId = $1e4516afffd1665d$export$a67dd585df937baa.perfUniqueGroupId++;
    const groupKey = `${uid}-${type}`;
    appRecord.perfGroupIds.set(groupKey, {
        groupId: groupId,
        time: time
    });
    await api.addTimelineEvent({
        layerId: $1e4516afffd1665d$var$PERFORMANCE_EVENT_LAYER_ID,
        event: {
            time: Date.now(),
            data: {
                component: componentName,
                type: type,
                measure: "start"
            },
            title: componentName,
            subtitle: type,
            groupId: groupId
        }
    });
    if ($1e4516afffd1665d$var$markEndQueue.has(groupKey)) {
        const { app: app, uid: uid, instance: instance, type: type, time: time } = $1e4516afffd1665d$var$markEndQueue.get(groupKey);
        $1e4516afffd1665d$var$markEndQueue.delete(groupKey);
        await $1e4516afffd1665d$var$performanceMarkEnd(api, app, uid, instance, type, time);
    }
}
function $1e4516afffd1665d$var$performanceMarkEnd(api, app, uid, vm, type, time) {
    const appRecord = $1e4516afffd1665d$var$getAppRecord(app);
    if (!appRecord) return;
    const componentName = $1e4516afffd1665d$var$getInstanceName(vm) || "Unknown Component";
    const groupKey = `${uid}-${type}`;
    const groupInfo = appRecord.perfGroupIds.get(groupKey);
    if (groupInfo) {
        const groupId = groupInfo.groupId;
        const duration = time - groupInfo.time;
        api.addTimelineEvent({
            layerId: $1e4516afffd1665d$var$PERFORMANCE_EVENT_LAYER_ID,
            event: {
                time: Date.now(),
                data: {
                    component: componentName,
                    type: type,
                    measure: "end",
                    duration: {
                        _custom: {
                            type: "Duration",
                            value: duration,
                            display: `${duration} ms`
                        }
                    }
                },
                title: componentName,
                subtitle: type,
                groupId: groupId
            }
        });
    } else $1e4516afffd1665d$var$markEndQueue.set(groupKey, {
        app: app,
        uid: uid,
        instance: vm,
        type: type,
        time: time
    });
}
//#endregion
//#region src/core/timeline/index.ts
const $1e4516afffd1665d$var$COMPONENT_EVENT_LAYER_ID = "component-event";
function $1e4516afffd1665d$var$setupBuiltinTimelineLayers(api) {
    if (!(0, $7vMoz.isBrowser)) return;
    api.addTimelineLayer({
        id: "mouse",
        label: "Mouse",
        color: 10768815
    });
    [
        "mousedown",
        "mouseup",
        "click",
        "dblclick"
    ].forEach((eventType)=>{
        if (!$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState.recordingState || !$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState.mouseEventEnabled) return;
        window.addEventListener(eventType, async (event)=>{
            await api.addTimelineEvent({
                layerId: "mouse",
                event: {
                    time: Date.now(),
                    data: {
                        type: eventType,
                        x: event.clientX,
                        y: event.clientY
                    },
                    title: eventType
                }
            });
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: "keyboard",
        label: "Keyboard",
        color: 8475055
    });
    [
        "keyup",
        "keydown",
        "keypress"
    ].forEach((eventType)=>{
        window.addEventListener(eventType, async (event)=>{
            if (!$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState.recordingState || !$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState.keyboardEventEnabled) return;
            await api.addTimelineEvent({
                layerId: "keyboard",
                event: {
                    time: Date.now(),
                    data: {
                        type: eventType,
                        key: event.key,
                        ctrlKey: event.ctrlKey,
                        shiftKey: event.shiftKey,
                        altKey: event.altKey,
                        metaKey: event.metaKey
                    },
                    title: event.key
                }
            });
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: $1e4516afffd1665d$var$COMPONENT_EVENT_LAYER_ID,
        label: "Component events",
        color: 5226637
    });
    $1e4516afffd1665d$var$hook.on.componentEmit(async (app, instance, event, params)=>{
        if (!$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState.recordingState || !$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState.componentEventEnabled) return;
        const appRecord = await $1e4516afffd1665d$var$getAppRecord(app);
        if (!appRecord) return;
        const componentId = `${appRecord.id}:${instance.uid}`;
        const componentName = $1e4516afffd1665d$var$getInstanceName(instance) || "Unknown Component";
        api.addTimelineEvent({
            layerId: $1e4516afffd1665d$var$COMPONENT_EVENT_LAYER_ID,
            event: {
                time: Date.now(),
                data: {
                    component: {
                        _custom: {
                            type: "component-definition",
                            display: componentName
                        }
                    },
                    event: event,
                    params: params
                },
                title: event,
                subtitle: `by ${componentName}`,
                meta: {
                    componentId: componentId
                }
            }
        });
    });
    api.addTimelineLayer({
        id: "performance",
        label: $1e4516afffd1665d$var$PERFORMANCE_EVENT_LAYER_ID,
        color: 4307050
    });
    $1e4516afffd1665d$var$hook.on.perfStart((app, uid, vm, type, time)=>{
        if (!$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState.recordingState || !$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $1e4516afffd1665d$var$performanceMarkStart(api, app, uid, vm, type, time);
    });
    $1e4516afffd1665d$var$hook.on.perfEnd((app, uid, vm, type, time)=>{
        if (!$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState.recordingState || !$1e4516afffd1665d$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $1e4516afffd1665d$var$performanceMarkEnd(api, app, uid, vm, type, time);
    });
}
//#endregion
//#region src/core/vm/index.ts
const $1e4516afffd1665d$var$MAX_$VM = 10;
const $1e4516afffd1665d$var$$vmQueue = [];
function $1e4516afffd1665d$var$exposeInstanceToWindow(componentInstance) {
    if (typeof window === "undefined") return;
    const win = window;
    if (!componentInstance) return;
    win.$vm = componentInstance;
    if ($1e4516afffd1665d$var$$vmQueue[0] !== componentInstance) {
        if ($1e4516afffd1665d$var$$vmQueue.length >= $1e4516afffd1665d$var$MAX_$VM) $1e4516afffd1665d$var$$vmQueue.pop();
        for(let i = $1e4516afffd1665d$var$$vmQueue.length; i > 0; i--)win[`$vm${i}`] = $1e4516afffd1665d$var$$vmQueue[i] = $1e4516afffd1665d$var$$vmQueue[i - 1];
        win.$vm0 = $1e4516afffd1665d$var$$vmQueue[0] = componentInstance;
    }
}
//#endregion
//#region src/core/plugin/components.ts
const $1e4516afffd1665d$var$INSPECTOR_ID = "components";
function $1e4516afffd1665d$export$7e5554ded389d004(app) {
    const descriptor = {
        id: $1e4516afffd1665d$var$INSPECTOR_ID,
        label: "Components",
        app: app
    };
    const setupFn = (api)=>{
        api.addInspector({
            id: $1e4516afffd1665d$var$INSPECTOR_ID,
            label: "Components",
            treeFilterPlaceholder: "Search components"
        });
        $1e4516afffd1665d$var$setupBuiltinTimelineLayers(api);
        api.on.getInspectorTree(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $1e4516afffd1665d$var$INSPECTOR_ID) {
                const instance = $1e4516afffd1665d$var$getComponentInstance($1e4516afffd1665d$export$162128841a7f2877.value, payload.instanceId);
                if (instance) payload.rootNodes = await new $1e4516afffd1665d$var$ComponentWalker({
                    filterText: payload.filter,
                    maxDepth: 100,
                    recursively: false,
                    api: api
                }).getComponentTree(instance);
            }
        });
        api.on.getInspectorState(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $1e4516afffd1665d$var$INSPECTOR_ID) {
                const result = $1e4516afffd1665d$var$getInstanceState({
                    instanceId: payload.nodeId
                });
                const componentInstance = result.instance;
                const _payload = {
                    componentInstance: componentInstance,
                    app: result.instance?.appContext.app,
                    instanceData: result
                };
                $1e4516afffd1665d$export$4f1904c03898171b.hooks.callHookWith((callbacks)=>{
                    callbacks.forEach((cb)=>cb(_payload));
                }, $1e4516afffd1665d$export$3936435a794cb908.INSPECT_COMPONENT);
                payload.state = result;
                $1e4516afffd1665d$var$exposeInstanceToWindow(componentInstance);
            }
        });
        api.on.editInspectorState(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $1e4516afffd1665d$var$INSPECTOR_ID) {
                $1e4516afffd1665d$var$editState(payload);
                await api.sendInspectorState("components");
            }
        });
        const debounceSendInspectorTree = (0, $aZyT4.debounce)(()=>{
            api.sendInspectorTree($1e4516afffd1665d$var$INSPECTOR_ID);
        }, 120);
        const debounceSendInspectorState = (0, $aZyT4.debounce)(()=>{
            api.sendInspectorState($1e4516afffd1665d$var$INSPECTOR_ID);
        }, 120);
        $1e4516afffd1665d$var$hook.on.componentAdded(async (app, uid, parentUid, component)=>{
            if ($1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
            if (app?._instance?.type?.devtools?.hide) return;
            if (!app || typeof uid !== "number" && !uid || !component) return;
            const id = await $1e4516afffd1665d$var$getComponentId({
                app: app,
                uid: uid,
                instance: component
            });
            const appRecord = await $1e4516afffd1665d$var$getAppRecord(app);
            if (component) {
                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                if (!appRecord?.instanceMap.has(id)) {
                    appRecord?.instanceMap.set(id, component);
                    if ($1e4516afffd1665d$export$162128841a7f2877.value.id === appRecord?.id) $1e4516afffd1665d$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                }
            }
            if (!appRecord) return;
            debounceSendInspectorTree();
        });
        $1e4516afffd1665d$var$hook.on.componentUpdated(async (app, uid, parentUid, component)=>{
            if ($1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
            if (app?._instance?.type?.devtools?.hide) return;
            if (!app || typeof uid !== "number" && !uid || !component) return;
            const id = await $1e4516afffd1665d$var$getComponentId({
                app: app,
                uid: uid,
                instance: component
            });
            const appRecord = await $1e4516afffd1665d$var$getAppRecord(app);
            if (component) {
                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                if (!appRecord?.instanceMap.has(id)) {
                    appRecord?.instanceMap.set(id, component);
                    if ($1e4516afffd1665d$export$162128841a7f2877.value.id === appRecord?.id) $1e4516afffd1665d$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                }
            }
            if (!appRecord) return;
            debounceSendInspectorTree();
            debounceSendInspectorState();
        });
        $1e4516afffd1665d$var$hook.on.componentRemoved(async (app, uid, parentUid, component)=>{
            if ($1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
            if (app?._instance?.type?.devtools?.hide) return;
            if (!app || typeof uid !== "number" && !uid || !component) return;
            const appRecord = await $1e4516afffd1665d$var$getAppRecord(app);
            if (!appRecord) return;
            const id = await $1e4516afffd1665d$var$getComponentId({
                app: app,
                uid: uid,
                instance: component
            });
            appRecord?.instanceMap.delete(id);
            if ($1e4516afffd1665d$export$162128841a7f2877.value.id === appRecord?.id) $1e4516afffd1665d$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
            debounceSendInspectorTree();
        });
    };
    return [
        descriptor,
        setupFn
    ];
}
//#endregion
//#region src/core/plugin/index.ts
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ ??= /* @__PURE__ */ new Set();
function $1e4516afffd1665d$export$1f0daed17c8e64f(pluginDescriptor, setupFn) {
    return $1e4516afffd1665d$var$hook.setupDevToolsPlugin(pluginDescriptor, setupFn);
}
function $1e4516afffd1665d$export$873c261f47a243e7(plugin, app) {
    const [pluginDescriptor, setupFn] = plugin;
    if (pluginDescriptor.app !== app) return;
    const api = new $1e4516afffd1665d$var$DevToolsPluginAPI({
        plugin: {
            setupFn: setupFn,
            descriptor: pluginDescriptor
        },
        ctx: $1e4516afffd1665d$export$4f1904c03898171b
    });
    if (pluginDescriptor.packageName === "vuex") api.on.editInspectorState((payload)=>{
        api.sendInspectorState(payload.inspectorId);
    });
    setupFn(api);
}
function $1e4516afffd1665d$export$7f52963080ec618f(app) {
    (0, $7vMoz.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.delete(app);
}
function $1e4516afffd1665d$export$c357c87447719db2(app, options) {
    if ((0, $7vMoz.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(app)) return;
    if ($1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled && !options?.inspectingComponent) return;
    (0, $7vMoz.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(app);
    $1e4516afffd1665d$export$df02dcb86618c10f.forEach((plugin)=>{
        $1e4516afffd1665d$export$873c261f47a243e7(plugin, app);
    });
}
//#endregion
//#region src/ctx/router.ts
const $1e4516afffd1665d$export$57206cad6442cbbb = "__VUE_DEVTOOLS_ROUTER__";
const $1e4516afffd1665d$export$bcb936c2c1e0b8ba = "__VUE_DEVTOOLS_ROUTER_INFO__";
(0, $7vMoz.target)[$1e4516afffd1665d$export$bcb936c2c1e0b8ba] ??= {
    currentRoute: null,
    routes: []
};
(0, $7vMoz.target)[$1e4516afffd1665d$export$57206cad6442cbbb] ??= {};
const $1e4516afffd1665d$export$10a28a01c0e59bea = new Proxy((0, $7vMoz.target)[$1e4516afffd1665d$export$bcb936c2c1e0b8ba], {
    get (target$1, property) {
        return (0, $7vMoz.target)[$1e4516afffd1665d$export$bcb936c2c1e0b8ba][property];
    }
});
const $1e4516afffd1665d$export$73b6e4968c970971 = new Proxy((0, $7vMoz.target)[$1e4516afffd1665d$export$57206cad6442cbbb], {
    get (target$2, property) {
        if (property === "value") return (0, $7vMoz.target)[$1e4516afffd1665d$export$57206cad6442cbbb];
    }
});
//#endregion
//#region src/core/router/index.ts
function $1e4516afffd1665d$var$getRoutes(router) {
    const routesMap = /* @__PURE__ */ new Map();
    return (router?.getRoutes() || []).filter((i)=>!routesMap.has(i.path) && routesMap.set(i.path, 1));
}
function $1e4516afffd1665d$var$filterRoutes(routes) {
    return routes.map((item)=>{
        let { path: path, name: name, children: children, meta: meta } = item;
        if (children?.length) children = $1e4516afffd1665d$var$filterRoutes(children);
        return {
            path: path,
            name: name,
            children: children,
            meta: meta
        };
    });
}
function $1e4516afffd1665d$var$filterCurrentRoute(route) {
    if (route) {
        const { fullPath: fullPath, hash: hash, href: href, path: path, name: name, matched: matched, params: params, query: query } = route;
        return {
            fullPath: fullPath,
            hash: hash,
            href: href,
            path: path,
            name: name,
            params: params,
            query: query,
            matched: $1e4516afffd1665d$var$filterRoutes(matched)
        };
    }
    return route;
}
function $1e4516afffd1665d$var$normalizeRouterInfo(appRecord, activeAppRecord) {
    function init() {
        const router = appRecord.app?.config.globalProperties.$router;
        const currentRoute = $1e4516afffd1665d$var$filterCurrentRoute(router?.currentRoute.value);
        const routes = $1e4516afffd1665d$var$filterRoutes($1e4516afffd1665d$var$getRoutes(router));
        const c = console.warn;
        console.warn = ()=>{};
        (0, $7vMoz.target)[$1e4516afffd1665d$export$bcb936c2c1e0b8ba] = {
            currentRoute: currentRoute ? (0, $7vMoz.deepClone)(currentRoute) : {},
            routes: (0, $7vMoz.deepClone)(routes)
        };
        (0, $7vMoz.target)[$1e4516afffd1665d$export$57206cad6442cbbb] = router;
        console.warn = c;
    }
    init();
    $1e4516afffd1665d$var$hook.on.componentUpdated((0, $aZyT4.debounce)(()=>{
        if (activeAppRecord.value?.app !== appRecord.app) return;
        init();
        if ($1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled) return;
        $1e4516afffd1665d$export$4f1904c03898171b.hooks.callHook($1e4516afffd1665d$export$12aa7e661bddec80.ROUTER_INFO_UPDATED, {
            state: (0, $7vMoz.target)[$1e4516afffd1665d$export$bcb936c2c1e0b8ba]
        });
    }, 200));
}
//#endregion
//#region src/ctx/api.ts
function $1e4516afffd1665d$export$bb51459158adb36b(hooks) {
    return {
        async getInspectorTree (payload) {
            const _payload = {
                ...payload,
                app: $1e4516afffd1665d$export$162128841a7f2877.value.app,
                rootNodes: []
            };
            await new Promise((resolve)=>{
                hooks.callHookWith(async (callbacks)=>{
                    await Promise.all(callbacks.map((cb)=>cb(_payload)));
                    resolve();
                }, $1e4516afffd1665d$export$3936435a794cb908.GET_INSPECTOR_TREE);
            });
            return _payload.rootNodes;
        },
        async getInspectorState (payload) {
            const _payload = {
                ...payload,
                app: $1e4516afffd1665d$export$162128841a7f2877.value.app,
                state: null
            };
            const ctx = {
                currentTab: `custom-inspector:${payload.inspectorId}`
            };
            await new Promise((resolve)=>{
                hooks.callHookWith(async (callbacks)=>{
                    await Promise.all(callbacks.map((cb)=>cb(_payload, ctx)));
                    resolve();
                }, $1e4516afffd1665d$export$3936435a794cb908.GET_INSPECTOR_STATE);
            });
            return _payload.state;
        },
        editInspectorState (payload) {
            const stateEditor = new $1e4516afffd1665d$var$StateEditor();
            const _payload = {
                ...payload,
                app: $1e4516afffd1665d$export$162128841a7f2877.value.app,
                set: (obj, path = payload.path, value = payload.state.value, cb)=>{
                    stateEditor.set(obj, path, value, cb || stateEditor.createDefaultSetCallback(payload.state));
                }
            };
            hooks.callHookWith((callbacks)=>{
                callbacks.forEach((cb)=>cb(_payload));
            }, $1e4516afffd1665d$export$3936435a794cb908.EDIT_INSPECTOR_STATE);
        },
        sendInspectorState (inspectorId) {
            const inspector = $1e4516afffd1665d$export$aa4140d0f5ce4bbe(inspectorId);
            hooks.callHook($1e4516afffd1665d$export$4c35c03df042a977.SEND_INSPECTOR_STATE, {
                inspectorId: inspectorId,
                plugin: {
                    descriptor: inspector.descriptor,
                    setupFn: ()=>({})
                }
            });
        },
        inspectComponentInspector () {
            return $1e4516afffd1665d$var$inspectComponentHighLighter();
        },
        cancelInspectComponentInspector () {
            return $1e4516afffd1665d$var$cancelInspectComponentHighLighter();
        },
        getComponentRenderCode (id) {
            const instance = $1e4516afffd1665d$var$getComponentInstance($1e4516afffd1665d$export$162128841a7f2877.value, id);
            if (instance) return !(typeof instance?.type === "function") ? instance.render.toString() : instance.type.toString();
        },
        scrollToComponent (id) {
            return $1e4516afffd1665d$var$scrollToComponent({
                id: id
            });
        },
        openInEditor: $1e4516afffd1665d$var$openInEditor,
        getVueInspector: $1e4516afffd1665d$var$getComponentInspector,
        toggleApp (id, options) {
            const appRecord = $1e4516afffd1665d$export$d3c0473489b1d63b.value.find((record)=>record.id === id);
            if (appRecord) {
                $1e4516afffd1665d$export$1a7804ab8d8511d1(id);
                $1e4516afffd1665d$export$1574774def61bdf9(appRecord);
                $1e4516afffd1665d$var$normalizeRouterInfo(appRecord, $1e4516afffd1665d$export$162128841a7f2877);
                $1e4516afffd1665d$export$17f8005932e80cc0();
                $1e4516afffd1665d$export$c357c87447719db2(appRecord.app, options);
            }
        },
        inspectDOM (instanceId) {
            const instance = $1e4516afffd1665d$var$getComponentInstance($1e4516afffd1665d$export$162128841a7f2877.value, instanceId);
            if (instance) {
                const [el] = $1e4516afffd1665d$var$getRootElementsFromComponentInstance(instance);
                if (el) (0, $7vMoz.target).__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = el;
            }
        },
        updatePluginSettings (pluginId, key, value) {
            $1e4516afffd1665d$var$setPluginSettings(pluginId, key, value);
        },
        getPluginSettings (pluginId) {
            return {
                options: $1e4516afffd1665d$var$getPluginSettingsOptions(pluginId),
                values: $1e4516afffd1665d$var$getPluginSettings(pluginId)
            };
        }
    };
}
//#endregion
//#region src/ctx/env.ts
(0, $7vMoz.target).__VUE_DEVTOOLS_ENV__ ??= {
    vitePluginDetected: false
};
function $1e4516afffd1665d$export$6fcf3c68ecb51939() {
    return (0, $7vMoz.target).__VUE_DEVTOOLS_ENV__;
}
function $1e4516afffd1665d$export$b209b470d7c4ea55(env) {
    (0, $7vMoz.target).__VUE_DEVTOOLS_ENV__ = {
        ...(0, $7vMoz.target).__VUE_DEVTOOLS_ENV__,
        ...env
    };
}
//#endregion
//#region src/ctx/index.ts
const $1e4516afffd1665d$var$hooks = $1e4516afffd1665d$export$73be3ac6032ad9bb();
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_CONTEXT__ ??= {
    hooks: $1e4516afffd1665d$var$hooks,
    get state () {
        return {
            ...$1e4516afffd1665d$export$a67dd585df937baa,
            activeAppRecordId: $1e4516afffd1665d$export$162128841a7f2877.id,
            activeAppRecord: $1e4516afffd1665d$export$162128841a7f2877.value,
            appRecords: $1e4516afffd1665d$export$d3c0473489b1d63b.value
        };
    },
    api: $1e4516afffd1665d$export$bb51459158adb36b($1e4516afffd1665d$var$hooks)
};
const $1e4516afffd1665d$export$4f1904c03898171b = (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_CONTEXT__;
//#endregion
//#region ../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js
var $1e4516afffd1665d$var$require_speakingurl$1 = /* @__PURE__ */ $1e4516afffd1665d$var$__commonJSMin((exports, module)=>{
    (function(root) {
        "use strict";
        /**
		* charMap
		* @type {Object}
		*/ var charMap = {
            "\xc0": "A",
            "\xc1": "A",
            "\xc2": "A",
            "\xc3": "A",
            "\xc4": "Ae",
            "\xc5": "A",
            "\xc6": "AE",
            "\xc7": "C",
            "\xc8": "E",
            "\xc9": "E",
            "\xca": "E",
            "\xcb": "E",
            "\xcc": "I",
            "\xcd": "I",
            "\xce": "I",
            "\xcf": "I",
            "\xd0": "D",
            "\xd1": "N",
            "\xd2": "O",
            "\xd3": "O",
            "\xd4": "O",
            "\xd5": "O",
            "\xd6": "Oe",
            "\u0150": "O",
            "\xd8": "O",
            "\xd9": "U",
            "\xda": "U",
            "\xdb": "U",
            "\xdc": "Ue",
            "\u0170": "U",
            "\xdd": "Y",
            "\xde": "TH",
            "\xdf": "ss",
            "\xe0": "a",
            "\xe1": "a",
            "\xe2": "a",
            "\xe3": "a",
            "\xe4": "ae",
            "\xe5": "a",
            "\xe6": "ae",
            "\xe7": "c",
            "\xe8": "e",
            "\xe9": "e",
            "\xea": "e",
            "\xeb": "e",
            "\xec": "i",
            "\xed": "i",
            "\xee": "i",
            "\xef": "i",
            "\xf0": "d",
            "\xf1": "n",
            "\xf2": "o",
            "\xf3": "o",
            "\xf4": "o",
            "\xf5": "o",
            "\xf6": "oe",
            "\u0151": "o",
            "\xf8": "o",
            "\xf9": "u",
            "\xfa": "u",
            "\xfb": "u",
            "\xfc": "ue",
            "\u0171": "u",
            "\xfd": "y",
            "\xfe": "th",
            "\xff": "y",
            "\u1E9E": "SS",
            "\u0627": "a",
            "\u0623": "a",
            "\u0625": "i",
            "\u0622": "aa",
            "\u0624": "u",
            "\u0626": "e",
            "\u0621": "a",
            "\u0628": "b",
            "\u062A": "t",
            "\u062B": "th",
            "\u062C": "j",
            "\u062D": "h",
            "\u062E": "kh",
            "\u062F": "d",
            "\u0630": "th",
            "\u0631": "r",
            "\u0632": "z",
            "\u0633": "s",
            "\u0634": "sh",
            "\u0635": "s",
            "\u0636": "dh",
            "\u0637": "t",
            "\u0638": "z",
            "\u0639": "a",
            "\u063A": "gh",
            "\u0641": "f",
            "\u0642": "q",
            "\u0643": "k",
            "\u0644": "l",
            "\u0645": "m",
            "\u0646": "n",
            "\u0647": "h",
            "\u0648": "w",
            "\u064A": "y",
            "\u0649": "a",
            "\u0629": "h",
            "\uFEFB": "la",
            "\uFEF7": "laa",
            "\uFEF9": "lai",
            "\uFEF5": "laa",
            "\u06AF": "g",
            "\u0686": "ch",
            "\u067E": "p",
            "\u0698": "zh",
            "\u06A9": "k",
            "\u06CC": "y",
            "\u064E": "a",
            "\u064B": "an",
            "\u0650": "e",
            "\u064D": "en",
            "\u064F": "u",
            "\u064C": "on",
            "\u0652": "",
            "\u0660": "0",
            "\u0661": "1",
            "\u0662": "2",
            "\u0663": "3",
            "\u0664": "4",
            "\u0665": "5",
            "\u0666": "6",
            "\u0667": "7",
            "\u0668": "8",
            "\u0669": "9",
            "\u06F0": "0",
            "\u06F1": "1",
            "\u06F2": "2",
            "\u06F3": "3",
            "\u06F4": "4",
            "\u06F5": "5",
            "\u06F6": "6",
            "\u06F7": "7",
            "\u06F8": "8",
            "\u06F9": "9",
            "\u1000": "k",
            "\u1001": "kh",
            "\u1002": "g",
            "\u1003": "ga",
            "\u1004": "ng",
            "\u1005": "s",
            "\u1006": "sa",
            "\u1007": "z",
            "\u1005\u103B": "za",
            "\u100A": "ny",
            "\u100B": "t",
            "\u100C": "ta",
            "\u100D": "d",
            "\u100E": "da",
            "\u100F": "na",
            "\u1010": "t",
            "\u1011": "ta",
            "\u1012": "d",
            "\u1013": "da",
            "\u1014": "n",
            "\u1015": "p",
            "\u1016": "pa",
            "\u1017": "b",
            "\u1018": "ba",
            "\u1019": "m",
            "\u101A": "y",
            "\u101B": "ya",
            "\u101C": "l",
            "\u101D": "w",
            "\u101E": "th",
            "\u101F": "h",
            "\u1020": "la",
            "\u1021": "a",
            "\u103C": "y",
            "\u103B": "ya",
            "\u103D": "w",
            "\u103C\u103D": "yw",
            "\u103B\u103D": "ywa",
            "\u103E": "h",
            "\u1027": "e",
            "\u104F": "-e",
            "\u1023": "i",
            "\u1024": "-i",
            "\u1009": "u",
            "\u1026": "-u",
            "\u1029": "aw",
            "\u101E\u103C\u1031\u102C": "aw",
            "\u102A": "aw",
            "\u1040": "0",
            "\u1041": "1",
            "\u1042": "2",
            "\u1043": "3",
            "\u1044": "4",
            "\u1045": "5",
            "\u1046": "6",
            "\u1047": "7",
            "\u1048": "8",
            "\u1049": "9",
            "\u1039": "",
            "\u1037": "",
            "\u1038": "",
            "\u010D": "c",
            "\u010F": "d",
            "\u011B": "e",
            "\u0148": "n",
            "\u0159": "r",
            "\u0161": "s",
            "\u0165": "t",
            "\u016F": "u",
            "\u017E": "z",
            "\u010C": "C",
            "\u010E": "D",
            "\u011A": "E",
            "\u0147": "N",
            "\u0158": "R",
            "\u0160": "S",
            "\u0164": "T",
            "\u016E": "U",
            "\u017D": "Z",
            "\u0780": "h",
            "\u0781": "sh",
            "\u0782": "n",
            "\u0783": "r",
            "\u0784": "b",
            "\u0785": "lh",
            "\u0786": "k",
            "\u0787": "a",
            "\u0788": "v",
            "\u0789": "m",
            "\u078A": "f",
            "\u078B": "dh",
            "\u078C": "th",
            "\u078D": "l",
            "\u078E": "g",
            "\u078F": "gn",
            "\u0790": "s",
            "\u0791": "d",
            "\u0792": "z",
            "\u0793": "t",
            "\u0794": "y",
            "\u0795": "p",
            "\u0796": "j",
            "\u0797": "ch",
            "\u0798": "tt",
            "\u0799": "hh",
            "\u079A": "kh",
            "\u079B": "th",
            "\u079C": "z",
            "\u079D": "sh",
            "\u079E": "s",
            "\u079F": "d",
            "\u07A0": "t",
            "\u07A1": "z",
            "\u07A2": "a",
            "\u07A3": "gh",
            "\u07A4": "q",
            "\u07A5": "w",
            "\u07A6": "a",
            "\u07A7": "aa",
            "\u07A8": "i",
            "\u07A9": "ee",
            "\u07AA": "u",
            "\u07AB": "oo",
            "\u07AC": "e",
            "\u07AD": "ey",
            "\u07AE": "o",
            "\u07AF": "oa",
            "\u07B0": "",
            "\u10D0": "a",
            "\u10D1": "b",
            "\u10D2": "g",
            "\u10D3": "d",
            "\u10D4": "e",
            "\u10D5": "v",
            "\u10D6": "z",
            "\u10D7": "t",
            "\u10D8": "i",
            "\u10D9": "k",
            "\u10DA": "l",
            "\u10DB": "m",
            "\u10DC": "n",
            "\u10DD": "o",
            "\u10DE": "p",
            "\u10DF": "zh",
            "\u10E0": "r",
            "\u10E1": "s",
            "\u10E2": "t",
            "\u10E3": "u",
            "\u10E4": "p",
            "\u10E5": "k",
            "\u10E6": "gh",
            "\u10E7": "q",
            "\u10E8": "sh",
            "\u10E9": "ch",
            "\u10EA": "ts",
            "\u10EB": "dz",
            "\u10EC": "ts",
            "\u10ED": "ch",
            "\u10EE": "kh",
            "\u10EF": "j",
            "\u10F0": "h",
            "\u03B1": "a",
            "\u03B2": "v",
            "\u03B3": "g",
            "\u03B4": "d",
            "\u03B5": "e",
            "\u03B6": "z",
            "\u03B7": "i",
            "\u03B8": "th",
            "\u03B9": "i",
            "\u03BA": "k",
            "\u03BB": "l",
            "\u03BC": "m",
            "\u03BD": "n",
            "\u03BE": "ks",
            "\u03BF": "o",
            "\u03C0": "p",
            "\u03C1": "r",
            "\u03C3": "s",
            "\u03C4": "t",
            "\u03C5": "y",
            "\u03C6": "f",
            "\u03C7": "x",
            "\u03C8": "ps",
            "\u03C9": "o",
            "\u03AC": "a",
            "\u03AD": "e",
            "\u03AF": "i",
            "\u03CC": "o",
            "\u03CD": "y",
            "\u03AE": "i",
            "\u03CE": "o",
            "\u03C2": "s",
            "\u03CA": "i",
            "\u03B0": "y",
            "\u03CB": "y",
            "\u0390": "i",
            "\u0391": "A",
            "\u0392": "B",
            "\u0393": "G",
            "\u0394": "D",
            "\u0395": "E",
            "\u0396": "Z",
            "\u0397": "I",
            "\u0398": "TH",
            "\u0399": "I",
            "\u039A": "K",
            "\u039B": "L",
            "\u039C": "M",
            "\u039D": "N",
            "\u039E": "KS",
            "\u039F": "O",
            "\u03A0": "P",
            "\u03A1": "R",
            "\u03A3": "S",
            "\u03A4": "T",
            "\u03A5": "Y",
            "\u03A6": "F",
            "\u03A7": "X",
            "\u03A8": "PS",
            "\u03A9": "O",
            "\u0386": "A",
            "\u0388": "E",
            "\u038A": "I",
            "\u038C": "O",
            "\u038E": "Y",
            "\u0389": "I",
            "\u038F": "O",
            "\u03AA": "I",
            "\u03AB": "Y",
            "\u0101": "a",
            "\u0113": "e",
            "\u0123": "g",
            "\u012B": "i",
            "\u0137": "k",
            "\u013C": "l",
            "\u0146": "n",
            "\u016B": "u",
            "\u0100": "A",
            "\u0112": "E",
            "\u0122": "G",
            "\u012A": "I",
            "\u0136": "k",
            "\u013B": "L",
            "\u0145": "N",
            "\u016A": "U",
            "\u040C": "Kj",
            "\u045C": "kj",
            "\u0409": "Lj",
            "\u0459": "lj",
            "\u040A": "Nj",
            "\u045A": "nj",
            "\u0422\u0441": "Ts",
            "\u0442\u0441": "ts",
            "\u0105": "a",
            "\u0107": "c",
            "\u0119": "e",
            "\u0142": "l",
            "\u0144": "n",
            "\u015B": "s",
            "\u017A": "z",
            "\u017C": "z",
            "\u0104": "A",
            "\u0106": "C",
            "\u0118": "E",
            "\u0141": "L",
            "\u0143": "N",
            "\u015A": "S",
            "\u0179": "Z",
            "\u017B": "Z",
            "\u0404": "Ye",
            "\u0406": "I",
            "\u0407": "Yi",
            "\u0490": "G",
            "\u0454": "ye",
            "\u0456": "i",
            "\u0457": "yi",
            "\u0491": "g",
            "\u0103": "a",
            "\u0102": "A",
            "\u0219": "s",
            "\u0218": "S",
            "\u021B": "t",
            "\u021A": "T",
            "\u0163": "t",
            "\u0162": "T",
            "\u0430": "a",
            "\u0431": "b",
            "\u0432": "v",
            "\u0433": "g",
            "\u0434": "d",
            "\u0435": "e",
            "\u0451": "yo",
            "\u0436": "zh",
            "\u0437": "z",
            "\u0438": "i",
            "\u0439": "i",
            "\u043A": "k",
            "\u043B": "l",
            "\u043C": "m",
            "\u043D": "n",
            "\u043E": "o",
            "\u043F": "p",
            "\u0440": "r",
            "\u0441": "s",
            "\u0442": "t",
            "\u0443": "u",
            "\u0444": "f",
            "\u0445": "kh",
            "\u0446": "c",
            "\u0447": "ch",
            "\u0448": "sh",
            "\u0449": "sh",
            "\u044A": "",
            "\u044B": "y",
            "\u044C": "",
            "\u044D": "e",
            "\u044E": "yu",
            "\u044F": "ya",
            "\u0410": "A",
            "\u0411": "B",
            "\u0412": "V",
            "\u0413": "G",
            "\u0414": "D",
            "\u0415": "E",
            "\u0401": "Yo",
            "\u0416": "Zh",
            "\u0417": "Z",
            "\u0418": "I",
            "\u0419": "I",
            "\u041A": "K",
            "\u041B": "L",
            "\u041C": "M",
            "\u041D": "N",
            "\u041E": "O",
            "\u041F": "P",
            "\u0420": "R",
            "\u0421": "S",
            "\u0422": "T",
            "\u0423": "U",
            "\u0424": "F",
            "\u0425": "Kh",
            "\u0426": "C",
            "\u0427": "Ch",
            "\u0428": "Sh",
            "\u0429": "Sh",
            "\u042A": "",
            "\u042B": "Y",
            "\u042C": "",
            "\u042D": "E",
            "\u042E": "Yu",
            "\u042F": "Ya",
            "\u0452": "dj",
            "\u0458": "j",
            "\u045B": "c",
            "\u045F": "dz",
            "\u0402": "Dj",
            "\u0408": "j",
            "\u040B": "C",
            "\u040F": "Dz",
            "\u013E": "l",
            "\u013A": "l",
            "\u0155": "r",
            "\u013D": "L",
            "\u0139": "L",
            "\u0154": "R",
            "\u015F": "s",
            "\u015E": "S",
            "\u0131": "i",
            "\u0130": "I",
            "\u011F": "g",
            "\u011E": "G",
            "\u1EA3": "a",
            "\u1EA2": "A",
            "\u1EB3": "a",
            "\u1EB2": "A",
            "\u1EA9": "a",
            "\u1EA8": "A",
            "\u0111": "d",
            "\u0110": "D",
            "\u1EB9": "e",
            "\u1EB8": "E",
            "\u1EBD": "e",
            "\u1EBC": "E",
            "\u1EBB": "e",
            "\u1EBA": "E",
            "\u1EBF": "e",
            "\u1EBE": "E",
            "\u1EC1": "e",
            "\u1EC0": "E",
            "\u1EC7": "e",
            "\u1EC6": "E",
            "\u1EC5": "e",
            "\u1EC4": "E",
            "\u1EC3": "e",
            "\u1EC2": "E",
            "\u1ECF": "o",
            "\u1ECD": "o",
            "\u1ECC": "o",
            "\u1ED1": "o",
            "\u1ED0": "O",
            "\u1ED3": "o",
            "\u1ED2": "O",
            "\u1ED5": "o",
            "\u1ED4": "O",
            "\u1ED9": "o",
            "\u1ED8": "O",
            "\u1ED7": "o",
            "\u1ED6": "O",
            "\u01A1": "o",
            "\u01A0": "O",
            "\u1EDB": "o",
            "\u1EDA": "O",
            "\u1EDD": "o",
            "\u1EDC": "O",
            "\u1EE3": "o",
            "\u1EE2": "O",
            "\u1EE1": "o",
            "\u1EE0": "O",
            "\u1EDE": "o",
            "\u1EDF": "o",
            "\u1ECB": "i",
            "\u1ECA": "I",
            "\u0129": "i",
            "\u0128": "I",
            "\u1EC9": "i",
            "\u1EC8": "i",
            "\u1EE7": "u",
            "\u1EE6": "U",
            "\u1EE5": "u",
            "\u1EE4": "U",
            "\u0169": "u",
            "\u0168": "U",
            "\u01B0": "u",
            "\u01AF": "U",
            "\u1EE9": "u",
            "\u1EE8": "U",
            "\u1EEB": "u",
            "\u1EEA": "U",
            "\u1EF1": "u",
            "\u1EF0": "U",
            "\u1EEF": "u",
            "\u1EEE": "U",
            "\u1EED": "u",
            "\u1EEC": "\u01B0",
            "\u1EF7": "y",
            "\u1EF6": "y",
            "\u1EF3": "y",
            "\u1EF2": "Y",
            "\u1EF5": "y",
            "\u1EF4": "Y",
            "\u1EF9": "y",
            "\u1EF8": "Y",
            "\u1EA1": "a",
            "\u1EA0": "A",
            "\u1EA5": "a",
            "\u1EA4": "A",
            "\u1EA7": "a",
            "\u1EA6": "A",
            "\u1EAD": "a",
            "\u1EAC": "A",
            "\u1EAB": "a",
            "\u1EAA": "A",
            "\u1EAF": "a",
            "\u1EAE": "A",
            "\u1EB1": "a",
            "\u1EB0": "A",
            "\u1EB7": "a",
            "\u1EB6": "A",
            "\u1EB5": "a",
            "\u1EB4": "A",
            "\u24EA": "0",
            "\u2460": "1",
            "\u2461": "2",
            "\u2462": "3",
            "\u2463": "4",
            "\u2464": "5",
            "\u2465": "6",
            "\u2466": "7",
            "\u2467": "8",
            "\u2468": "9",
            "\u2469": "10",
            "\u246A": "11",
            "\u246B": "12",
            "\u246C": "13",
            "\u246D": "14",
            "\u246E": "15",
            "\u246F": "16",
            "\u2470": "17",
            "\u2471": "18",
            "\u2472": "18",
            "\u2473": "18",
            "\u24F5": "1",
            "\u24F6": "2",
            "\u24F7": "3",
            "\u24F8": "4",
            "\u24F9": "5",
            "\u24FA": "6",
            "\u24FB": "7",
            "\u24FC": "8",
            "\u24FD": "9",
            "\u24FE": "10",
            "\u24FF": "0",
            "\u24EB": "11",
            "\u24EC": "12",
            "\u24ED": "13",
            "\u24EE": "14",
            "\u24EF": "15",
            "\u24F0": "16",
            "\u24F1": "17",
            "\u24F2": "18",
            "\u24F3": "19",
            "\u24F4": "20",
            "\u24B6": "A",
            "\u24B7": "B",
            "\u24B8": "C",
            "\u24B9": "D",
            "\u24BA": "E",
            "\u24BB": "F",
            "\u24BC": "G",
            "\u24BD": "H",
            "\u24BE": "I",
            "\u24BF": "J",
            "\u24C0": "K",
            "\u24C1": "L",
            "\u24C2": "M",
            "\u24C3": "N",
            "\u24C4": "O",
            "\u24C5": "P",
            "\u24C6": "Q",
            "\u24C7": "R",
            "\u24C8": "S",
            "\u24C9": "T",
            "\u24CA": "U",
            "\u24CB": "V",
            "\u24CC": "W",
            "\u24CD": "X",
            "\u24CE": "Y",
            "\u24CF": "Z",
            "\u24D0": "a",
            "\u24D1": "b",
            "\u24D2": "c",
            "\u24D3": "d",
            "\u24D4": "e",
            "\u24D5": "f",
            "\u24D6": "g",
            "\u24D7": "h",
            "\u24D8": "i",
            "\u24D9": "j",
            "\u24DA": "k",
            "\u24DB": "l",
            "\u24DC": "m",
            "\u24DD": "n",
            "\u24DE": "o",
            "\u24DF": "p",
            "\u24E0": "q",
            "\u24E1": "r",
            "\u24E2": "s",
            "\u24E3": "t",
            "\u24E4": "u",
            "\u24E6": "v",
            "\u24E5": "w",
            "\u24E7": "x",
            "\u24E8": "y",
            "\u24E9": "z",
            "\u201C": "\"",
            "\u201D": "\"",
            "\u2018": "'",
            "\u2019": "'",
            "\u2202": "d",
            "\u0192": "f",
            "\u2122": "(TM)",
            "\xa9": "(C)",
            "\u0153": "oe",
            "\u0152": "OE",
            "\xae": "(R)",
            "\u2020": "+",
            "\u2120": "(SM)",
            "\u2026": "...",
            "\u02DA": "o",
            "\xba": "o",
            "\xaa": "a",
            "\u2022": "*",
            "\u104A": ",",
            "\u104B": ".",
            "$": "USD",
            "\u20AC": "EUR",
            "\u20A2": "BRN",
            "\u20A3": "FRF",
            "\xa3": "GBP",
            "\u20A4": "ITL",
            "\u20A6": "NGN",
            "\u20A7": "ESP",
            "\u20A9": "KRW",
            "\u20AA": "ILS",
            "\u20AB": "VND",
            "\u20AD": "LAK",
            "\u20AE": "MNT",
            "\u20AF": "GRD",
            "\u20B1": "ARS",
            "\u20B2": "PYG",
            "\u20B3": "ARA",
            "\u20B4": "UAH",
            "\u20B5": "GHS",
            "\xa2": "cent",
            "\xa5": "CNY",
            "\u5143": "CNY",
            "\u5186": "YEN",
            "\uFDFC": "IRR",
            "\u20A0": "EWE",
            "\u0E3F": "THB",
            "\u20A8": "INR",
            "\u20B9": "INR",
            "\u20B0": "PF",
            "\u20BA": "TRY",
            "\u060B": "AFN",
            "\u20BC": "AZN",
            "\u043B\u0432": "BGN",
            "\u17DB": "KHR",
            "\u20A1": "CRC",
            "\u20B8": "KZT",
            "\u0434\u0435\u043D": "MKD",
            "z\u0142": "PLN",
            "\u20BD": "RUB",
            "\u20BE": "GEL"
        };
        /**
		* special look ahead character array
		* These characters form with consonants to become 'single'/consonant combo
		* @type [Array]
		*/ var lookAheadCharArray = [
            "\u103A",
            "\u07B0"
        ];
        /**
		* diatricMap for languages where transliteration changes entirely as more diatrics are added
		* @type {Object}
		*/ var diatricMap = {
            "\u102C": "a",
            "\u102B": "a",
            "\u1031": "e",
            "\u1032": "e",
            "\u102D": "i",
            "\u102E": "i",
            "\u102D\u102F": "o",
            "\u102F": "u",
            "\u1030": "u",
            "\u1031\u102B\u1004\u103A": "aung",
            "\u1031\u102C": "aw",
            "\u1031\u102C\u103A": "aw",
            "\u1031\u102B": "aw",
            "\u1031\u102B\u103A": "aw",
            "\u103A": "\u103A",
            "\u1000\u103A": "et",
            "\u102D\u102F\u1000\u103A": "aik",
            "\u1031\u102C\u1000\u103A": "auk",
            "\u1004\u103A": "in",
            "\u102D\u102F\u1004\u103A": "aing",
            "\u1031\u102C\u1004\u103A": "aung",
            "\u1005\u103A": "it",
            "\u100A\u103A": "i",
            "\u1010\u103A": "at",
            "\u102D\u1010\u103A": "eik",
            "\u102F\u1010\u103A": "ok",
            "\u103D\u1010\u103A": "ut",
            "\u1031\u1010\u103A": "it",
            "\u1012\u103A": "d",
            "\u102D\u102F\u1012\u103A": "ok",
            "\u102F\u1012\u103A": "ait",
            "\u1014\u103A": "an",
            "\u102C\u1014\u103A": "an",
            "\u102D\u1014\u103A": "ein",
            "\u102F\u1014\u103A": "on",
            "\u103D\u1014\u103A": "un",
            "\u1015\u103A": "at",
            "\u102D\u1015\u103A": "eik",
            "\u102F\u1015\u103A": "ok",
            "\u103D\u1015\u103A": "ut",
            "\u1014\u103A\u102F\u1015\u103A": "nub",
            "\u1019\u103A": "an",
            "\u102D\u1019\u103A": "ein",
            "\u102F\u1019\u103A": "on",
            "\u103D\u1019\u103A": "un",
            "\u101A\u103A": "e",
            "\u102D\u102F\u101C\u103A": "ol",
            "\u1009\u103A": "in",
            "\u1036": "an",
            "\u102D\u1036": "ein",
            "\u102F\u1036": "on",
            "\u07A6\u0787\u07B0": "ah",
            "\u07A6\u0781\u07B0": "ah"
        };
        /**
		* langCharMap language specific characters translations
		* @type   {Object}
		*/ var langCharMap = {
            "en": {},
            "az": {
                "\xe7": "c",
                "\u0259": "e",
                "\u011F": "g",
                "\u0131": "i",
                "\xf6": "o",
                "\u015F": "s",
                "\xfc": "u",
                "\xc7": "C",
                "\u018F": "E",
                "\u011E": "G",
                "\u0130": "I",
                "\xd6": "O",
                "\u015E": "S",
                "\xdc": "U"
            },
            "cs": {
                "\u010D": "c",
                "\u010F": "d",
                "\u011B": "e",
                "\u0148": "n",
                "\u0159": "r",
                "\u0161": "s",
                "\u0165": "t",
                "\u016F": "u",
                "\u017E": "z",
                "\u010C": "C",
                "\u010E": "D",
                "\u011A": "E",
                "\u0147": "N",
                "\u0158": "R",
                "\u0160": "S",
                "\u0164": "T",
                "\u016E": "U",
                "\u017D": "Z"
            },
            "fi": {
                "\xe4": "a",
                "\xc4": "A",
                "\xf6": "o",
                "\xd6": "O"
            },
            "hu": {
                "\xe4": "a",
                "\xc4": "A",
                "\xf6": "o",
                "\xd6": "O",
                "\xfc": "u",
                "\xdc": "U",
                "\u0171": "u",
                "\u0170": "U"
            },
            "lt": {
                "\u0105": "a",
                "\u010D": "c",
                "\u0119": "e",
                "\u0117": "e",
                "\u012F": "i",
                "\u0161": "s",
                "\u0173": "u",
                "\u016B": "u",
                "\u017E": "z",
                "\u0104": "A",
                "\u010C": "C",
                "\u0118": "E",
                "\u0116": "E",
                "\u012E": "I",
                "\u0160": "S",
                "\u0172": "U",
                "\u016A": "U"
            },
            "lv": {
                "\u0101": "a",
                "\u010D": "c",
                "\u0113": "e",
                "\u0123": "g",
                "\u012B": "i",
                "\u0137": "k",
                "\u013C": "l",
                "\u0146": "n",
                "\u0161": "s",
                "\u016B": "u",
                "\u017E": "z",
                "\u0100": "A",
                "\u010C": "C",
                "\u0112": "E",
                "\u0122": "G",
                "\u012A": "i",
                "\u0136": "k",
                "\u013B": "L",
                "\u0145": "N",
                "\u0160": "S",
                "\u016A": "u",
                "\u017D": "Z"
            },
            "pl": {
                "\u0105": "a",
                "\u0107": "c",
                "\u0119": "e",
                "\u0142": "l",
                "\u0144": "n",
                "\xf3": "o",
                "\u015B": "s",
                "\u017A": "z",
                "\u017C": "z",
                "\u0104": "A",
                "\u0106": "C",
                "\u0118": "e",
                "\u0141": "L",
                "\u0143": "N",
                "\xd3": "O",
                "\u015A": "S",
                "\u0179": "Z",
                "\u017B": "Z"
            },
            "sv": {
                "\xe4": "a",
                "\xc4": "A",
                "\xf6": "o",
                "\xd6": "O"
            },
            "sk": {
                "\xe4": "a",
                "\xc4": "A"
            },
            "sr": {
                "\u0459": "lj",
                "\u045A": "nj",
                "\u0409": "Lj",
                "\u040A": "Nj",
                "\u0111": "dj",
                "\u0110": "Dj"
            },
            "tr": {
                "\xdc": "U",
                "\xd6": "O",
                "\xfc": "u",
                "\xf6": "o"
            }
        };
        /**
		* symbolMap language specific symbol translations
		* translations must be transliterated already
		* @type   {Object}
		*/ var symbolMap = {
            "ar": {
                "\u2206": "delta",
                "\u221E": "la-nihaya",
                "\u2665": "hob",
                "&": "wa",
                "|": "aw",
                "<": "aqal-men",
                ">": "akbar-men",
                "\u2211": "majmou",
                "\xa4": "omla"
            },
            "az": {},
            "ca": {
                "\u2206": "delta",
                "\u221E": "infinit",
                "\u2665": "amor",
                "&": "i",
                "|": "o",
                "<": "menys que",
                ">": "mes que",
                "\u2211": "suma dels",
                "\xa4": "moneda"
            },
            "cs": {
                "\u2206": "delta",
                "\u221E": "nekonecno",
                "\u2665": "laska",
                "&": "a",
                "|": "nebo",
                "<": "mensi nez",
                ">": "vetsi nez",
                "\u2211": "soucet",
                "\xa4": "mena"
            },
            "de": {
                "\u2206": "delta",
                "\u221E": "unendlich",
                "\u2665": "Liebe",
                "&": "und",
                "|": "oder",
                "<": "kleiner als",
                ">": "groesser als",
                "\u2211": "Summe von",
                "\xa4": "Waehrung"
            },
            "dv": {
                "\u2206": "delta",
                "\u221E": "kolunulaa",
                "\u2665": "loabi",
                "&": "aai",
                "|": "noonee",
                "<": "ah vure kuda",
                ">": "ah vure bodu",
                "\u2211": "jumula",
                "\xa4": "faisaa"
            },
            "en": {
                "\u2206": "delta",
                "\u221E": "infinity",
                "\u2665": "love",
                "&": "and",
                "|": "or",
                "<": "less than",
                ">": "greater than",
                "\u2211": "sum",
                "\xa4": "currency"
            },
            "es": {
                "\u2206": "delta",
                "\u221E": "infinito",
                "\u2665": "amor",
                "&": "y",
                "|": "u",
                "<": "menos que",
                ">": "mas que",
                "\u2211": "suma de los",
                "\xa4": "moneda"
            },
            "fa": {
                "\u2206": "delta",
                "\u221E": "bi-nahayat",
                "\u2665": "eshgh",
                "&": "va",
                "|": "ya",
                "<": "kamtar-az",
                ">": "bishtar-az",
                "\u2211": "majmooe",
                "\xa4": "vahed"
            },
            "fi": {
                "\u2206": "delta",
                "\u221E": "aarettomyys",
                "\u2665": "rakkaus",
                "&": "ja",
                "|": "tai",
                "<": "pienempi kuin",
                ">": "suurempi kuin",
                "\u2211": "summa",
                "\xa4": "valuutta"
            },
            "fr": {
                "\u2206": "delta",
                "\u221E": "infiniment",
                "\u2665": "Amour",
                "&": "et",
                "|": "ou",
                "<": "moins que",
                ">": "superieure a",
                "\u2211": "somme des",
                "\xa4": "monnaie"
            },
            "ge": {
                "\u2206": "delta",
                "\u221E": "usasruloba",
                "\u2665": "siqvaruli",
                "&": "da",
                "|": "an",
                "<": "naklebi",
                ">": "meti",
                "\u2211": "jami",
                "\xa4": "valuta"
            },
            "gr": {},
            "hu": {
                "\u2206": "delta",
                "\u221E": "vegtelen",
                "\u2665": "szerelem",
                "&": "es",
                "|": "vagy",
                "<": "kisebb mint",
                ">": "nagyobb mint",
                "\u2211": "szumma",
                "\xa4": "penznem"
            },
            "it": {
                "\u2206": "delta",
                "\u221E": "infinito",
                "\u2665": "amore",
                "&": "e",
                "|": "o",
                "<": "minore di",
                ">": "maggiore di",
                "\u2211": "somma",
                "\xa4": "moneta"
            },
            "lt": {
                "\u2206": "delta",
                "\u221E": "begalybe",
                "\u2665": "meile",
                "&": "ir",
                "|": "ar",
                "<": "maziau nei",
                ">": "daugiau nei",
                "\u2211": "suma",
                "\xa4": "valiuta"
            },
            "lv": {
                "\u2206": "delta",
                "\u221E": "bezgaliba",
                "\u2665": "milestiba",
                "&": "un",
                "|": "vai",
                "<": "mazak neka",
                ">": "lielaks neka",
                "\u2211": "summa",
                "\xa4": "valuta"
            },
            "my": {
                "\u2206": "kwahkhyaet",
                "\u221E": "asaonasme",
                "\u2665": "akhyait",
                "&": "nhin",
                "|": "tho",
                "<": "ngethaw",
                ">": "kyithaw",
                "\u2211": "paungld",
                "\xa4": "ngwekye"
            },
            "mk": {},
            "nl": {
                "\u2206": "delta",
                "\u221E": "oneindig",
                "\u2665": "liefde",
                "&": "en",
                "|": "of",
                "<": "kleiner dan",
                ">": "groter dan",
                "\u2211": "som",
                "\xa4": "valuta"
            },
            "pl": {
                "\u2206": "delta",
                "\u221E": "nieskonczonosc",
                "\u2665": "milosc",
                "&": "i",
                "|": "lub",
                "<": "mniejsze niz",
                ">": "wieksze niz",
                "\u2211": "suma",
                "\xa4": "waluta"
            },
            "pt": {
                "\u2206": "delta",
                "\u221E": "infinito",
                "\u2665": "amor",
                "&": "e",
                "|": "ou",
                "<": "menor que",
                ">": "maior que",
                "\u2211": "soma",
                "\xa4": "moeda"
            },
            "ro": {
                "\u2206": "delta",
                "\u221E": "infinit",
                "\u2665": "dragoste",
                "&": "si",
                "|": "sau",
                "<": "mai mic ca",
                ">": "mai mare ca",
                "\u2211": "suma",
                "\xa4": "valuta"
            },
            "ru": {
                "\u2206": "delta",
                "\u221E": "beskonechno",
                "\u2665": "lubov",
                "&": "i",
                "|": "ili",
                "<": "menshe",
                ">": "bolshe",
                "\u2211": "summa",
                "\xa4": "valjuta"
            },
            "sk": {
                "\u2206": "delta",
                "\u221E": "nekonecno",
                "\u2665": "laska",
                "&": "a",
                "|": "alebo",
                "<": "menej ako",
                ">": "viac ako",
                "\u2211": "sucet",
                "\xa4": "mena"
            },
            "sr": {},
            "tr": {
                "\u2206": "delta",
                "\u221E": "sonsuzluk",
                "\u2665": "ask",
                "&": "ve",
                "|": "veya",
                "<": "kucuktur",
                ">": "buyuktur",
                "\u2211": "toplam",
                "\xa4": "para birimi"
            },
            "uk": {
                "\u2206": "delta",
                "\u221E": "bezkinechnist",
                "\u2665": "lubov",
                "&": "i",
                "|": "abo",
                "<": "menshe",
                ">": "bilshe",
                "\u2211": "suma",
                "\xa4": "valjuta"
            },
            "vn": {
                "\u2206": "delta",
                "\u221E": "vo cuc",
                "\u2665": "yeu",
                "&": "va",
                "|": "hoac",
                "<": "nho hon",
                ">": "lon hon",
                "\u2211": "tong",
                "\xa4": "tien te"
            }
        };
        var uricChars = [
            ";",
            "?",
            ":",
            "@",
            "&",
            "=",
            "+",
            "$",
            ",",
            "/"
        ].join("");
        var uricNoSlashChars = [
            ";",
            "?",
            ":",
            "@",
            "&",
            "=",
            "+",
            "$",
            ","
        ].join("");
        var markChars = [
            ".",
            "!",
            "~",
            "*",
            "'",
            "(",
            ")"
        ].join("");
        /**
		* getSlug
		* @param  {string} input input string
		* @param  {object|string} opts config object or separator string/char
		* @api    public
		* @return {string}  sluggified string
		*/ var getSlug = function getSlug(input, opts) {
            var separator = "-";
            var result = "";
            var diatricString = "";
            var convertSymbols = true;
            var customReplacements = {};
            var maintainCase;
            var titleCase;
            var truncate;
            var uricFlag;
            var uricNoSlashFlag;
            var markFlag;
            var symbol;
            var langChar;
            var lucky;
            var i;
            var ch;
            var l;
            var lastCharWasSymbol;
            var lastCharWasDiatric;
            var allowedChars = "";
            if (typeof input !== "string") return "";
            if (typeof opts === "string") separator = opts;
            symbol = symbolMap.en;
            langChar = langCharMap.en;
            if (typeof opts === "object") {
                maintainCase = opts.maintainCase || false;
                customReplacements = opts.custom && typeof opts.custom === "object" ? opts.custom : customReplacements;
                truncate = +opts.truncate > 1 && opts.truncate || false;
                uricFlag = opts.uric || false;
                uricNoSlashFlag = opts.uricNoSlash || false;
                markFlag = opts.mark || false;
                convertSymbols = opts.symbols === false || opts.lang === false ? false : true;
                separator = opts.separator || separator;
                if (uricFlag) allowedChars += uricChars;
                if (uricNoSlashFlag) allowedChars += uricNoSlashChars;
                if (markFlag) allowedChars += markChars;
                symbol = opts.lang && symbolMap[opts.lang] && convertSymbols ? symbolMap[opts.lang] : convertSymbols ? symbolMap.en : {};
                langChar = opts.lang && langCharMap[opts.lang] ? langCharMap[opts.lang] : opts.lang === false || opts.lang === true ? {} : langCharMap.en;
                if (opts.titleCase && typeof opts.titleCase.length === "number" && Array.prototype.toString.call(opts.titleCase)) {
                    opts.titleCase.forEach(function(v) {
                        customReplacements[v + ""] = v + "";
                    });
                    titleCase = true;
                } else titleCase = !!opts.titleCase;
                if (opts.custom && typeof opts.custom.length === "number" && Array.prototype.toString.call(opts.custom)) opts.custom.forEach(function(v) {
                    customReplacements[v + ""] = v + "";
                });
                Object.keys(customReplacements).forEach(function(v) {
                    var r;
                    if (v.length > 1) r = new RegExp("\\b" + escapeChars(v) + "\\b", "gi");
                    else r = new RegExp(escapeChars(v), "gi");
                    input = input.replace(r, customReplacements[v]);
                });
                for(ch in customReplacements)allowedChars += ch;
            }
            allowedChars += separator;
            allowedChars = escapeChars(allowedChars);
            input = input.replace(/(^\s+|\s+$)/g, "");
            lastCharWasSymbol = false;
            lastCharWasDiatric = false;
            for(i = 0, l = input.length; i < l; i++){
                ch = input[i];
                if (isReplacedCustomChar(ch, customReplacements)) lastCharWasSymbol = false;
                else if (langChar[ch]) {
                    ch = lastCharWasSymbol && langChar[ch].match(/[A-Za-z0-9]/) ? " " + langChar[ch] : langChar[ch];
                    lastCharWasSymbol = false;
                } else if (ch in charMap) {
                    if (i + 1 < l && lookAheadCharArray.indexOf(input[i + 1]) >= 0) {
                        diatricString += ch;
                        ch = "";
                    } else if (lastCharWasDiatric === true) {
                        ch = diatricMap[diatricString] + charMap[ch];
                        diatricString = "";
                    } else ch = lastCharWasSymbol && charMap[ch].match(/[A-Za-z0-9]/) ? " " + charMap[ch] : charMap[ch];
                    lastCharWasSymbol = false;
                    lastCharWasDiatric = false;
                } else if (ch in diatricMap) {
                    diatricString += ch;
                    ch = "";
                    if (i === l - 1) ch = diatricMap[diatricString];
                    lastCharWasDiatric = true;
                } else if (symbol[ch] && !(uricFlag && uricChars.indexOf(ch) !== -1) && !(uricNoSlashFlag && uricNoSlashChars.indexOf(ch) !== -1)) {
                    ch = lastCharWasSymbol || result.substr(-1).match(/[A-Za-z0-9]/) ? separator + symbol[ch] : symbol[ch];
                    ch += input[i + 1] !== void 0 && input[i + 1].match(/[A-Za-z0-9]/) ? separator : "";
                    lastCharWasSymbol = true;
                } else {
                    if (lastCharWasDiatric === true) {
                        ch = diatricMap[diatricString] + ch;
                        diatricString = "";
                        lastCharWasDiatric = false;
                    } else if (lastCharWasSymbol && (/[A-Za-z0-9]/.test(ch) || result.substr(-1).match(/A-Za-z0-9]/))) ch = " " + ch;
                    lastCharWasSymbol = false;
                }
                result += ch.replace(new RegExp("[^\\w\\s" + allowedChars + "_-]", "g"), separator);
            }
            if (titleCase) result = result.replace(/(\w)(\S*)/g, function(_, i, r) {
                var j = i.toUpperCase() + (r !== null ? r : "");
                return Object.keys(customReplacements).indexOf(j.toLowerCase()) < 0 ? j : j.toLowerCase();
            });
            result = result.replace(/\s+/g, separator).replace(new RegExp("\\" + separator + "+", "g"), separator).replace(new RegExp("(^\\" + separator + "+|\\" + separator + "+$)", "g"), "");
            if (truncate && result.length > truncate) {
                lucky = result.charAt(truncate) === separator;
                result = result.slice(0, truncate);
                if (!lucky) result = result.slice(0, result.lastIndexOf(separator));
            }
            if (!maintainCase && !titleCase) result = result.toLowerCase();
            return result;
        };
        /**
		* createSlug curried(opts)(input)
		* @param   {object|string} opts config object or input string
		* @return  {Function} function getSlugWithConfig()
		**/ var createSlug = function createSlug(opts) {
            /**
			* getSlugWithConfig
			* @param   {string} input string
			* @return  {string} slug string
			*/ return function getSlugWithConfig(input) {
                return getSlug(input, opts);
            };
        };
        /**
		* escape Chars
		* @param   {string} input string
		*/ var escapeChars = function escapeChars(input) {
            return input.replace(/[-\\^$*+?.()|[\]{}\/]/g, "\\$&");
        };
        /**
		* check if the char is an already converted char from custom list
		* @param   {char} ch character to check
		* @param   {object} customReplacements custom translation map
		*/ var isReplacedCustomChar = function(ch, customReplacements) {
            for(var c in customReplacements)if (customReplacements[c] === ch) return true;
        };
        if (typeof module !== "undefined" && module.exports) {
            module.exports = getSlug;
            module.exports.createSlug = createSlug;
        } else if (typeof define !== "undefined" && define.amd) define([], function() {
            return getSlug;
        });
        else try {
            if (root.getSlug || root.createSlug) throw "speakingurl: globals exists /(getSlug|createSlug)/";
            else {
                root.getSlug = getSlug;
                root.createSlug = createSlug;
            }
        } catch (e) {}
    })(exports);
});
//#endregion
//#region src/core/app/index.ts
var $1e4516afffd1665d$var$import_speakingurl = /* @__PURE__ */ $1e4516afffd1665d$var$__toESM(/* @__PURE__ */ $1e4516afffd1665d$var$__commonJSMin((exports, module)=>{
    module.exports = $1e4516afffd1665d$var$require_speakingurl$1();
})(), 1);
const $1e4516afffd1665d$var$appRecordInfo = (0, $7vMoz.target).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ ??= {
    id: 0,
    appIds: /* @__PURE__ */ new Set()
};
function $1e4516afffd1665d$var$getAppRecordName(app, fallbackName) {
    return app?._component?.name || `App ${fallbackName}`;
}
function $1e4516afffd1665d$var$getAppRootInstance(app) {
    if (app._instance) return app._instance;
    else if (app._container?._vnode?.component) return app._container?._vnode?.component;
}
function $1e4516afffd1665d$var$removeAppRecordId(app) {
    const id = app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    if (id != null) {
        $1e4516afffd1665d$var$appRecordInfo.appIds.delete(id);
        $1e4516afffd1665d$var$appRecordInfo.id--;
    }
}
function $1e4516afffd1665d$var$getAppRecordId(app, defaultId) {
    if (app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ != null) return app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    let id = defaultId ?? ($1e4516afffd1665d$var$appRecordInfo.id++).toString();
    if (defaultId && $1e4516afffd1665d$var$appRecordInfo.appIds.has(id)) {
        let count = 1;
        while($1e4516afffd1665d$var$appRecordInfo.appIds.has(`${defaultId}_${count}`))count++;
        id = `${defaultId}_${count}`;
    }
    $1e4516afffd1665d$var$appRecordInfo.appIds.add(id);
    app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ = id;
    return id;
}
function $1e4516afffd1665d$var$createAppRecord(app, types) {
    const rootInstance = $1e4516afffd1665d$var$getAppRootInstance(app);
    if (rootInstance) {
        $1e4516afffd1665d$var$appRecordInfo.id++;
        const name = $1e4516afffd1665d$var$getAppRecordName(app, $1e4516afffd1665d$var$appRecordInfo.id.toString());
        const id = $1e4516afffd1665d$var$getAppRecordId(app, (0, $1e4516afffd1665d$var$import_speakingurl.default)(name));
        const [el] = $1e4516afffd1665d$var$getRootElementsFromComponentInstance(rootInstance);
        const record = {
            id: id,
            name: name,
            types: types,
            instanceMap: /* @__PURE__ */ new Map(),
            perfGroupIds: /* @__PURE__ */ new Map(),
            rootInstance: rootInstance,
            iframe: (0, $7vMoz.isBrowser) && document !== el?.ownerDocument ? el?.ownerDocument?.location?.pathname : void 0
        };
        app.__VUE_DEVTOOLS_NEXT_APP_RECORD__ = record;
        const rootId = `${record.id}:root`;
        record.instanceMap.set(rootId, record.rootInstance);
        record.rootInstance.__VUE_DEVTOOLS_NEXT_UID__ = rootId;
        return record;
    } else return {};
}
//#endregion
//#region src/core/iframe/index.ts
function $1e4516afffd1665d$var$detectIframeApp(target, inIframe = false) {
    if (inIframe) {
        function sendEventToParent(cb) {
            try {
                const hook = window.parent.__VUE_DEVTOOLS_GLOBAL_HOOK__;
                if (hook) cb(hook);
            } catch (e) {}
        }
        const hook = {
            id: "vue-devtools-next",
            devtoolsVersion: "7.0",
            on: (event, cb)=>{
                sendEventToParent((hook)=>{
                    hook.on(event, cb);
                });
            },
            once: (event, cb)=>{
                sendEventToParent((hook)=>{
                    hook.once(event, cb);
                });
            },
            off: (event, cb)=>{
                sendEventToParent((hook)=>{
                    hook.off(event, cb);
                });
            },
            emit: (event, ...payload)=>{
                sendEventToParent((hook)=>{
                    hook.emit(event, ...payload);
                });
            }
        };
        Object.defineProperty(target, "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
            get () {
                return hook;
            },
            configurable: true
        });
    }
    function injectVueHookToIframe(iframe) {
        if (iframe.__vdevtools__injected) return;
        try {
            iframe.__vdevtools__injected = true;
            const inject = ()=>{
                try {
                    iframe.contentWindow.__VUE_DEVTOOLS_IFRAME__ = iframe;
                    const script = iframe.contentDocument.createElement("script");
                    script.textContent = `;(${$1e4516afffd1665d$var$detectIframeApp.toString()})(window, true)`;
                    iframe.contentDocument.documentElement.appendChild(script);
                    script.parentNode.removeChild(script);
                } catch (e) {}
            };
            inject();
            iframe.addEventListener("load", ()=>inject());
        } catch (e) {}
    }
    function injectVueHookToIframes() {
        if (typeof window === "undefined") return;
        const iframes = Array.from(document.querySelectorAll("iframe:not([data-vue-devtools-ignore])"));
        for (const iframe of iframes)injectVueHookToIframe(iframe);
    }
    injectVueHookToIframes();
    let iframeAppChecks = 0;
    const iframeAppCheckTimer = setInterval(()=>{
        injectVueHookToIframes();
        iframeAppChecks++;
        if (iframeAppChecks >= 5) clearInterval(iframeAppCheckTimer);
    }, 1e3);
}
//#endregion
//#region src/core/index.ts
function $1e4516afffd1665d$export$93f430585c3f6d11() {
    $1e4516afffd1665d$var$detectIframeApp((0, $7vMoz.target));
    $1e4516afffd1665d$export$ee22a7aaf6b41ce2({
        vitePluginDetected: $1e4516afffd1665d$export$6fcf3c68ecb51939().vitePluginDetected
    });
    const isDevToolsNext = (0, $7vMoz.target).__VUE_DEVTOOLS_GLOBAL_HOOK__?.id === "vue-devtools-next";
    if ((0, $7vMoz.target).__VUE_DEVTOOLS_GLOBAL_HOOK__ && isDevToolsNext) return;
    const _devtoolsHook = $1e4516afffd1665d$var$createDevToolsHook();
    if ((0, $7vMoz.target).__VUE_DEVTOOLS_HOOK_REPLAY__) try {
        (0, $7vMoz.target).__VUE_DEVTOOLS_HOOK_REPLAY__.forEach((cb)=>cb(_devtoolsHook));
        (0, $7vMoz.target).__VUE_DEVTOOLS_HOOK_REPLAY__ = [];
    } catch (e) {
        console.error("[vue-devtools] Error during hook replay", e);
    }
    _devtoolsHook.once("init", (Vue)=>{
        (0, $7vMoz.target).__VUE_DEVTOOLS_VUE2_APP_DETECTED__ = true;
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
        console.log("%cVue DevTools v7 detected in your Vue2 project. v7 only supports Vue3 and will not work.", "font-bold: 500; font-size: 14px;");
        const legacyChromeUrl = "https://chromewebstore.google.com/detail/vuejs-devtools/iaajmlceplecbljialhhkmedjlpdblhp";
        const legacyFirefoxUrl = "https://addons.mozilla.org/firefox/addon/vue-js-devtools-v6-legacy";
        console.log(`%cThe legacy version of chrome extension that supports both Vue 2 and Vue 3 has been moved to %c ${legacyChromeUrl}`, "font-size: 14px;", "text-decoration: underline; cursor: pointer;font-size: 14px;");
        console.log(`%cThe legacy version of firefox extension that supports both Vue 2 and Vue 3 has been moved to %c ${legacyFirefoxUrl}`, "font-size: 14px;", "text-decoration: underline; cursor: pointer;font-size: 14px;");
        console.log("%cPlease install and enable only the legacy version for your Vue2 app.", "font-bold: 500; font-size: 14px;");
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
    });
    $1e4516afffd1665d$var$hook.on.setupDevtoolsPlugin((pluginDescriptor, setupFn)=>{
        $1e4516afffd1665d$export$5158df7771943590(pluginDescriptor, setupFn);
        const { app: app } = $1e4516afffd1665d$export$162128841a7f2877 ?? {};
        if (pluginDescriptor.settings) $1e4516afffd1665d$var$initPluginSettings(pluginDescriptor.id, pluginDescriptor.settings);
        if (!app) return;
        $1e4516afffd1665d$export$873c261f47a243e7([
            pluginDescriptor,
            setupFn
        ], app);
    });
    $1e4516afffd1665d$var$onLegacyDevToolsPluginApiAvailable(()=>{
        $1e4516afffd1665d$export$df02dcb86618c10f.filter(([item])=>item.id !== "components").forEach(([pluginDescriptor, setupFn])=>{
            _devtoolsHook.emit($1e4516afffd1665d$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, pluginDescriptor, setupFn, {
                target: "legacy"
            });
        });
    });
    $1e4516afffd1665d$var$hook.on.vueAppInit(async (app, version, types)=>{
        const normalizedAppRecord = {
            ...$1e4516afffd1665d$var$createAppRecord(app, types),
            app: app,
            version: version
        };
        $1e4516afffd1665d$export$c1761479e1420543(normalizedAppRecord);
        if ($1e4516afffd1665d$export$d3c0473489b1d63b.value.length === 1) {
            $1e4516afffd1665d$export$1574774def61bdf9(normalizedAppRecord);
            $1e4516afffd1665d$export$1a7804ab8d8511d1(normalizedAppRecord.id);
            $1e4516afffd1665d$var$normalizeRouterInfo(normalizedAppRecord, $1e4516afffd1665d$export$162128841a7f2877);
            $1e4516afffd1665d$export$c357c87447719db2(normalizedAppRecord.app);
        }
        $1e4516afffd1665d$export$1f0daed17c8e64f(...$1e4516afffd1665d$export$7e5554ded389d004(normalizedAppRecord.app));
        $1e4516afffd1665d$export$ee22a7aaf6b41ce2({
            connected: true
        });
        _devtoolsHook.apps.push(app);
    });
    $1e4516afffd1665d$var$hook.on.vueAppUnmount(async (app)=>{
        const activeRecords = $1e4516afffd1665d$export$d3c0473489b1d63b.value.filter((appRecord)=>appRecord.app !== app);
        if (activeRecords.length === 0) $1e4516afffd1665d$export$ee22a7aaf6b41ce2({
            connected: false
        });
        $1e4516afffd1665d$export$4d20c72f1da170ba(app);
        $1e4516afffd1665d$var$removeAppRecordId(app);
        if ($1e4516afffd1665d$export$162128841a7f2877.value.app === app) {
            $1e4516afffd1665d$export$1574774def61bdf9(activeRecords[0]);
            $1e4516afffd1665d$export$4f1904c03898171b.hooks.callHook($1e4516afffd1665d$export$12aa7e661bddec80.SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT);
        }
        (0, $7vMoz.target).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.splice((0, $7vMoz.target).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.indexOf(app), 1);
        $1e4516afffd1665d$export$7f52963080ec618f(app);
    });
    $1e4516afffd1665d$var$subscribeDevToolsHook(_devtoolsHook);
    if (!(0, $7vMoz.target).__VUE_DEVTOOLS_GLOBAL_HOOK__) Object.defineProperty((0, $7vMoz.target), "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
        get () {
            return _devtoolsHook;
        },
        configurable: true
    });
    else if (!(0, $7vMoz.isNuxtApp)) Object.assign(__VUE_DEVTOOLS_GLOBAL_HOOK__, _devtoolsHook);
}
function $1e4516afffd1665d$export$cb42e76452729606(fn) {
    return new Promise((resolve)=>{
        if ($1e4516afffd1665d$export$a67dd585df937baa.connected && $1e4516afffd1665d$export$a67dd585df937baa.clientConnected) {
            fn();
            resolve();
            return;
        }
        $1e4516afffd1665d$export$4f1904c03898171b.hooks.hook($1e4516afffd1665d$export$12aa7e661bddec80.DEVTOOLS_CONNECTED_UPDATED, ({ state: state })=>{
            if (state.connected && state.clientConnected) {
                fn();
                resolve();
            }
        });
    });
}
//#endregion
//#region src/core/high-perf-mode/index.ts
function $1e4516afffd1665d$export$6f15da7a796da26a(state) {
    $1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled = state ?? !$1e4516afffd1665d$export$a67dd585df937baa.highPerfModeEnabled;
    if (!state && $1e4516afffd1665d$export$162128841a7f2877.value) $1e4516afffd1665d$export$c357c87447719db2($1e4516afffd1665d$export$162128841a7f2877.value.app);
}
//#endregion
//#region src/core/component/state/reviver.ts
function $1e4516afffd1665d$var$reviveSet(val) {
    const result = /* @__PURE__ */ new Set();
    const list = val._custom.value;
    for(let i = 0; i < list.length; i++){
        const value = list[i];
        result.add($1e4516afffd1665d$var$revive(value));
    }
    return result;
}
function $1e4516afffd1665d$var$reviveMap(val) {
    const result = /* @__PURE__ */ new Map();
    const list = val._custom.value;
    for(let i = 0; i < list.length; i++){
        const { key: key, value: value } = list[i];
        result.set(key, $1e4516afffd1665d$var$revive(value));
    }
    return result;
}
function $1e4516afffd1665d$var$revive(val) {
    if (val === "__vue_devtool_undefined__") return;
    else if (val === "__vue_devtool_infinity__") return Number.POSITIVE_INFINITY;
    else if (val === "__vue_devtool_negative_infinity__") return Number.NEGATIVE_INFINITY;
    else if (val === "__vue_devtool_nan__") return NaN;
    else if (val && val._custom) {
        const { _custom: custom } = val;
        if (custom.type === "component") return $1e4516afffd1665d$export$162128841a7f2877.value.instanceMap.get(custom.id);
        else if (custom.type === "map") return $1e4516afffd1665d$var$reviveMap(val);
        else if (custom.type === "set") return $1e4516afffd1665d$var$reviveSet(val);
        else if (custom.type === "bigint") return BigInt(custom.value);
        else return $1e4516afffd1665d$var$revive(custom.value);
    } else if ($1e4516afffd1665d$var$symbolRE.test(val)) {
        const [, string] = $1e4516afffd1665d$var$symbolRE.exec(val);
        return Symbol.for(string);
    } else if ($1e4516afffd1665d$var$specialTypeRE.test(val)) {
        const [, type, string, , details] = $1e4516afffd1665d$var$specialTypeRE.exec(val);
        const result = new (0, $7vMoz.target)[type](string);
        if (type === "Error" && details) result.stack = details;
        return result;
    } else return val;
}
function $1e4516afffd1665d$var$reviver(key, value) {
    return $1e4516afffd1665d$var$revive(value);
}
//#endregion
//#region src/core/component/state/format.ts
function $1e4516afffd1665d$export$a2acd0fde5480ad5(value, raw = true) {
    const type = typeof value;
    if (value == null || value === "__vue_devtool_undefined__" || value === "undefined") return "null";
    else if (type === "boolean" || type === "number" || value === "__vue_devtool_infinity__" || value === "__vue_devtool_negative_infinity__" || value === "__vue_devtool_nan__") return "literal";
    else if (value?._custom) {
        if (raw || value._custom.display != null || value._custom.displayText != null) return "custom";
        else return $1e4516afffd1665d$export$a2acd0fde5480ad5(value._custom.value);
    } else if (typeof value === "string") {
        const typeMatch = $1e4516afffd1665d$var$specialTypeRE.exec(value);
        if (typeMatch) {
            const [, type] = typeMatch;
            return `native ${type}`;
        } else return "string";
    } else if (Array.isArray(value) || value?._isArray) return "array";
    else if ($1e4516afffd1665d$export$53b83ca8eaab0383(value)) return "plain-object";
    else return "unknown";
}
function $1e4516afffd1665d$export$6c635c17a78ff695(value, quotes = false, options) {
    const { customClass: customClass } = options ?? {};
    let result;
    const type = $1e4516afffd1665d$export$a2acd0fde5480ad5(value, false);
    if (type !== "custom" && value?._custom) value = value._custom.value;
    if (result = $1e4516afffd1665d$var$internalStateTokenToString(value)) return result;
    else if (type === "custom") return value._custom.value?._custom && $1e4516afffd1665d$export$6c635c17a78ff695(value._custom.value, quotes, options) || value._custom.displayText || value._custom.display;
    else if (type === "array") return `Array[${value.length}]`;
    else if (type === "plain-object") return `Object${Object.keys(value).length ? "" : " (empty)"}`;
    else if (type?.includes("native")) return $1e4516afffd1665d$export$4e7f196112fea3c5($1e4516afffd1665d$var$specialTypeRE.exec(value)?.[2]);
    else if (typeof value === "string") {
        const typeMatch = value.match($1e4516afffd1665d$var$rawTypeRE);
        if (typeMatch) value = $1e4516afffd1665d$var$escapeString(typeMatch[1]);
        else if (quotes) value = `<span>"</span>${customClass?.string ? `<span class=${customClass.string}>${$1e4516afffd1665d$var$escapeString(value)}</span>` : $1e4516afffd1665d$var$escapeString(value)}<span>"</span>`;
        else value = customClass?.string ? `<span class="${customClass?.string ?? ""}">${$1e4516afffd1665d$var$escapeString(value)}</span>` : $1e4516afffd1665d$var$escapeString(value);
    }
    return value;
}
function $1e4516afffd1665d$var$escapeString(value) {
    return $1e4516afffd1665d$export$4e7f196112fea3c5(value).replace(/ /g, "&nbsp;").replace(/\n/g, "<span>\\n</span>");
}
function $1e4516afffd1665d$export$d049e3525cb8af5d(value) {
    let customType;
    const isCustom = $1e4516afffd1665d$export$a2acd0fde5480ad5(value) === "custom";
    let inherit = {};
    if (isCustom) {
        const data = value;
        const customValue = data._custom?.value;
        const currentCustomType = data._custom?.type;
        const nestedCustom = typeof customValue === "object" && customValue !== null && "_custom" in customValue ? $1e4516afffd1665d$export$d049e3525cb8af5d(customValue) : {
            inherit: void 0,
            value: void 0,
            customType: void 0
        };
        inherit = nestedCustom.inherit || data._custom?.fields || {};
        value = nestedCustom.value || customValue;
        customType = nestedCustom.customType || currentCustomType;
    }
    if (value && value._isArray) value = value.items;
    return {
        value: value,
        inherit: inherit,
        customType: customType
    };
}
function $1e4516afffd1665d$export$b0067b146e5937f7(value, customType) {
    if (customType === "bigint") return value;
    if (customType === "date") return value;
    return $1e4516afffd1665d$var$replaceTokenToString(JSON.stringify(value));
}
function $1e4516afffd1665d$export$d61dc8d725d3735e(value, customType) {
    if (customType === "bigint") return BigInt(value);
    if (customType === "date") return new Date(value);
    return JSON.parse($1e4516afffd1665d$var$replaceStringToToken(value), $1e4516afffd1665d$var$reviver);
}
//#endregion
//#region src/core/devtools-client/detected.ts
function $1e4516afffd1665d$export$2fce292577290205(params) {
    $1e4516afffd1665d$export$a67dd585df937baa.devtoolsClientDetected = {
        ...$1e4516afffd1665d$export$a67dd585df937baa.devtoolsClientDetected,
        ...params
    };
    $1e4516afffd1665d$export$6f15da7a796da26a(!Object.values($1e4516afffd1665d$export$a67dd585df937baa.devtoolsClientDetected).some(Boolean));
}
(0, $7vMoz.target).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ ??= $1e4516afffd1665d$export$2fce292577290205;
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/double-indexed-kv.js
var $1e4516afffd1665d$var$DoubleIndexedKV = class {
    constructor(){
        this.keyToValue = /* @__PURE__ */ new Map();
        this.valueToKey = /* @__PURE__ */ new Map();
    }
    set(key, value) {
        this.keyToValue.set(key, value);
        this.valueToKey.set(value, key);
    }
    getByKey(key) {
        return this.keyToValue.get(key);
    }
    getByValue(value) {
        return this.valueToKey.get(value);
    }
    clear() {
        this.keyToValue.clear();
        this.valueToKey.clear();
    }
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/registry.js
var $1e4516afffd1665d$var$Registry = class {
    constructor(generateIdentifier){
        this.generateIdentifier = generateIdentifier;
        this.kv = new $1e4516afffd1665d$var$DoubleIndexedKV();
    }
    register(value, identifier) {
        if (this.kv.getByValue(value)) return;
        if (!identifier) identifier = this.generateIdentifier(value);
        this.kv.set(identifier, value);
    }
    clear() {
        this.kv.clear();
    }
    getIdentifier(value) {
        return this.kv.getByValue(value);
    }
    getValue(identifier) {
        return this.kv.getByKey(identifier);
    }
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/class-registry.js
var $1e4516afffd1665d$var$ClassRegistry = class extends $1e4516afffd1665d$var$Registry {
    constructor(){
        super((c)=>c.name);
        this.classToAllowedProps = /* @__PURE__ */ new Map();
    }
    register(value, options) {
        if (typeof options === "object") {
            if (options.allowProps) this.classToAllowedProps.set(value, options.allowProps);
            super.register(value, options.identifier);
        } else super.register(value, options);
    }
    getAllowedProps(value) {
        return this.classToAllowedProps.get(value);
    }
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/util.js
function $1e4516afffd1665d$var$valuesOfObj(record) {
    if ("values" in Object) return Object.values(record);
    const values = [];
    for(const key in record)if (record.hasOwnProperty(key)) values.push(record[key]);
    return values;
}
function $1e4516afffd1665d$var$find(record, predicate) {
    const values = $1e4516afffd1665d$var$valuesOfObj(record);
    if ("find" in values) return values.find(predicate);
    const valuesNotNever = values;
    for(let i = 0; i < valuesNotNever.length; i++){
        const value = valuesNotNever[i];
        if (predicate(value)) return value;
    }
}
function $1e4516afffd1665d$var$forEach(record, run) {
    Object.entries(record).forEach(([key, value])=>run(value, key));
}
function $1e4516afffd1665d$var$includes(arr, value) {
    return arr.indexOf(value) !== -1;
}
function $1e4516afffd1665d$var$findArr(record, predicate) {
    for(let i = 0; i < record.length; i++){
        const value = record[i];
        if (predicate(value)) return value;
    }
}
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/custom-transformer-registry.js
var $1e4516afffd1665d$var$CustomTransformerRegistry = class {
    constructor(){
        this.transfomers = {};
    }
    register(transformer) {
        this.transfomers[transformer.name] = transformer;
    }
    findApplicable(v) {
        return $1e4516afffd1665d$var$find(this.transfomers, (transformer)=>transformer.isApplicable(v));
    }
    findByName(name) {
        return this.transfomers[name];
    }
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/is.js
const $1e4516afffd1665d$var$getType$1 = (payload)=>Object.prototype.toString.call(payload).slice(8, -1);
const $1e4516afffd1665d$var$isUndefined$1 = (payload)=>typeof payload === "undefined";
const $1e4516afffd1665d$var$isNull$1 = (payload)=>payload === null;
const $1e4516afffd1665d$var$isPlainObject$2 = (payload)=>{
    if (typeof payload !== "object" || payload === null) return false;
    if (payload === Object.prototype) return false;
    if (Object.getPrototypeOf(payload) === null) return true;
    return Object.getPrototypeOf(payload) === Object.prototype;
};
const $1e4516afffd1665d$var$isEmptyObject = (payload)=>$1e4516afffd1665d$var$isPlainObject$2(payload) && Object.keys(payload).length === 0;
const $1e4516afffd1665d$var$isArray$2 = (payload)=>Array.isArray(payload);
const $1e4516afffd1665d$var$isString = (payload)=>typeof payload === "string";
const $1e4516afffd1665d$var$isNumber = (payload)=>typeof payload === "number" && !isNaN(payload);
const $1e4516afffd1665d$var$isBoolean = (payload)=>typeof payload === "boolean";
const $1e4516afffd1665d$var$isRegExp = (payload)=>payload instanceof RegExp;
const $1e4516afffd1665d$var$isMap = (payload)=>payload instanceof Map;
const $1e4516afffd1665d$var$isSet = (payload)=>payload instanceof Set;
const $1e4516afffd1665d$var$isSymbol = (payload)=>$1e4516afffd1665d$var$getType$1(payload) === "Symbol";
const $1e4516afffd1665d$var$isDate = (payload)=>payload instanceof Date && !isNaN(payload.valueOf());
const $1e4516afffd1665d$var$isError = (payload)=>payload instanceof Error;
const $1e4516afffd1665d$var$isNaNValue = (payload)=>typeof payload === "number" && isNaN(payload);
const $1e4516afffd1665d$var$isPrimitive = (payload)=>$1e4516afffd1665d$var$isBoolean(payload) || $1e4516afffd1665d$var$isNull$1(payload) || $1e4516afffd1665d$var$isUndefined$1(payload) || $1e4516afffd1665d$var$isNumber(payload) || $1e4516afffd1665d$var$isString(payload) || $1e4516afffd1665d$var$isSymbol(payload);
const $1e4516afffd1665d$var$isBigint = (payload)=>typeof payload === "bigint";
const $1e4516afffd1665d$var$isInfinite = (payload)=>payload === Infinity || payload === -Infinity;
const $1e4516afffd1665d$var$isTypedArray = (payload)=>ArrayBuffer.isView(payload) && !(payload instanceof DataView);
const $1e4516afffd1665d$var$isURL = (payload)=>payload instanceof URL;
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/pathstringifier.js
const $1e4516afffd1665d$var$escapeKey = (key)=>key.replace(/\./g, "\\.");
const $1e4516afffd1665d$var$stringifyPath = (path)=>path.map(String).map($1e4516afffd1665d$var$escapeKey).join(".");
const $1e4516afffd1665d$var$parsePath = (string)=>{
    const result = [];
    let segment = "";
    for(let i = 0; i < string.length; i++){
        let char = string.charAt(i);
        if (char === "\\" && string.charAt(i + 1) === ".") {
            segment += ".";
            i++;
            continue;
        }
        if (char === ".") {
            result.push(segment);
            segment = "";
            continue;
        }
        segment += char;
    }
    const lastSegment = segment;
    result.push(lastSegment);
    return result;
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/transformer.js
function $1e4516afffd1665d$var$simpleTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
const $1e4516afffd1665d$var$simpleRules = [
    $1e4516afffd1665d$var$simpleTransformation($1e4516afffd1665d$var$isUndefined$1, "undefined", ()=>null, ()=>void 0),
    $1e4516afffd1665d$var$simpleTransformation($1e4516afffd1665d$var$isBigint, "bigint", (v)=>v.toString(), (v)=>{
        if (typeof BigInt !== "undefined") return BigInt(v);
        console.error("Please add a BigInt polyfill.");
        return v;
    }),
    $1e4516afffd1665d$var$simpleTransformation($1e4516afffd1665d$var$isDate, "Date", (v)=>v.toISOString(), (v)=>new Date(v)),
    $1e4516afffd1665d$var$simpleTransformation($1e4516afffd1665d$var$isError, "Error", (v, superJson)=>{
        const baseError = {
            name: v.name,
            message: v.message
        };
        superJson.allowedErrorProps.forEach((prop)=>{
            baseError[prop] = v[prop];
        });
        return baseError;
    }, (v, superJson)=>{
        const e = new Error(v.message);
        e.name = v.name;
        e.stack = v.stack;
        superJson.allowedErrorProps.forEach((prop)=>{
            e[prop] = v[prop];
        });
        return e;
    }),
    $1e4516afffd1665d$var$simpleTransformation($1e4516afffd1665d$var$isRegExp, "regexp", (v)=>"" + v, (regex)=>{
        const body = regex.slice(1, regex.lastIndexOf("/"));
        const flags = regex.slice(regex.lastIndexOf("/") + 1);
        return new RegExp(body, flags);
    }),
    $1e4516afffd1665d$var$simpleTransformation($1e4516afffd1665d$var$isSet, "set", (v)=>[
            ...v.values()
        ], (v)=>new Set(v)),
    $1e4516afffd1665d$var$simpleTransformation($1e4516afffd1665d$var$isMap, "map", (v)=>[
            ...v.entries()
        ], (v)=>new Map(v)),
    $1e4516afffd1665d$var$simpleTransformation((v)=>$1e4516afffd1665d$var$isNaNValue(v) || $1e4516afffd1665d$var$isInfinite(v), "number", (v)=>{
        if ($1e4516afffd1665d$var$isNaNValue(v)) return "NaN";
        if (v > 0) return "Infinity";
        else return "-Infinity";
    }, Number),
    $1e4516afffd1665d$var$simpleTransformation((v)=>v === 0 && 1 / v === -Infinity, "number", ()=>{
        return "-0";
    }, Number),
    $1e4516afffd1665d$var$simpleTransformation($1e4516afffd1665d$var$isURL, "URL", (v)=>v.toString(), (v)=>new URL(v))
];
function $1e4516afffd1665d$var$compositeTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
const $1e4516afffd1665d$var$symbolRule = $1e4516afffd1665d$var$compositeTransformation((s, superJson)=>{
    if ($1e4516afffd1665d$var$isSymbol(s)) return !!superJson.symbolRegistry.getIdentifier(s);
    return false;
}, (s, superJson)=>{
    return [
        "symbol",
        superJson.symbolRegistry.getIdentifier(s)
    ];
}, (v)=>v.description, (_, a, superJson)=>{
    const value = superJson.symbolRegistry.getValue(a[1]);
    if (!value) throw new Error("Trying to deserialize unknown symbol");
    return value;
});
const $1e4516afffd1665d$var$constructorToName = [
    Int8Array,
    Uint8Array,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    Uint8ClampedArray
].reduce((obj, ctor)=>{
    obj[ctor.name] = ctor;
    return obj;
}, {});
const $1e4516afffd1665d$var$typedArrayRule = $1e4516afffd1665d$var$compositeTransformation($1e4516afffd1665d$var$isTypedArray, (v)=>[
        "typed-array",
        v.constructor.name
    ], (v)=>[
        ...v
    ], (v, a)=>{
    const ctor = $1e4516afffd1665d$var$constructorToName[a[1]];
    if (!ctor) throw new Error("Trying to deserialize unknown typed array");
    return new ctor(v);
});
function $1e4516afffd1665d$var$isInstanceOfRegisteredClass(potentialClass, superJson) {
    if (potentialClass?.constructor) return !!superJson.classRegistry.getIdentifier(potentialClass.constructor);
    return false;
}
const $1e4516afffd1665d$var$classRule = $1e4516afffd1665d$var$compositeTransformation($1e4516afffd1665d$var$isInstanceOfRegisteredClass, (clazz, superJson)=>{
    return [
        "class",
        superJson.classRegistry.getIdentifier(clazz.constructor)
    ];
}, (clazz, superJson)=>{
    const allowedProps = superJson.classRegistry.getAllowedProps(clazz.constructor);
    if (!allowedProps) return {
        ...clazz
    };
    const result = {};
    allowedProps.forEach((prop)=>{
        result[prop] = clazz[prop];
    });
    return result;
}, (v, a, superJson)=>{
    const clazz = superJson.classRegistry.getValue(a[1]);
    if (!clazz) throw new Error(`Trying to deserialize unknown class '${a[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
    return Object.assign(Object.create(clazz.prototype), v);
});
const $1e4516afffd1665d$var$customRule = $1e4516afffd1665d$var$compositeTransformation((value, superJson)=>{
    return !!superJson.customTransformerRegistry.findApplicable(value);
}, (value, superJson)=>{
    return [
        "custom",
        superJson.customTransformerRegistry.findApplicable(value).name
    ];
}, (value, superJson)=>{
    return superJson.customTransformerRegistry.findApplicable(value).serialize(value);
}, (v, a, superJson)=>{
    const transformer = superJson.customTransformerRegistry.findByName(a[1]);
    if (!transformer) throw new Error("Trying to deserialize unknown custom value");
    return transformer.deserialize(v);
});
const $1e4516afffd1665d$var$compositeRules = [
    $1e4516afffd1665d$var$classRule,
    $1e4516afffd1665d$var$symbolRule,
    $1e4516afffd1665d$var$customRule,
    $1e4516afffd1665d$var$typedArrayRule
];
const $1e4516afffd1665d$var$transformValue = (value, superJson)=>{
    const applicableCompositeRule = $1e4516afffd1665d$var$findArr($1e4516afffd1665d$var$compositeRules, (rule)=>rule.isApplicable(value, superJson));
    if (applicableCompositeRule) return {
        value: applicableCompositeRule.transform(value, superJson),
        type: applicableCompositeRule.annotation(value, superJson)
    };
    const applicableSimpleRule = $1e4516afffd1665d$var$findArr($1e4516afffd1665d$var$simpleRules, (rule)=>rule.isApplicable(value, superJson));
    if (applicableSimpleRule) return {
        value: applicableSimpleRule.transform(value, superJson),
        type: applicableSimpleRule.annotation
    };
};
const $1e4516afffd1665d$var$simpleRulesByAnnotation = {};
$1e4516afffd1665d$var$simpleRules.forEach((rule)=>{
    $1e4516afffd1665d$var$simpleRulesByAnnotation[rule.annotation] = rule;
});
const $1e4516afffd1665d$var$untransformValue = (json, type, superJson)=>{
    if ($1e4516afffd1665d$var$isArray$2(type)) switch(type[0]){
        case "symbol":
            return $1e4516afffd1665d$var$symbolRule.untransform(json, type, superJson);
        case "class":
            return $1e4516afffd1665d$var$classRule.untransform(json, type, superJson);
        case "custom":
            return $1e4516afffd1665d$var$customRule.untransform(json, type, superJson);
        case "typed-array":
            return $1e4516afffd1665d$var$typedArrayRule.untransform(json, type, superJson);
        default:
            throw new Error("Unknown transformation: " + type);
    }
    else {
        const transformation = $1e4516afffd1665d$var$simpleRulesByAnnotation[type];
        if (!transformation) throw new Error("Unknown transformation: " + type);
        return transformation.untransform(json, superJson);
    }
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/accessDeep.js
const $1e4516afffd1665d$var$getNthKey = (value, n)=>{
    if (n > value.size) throw new Error("index out of bounds");
    const keys = value.keys();
    while(n > 0){
        keys.next();
        n--;
    }
    return keys.next().value;
};
function $1e4516afffd1665d$var$validatePath(path) {
    if ($1e4516afffd1665d$var$includes(path, "__proto__")) throw new Error("__proto__ is not allowed as a property");
    if ($1e4516afffd1665d$var$includes(path, "prototype")) throw new Error("prototype is not allowed as a property");
    if ($1e4516afffd1665d$var$includes(path, "constructor")) throw new Error("constructor is not allowed as a property");
}
const $1e4516afffd1665d$var$getDeep = (object, path)=>{
    $1e4516afffd1665d$var$validatePath(path);
    for(let i = 0; i < path.length; i++){
        const key = path[i];
        if ($1e4516afffd1665d$var$isSet(object)) object = $1e4516afffd1665d$var$getNthKey(object, +key);
        else if ($1e4516afffd1665d$var$isMap(object)) {
            const row = +key;
            const type = +path[++i] === 0 ? "key" : "value";
            const keyOfRow = $1e4516afffd1665d$var$getNthKey(object, row);
            switch(type){
                case "key":
                    object = keyOfRow;
                    break;
                case "value":
                    object = object.get(keyOfRow);
                    break;
            }
        } else object = object[key];
    }
    return object;
};
const $1e4516afffd1665d$var$setDeep = (object, path, mapper)=>{
    $1e4516afffd1665d$var$validatePath(path);
    if (path.length === 0) return mapper(object);
    let parent = object;
    for(let i = 0; i < path.length - 1; i++){
        const key = path[i];
        if ($1e4516afffd1665d$var$isArray$2(parent)) {
            const index = +key;
            parent = parent[index];
        } else if ($1e4516afffd1665d$var$isPlainObject$2(parent)) parent = parent[key];
        else if ($1e4516afffd1665d$var$isSet(parent)) {
            const row = +key;
            parent = $1e4516afffd1665d$var$getNthKey(parent, row);
        } else if ($1e4516afffd1665d$var$isMap(parent)) {
            if (i === path.length - 2) break;
            const row = +key;
            const type = +path[++i] === 0 ? "key" : "value";
            const keyOfRow = $1e4516afffd1665d$var$getNthKey(parent, row);
            switch(type){
                case "key":
                    parent = keyOfRow;
                    break;
                case "value":
                    parent = parent.get(keyOfRow);
                    break;
            }
        }
    }
    const lastKey = path[path.length - 1];
    if ($1e4516afffd1665d$var$isArray$2(parent)) parent[+lastKey] = mapper(parent[+lastKey]);
    else if ($1e4516afffd1665d$var$isPlainObject$2(parent)) parent[lastKey] = mapper(parent[lastKey]);
    if ($1e4516afffd1665d$var$isSet(parent)) {
        const oldValue = $1e4516afffd1665d$var$getNthKey(parent, +lastKey);
        const newValue = mapper(oldValue);
        if (oldValue !== newValue) {
            parent.delete(oldValue);
            parent.add(newValue);
        }
    }
    if ($1e4516afffd1665d$var$isMap(parent)) {
        const row = +path[path.length - 2];
        const keyToRow = $1e4516afffd1665d$var$getNthKey(parent, row);
        switch(+lastKey === 0 ? "key" : "value"){
            case "key":
                {
                    const newKey = mapper(keyToRow);
                    parent.set(newKey, parent.get(keyToRow));
                    if (newKey !== keyToRow) parent.delete(keyToRow);
                    break;
                }
            case "value":
                parent.set(keyToRow, mapper(parent.get(keyToRow)));
                break;
        }
    }
    return object;
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/plainer.js
function $1e4516afffd1665d$var$traverse(tree, walker, origin = []) {
    if (!tree) return;
    if (!$1e4516afffd1665d$var$isArray$2(tree)) {
        $1e4516afffd1665d$var$forEach(tree, (subtree, key)=>$1e4516afffd1665d$var$traverse(subtree, walker, [
                ...origin,
                ...$1e4516afffd1665d$var$parsePath(key)
            ]));
        return;
    }
    const [nodeValue, children] = tree;
    if (children) $1e4516afffd1665d$var$forEach(children, (child, key)=>{
        $1e4516afffd1665d$var$traverse(child, walker, [
            ...origin,
            ...$1e4516afffd1665d$var$parsePath(key)
        ]);
    });
    walker(nodeValue, origin);
}
function $1e4516afffd1665d$var$applyValueAnnotations(plain, annotations, superJson) {
    $1e4516afffd1665d$var$traverse(annotations, (type, path)=>{
        plain = $1e4516afffd1665d$var$setDeep(plain, path, (v)=>$1e4516afffd1665d$var$untransformValue(v, type, superJson));
    });
    return plain;
}
function $1e4516afffd1665d$var$applyReferentialEqualityAnnotations(plain, annotations) {
    function apply(identicalPaths, path) {
        const object = $1e4516afffd1665d$var$getDeep(plain, $1e4516afffd1665d$var$parsePath(path));
        identicalPaths.map($1e4516afffd1665d$var$parsePath).forEach((identicalObjectPath)=>{
            plain = $1e4516afffd1665d$var$setDeep(plain, identicalObjectPath, ()=>object);
        });
    }
    if ($1e4516afffd1665d$var$isArray$2(annotations)) {
        const [root, other] = annotations;
        root.forEach((identicalPath)=>{
            plain = $1e4516afffd1665d$var$setDeep(plain, $1e4516afffd1665d$var$parsePath(identicalPath), ()=>plain);
        });
        if (other) $1e4516afffd1665d$var$forEach(other, apply);
    } else $1e4516afffd1665d$var$forEach(annotations, apply);
    return plain;
}
const $1e4516afffd1665d$var$isDeep = (object, superJson)=>$1e4516afffd1665d$var$isPlainObject$2(object) || $1e4516afffd1665d$var$isArray$2(object) || $1e4516afffd1665d$var$isMap(object) || $1e4516afffd1665d$var$isSet(object) || $1e4516afffd1665d$var$isInstanceOfRegisteredClass(object, superJson);
function $1e4516afffd1665d$var$addIdentity(object, path, identities) {
    const existingSet = identities.get(object);
    if (existingSet) existingSet.push(path);
    else identities.set(object, [
        path
    ]);
}
function $1e4516afffd1665d$var$generateReferentialEqualityAnnotations(identitites, dedupe) {
    const result = {};
    let rootEqualityPaths = void 0;
    identitites.forEach((paths)=>{
        if (paths.length <= 1) return;
        if (!dedupe) paths = paths.map((path)=>path.map(String)).sort((a, b)=>a.length - b.length);
        const [representativePath, ...identicalPaths] = paths;
        if (representativePath.length === 0) rootEqualityPaths = identicalPaths.map($1e4516afffd1665d$var$stringifyPath);
        else result[$1e4516afffd1665d$var$stringifyPath(representativePath)] = identicalPaths.map($1e4516afffd1665d$var$stringifyPath);
    });
    if (rootEqualityPaths) {
        if ($1e4516afffd1665d$var$isEmptyObject(result)) return [
            rootEqualityPaths
        ];
        else return [
            rootEqualityPaths,
            result
        ];
    } else return $1e4516afffd1665d$var$isEmptyObject(result) ? void 0 : result;
}
const $1e4516afffd1665d$var$walker = (object, identities, superJson, dedupe, path = [], objectsInThisPath = [], seenObjects = /* @__PURE__ */ new Map())=>{
    const primitive = $1e4516afffd1665d$var$isPrimitive(object);
    if (!primitive) {
        $1e4516afffd1665d$var$addIdentity(object, path, identities);
        const seen = seenObjects.get(object);
        if (seen) return dedupe ? {
            transformedValue: null
        } : seen;
    }
    if (!$1e4516afffd1665d$var$isDeep(object, superJson)) {
        const transformed = $1e4516afffd1665d$var$transformValue(object, superJson);
        const result = transformed ? {
            transformedValue: transformed.value,
            annotations: [
                transformed.type
            ]
        } : {
            transformedValue: object
        };
        if (!primitive) seenObjects.set(object, result);
        return result;
    }
    if ($1e4516afffd1665d$var$includes(objectsInThisPath, object)) return {
        transformedValue: null
    };
    const transformationResult = $1e4516afffd1665d$var$transformValue(object, superJson);
    const transformed = transformationResult?.value ?? object;
    const transformedValue = $1e4516afffd1665d$var$isArray$2(transformed) ? [] : {};
    const innerAnnotations = {};
    $1e4516afffd1665d$var$forEach(transformed, (value, index)=>{
        if (index === "__proto__" || index === "constructor" || index === "prototype") throw new Error(`Detected property ${index}. This is a prototype pollution risk, please remove it from your object.`);
        const recursiveResult = $1e4516afffd1665d$var$walker(value, identities, superJson, dedupe, [
            ...path,
            index
        ], [
            ...objectsInThisPath,
            object
        ], seenObjects);
        transformedValue[index] = recursiveResult.transformedValue;
        if ($1e4516afffd1665d$var$isArray$2(recursiveResult.annotations)) innerAnnotations[index] = recursiveResult.annotations;
        else if ($1e4516afffd1665d$var$isPlainObject$2(recursiveResult.annotations)) $1e4516afffd1665d$var$forEach(recursiveResult.annotations, (tree, key)=>{
            innerAnnotations[$1e4516afffd1665d$var$escapeKey(index) + "." + key] = tree;
        });
    });
    const result = $1e4516afffd1665d$var$isEmptyObject(innerAnnotations) ? {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type
        ] : void 0
    } : {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type,
            innerAnnotations
        ] : innerAnnotations
    };
    if (!primitive) seenObjects.set(object, result);
    return result;
};
//#endregion
//#region ../../node_modules/.pnpm/is-what@4.1.16/node_modules/is-what/dist/index.js
function $1e4516afffd1665d$var$getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
function $1e4516afffd1665d$var$isArray$1(payload) {
    return $1e4516afffd1665d$var$getType(payload) === "Array";
}
function $1e4516afffd1665d$var$isPlainObject$1(payload) {
    if ($1e4516afffd1665d$var$getType(payload) !== "Object") return false;
    const prototype = Object.getPrototypeOf(payload);
    return !!prototype && prototype.constructor === Object && prototype === Object.prototype;
}
function $1e4516afffd1665d$var$isNull(payload) {
    return $1e4516afffd1665d$var$getType(payload) === "Null";
}
function $1e4516afffd1665d$var$isOneOf(a, b, c, d, e) {
    return (value)=>a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
}
function $1e4516afffd1665d$var$isUndefined(payload) {
    return $1e4516afffd1665d$var$getType(payload) === "Undefined";
}
$1e4516afffd1665d$var$isOneOf($1e4516afffd1665d$var$isNull, $1e4516afffd1665d$var$isUndefined);
//#endregion
//#region ../../node_modules/.pnpm/copy-anything@3.0.5/node_modules/copy-anything/dist/index.js
function $1e4516afffd1665d$var$assignProp(carry, key, newVal, originalObject, includeNonenumerable) {
    const propType = ({}).propertyIsEnumerable.call(originalObject, key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (includeNonenumerable && propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function $1e4516afffd1665d$var$copy(target, options = {}) {
    if ($1e4516afffd1665d$var$isArray$1(target)) return target.map((item)=>$1e4516afffd1665d$var$copy(item, options));
    if (!$1e4516afffd1665d$var$isPlainObject$1(target)) return target;
    const props = Object.getOwnPropertyNames(target);
    const symbols = Object.getOwnPropertySymbols(target);
    return [
        ...props,
        ...symbols
    ].reduce((carry, key)=>{
        if ($1e4516afffd1665d$var$isArray$1(options.props) && !options.props.includes(key)) return carry;
        const val = target[key];
        $1e4516afffd1665d$var$assignProp(carry, key, $1e4516afffd1665d$var$copy(val, options), target, options.nonenumerable);
        return carry;
    }, {});
}
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/index.js
var $1e4516afffd1665d$var$SuperJSON = class {
    /**
	* @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
	*/ constructor({ dedupe: dedupe = false } = {}){
        this.classRegistry = new $1e4516afffd1665d$var$ClassRegistry();
        this.symbolRegistry = new $1e4516afffd1665d$var$Registry((s)=>s.description ?? "");
        this.customTransformerRegistry = new $1e4516afffd1665d$var$CustomTransformerRegistry();
        this.allowedErrorProps = [];
        this.dedupe = dedupe;
    }
    serialize(object) {
        const identities = /* @__PURE__ */ new Map();
        const output = $1e4516afffd1665d$var$walker(object, identities, this, this.dedupe);
        const res = {
            json: output.transformedValue
        };
        if (output.annotations) res.meta = {
            ...res.meta,
            values: output.annotations
        };
        const equalityAnnotations = $1e4516afffd1665d$var$generateReferentialEqualityAnnotations(identities, this.dedupe);
        if (equalityAnnotations) res.meta = {
            ...res.meta,
            referentialEqualities: equalityAnnotations
        };
        return res;
    }
    deserialize(payload) {
        const { json: json, meta: meta } = payload;
        let result = $1e4516afffd1665d$var$copy(json);
        if (meta?.values) result = $1e4516afffd1665d$var$applyValueAnnotations(result, meta.values, this);
        if (meta?.referentialEqualities) result = $1e4516afffd1665d$var$applyReferentialEqualityAnnotations(result, meta.referentialEqualities);
        return result;
    }
    stringify(object) {
        return JSON.stringify(this.serialize(object));
    }
    parse(string) {
        return this.deserialize(JSON.parse(string));
    }
    registerClass(v, options) {
        this.classRegistry.register(v, options);
    }
    registerSymbol(v, identifier) {
        this.symbolRegistry.register(v, identifier);
    }
    registerCustom(transformer, name) {
        this.customTransformerRegistry.register({
            name: name,
            ...transformer
        });
    }
    allowErrorProps(...props) {
        this.allowedErrorProps.push(...props);
    }
};
$1e4516afffd1665d$var$SuperJSON.defaultInstance = new $1e4516afffd1665d$var$SuperJSON();
$1e4516afffd1665d$var$SuperJSON.serialize = $1e4516afffd1665d$var$SuperJSON.defaultInstance.serialize.bind($1e4516afffd1665d$var$SuperJSON.defaultInstance);
$1e4516afffd1665d$var$SuperJSON.deserialize = $1e4516afffd1665d$var$SuperJSON.defaultInstance.deserialize.bind($1e4516afffd1665d$var$SuperJSON.defaultInstance);
$1e4516afffd1665d$var$SuperJSON.stringify = $1e4516afffd1665d$var$SuperJSON.defaultInstance.stringify.bind($1e4516afffd1665d$var$SuperJSON.defaultInstance);
$1e4516afffd1665d$var$SuperJSON.parse = $1e4516afffd1665d$var$SuperJSON.defaultInstance.parse.bind($1e4516afffd1665d$var$SuperJSON.defaultInstance);
$1e4516afffd1665d$var$SuperJSON.registerClass = $1e4516afffd1665d$var$SuperJSON.defaultInstance.registerClass.bind($1e4516afffd1665d$var$SuperJSON.defaultInstance);
$1e4516afffd1665d$var$SuperJSON.registerSymbol = $1e4516afffd1665d$var$SuperJSON.defaultInstance.registerSymbol.bind($1e4516afffd1665d$var$SuperJSON.defaultInstance);
$1e4516afffd1665d$var$SuperJSON.registerCustom = $1e4516afffd1665d$var$SuperJSON.defaultInstance.registerCustom.bind($1e4516afffd1665d$var$SuperJSON.defaultInstance);
$1e4516afffd1665d$var$SuperJSON.allowErrorProps = $1e4516afffd1665d$var$SuperJSON.defaultInstance.allowErrorProps.bind($1e4516afffd1665d$var$SuperJSON.defaultInstance);
$1e4516afffd1665d$var$SuperJSON.serialize;
$1e4516afffd1665d$var$SuperJSON.deserialize;
$1e4516afffd1665d$var$SuperJSON.stringify;
$1e4516afffd1665d$var$SuperJSON.parse;
$1e4516afffd1665d$var$SuperJSON.registerClass;
$1e4516afffd1665d$var$SuperJSON.registerCustom;
$1e4516afffd1665d$var$SuperJSON.registerSymbol;
$1e4516afffd1665d$var$SuperJSON.allowErrorProps;
//#endregion
//#region src/messaging/presets/broadcast-channel/context.ts
const $1e4516afffd1665d$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY = "__devtools-kit-broadcast-messaging-event-key__";
//#endregion
//#region src/messaging/presets/broadcast-channel/index.ts
const $1e4516afffd1665d$var$BROADCAST_CHANNEL_NAME = "__devtools-kit:broadcast-channel__";
function $1e4516afffd1665d$var$createBroadcastChannel() {
    const channel = new BroadcastChannel($1e4516afffd1665d$var$BROADCAST_CHANNEL_NAME);
    return {
        post: (data)=>{
            channel.postMessage($1e4516afffd1665d$var$SuperJSON.stringify({
                event: $1e4516afffd1665d$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY,
                data: data
            }));
        },
        on: (handler)=>{
            channel.onmessage = (event)=>{
                const parsed = $1e4516afffd1665d$var$SuperJSON.parse(event.data);
                if (parsed.event === "__devtools-kit-broadcast-messaging-event-key__") handler(parsed.data);
            };
        }
    };
}
//#endregion
//#region src/messaging/presets/electron/context.ts
const $1e4516afffd1665d$var$__ELECTRON_CLIENT_CONTEXT__ = "electron:client-context";
const $1e4516afffd1665d$var$__ELECTRON_RPOXY_CONTEXT__ = "electron:proxy-context";
const $1e4516afffd1665d$var$__ELECTRON_SERVER_CONTEXT__ = "electron:server-context";
const $1e4516afffd1665d$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__ = {
    CLIENT_TO_PROXY: "client->proxy",
    PROXY_TO_CLIENT: "proxy->client",
    PROXY_TO_SERVER: "proxy->server",
    SERVER_TO_PROXY: "server->proxy"
};
function $1e4516afffd1665d$var$getElectronClientContext() {
    return (0, $7vMoz.target)[$1e4516afffd1665d$var$__ELECTRON_CLIENT_CONTEXT__];
}
function $1e4516afffd1665d$export$2837faaf25ee2c9a(context) {
    (0, $7vMoz.target)[$1e4516afffd1665d$var$__ELECTRON_CLIENT_CONTEXT__] = context;
}
function $1e4516afffd1665d$var$getElectronProxyContext() {
    return (0, $7vMoz.target)[$1e4516afffd1665d$var$__ELECTRON_RPOXY_CONTEXT__];
}
function $1e4516afffd1665d$export$f4b34d15f9836c97(context) {
    (0, $7vMoz.target)[$1e4516afffd1665d$var$__ELECTRON_RPOXY_CONTEXT__] = context;
}
function $1e4516afffd1665d$var$getElectronServerContext() {
    return (0, $7vMoz.target)[$1e4516afffd1665d$var$__ELECTRON_SERVER_CONTEXT__];
}
function $1e4516afffd1665d$export$d8c81043a9a1bbbe(context) {
    (0, $7vMoz.target)[$1e4516afffd1665d$var$__ELECTRON_SERVER_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/electron/client.ts
function $1e4516afffd1665d$var$createElectronClientChannel() {
    const socket = $1e4516afffd1665d$var$getElectronClientContext();
    return {
        post: (data)=>{
            socket.emit($1e4516afffd1665d$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, $1e4516afffd1665d$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            socket.on($1e4516afffd1665d$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, (e)=>{
                handler($1e4516afffd1665d$var$SuperJSON.parse(e));
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/electron/proxy.ts
function $1e4516afffd1665d$var$createElectronProxyChannel() {
    const socket = $1e4516afffd1665d$var$getElectronProxyContext();
    return {
        post: (data)=>{},
        on: (handler)=>{
            socket.on($1e4516afffd1665d$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, (data)=>{
                socket.broadcast.emit($1e4516afffd1665d$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, data);
            });
            socket.on($1e4516afffd1665d$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, (data)=>{
                socket.broadcast.emit($1e4516afffd1665d$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, data);
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/electron/server.ts
function $1e4516afffd1665d$var$createElectronServerChannel() {
    const socket = $1e4516afffd1665d$var$getElectronServerContext();
    return {
        post: (data)=>{
            socket.emit($1e4516afffd1665d$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, $1e4516afffd1665d$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            socket.on($1e4516afffd1665d$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, (data)=>{
                handler($1e4516afffd1665d$var$SuperJSON.parse(data));
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/extension/context.ts
const $1e4516afffd1665d$var$__EXTENSION_CLIENT_CONTEXT__ = "electron:client-context";
const $1e4516afffd1665d$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__ = {
    CLIENT_TO_PROXY: "client->proxy",
    PROXY_TO_CLIENT: "proxy->client",
    PROXY_TO_SERVER: "proxy->server",
    SERVER_TO_PROXY: "server->proxy"
};
function $1e4516afffd1665d$export$6c3de6c2be1b2806() {
    return (0, $7vMoz.target)[$1e4516afffd1665d$var$__EXTENSION_CLIENT_CONTEXT__];
}
function $1e4516afffd1665d$export$31a9a778785defb(context) {
    (0, $7vMoz.target)[$1e4516afffd1665d$var$__EXTENSION_CLIENT_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/extension/client.ts
function $1e4516afffd1665d$var$createExtensionClientChannel() {
    let disconnected = false;
    let port = null;
    let reconnectTimer = null;
    let onMessageHandler = null;
    function connect() {
        try {
            clearTimeout(reconnectTimer);
            port = chrome.runtime.connect({
                name: `${chrome.devtools.inspectedWindow.tabId}`
            });
            $1e4516afffd1665d$export$31a9a778785defb(port);
            disconnected = false;
            port?.onMessage.addListener(onMessageHandler);
            port.onDisconnect.addListener(()=>{
                disconnected = true;
                port?.onMessage.removeListener(onMessageHandler);
                reconnectTimer = setTimeout(connect, 1e3);
            });
        } catch (e) {
            disconnected = true;
        }
    }
    connect();
    return {
        post: (data)=>{
            if (disconnected) return;
            port?.postMessage($1e4516afffd1665d$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            onMessageHandler = (data)=>{
                if (disconnected) return;
                handler($1e4516afffd1665d$var$SuperJSON.parse(data));
            };
            port?.onMessage.addListener(onMessageHandler);
        }
    };
}
//#endregion
//#region src/messaging/presets/extension/proxy.ts
function $1e4516afffd1665d$var$createExtensionProxyChannel() {
    const port = chrome.runtime.connect({
        name: "content-script"
    });
    function sendMessageToUserApp(payload) {
        window.postMessage({
            source: $1e4516afffd1665d$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER,
            payload: payload
        }, "*");
    }
    function sendMessageToDevToolsClient(e) {
        if (e.data && e.data.source === $1e4516afffd1665d$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY) try {
            port.postMessage(e.data.payload);
        } catch (e) {}
    }
    port.onMessage.addListener(sendMessageToUserApp);
    window.addEventListener("message", sendMessageToDevToolsClient);
    port.onDisconnect.addListener(()=>{
        window.removeEventListener("message", sendMessageToDevToolsClient);
        sendMessageToUserApp($1e4516afffd1665d$var$SuperJSON.stringify({
            event: "shutdown"
        }));
    });
    sendMessageToUserApp($1e4516afffd1665d$var$SuperJSON.stringify({
        event: "init"
    }));
    return {
        post: (data)=>{},
        on: (handler)=>{}
    };
}
//#endregion
//#region src/messaging/presets/extension/server.ts
function $1e4516afffd1665d$var$createExtensionServerChannel() {
    return {
        post: (data)=>{
            window.postMessage({
                source: $1e4516afffd1665d$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY,
                payload: $1e4516afffd1665d$var$SuperJSON.stringify(data)
            }, "*");
        },
        on: (handler)=>{
            const listener = (event)=>{
                if (event.data.source === $1e4516afffd1665d$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER && event.data.payload) handler($1e4516afffd1665d$var$SuperJSON.parse(event.data.payload));
            };
            window.addEventListener("message", listener);
            return ()=>{
                window.removeEventListener("message", listener);
            };
        }
    };
}
//#endregion
//#region src/messaging/presets/iframe/context.ts
const $1e4516afffd1665d$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY = "__devtools-kit-iframe-messaging-event-key__";
const $1e4516afffd1665d$var$__IFRAME_SERVER_CONTEXT__ = "iframe:server-context";
function $1e4516afffd1665d$var$getIframeServerContext() {
    return (0, $7vMoz.target)[$1e4516afffd1665d$var$__IFRAME_SERVER_CONTEXT__];
}
function $1e4516afffd1665d$export$918b6d08f99ca1d5(context) {
    (0, $7vMoz.target)[$1e4516afffd1665d$var$__IFRAME_SERVER_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/iframe/client.ts
function $1e4516afffd1665d$var$createIframeClientChannel() {
    if (!(0, $7vMoz.isBrowser)) return {
        post: (data)=>{},
        on: (handler)=>{}
    };
    return {
        post: (data)=>window.parent.postMessage($1e4516afffd1665d$var$SuperJSON.stringify({
                event: $1e4516afffd1665d$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*"),
        on: (handler)=>window.addEventListener("message", (event)=>{
                try {
                    const parsed = $1e4516afffd1665d$var$SuperJSON.parse(event.data);
                    if (event.source === window.parent && parsed.event === "__devtools-kit-iframe-messaging-event-key__") handler(parsed.data);
                } catch (e) {}
            })
    };
}
//#endregion
//#region src/messaging/presets/iframe/server.ts
function $1e4516afffd1665d$var$createIframeServerChannel() {
    if (!(0, $7vMoz.isBrowser)) return {
        post: (data)=>{},
        on: (handler)=>{}
    };
    return {
        post: (data)=>{
            $1e4516afffd1665d$var$getIframeServerContext()?.contentWindow?.postMessage($1e4516afffd1665d$var$SuperJSON.stringify({
                event: $1e4516afffd1665d$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*");
        },
        on: (handler)=>{
            window.addEventListener("message", (event)=>{
                const iframe = $1e4516afffd1665d$var$getIframeServerContext();
                try {
                    const parsed = $1e4516afffd1665d$var$SuperJSON.parse(event.data);
                    if (event.source === iframe?.contentWindow && parsed.event === "__devtools-kit-iframe-messaging-event-key__") handler(parsed.data);
                } catch (e) {}
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/vite/context.ts
const $1e4516afffd1665d$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY = "__devtools-kit-vite-messaging-event-key__";
const $1e4516afffd1665d$var$__VITE_CLIENT_CONTEXT__ = "vite:client-context";
const $1e4516afffd1665d$var$__VITE_SERVER_CONTEXT__ = "vite:server-context";
function $1e4516afffd1665d$var$getViteClientContext() {
    return (0, $7vMoz.target)[$1e4516afffd1665d$var$__VITE_CLIENT_CONTEXT__];
}
function $1e4516afffd1665d$export$8559d72d41937efd(context) {
    (0, $7vMoz.target)[$1e4516afffd1665d$var$__VITE_CLIENT_CONTEXT__] = context;
}
function $1e4516afffd1665d$var$getViteServerContext() {
    return (0, $7vMoz.target)[$1e4516afffd1665d$var$__VITE_SERVER_CONTEXT__];
}
function $1e4516afffd1665d$export$4c32fe701137877e(context) {
    (0, $7vMoz.target)[$1e4516afffd1665d$var$__VITE_SERVER_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/vite/client.ts
function $1e4516afffd1665d$var$createViteClientChannel() {
    const client = $1e4516afffd1665d$var$getViteClientContext();
    return {
        post: (data)=>{
            client?.send($1e4516afffd1665d$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $1e4516afffd1665d$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            client?.on($1e4516afffd1665d$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, (event)=>{
                handler($1e4516afffd1665d$var$SuperJSON.parse(event));
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/vite/server.ts
function $1e4516afffd1665d$var$createViteServerChannel() {
    const viteServer = $1e4516afffd1665d$var$getViteServerContext();
    const ws = viteServer.hot ?? viteServer.ws;
    return {
        post: (data)=>ws?.send($1e4516afffd1665d$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $1e4516afffd1665d$var$SuperJSON.stringify(data)),
        on: (handler)=>ws?.on($1e4516afffd1665d$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, (event)=>{
                handler($1e4516afffd1665d$var$SuperJSON.parse(event));
            })
    };
}
//#endregion
//#region src/messaging/index.ts
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ ??= [];
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_RPC_CLIENT__ ??= null;
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_RPC_SERVER__ ??= null;
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ ??= null;
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ ??= null;
(0, $7vMoz.target).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ ??= null;
function $1e4516afffd1665d$var$setRpcClientToGlobal(rpc) {
    (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = rpc;
}
function $1e4516afffd1665d$export$7f98be55f66c4a0d(rpc) {
    (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_RPC_SERVER__ = rpc;
}
function $1e4516afffd1665d$export$9362d59e25b9feb1() {
    return (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_RPC_CLIENT__;
}
function $1e4516afffd1665d$export$380718822fedc343() {
    return (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_RPC_SERVER__;
}
function $1e4516afffd1665d$export$5f8b48d38df9666a(rpc) {
    (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = rpc;
}
function $1e4516afffd1665d$export$5105f0908e5b2002(rpc) {
    (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = rpc;
}
function $1e4516afffd1665d$export$c7310d0d7eeaac08() {
    return (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__;
}
function $1e4516afffd1665d$export$97b242d29756c723() {
    return (0, $7vMoz.target).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__;
}
function $1e4516afffd1665d$var$getChannel(preset, host = "client") {
    const channel = {
        iframe: {
            client: $1e4516afffd1665d$var$createIframeClientChannel,
            server: $1e4516afffd1665d$var$createIframeServerChannel
        }[host],
        electron: {
            client: $1e4516afffd1665d$var$createElectronClientChannel,
            proxy: $1e4516afffd1665d$var$createElectronProxyChannel,
            server: $1e4516afffd1665d$var$createElectronServerChannel
        }[host],
        vite: {
            client: $1e4516afffd1665d$var$createViteClientChannel,
            server: $1e4516afffd1665d$var$createViteServerChannel
        }[host],
        broadcast: {
            client: $1e4516afffd1665d$var$createBroadcastChannel,
            server: $1e4516afffd1665d$var$createBroadcastChannel
        }[host],
        extension: {
            client: $1e4516afffd1665d$var$createExtensionClientChannel,
            proxy: $1e4516afffd1665d$var$createExtensionProxyChannel,
            server: $1e4516afffd1665d$var$createExtensionServerChannel
        }[host]
    }[preset];
    return channel();
}
function $1e4516afffd1665d$export$9c13c20c639717e6(functions, options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $1e4516afffd1665d$var$getChannel(preset) : _channel;
    const rpc = (0, $kN14I.createBirpc)(functions, {
        ..._options,
        ...channel,
        timeout: -1
    });
    if (preset === "vite") {
        $1e4516afffd1665d$export$5f8b48d38df9666a(rpc);
        return;
    }
    $1e4516afffd1665d$var$setRpcClientToGlobal(rpc);
    return rpc;
}
function $1e4516afffd1665d$export$fbf8e1689a053c1c(functions, options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $1e4516afffd1665d$var$getChannel(preset, "server") : _channel;
    const rpcServer = $1e4516afffd1665d$export$380718822fedc343();
    if (!rpcServer) {
        const group = (0, $kN14I.createBirpcGroup)(functions, [
            channel
        ], {
            ..._options,
            timeout: -1
        });
        if (preset === "vite") {
            $1e4516afffd1665d$export$5105f0908e5b2002(group);
            return;
        }
        $1e4516afffd1665d$export$7f98be55f66c4a0d(group);
    } else rpcServer.updateChannels((channels)=>{
        channels.push(channel);
    });
}
function $1e4516afffd1665d$export$490df4aa0eb47722(options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $1e4516afffd1665d$var$getChannel(preset, "proxy") : _channel;
    return (0, $kN14I.createBirpc)({}, {
        ..._options,
        ...channel,
        timeout: -1
    });
}
//#endregion
//#region src/core/component/state/custom.ts
function $1e4516afffd1665d$var$getFunctionDetails(func) {
    let string = "";
    let matches = null;
    try {
        string = Function.prototype.toString.call(func);
        matches = String.prototype.match.call(string, /\([\s\S]*?\)/);
    } catch (e) {}
    const match = matches && matches[0];
    const args = typeof match === "string" ? match : "(?)";
    return {
        _custom: {
            type: "function",
            displayText: `<span style="opacity:.8;margin-right:5px;">function</span> <span style="white-space:nowrap;">${$1e4516afffd1665d$export$4e7f196112fea3c5(typeof func.name === "string" ? func.name : "")}${args}</span>`,
            tooltipText: string.trim() ? `<pre>${$1e4516afffd1665d$export$4e7f196112fea3c5(string)}</pre>` : null
        }
    };
}
function $1e4516afffd1665d$var$getBigIntDetails(val) {
    const stringifiedBigInt = BigInt.prototype.toString.call(val);
    return {
        _custom: {
            type: "bigint",
            displayText: `BigInt(${stringifiedBigInt})`,
            value: stringifiedBigInt
        }
    };
}
function $1e4516afffd1665d$var$getDateDetails(val) {
    const date = new Date(val.getTime());
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return {
        _custom: {
            type: "date",
            displayText: Date.prototype.toString.call(val),
            value: date.toISOString().slice(0, -1)
        }
    };
}
function $1e4516afffd1665d$var$getMapDetails(val) {
    return {
        _custom: {
            type: "map",
            displayText: "Map",
            value: Object.fromEntries(val),
            readOnly: true,
            fields: {
                abstract: true
            }
        }
    };
}
function $1e4516afffd1665d$var$getSetDetails(val) {
    const list = Array.from(val);
    return {
        _custom: {
            type: "set",
            displayText: `Set[${list.length}]`,
            value: list,
            readOnly: true
        }
    };
}
function $1e4516afffd1665d$var$getCaughtGetters(store) {
    const getters = {};
    const origGetters = store.getters || {};
    const keys = Object.keys(origGetters);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        Object.defineProperty(getters, key, {
            enumerable: true,
            get: ()=>{
                try {
                    return origGetters[key];
                } catch (e) {
                    return e;
                }
            }
        });
    }
    return getters;
}
function $1e4516afffd1665d$var$reduceStateList(list) {
    if (!list.length) return void 0;
    return list.reduce((map, item)=>{
        const key = item.type || "data";
        const obj = map[key] = map[key] || {};
        obj[item.key] = item.value;
        return map;
    }, {});
}
function $1e4516afffd1665d$var$namedNodeMapToObject(map) {
    const result = {};
    const l = map.length;
    for(let i = 0; i < l; i++){
        const node = map.item(i);
        result[node.name] = node.value;
    }
    return result;
}
function $1e4516afffd1665d$var$getStoreDetails(store) {
    return {
        _custom: {
            type: "store",
            displayText: "Store",
            value: {
                state: store.state,
                getters: $1e4516afffd1665d$var$getCaughtGetters(store)
            },
            fields: {
                abstract: true
            }
        }
    };
}
function $1e4516afffd1665d$var$getInstanceDetails(instance) {
    if (instance._) instance = instance._;
    const state = $1e4516afffd1665d$var$processInstanceState(instance);
    return {
        _custom: {
            type: "component",
            id: instance.__VUE_DEVTOOLS_NEXT_UID__,
            displayText: $1e4516afffd1665d$var$getInstanceName(instance),
            tooltipText: "Component instance",
            value: $1e4516afffd1665d$var$reduceStateList(state),
            fields: {
                abstract: true
            }
        }
    };
}
function $1e4516afffd1665d$var$getComponentDefinitionDetails(definition) {
    let display = $1e4516afffd1665d$var$getComponentName(definition);
    if (display) {
        if (definition.name && definition.__file) display += ` <span>(${definition.__file})</span>`;
    } else display = "<i>Unknown Component</i>";
    return {
        _custom: {
            type: "component-definition",
            displayText: display,
            tooltipText: "Component definition",
            ...definition.__file ? {
                file: definition.__file
            } : {}
        }
    };
}
function $1e4516afffd1665d$var$getHTMLElementDetails(value) {
    try {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: `<span class="opacity-30">&lt;</span><span class="text-blue-500">${value.tagName.toLowerCase()}</span><span class="opacity-30">&gt;</span>`,
                value: $1e4516afffd1665d$var$namedNodeMapToObject(value.attributes)
            }
        };
    } catch (e) {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: `<span class="text-blue-500">${String(value)}</span>`
            }
        };
    }
}
/**
* - ObjectRefImpl, toRef({ foo: 'foo' }, 'foo'), `_value` is the actual value, (since 3.5.0)
* - GetterRefImpl, toRef(() => state.foo), `_value` is the actual value, (since 3.5.0)
* - RefImpl, ref('foo') / computed(() => 'foo'), `_value` is the actual value
*/ function $1e4516afffd1665d$var$tryGetRefValue(ref) {
    if ($1e4516afffd1665d$var$ensurePropertyExists(ref, "_value", true)) return ref._value;
    if ($1e4516afffd1665d$var$ensurePropertyExists(ref, "value", true)) return ref.value;
}
function $1e4516afffd1665d$var$getObjectDetails(object) {
    const info = $1e4516afffd1665d$var$getSetupStateType(object);
    if (info.ref || info.computed || info.reactive) {
        const stateTypeName = info.computed ? "Computed" : info.ref ? "Ref" : info.reactive ? "Reactive" : null;
        const value = $1e4516afffd1665d$var$toRaw(info.reactive ? object : $1e4516afffd1665d$var$tryGetRefValue(object));
        const raw = $1e4516afffd1665d$var$ensurePropertyExists(object, "effect") ? object.effect?.raw?.toString() || object.effect?.fn?.toString() : null;
        return {
            _custom: {
                type: stateTypeName?.toLowerCase(),
                stateTypeName: stateTypeName,
                value: value,
                ...raw ? {
                    tooltipText: `<pre>${$1e4516afffd1665d$export$4e7f196112fea3c5(raw)}</pre>`
                } : {}
            }
        };
    }
    if ($1e4516afffd1665d$var$ensurePropertyExists(object, "__asyncLoader") && typeof object.__asyncLoader === "function") return {
        _custom: {
            type: "component-definition",
            display: "Async component definition"
        }
    };
}
//#endregion
//#region src/core/component/state/replacer.ts
function $1e4516afffd1665d$var$stringifyReplacer(key, _value, depth, seenInstance) {
    if (key === "compilerOptions") return;
    const val = this[key];
    const type = typeof val;
    if (Array.isArray(val)) {
        const l = val.length;
        if (l > 5e3) return {
            _isArray: true,
            length: l,
            items: val.slice(0, $1e4516afffd1665d$var$MAX_ARRAY_SIZE)
        };
        return val;
    } else if (typeof val === "string") {
        if (val.length > 1e4) return `${val.substring(0, $1e4516afffd1665d$var$MAX_STRING_SIZE)}... (${val.length} total length)`;
        else return val;
    } else if (type === "undefined") return $1e4516afffd1665d$export$6db089fe7b26f5b6;
    else if (val === Number.POSITIVE_INFINITY) return $1e4516afffd1665d$export$b4bf424ed968e242;
    else if (val === Number.NEGATIVE_INFINITY) return $1e4516afffd1665d$export$95cb88e357cbada8;
    else if (typeof val === "function") return $1e4516afffd1665d$var$getFunctionDetails(val);
    else if (type === "symbol") return `[native Symbol ${Symbol.prototype.toString.call(val)}]`;
    else if (typeof val === "bigint") return $1e4516afffd1665d$var$getBigIntDetails(val);
    else if (val !== null && typeof val === "object") {
        const proto = Object.prototype.toString.call(val);
        if (proto === "[object Map]") return $1e4516afffd1665d$var$getMapDetails(val);
        else if (proto === "[object Set]") return $1e4516afffd1665d$var$getSetDetails(val);
        else if (proto === "[object RegExp]") return `[native RegExp ${RegExp.prototype.toString.call(val)}]`;
        else if (proto === "[object Date]") return $1e4516afffd1665d$var$getDateDetails(val);
        else if (proto === "[object Error]") return `[native Error ${val.message}<>${val.stack}]`;
        else if ($1e4516afffd1665d$var$ensurePropertyExists(val, "state", true) && $1e4516afffd1665d$var$ensurePropertyExists(val, "_vm", true)) return $1e4516afffd1665d$var$getStoreDetails(val);
        else if ($1e4516afffd1665d$var$isVueInstance(val)) {
            const componentVal = $1e4516afffd1665d$var$getInstanceDetails(val);
            const parentInstanceDepth = seenInstance?.get(val);
            if (parentInstanceDepth && parentInstanceDepth < depth) return `[[CircularRef]] <${componentVal._custom.displayText}>`;
            seenInstance?.set(val, depth);
            return componentVal;
        } else if ($1e4516afffd1665d$var$ensurePropertyExists(val, "render", true) && typeof val.render === "function") return $1e4516afffd1665d$var$getComponentDefinitionDetails(val);
        else if (val.constructor && val.constructor.name === "VNode") return `[native VNode <${val.tag}>]`;
        else if (typeof HTMLElement !== "undefined" && val instanceof HTMLElement) return $1e4516afffd1665d$var$getHTMLElementDetails(val);
        else if (val.constructor?.name === "Store" && "_wrappedGetters" in val) return "[object Store]";
        const customDetails = $1e4516afffd1665d$var$getObjectDetails(val);
        if (customDetails != null) return customDetails;
    } else if (Number.isNaN(val)) return $1e4516afffd1665d$export$d7ae0f70ebb9e144;
    return $1e4516afffd1665d$var$sanitize(val);
}
//#endregion
//#region src/shared/transfer.ts
const $1e4516afffd1665d$var$MAX_SERIALIZED_SIZE = 2097152;
function $1e4516afffd1665d$var$isObject(_data, proto) {
    return proto === "[object Object]";
}
function $1e4516afffd1665d$var$isArray(_data, proto) {
    return proto === "[object Array]";
}
function $1e4516afffd1665d$var$isVueReactiveLinkNode(node) {
    const constructorName = node?.constructor?.name;
    return constructorName === "Dep" && "activeLink" in node || constructorName === "Link" && "dep" in node;
}
/**
* This function is used to serialize object with handling circular references.
*
* ```ts
* const obj = { a: 1, b: { c: 2 }, d: obj }
* const result = stringifyCircularAutoChunks(obj) // call `encode` inside
* console.log(result) // [{"a":1,"b":2,"d":0},1,{"c":4},2]
* ```
*
* Each object is stored in a list and the index is used to reference the object.
* With seen map, we can check if the object is already stored in the list to avoid circular references.
*
* Note: here we have a special case for Vue instance.
* We check if a vue instance includes itself in its properties and skip it
* by using `seenVueInstance` and `depth` to avoid infinite loop.
*/ function $1e4516afffd1665d$var$encode(data, replacer, list, seen, depth = 0, seenVueInstance = /* @__PURE__ */ new Map()) {
    let stored;
    let key;
    let value;
    let i;
    let l;
    const seenIndex = seen.get(data);
    if (seenIndex != null) return seenIndex;
    const index = list.length;
    const proto = Object.prototype.toString.call(data);
    if ($1e4516afffd1665d$var$isObject(data, proto)) {
        if ($1e4516afffd1665d$var$isVueReactiveLinkNode(data)) return index;
        stored = {};
        seen.set(data, index);
        list.push(stored);
        const keys = Object.keys(data);
        for(i = 0, l = keys.length; i < l; i++){
            key = keys[i];
            if (key === "compilerOptions") return index;
            value = data[key];
            const isVm = value != null && $1e4516afffd1665d$var$isObject(value, Object.prototype.toString.call(data)) && $1e4516afffd1665d$var$isVueInstance(value);
            try {
                if (replacer) value = replacer.call(data, key, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[key] = $1e4516afffd1665d$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
            if (isVm) seenVueInstance.delete(value);
        }
    } else if ($1e4516afffd1665d$var$isArray(data, proto)) {
        stored = [];
        seen.set(data, index);
        list.push(stored);
        for(i = 0, l = data.length; i < l; i++){
            try {
                value = data[i];
                if (replacer) value = replacer.call(data, i, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[i] = $1e4516afffd1665d$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
        }
    } else list.push(data);
    return index;
}
function $1e4516afffd1665d$var$decode(list, reviver = null) {
    let i = list.length;
    let j, k, data, key, value, proto;
    while(i--){
        data = list[i];
        proto = Object.prototype.toString.call(data);
        if (proto === "[object Object]") {
            const keys = Object.keys(data);
            for(j = 0, k = keys.length; j < k; j++){
                key = keys[j];
                value = list[data[key]];
                if (reviver) value = reviver.call(data, key, value);
                data[key] = value;
            }
        } else if (proto === "[object Array]") for(j = 0, k = data.length; j < k; j++){
            value = list[data[j]];
            if (reviver) value = reviver.call(data, j, value);
            data[j] = value;
        }
    }
}
function $1e4516afffd1665d$var$stringifyCircularAutoChunks(data, replacer = null, space = null) {
    let result;
    try {
        result = arguments.length === 1 ? JSON.stringify(data) : JSON.stringify(data, (k, v)=>replacer?.(k, v)?.call(this), space);
    } catch (e) {
        result = $1e4516afffd1665d$var$stringifyStrictCircularAutoChunks(data, replacer, space);
    }
    if (result.length > $1e4516afffd1665d$var$MAX_SERIALIZED_SIZE) {
        const chunkCount = Math.ceil(result.length / $1e4516afffd1665d$var$MAX_SERIALIZED_SIZE);
        const chunks = [];
        for(let i = 0; i < chunkCount; i++)chunks.push(result.slice(i * $1e4516afffd1665d$var$MAX_SERIALIZED_SIZE, (i + 1) * $1e4516afffd1665d$var$MAX_SERIALIZED_SIZE));
        return chunks;
    }
    return result;
}
function $1e4516afffd1665d$var$stringifyStrictCircularAutoChunks(data, replacer = null, space = null) {
    const list = [];
    $1e4516afffd1665d$var$encode(data, replacer, list, /* @__PURE__ */ new Map());
    return space ? ` ${JSON.stringify(list, null, space)}` : ` ${JSON.stringify(list)}`;
}
function $1e4516afffd1665d$var$parseCircularAutoChunks(data, reviver = null) {
    if (Array.isArray(data)) data = data.join("");
    if (!/^\s/.test(data)) return arguments.length === 1 ? JSON.parse(data) : JSON.parse(data, reviver);
    else {
        const list = JSON.parse(data);
        $1e4516afffd1665d$var$decode(list, reviver);
        return list[0];
    }
}
//#endregion
//#region src/shared/util.ts
function $1e4516afffd1665d$export$fac44ee5b035f737(data) {
    return $1e4516afffd1665d$var$stringifyCircularAutoChunks(data, $1e4516afffd1665d$var$stringifyReplacer);
}
function $1e4516afffd1665d$export$98e6a39c04603d36(data, revive = false) {
    if (data == void 0) return {};
    return revive ? $1e4516afffd1665d$var$parseCircularAutoChunks(data, $1e4516afffd1665d$var$reviver) : $1e4516afffd1665d$var$parseCircularAutoChunks(data);
}
//#endregion
//#region src/index.ts
const $1e4516afffd1665d$export$6922d3b3a607469e = {
    hook: $1e4516afffd1665d$var$hook,
    init: ()=>{
        $1e4516afffd1665d$export$93f430585c3f6d11();
    },
    get ctx () {
        return $1e4516afffd1665d$export$4f1904c03898171b;
    },
    get api () {
        return $1e4516afffd1665d$export$4f1904c03898171b.api;
    }
};

});
parcelRegister("7vMoz", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $5780f7f8cb85a7a6$export$4e09c449d6c407f7);
$parcel$export(module.exports, "target", () => $5780f7f8cb85a7a6$export$44271b4f0c6a3563);
$parcel$export(module.exports, "isNuxtApp", () => $5780f7f8cb85a7a6$export$e34a31924fd64105);
$parcel$export(module.exports, "classify", () => $5780f7f8cb85a7a6$export$b04d9b8d414ba5e8);
$parcel$export(module.exports, "camelize", () => $5780f7f8cb85a7a6$export$161d051f5dd25de7);
$parcel$export(module.exports, "kebabize", () => $5780f7f8cb85a7a6$export$3b2e9c066cbbdd4c);
$parcel$export(module.exports, "basename", () => $5780f7f8cb85a7a6$export$9bf319d8f74f51d1);
$parcel$export(module.exports, "isUrlString", () => $5780f7f8cb85a7a6$export$8092cb61b2731942);
$parcel$export(module.exports, "deepClone", () => $5780f7f8cb85a7a6$export$b7d58db314e0ac27);
//#region \0rolldown/runtime.js

var $kFATv = parcelRequire("kFATv");
var $5780f7f8cb85a7a6$require$Buffer = $kFATv.Buffer;
var $5780f7f8cb85a7a6$var$__create = Object.create;
var $5780f7f8cb85a7a6$var$__defProp = Object.defineProperty;
var $5780f7f8cb85a7a6$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $5780f7f8cb85a7a6$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $5780f7f8cb85a7a6$var$__getProtoOf = Object.getPrototypeOf;
var $5780f7f8cb85a7a6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5780f7f8cb85a7a6$var$__commonJSMin = (cb, mod)=>()=>(mod || cb((mod = {
            exports: {}
        }).exports, mod), mod.exports);
var $5780f7f8cb85a7a6$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") for(var keys = $5780f7f8cb85a7a6$var$__getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++){
        key = keys[i];
        if (!$5780f7f8cb85a7a6$var$__hasOwnProp.call(to, key) && key !== except) $5780f7f8cb85a7a6$var$__defProp(to, key, {
            get: ((k)=>from[k]).bind(null, key),
            enumerable: !(desc = $5780f7f8cb85a7a6$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $5780f7f8cb85a7a6$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $5780f7f8cb85a7a6$var$__create($5780f7f8cb85a7a6$var$__getProtoOf(mod)) : {}, $5780f7f8cb85a7a6$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $5780f7f8cb85a7a6$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
//#endregion
//#region src/constants.ts
const $5780f7f8cb85a7a6$export$a13f7f627010bccd = "__vue-devtools-view-mode__";
const $5780f7f8cb85a7a6$export$cb85e77fef76bd8b = "__vue-devtools-vite-plugin-detected__";
const $5780f7f8cb85a7a6$export$45e7092a470efb27 = "__vue-devtools-vite-plugin-client-url__";
const $5780f7f8cb85a7a6$export$a7ca7371bc63510e = "__vue-devtools-broadcast-channel__";
//#endregion
//#region src/env.ts
const $5780f7f8cb85a7a6$export$4e09c449d6c407f7 = typeof navigator !== "undefined";
const $5780f7f8cb85a7a6$export$44271b4f0c6a3563 = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $5780f7f8cb85a7a6$export$2a47bd138bf4827c = typeof $5780f7f8cb85a7a6$export$44271b4f0c6a3563.chrome !== "undefined" && !!$5780f7f8cb85a7a6$export$44271b4f0c6a3563.chrome.devtools;
const $5780f7f8cb85a7a6$export$9f140ed41af5108c = $5780f7f8cb85a7a6$export$4e09c449d6c407f7 && $5780f7f8cb85a7a6$export$44271b4f0c6a3563.self !== $5780f7f8cb85a7a6$export$44271b4f0c6a3563.top;
const $5780f7f8cb85a7a6$export$6272d088ce0bd5ee = typeof navigator !== "undefined" && navigator.userAgent?.toLowerCase().includes("electron");
const $5780f7f8cb85a7a6$export$e34a31924fd64105 = typeof window !== "undefined" && !!window.__NUXT__;
const $5780f7f8cb85a7a6$export$cd24a69e3c9a51c8 = !$5780f7f8cb85a7a6$export$9f140ed41af5108c && !$5780f7f8cb85a7a6$export$2a47bd138bf4827c && !$5780f7f8cb85a7a6$export$6272d088ce0bd5ee;
//#endregion
//#region src/general.ts
var $5780f7f8cb85a7a6$var$import_rfdc = /* @__PURE__ */ $5780f7f8cb85a7a6$var$__toESM(/* @__PURE__ */ $5780f7f8cb85a7a6$var$__commonJSMin((exports, module)=>{
    module.exports = rfdc;
    function copyBuffer(cur) {
        if (cur instanceof $5780f7f8cb85a7a6$require$Buffer) return $5780f7f8cb85a7a6$require$Buffer.from(cur);
        return new cur.constructor(cur.buffer.slice(), cur.byteOffset, cur.length);
    }
    function rfdc(opts) {
        opts = opts || {};
        if (opts.circles) return rfdcCircles(opts);
        const constructorHandlers = /* @__PURE__ */ new Map();
        constructorHandlers.set(Date, (o)=>new Date(o));
        constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
        constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
        if (opts.constructorHandlers) for (const handler of opts.constructorHandlers)constructorHandlers.set(handler[0], handler[1]);
        let handler = null;
        return opts.proto ? cloneProto : clone;
        function cloneArray(a, fn) {
            const keys = Object.keys(a);
            const a2 = new Array(keys.length);
            for(let i = 0; i < keys.length; i++){
                const k = keys[i];
                const cur = a[k];
                if (typeof cur !== "object" || cur === null) a2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
                else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                else a2[k] = fn(cur);
            }
            return a2;
        }
        function clone(o) {
            if (typeof o !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, clone);
            if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
            const o2 = {};
            for(const k in o){
                if (Object.hasOwnProperty.call(o, k) === false) continue;
                const cur = o[k];
                if (typeof cur !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else o2[k] = clone(cur);
            }
            return o2;
        }
        function cloneProto(o) {
            if (typeof o !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, cloneProto);
            if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
            const o2 = {};
            for(const k in o){
                const cur = o[k];
                if (typeof cur !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else o2[k] = cloneProto(cur);
            }
            return o2;
        }
    }
    function rfdcCircles(opts) {
        const refs = [];
        const refsNew = [];
        const constructorHandlers = /* @__PURE__ */ new Map();
        constructorHandlers.set(Date, (o)=>new Date(o));
        constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
        constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
        if (opts.constructorHandlers) for (const handler of opts.constructorHandlers)constructorHandlers.set(handler[0], handler[1]);
        let handler = null;
        return opts.proto ? cloneProto : clone;
        function cloneArray(a, fn) {
            const keys = Object.keys(a);
            const a2 = new Array(keys.length);
            for(let i = 0; i < keys.length; i++){
                const k = keys[i];
                const cur = a[k];
                if (typeof cur !== "object" || cur === null) a2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
                else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                else {
                    const index = refs.indexOf(cur);
                    if (index !== -1) a2[k] = refsNew[index];
                    else a2[k] = fn(cur);
                }
            }
            return a2;
        }
        function clone(o) {
            if (typeof o !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, clone);
            if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
            const o2 = {};
            refs.push(o);
            refsNew.push(o2);
            for(const k in o){
                if (Object.hasOwnProperty.call(o, k) === false) continue;
                const cur = o[k];
                if (typeof cur !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else {
                    const i = refs.indexOf(cur);
                    if (i !== -1) o2[k] = refsNew[i];
                    else o2[k] = clone(cur);
                }
            }
            refs.pop();
            refsNew.pop();
            return o2;
        }
        function cloneProto(o) {
            if (typeof o !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, cloneProto);
            if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
            const o2 = {};
            refs.push(o);
            refsNew.push(o2);
            for(const k in o){
                const cur = o[k];
                if (typeof cur !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else {
                    const i = refs.indexOf(cur);
                    if (i !== -1) o2[k] = refsNew[i];
                    else o2[k] = cloneProto(cur);
                }
            }
            refs.pop();
            refsNew.pop();
            return o2;
        }
    }
})(), 1);
function $5780f7f8cb85a7a6$export$5702a91a6f42969f() {}
const $5780f7f8cb85a7a6$export$e90fb89750dba83f = (str)=>`${+str}` === str;
const $5780f7f8cb85a7a6$export$6159e43e50a41987 = ()=>navigator?.platform ? navigator?.platform.toLowerCase().includes("mac") : /Macintosh/.test(navigator.userAgent);
const $5780f7f8cb85a7a6$var$classifyRE = /(?:^|[-_/])(\w)/g;
const $5780f7f8cb85a7a6$var$camelizeRE = /-(\w)/g;
const $5780f7f8cb85a7a6$var$kebabizeRE = /([a-z0-9])([A-Z])/g;
function $5780f7f8cb85a7a6$var$toUpper(_, c) {
    return c ? c.toUpperCase() : "";
}
function $5780f7f8cb85a7a6$export$b04d9b8d414ba5e8(str) {
    return str && `${str}`.replace($5780f7f8cb85a7a6$var$classifyRE, $5780f7f8cb85a7a6$var$toUpper);
}
function $5780f7f8cb85a7a6$export$161d051f5dd25de7(str) {
    return str && str.replace($5780f7f8cb85a7a6$var$camelizeRE, $5780f7f8cb85a7a6$var$toUpper);
}
function $5780f7f8cb85a7a6$export$3b2e9c066cbbdd4c(str) {
    return str && str.replace($5780f7f8cb85a7a6$var$kebabizeRE, (_, lowerCaseCharacter, upperCaseLetter)=>{
        return `${lowerCaseCharacter}-${upperCaseLetter}`;
    }).toLowerCase();
}
function $5780f7f8cb85a7a6$export$9bf319d8f74f51d1(filename, ext) {
    let normalizedFilename = filename.replace(/^[a-z]:/i, "").replace(/\\/g, "/");
    if (normalizedFilename.endsWith(`index${ext}`)) normalizedFilename = normalizedFilename.replace(`/index${ext}`, ext);
    const lastSlashIndex = normalizedFilename.lastIndexOf("/");
    const baseNameWithExt = normalizedFilename.substring(lastSlashIndex + 1);
    if (ext) {
        const extIndex = baseNameWithExt.lastIndexOf(ext);
        return baseNameWithExt.substring(0, extIndex);
    }
    return "";
}
function $5780f7f8cb85a7a6$export$584200199479c807(state) {
    return state && state.slice().sort((a, b)=>{
        if (a.key < b.key) return -1;
        if (a.key > b.key) return 1;
        return 0;
    });
}
const $5780f7f8cb85a7a6$var$HTTP_URL_RE = /^https?:\/\//;
/**
* Check a string is start with `/` or a valid http url
*/ function $5780f7f8cb85a7a6$export$8092cb61b2731942(str) {
    return str.startsWith("/") || $5780f7f8cb85a7a6$var$HTTP_URL_RE.test(str);
}
/**
* @copyright [rfdc](https://github.com/davidmarkclements/rfdc)
* @description A really fast deep clone alternative
*/ const $5780f7f8cb85a7a6$export$b7d58db314e0ac27 = (0, $5780f7f8cb85a7a6$var$import_rfdc.default)({
    circles: true
});
function $5780f7f8cb85a7a6$export$e700e91d2b9349e8() {
    return Math.random().toString(36).slice(2);
}
function $5780f7f8cb85a7a6$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && !Array.isArray(value) && value !== null;
}
function $5780f7f8cb85a7a6$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $5780f7f8cb85a7a6$export$6750766a7c7ec627(value) {
    return value instanceof Set;
}
function $5780f7f8cb85a7a6$export$5c90113a285f2241(value) {
    return value instanceof Map;
}

});
parcelRegister("kFATv", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $f0c4416a745b85a1$export$a143d493d941bafc, (v) => $f0c4416a745b85a1$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $f0c4416a745b85a1$export$f99ded8fe4b79145, (v) => $f0c4416a745b85a1$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f0c4416a745b85a1$export$a143d493d941bafc;
var $f0c4416a745b85a1$export$e4cf37d7f6fb9e0a;
var $f0c4416a745b85a1$export$f99ded8fe4b79145;
var $f0c4416a745b85a1$export$599f31c3813fae4d;
'use strict';

var $6ocIT = parcelRequire("6ocIT");

var $1wLos = parcelRequire("1wLos");
var $f0c4416a745b85a1$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f0c4416a745b85a1$export$a143d493d941bafc = $f0c4416a745b85a1$var$Buffer;
$f0c4416a745b85a1$export$e4cf37d7f6fb9e0a = $f0c4416a745b85a1$var$SlowBuffer;
$f0c4416a745b85a1$export$f99ded8fe4b79145 = 50;
var $f0c4416a745b85a1$var$K_MAX_LENGTH = 0x7fffffff;
$f0c4416a745b85a1$export$599f31c3813fae4d = $f0c4416a745b85a1$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f0c4416a745b85a1$var$Buffer.TYPED_ARRAY_SUPPORT = $f0c4416a745b85a1$var$typedArraySupport();
if (!$f0c4416a745b85a1$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f0c4416a745b85a1$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f0c4416a745b85a1$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$f0c4416a745b85a1$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f0c4416a745b85a1$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$f0c4416a745b85a1$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f0c4416a745b85a1$var$createBuffer(length) {
    if (length > $f0c4416a745b85a1$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f0c4416a745b85a1$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f0c4416a745b85a1$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f0c4416a745b85a1$var$allocUnsafe(arg);
    }
    return $f0c4416a745b85a1$var$from(arg, encodingOrOffset, length);
}
$f0c4416a745b85a1$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f0c4416a745b85a1$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f0c4416a745b85a1$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f0c4416a745b85a1$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f0c4416a745b85a1$var$isInstance(value, ArrayBuffer) || value && $f0c4416a745b85a1$var$isInstance(value.buffer, ArrayBuffer)) return $f0c4416a745b85a1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f0c4416a745b85a1$var$isInstance(value, SharedArrayBuffer) || value && $f0c4416a745b85a1$var$isInstance(value.buffer, SharedArrayBuffer))) return $f0c4416a745b85a1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f0c4416a745b85a1$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $f0c4416a745b85a1$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f0c4416a745b85a1$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f0c4416a745b85a1$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f0c4416a745b85a1$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f0c4416a745b85a1$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f0c4416a745b85a1$var$Buffer, Uint8Array);
function $f0c4416a745b85a1$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f0c4416a745b85a1$var$alloc(size, fill, encoding) {
    $f0c4416a745b85a1$var$assertSize(size);
    if (size <= 0) return $f0c4416a745b85a1$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f0c4416a745b85a1$var$createBuffer(size).fill(fill, encoding) : $f0c4416a745b85a1$var$createBuffer(size).fill(fill);
    return $f0c4416a745b85a1$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f0c4416a745b85a1$var$Buffer.alloc = function(size, fill, encoding) {
    return $f0c4416a745b85a1$var$alloc(size, fill, encoding);
};
function $f0c4416a745b85a1$var$allocUnsafe(size) {
    $f0c4416a745b85a1$var$assertSize(size);
    return $f0c4416a745b85a1$var$createBuffer(size < 0 ? 0 : $f0c4416a745b85a1$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f0c4416a745b85a1$var$Buffer.allocUnsafe = function(size) {
    return $f0c4416a745b85a1$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f0c4416a745b85a1$var$Buffer.allocUnsafeSlow = function(size) {
    return $f0c4416a745b85a1$var$allocUnsafe(size);
};
function $f0c4416a745b85a1$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f0c4416a745b85a1$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $f0c4416a745b85a1$var$byteLength(string, encoding) | 0;
    var buf = $f0c4416a745b85a1$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f0c4416a745b85a1$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $f0c4416a745b85a1$var$checked(array.length) | 0;
    var buf = $f0c4416a745b85a1$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f0c4416a745b85a1$var$fromArrayView(arrayView) {
    if ($f0c4416a745b85a1$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $f0c4416a745b85a1$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f0c4416a745b85a1$var$fromArrayLike(arrayView);
}
function $f0c4416a745b85a1$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f0c4416a745b85a1$var$Buffer.prototype);
    return buf;
}
function $f0c4416a745b85a1$var$fromObject(obj) {
    if ($f0c4416a745b85a1$var$Buffer.isBuffer(obj)) {
        var len = $f0c4416a745b85a1$var$checked(obj.length) | 0;
        var buf = $f0c4416a745b85a1$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f0c4416a745b85a1$var$numberIsNaN(obj.length)) return $f0c4416a745b85a1$var$createBuffer(0);
        return $f0c4416a745b85a1$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f0c4416a745b85a1$var$fromArrayLike(obj.data);
}
function $f0c4416a745b85a1$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f0c4416a745b85a1$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f0c4416a745b85a1$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f0c4416a745b85a1$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f0c4416a745b85a1$var$Buffer.alloc(+length);
}
$f0c4416a745b85a1$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f0c4416a745b85a1$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f0c4416a745b85a1$var$Buffer.compare = function compare(a, b) {
    if ($f0c4416a745b85a1$var$isInstance(a, Uint8Array)) a = $f0c4416a745b85a1$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f0c4416a745b85a1$var$isInstance(b, Uint8Array)) b = $f0c4416a745b85a1$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f0c4416a745b85a1$var$Buffer.isBuffer(a) || !$f0c4416a745b85a1$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f0c4416a745b85a1$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f0c4416a745b85a1$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f0c4416a745b85a1$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $f0c4416a745b85a1$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($f0c4416a745b85a1$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $f0c4416a745b85a1$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f0c4416a745b85a1$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f0c4416a745b85a1$var$byteLength(string, encoding) {
    if ($f0c4416a745b85a1$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f0c4416a745b85a1$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f0c4416a745b85a1$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f0c4416a745b85a1$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f0c4416a745b85a1$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f0c4416a745b85a1$var$Buffer.byteLength = $f0c4416a745b85a1$var$byteLength;
function $f0c4416a745b85a1$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f0c4416a745b85a1$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f0c4416a745b85a1$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f0c4416a745b85a1$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f0c4416a745b85a1$var$latin1Slice(this, start, end);
        case 'base64':
            return $f0c4416a745b85a1$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f0c4416a745b85a1$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f0c4416a745b85a1$var$Buffer.prototype._isBuffer = true;
function $f0c4416a745b85a1$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f0c4416a745b85a1$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$f0c4416a745b85a1$var$swap(this, i, i + 1);
    return this;
};
$f0c4416a745b85a1$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $f0c4416a745b85a1$var$swap(this, i, i + 3);
        $f0c4416a745b85a1$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f0c4416a745b85a1$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $f0c4416a745b85a1$var$swap(this, i, i + 7);
        $f0c4416a745b85a1$var$swap(this, i + 1, i + 6);
        $f0c4416a745b85a1$var$swap(this, i + 2, i + 5);
        $f0c4416a745b85a1$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f0c4416a745b85a1$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f0c4416a745b85a1$var$utf8Slice(this, 0, length);
    return $f0c4416a745b85a1$var$slowToString.apply(this, arguments);
};
$f0c4416a745b85a1$var$Buffer.prototype.toLocaleString = $f0c4416a745b85a1$var$Buffer.prototype.toString;
$f0c4416a745b85a1$var$Buffer.prototype.equals = function equals(b) {
    if (!$f0c4416a745b85a1$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f0c4416a745b85a1$var$Buffer.compare(this, b) === 0;
};
$f0c4416a745b85a1$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $f0c4416a745b85a1$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f0c4416a745b85a1$var$customInspectSymbol) $f0c4416a745b85a1$var$Buffer.prototype[$f0c4416a745b85a1$var$customInspectSymbol] = $f0c4416a745b85a1$var$Buffer.prototype.inspect;
$f0c4416a745b85a1$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f0c4416a745b85a1$var$isInstance(target, Uint8Array)) target = $f0c4416a745b85a1$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f0c4416a745b85a1$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f0c4416a745b85a1$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f0c4416a745b85a1$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f0c4416a745b85a1$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f0c4416a745b85a1$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f0c4416a745b85a1$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f0c4416a745b85a1$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f0c4416a745b85a1$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f0c4416a745b85a1$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f0c4416a745b85a1$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f0c4416a745b85a1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f0c4416a745b85a1$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f0c4416a745b85a1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f0c4416a745b85a1$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f0c4416a745b85a1$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f0c4416a745b85a1$var$utf8Write(buf, string, offset, length) {
    return $f0c4416a745b85a1$var$blitBuffer($f0c4416a745b85a1$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f0c4416a745b85a1$var$asciiWrite(buf, string, offset, length) {
    return $f0c4416a745b85a1$var$blitBuffer($f0c4416a745b85a1$var$asciiToBytes(string), buf, offset, length);
}
function $f0c4416a745b85a1$var$base64Write(buf, string, offset, length) {
    return $f0c4416a745b85a1$var$blitBuffer($f0c4416a745b85a1$var$base64ToBytes(string), buf, offset, length);
}
function $f0c4416a745b85a1$var$ucs2Write(buf, string, offset, length) {
    return $f0c4416a745b85a1$var$blitBuffer($f0c4416a745b85a1$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f0c4416a745b85a1$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f0c4416a745b85a1$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f0c4416a745b85a1$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f0c4416a745b85a1$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f0c4416a745b85a1$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f0c4416a745b85a1$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f0c4416a745b85a1$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f0c4416a745b85a1$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6ocIT.fromByteArray(buf);
    else return $6ocIT.fromByteArray(buf.slice(start, end));
}
function $f0c4416a745b85a1$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f0c4416a745b85a1$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $f0c4416a745b85a1$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f0c4416a745b85a1$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $f0c4416a745b85a1$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f0c4416a745b85a1$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f0c4416a745b85a1$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f0c4416a745b85a1$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f0c4416a745b85a1$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $f0c4416a745b85a1$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f0c4416a745b85a1$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f0c4416a745b85a1$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f0c4416a745b85a1$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f0c4416a745b85a1$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f0c4416a745b85a1$var$Buffer.prototype.readUintLE = $f0c4416a745b85a1$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readUintBE = $f0c4416a745b85a1$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readUint8 = $f0c4416a745b85a1$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f0c4416a745b85a1$var$Buffer.prototype.readUint16LE = $f0c4416a745b85a1$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f0c4416a745b85a1$var$Buffer.prototype.readUint16BE = $f0c4416a745b85a1$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f0c4416a745b85a1$var$Buffer.prototype.readUint32LE = $f0c4416a745b85a1$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f0c4416a745b85a1$var$Buffer.prototype.readUint32BE = $f0c4416a745b85a1$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f0c4416a745b85a1$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f0c4416a745b85a1$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f0c4416a745b85a1$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f0c4416a745b85a1$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, true, 23, 4);
};
$f0c4416a745b85a1$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, false, 23, 4);
};
$f0c4416a745b85a1$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, true, 52, 8);
};
$f0c4416a745b85a1$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, false, 52, 8);
};
function $f0c4416a745b85a1$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f0c4416a745b85a1$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f0c4416a745b85a1$var$Buffer.prototype.writeUintLE = $f0c4416a745b85a1$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f0c4416a745b85a1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUintBE = $f0c4416a745b85a1$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f0c4416a745b85a1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUint8 = $f0c4416a745b85a1$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUint16LE = $f0c4416a745b85a1$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUint16BE = $f0c4416a745b85a1$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUint32LE = $f0c4416a745b85a1$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUint32BE = $f0c4416a745b85a1$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f0c4416a745b85a1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f0c4416a745b85a1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f0c4416a745b85a1$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f0c4416a745b85a1$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f0c4416a745b85a1$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f0c4416a745b85a1$var$writeFloat(this, value, offset, true, noAssert);
};
$f0c4416a745b85a1$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f0c4416a745b85a1$var$writeFloat(this, value, offset, false, noAssert);
};
function $f0c4416a745b85a1$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f0c4416a745b85a1$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f0c4416a745b85a1$var$writeDouble(this, value, offset, true, noAssert);
};
$f0c4416a745b85a1$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f0c4416a745b85a1$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f0c4416a745b85a1$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f0c4416a745b85a1$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f0c4416a745b85a1$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f0c4416a745b85a1$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $f0c4416a745b85a1$var$Buffer.isBuffer(val) ? val : $f0c4416a745b85a1$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $f0c4416a745b85a1$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f0c4416a745b85a1$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f0c4416a745b85a1$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f0c4416a745b85a1$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f0c4416a745b85a1$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f0c4416a745b85a1$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f0c4416a745b85a1$var$base64ToBytes(str) {
    return $6ocIT.toByteArray($f0c4416a745b85a1$var$base64clean(str));
}
function $f0c4416a745b85a1$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f0c4416a745b85a1$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f0c4416a745b85a1$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $f0c4416a745b85a1$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("6ocIT", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $4a6eda7d0e4e0857$export$d622b2ad8d90c771, (v) => $4a6eda7d0e4e0857$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $4a6eda7d0e4e0857$export$6100ba28696e12de, (v) => $4a6eda7d0e4e0857$export$6100ba28696e12de = v);
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("1wLos", function(module, exports) {

$parcel$export(module.exports, "read", () => $11cd8afb6c84e33a$export$aafa59e2e03f2942, (v) => $11cd8afb6c84e33a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $11cd8afb6c84e33a$export$68d8715fc104d294, (v) => $11cd8afb6c84e33a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("aZyT4", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $f6cd4fdf14cbf922$export$61fc7d43ac8f84b0);
//#region src/index.ts
const $f6cd4fdf14cbf922$var$DEBOUNCE_DEFAULTS = {
    trailing: true
};
/**
Debounce functions
@param fn - Promise-returning/async function to debounce.
@param wait - Milliseconds to wait before calling `fn`. Default value is 25ms
@returns A function that delays calling `fn` until after `wait` milliseconds have elapsed since the last time it was called.
@example
```
import { debounce } from 'perfect-debounce';
const expensiveCall = async input => input;
const debouncedFn = debounce(expensiveCall, 200);
for (const number of [1, 2, 3]) {
console.log(await debouncedFn(number));
}
//=> 1
//=> 2
//=> 3
```
*/ function $f6cd4fdf14cbf922$export$61fc7d43ac8f84b0(fn, wait = 25, options = {}) {
    options = {
        ...$f6cd4fdf14cbf922$var$DEBOUNCE_DEFAULTS,
        ...options
    };
    if (!Number.isFinite(wait)) throw new TypeError("Expected `wait` to be a finite number");
    let leadingValue;
    let timeout;
    let resolveList = [];
    let currentPromise;
    let trailingArgs;
    const applyFn = (_this, args)=>{
        currentPromise = $f6cd4fdf14cbf922$var$_applyPromised(fn, _this, args);
        currentPromise.finally(()=>{
            currentPromise = null;
            if (options.trailing && trailingArgs && !timeout) {
                const promise = applyFn(_this, trailingArgs);
                trailingArgs = null;
                return promise;
            }
        });
        return currentPromise;
    };
    const debounced = function(...args) {
        if (options.trailing) trailingArgs = args;
        if (currentPromise) return currentPromise;
        return new Promise((resolve)=>{
            const shouldCallNow = !timeout && options.leading;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                timeout = null;
                const promise = options.leading ? leadingValue : applyFn(this, args);
                trailingArgs = null;
                for (const _resolve of resolveList)_resolve(promise);
                resolveList = [];
            }, wait);
            if (shouldCallNow) {
                leadingValue = applyFn(this, args);
                resolve(leadingValue);
            } else resolveList.push(resolve);
        });
    };
    const _clearTimeout = (timer)=>{
        if (timer) {
            clearTimeout(timer);
            timeout = null;
        }
    };
    debounced.isPending = ()=>!!timeout;
    debounced.cancel = ()=>{
        _clearTimeout(timeout);
        resolveList = [];
        trailingArgs = null;
    };
    debounced.flush = ()=>{
        _clearTimeout(timeout);
        if (!trailingArgs || currentPromise) return;
        const args = trailingArgs;
        trailingArgs = null;
        return applyFn(this, args);
    };
    return debounced;
}
async function $f6cd4fdf14cbf922$var$_applyPromised(fn, _this, args) {
    return await fn.apply(_this, args);
}

});

parcelRegister("kFbbN", function(module, exports) {

$parcel$export(module.exports, "createHooks", () => $d83b05a2ccefeca2$export$39c6a2b4dbabca5d);
function $d83b05a2ccefeca2$export$9089e2fc8ae509cd(configHooks, hooks = {}, parentName) {
    for(const key in configHooks){
        const subHook = configHooks[key];
        const name = parentName ? `${parentName}:${key}` : key;
        if (typeof subHook === "object" && subHook !== null) $d83b05a2ccefeca2$export$9089e2fc8ae509cd(subHook, hooks, name);
        else if (typeof subHook === "function") hooks[name] = subHook;
    }
    return hooks;
}
function $d83b05a2ccefeca2$export$3de1ffbf114b9f2d(...hooks) {
    const finalHooks = {};
    for (const hook of hooks){
        const flatenHook = $d83b05a2ccefeca2$export$9089e2fc8ae509cd(hook);
        for(const key in flatenHook)if (finalHooks[key]) finalHooks[key].push(flatenHook[key]);
        else finalHooks[key] = [
            flatenHook[key]
        ];
    }
    for(const key in finalHooks)if (finalHooks[key].length > 1) {
        const array = finalHooks[key];
        finalHooks[key] = (...arguments_)=>$d83b05a2ccefeca2$export$6c2c9a00e27c07e8(array, (function_)=>function_(...arguments_));
    } else finalHooks[key] = finalHooks[key][0];
    return finalHooks;
}
function $d83b05a2ccefeca2$export$6c2c9a00e27c07e8(tasks, function_) {
    return tasks.reduce((promise, task)=>promise.then(()=>function_(task)), Promise.resolve());
}
const $d83b05a2ccefeca2$var$defaultTask = {
    run: (function_)=>function_()
};
const $d83b05a2ccefeca2$var$_createTask = ()=>$d83b05a2ccefeca2$var$defaultTask;
const $d83b05a2ccefeca2$var$createTask = typeof console.createTask !== "undefined" ? console.createTask : $d83b05a2ccefeca2$var$_createTask;
function $d83b05a2ccefeca2$var$serialTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $d83b05a2ccefeca2$var$createTask(name);
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>task.run(()=>hookFunction(...args))), Promise.resolve());
}
function $d83b05a2ccefeca2$var$parallelTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $d83b05a2ccefeca2$var$createTask(name);
    return Promise.all(hooks.map((hook)=>task.run(()=>hook(...args))));
}
function $d83b05a2ccefeca2$export$e1dd809e3137c513(hooks, arguments_) {
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>hookFunction(...arguments_ || [])), Promise.resolve());
}
function $d83b05a2ccefeca2$export$23b1f1c6efb4a44a(hooks, args) {
    return Promise.all(hooks.map((hook)=>hook(...args || [])));
}
function $d83b05a2ccefeca2$var$callEachWith(callbacks, arg0) {
    for (const callback of [
        ...callbacks
    ])callback(arg0);
}
class $d83b05a2ccefeca2$export$f26845e0fc859724 {
    constructor(){
        this._hooks = {};
        this._before = void 0;
        this._after = void 0;
        this._deprecatedMessages = void 0;
        this._deprecatedHooks = {};
        this.hook = this.hook.bind(this);
        this.callHook = this.callHook.bind(this);
        this.callHookWith = this.callHookWith.bind(this);
    }
    hook(name, function_, options = {}) {
        if (!name || typeof function_ !== "function") return ()=>{};
        const originalName = name;
        let dep;
        while(this._deprecatedHooks[name]){
            dep = this._deprecatedHooks[name];
            name = dep.to;
        }
        if (dep && !options.allowDeprecated) {
            let message = dep.message;
            if (!message) message = `${originalName} hook has been deprecated` + (dep.to ? `, please use ${dep.to}` : "");
            if (!this._deprecatedMessages) this._deprecatedMessages = /* @__PURE__ */ new Set();
            if (!this._deprecatedMessages.has(message)) {
                console.warn(message);
                this._deprecatedMessages.add(message);
            }
        }
        if (!function_.name) try {
            Object.defineProperty(function_, "name", {
                get: ()=>"_" + name.replace(/\W+/g, "_") + "_hook_cb",
                configurable: true
            });
        } catch  {}
        this._hooks[name] = this._hooks[name] || [];
        this._hooks[name].push(function_);
        return ()=>{
            if (function_) {
                this.removeHook(name, function_);
                function_ = void 0;
            }
        };
    }
    hookOnce(name, function_) {
        let _unreg;
        let _function = (...arguments_)=>{
            if (typeof _unreg === "function") _unreg();
            _unreg = void 0;
            _function = void 0;
            return function_(...arguments_);
        };
        _unreg = this.hook(name, _function);
        return _unreg;
    }
    removeHook(name, function_) {
        if (this._hooks[name]) {
            const index = this._hooks[name].indexOf(function_);
            if (index !== -1) this._hooks[name].splice(index, 1);
            if (this._hooks[name].length === 0) delete this._hooks[name];
        }
    }
    deprecateHook(name, deprecated) {
        this._deprecatedHooks[name] = typeof deprecated === "string" ? {
            to: deprecated
        } : deprecated;
        const _hooks = this._hooks[name] || [];
        delete this._hooks[name];
        for (const hook of _hooks)this.hook(name, hook);
    }
    deprecateHooks(deprecatedHooks) {
        Object.assign(this._deprecatedHooks, deprecatedHooks);
        for(const name in deprecatedHooks)this.deprecateHook(name, deprecatedHooks[name]);
    }
    addHooks(configHooks) {
        const hooks = $d83b05a2ccefeca2$export$9089e2fc8ae509cd(configHooks);
        const removeFns = Object.keys(hooks).map((key)=>this.hook(key, hooks[key]));
        return ()=>{
            for (const unreg of removeFns.splice(0, removeFns.length))unreg();
        };
    }
    removeHooks(configHooks) {
        const hooks = $d83b05a2ccefeca2$export$9089e2fc8ae509cd(configHooks);
        for(const key in hooks)this.removeHook(key, hooks[key]);
    }
    removeAllHooks() {
        for(const key in this._hooks)delete this._hooks[key];
    }
    callHook(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($d83b05a2ccefeca2$var$serialTaskCaller, name, ...arguments_);
    }
    callHookParallel(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($d83b05a2ccefeca2$var$parallelTaskCaller, name, ...arguments_);
    }
    callHookWith(caller, name, ...arguments_) {
        const event = this._before || this._after ? {
            name: name,
            args: arguments_,
            context: {}
        } : void 0;
        if (this._before) $d83b05a2ccefeca2$var$callEachWith(this._before, event);
        const result = caller(name in this._hooks ? [
            ...this._hooks[name]
        ] : [], arguments_);
        if (result instanceof Promise) return result.finally(()=>{
            if (this._after && event) $d83b05a2ccefeca2$var$callEachWith(this._after, event);
        });
        if (this._after && event) $d83b05a2ccefeca2$var$callEachWith(this._after, event);
        return result;
    }
    beforeEach(function_) {
        this._before = this._before || [];
        this._before.push(function_);
        return ()=>{
            if (this._before !== void 0) {
                const index = this._before.indexOf(function_);
                if (index !== -1) this._before.splice(index, 1);
            }
        };
    }
    afterEach(function_) {
        this._after = this._after || [];
        this._after.push(function_);
        return ()=>{
            if (this._after !== void 0) {
                const index = this._after.indexOf(function_);
                if (index !== -1) this._after.splice(index, 1);
            }
        };
    }
}
function $d83b05a2ccefeca2$export$39c6a2b4dbabca5d() {
    return new $d83b05a2ccefeca2$export$f26845e0fc859724();
}
const $d83b05a2ccefeca2$var$isBrowser = typeof window !== "undefined";
function $d83b05a2ccefeca2$export$acfdf6f45fa21f5e(hooks, _options = {}) {
    const options = {
        inspect: $d83b05a2ccefeca2$var$isBrowser,
        group: $d83b05a2ccefeca2$var$isBrowser,
        filter: ()=>true,
        ..._options
    };
    const _filter = options.filter;
    const filter = typeof _filter === "string" ? (name)=>name.startsWith(_filter) : _filter;
    const _tag = options.tag ? `[${options.tag}] ` : "";
    const logPrefix = (event)=>_tag + event.name + "".padEnd(event._id, "\0");
    const _idCtr = {};
    const unsubscribeBefore = hooks.beforeEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        _idCtr[event.name] = _idCtr[event.name] || 0;
        event._id = _idCtr[event.name]++;
        console.time(logPrefix(event));
    });
    const unsubscribeAfter = hooks.afterEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        if (options.group) console.groupCollapsed(event.name);
        if (options.inspect) console.timeLog(logPrefix(event), event.args);
        else console.timeEnd(logPrefix(event));
        if (options.group) console.groupEnd();
        _idCtr[event.name]--;
    });
    return {
        /** Stop debugging and remove listeners */ close: ()=>{
            unsubscribeBefore();
            unsubscribeAfter();
        }
    };
}

});

parcelRegister("kN14I", function(module, exports) {

$parcel$export(module.exports, "createBirpc", () => $fed955fc41ae7b7d$export$8de909a09ac6851a);
$parcel$export(module.exports, "createBirpcGroup", () => $fed955fc41ae7b7d$export$ec516731f3c62ae5);
const $fed955fc41ae7b7d$var$TYPE_REQUEST = "q";
const $fed955fc41ae7b7d$var$TYPE_RESPONSE = "s";
const $fed955fc41ae7b7d$export$7bd623b29ec8e1eb = 6e4;
function $fed955fc41ae7b7d$var$defaultSerialize(i) {
    return i;
}
const $fed955fc41ae7b7d$var$defaultDeserialize = $fed955fc41ae7b7d$var$defaultSerialize;
const { clearTimeout: $fed955fc41ae7b7d$var$clearTimeout, setTimeout: $fed955fc41ae7b7d$var$setTimeout } = globalThis;
const $fed955fc41ae7b7d$var$random = Math.random.bind(Math);
function $fed955fc41ae7b7d$export$8de909a09ac6851a($functions, options) {
    const { post: post, on: on, off: off = ()=>{}, eventNames: eventNames = [], serialize: serialize = $fed955fc41ae7b7d$var$defaultSerialize, deserialize: deserialize = $fed955fc41ae7b7d$var$defaultDeserialize, resolver: resolver, bind: bind = "rpc", timeout: timeout = $fed955fc41ae7b7d$export$7bd623b29ec8e1eb } = options;
    let $closed = false;
    const _rpcPromiseMap = /* @__PURE__ */ new Map();
    let _promiseInit;
    let rpc;
    async function _call(method, args, event, optional) {
        if ($closed) throw new Error(`[birpc] rpc is closed, cannot call "${method}"`);
        const req = {
            m: method,
            a: args,
            t: $fed955fc41ae7b7d$var$TYPE_REQUEST
        };
        if (optional) req.o = true;
        const send = async (_req)=>post(serialize(_req));
        if (event) {
            await send(req);
            return;
        }
        if (_promiseInit) try {
            await _promiseInit;
        } finally{
            _promiseInit = void 0;
        }
        let { promise: promise, resolve: resolve, reject: reject } = $fed955fc41ae7b7d$var$createPromiseWithResolvers();
        const id = $fed955fc41ae7b7d$var$nanoid();
        req.i = id;
        let timeoutId;
        async function handler(newReq = req) {
            if (timeout >= 0) {
                timeoutId = $fed955fc41ae7b7d$var$setTimeout(()=>{
                    try {
                        const handleResult = options.onTimeoutError?.call(rpc, method, args);
                        if (handleResult !== true) throw new Error(`[birpc] timeout on calling "${method}"`);
                    } catch (e) {
                        reject(e);
                    }
                    _rpcPromiseMap.delete(id);
                }, timeout);
                if (typeof timeoutId === "object") timeoutId = timeoutId.unref?.();
            }
            _rpcPromiseMap.set(id, {
                resolve: resolve,
                reject: reject,
                timeoutId: timeoutId,
                method: method
            });
            await send(newReq);
            return promise;
        }
        try {
            if (options.onRequest) await options.onRequest.call(rpc, req, handler, resolve);
            else await handler();
        } catch (e) {
            if (options.onGeneralError?.call(rpc, e) !== true) throw e;
            return;
        } finally{
            $fed955fc41ae7b7d$var$clearTimeout(timeoutId);
            _rpcPromiseMap.delete(id);
        }
        return promise;
    }
    const $call = (method, ...args)=>_call(method, args, false);
    const $callOptional = (method, ...args)=>_call(method, args, false, true);
    const $callEvent = (method, ...args)=>_call(method, args, true);
    const $callRaw = (options2)=>_call(options2.method, options2.args, options2.event, options2.optional);
    const builtinMethods = {
        $call: $call,
        $callOptional: $callOptional,
        $callEvent: $callEvent,
        $callRaw: $callRaw,
        $rejectPendingCalls: $rejectPendingCalls,
        get $closed () {
            return $closed;
        },
        get $meta () {
            return options.meta;
        },
        $close: $close,
        $functions: $functions
    };
    rpc = new Proxy({}, {
        get (_, method) {
            if (Object.prototype.hasOwnProperty.call(builtinMethods, method)) return builtinMethods[method];
            if (method === "then" && !eventNames.includes("then") && !("then" in $functions)) return void 0;
            const sendEvent = (...args)=>_call(method, args, true);
            if (eventNames.includes(method)) {
                sendEvent.asEvent = sendEvent;
                return sendEvent;
            }
            const sendCall = (...args)=>_call(method, args, false);
            sendCall.asEvent = sendEvent;
            return sendCall;
        }
    });
    function $close(customError) {
        $closed = true;
        _rpcPromiseMap.forEach(({ reject: reject, method: method })=>{
            const error = new Error(`[birpc] rpc is closed, cannot call "${method}"`);
            if (customError) {
                customError.cause ??= error;
                return reject(customError);
            }
            reject(error);
        });
        _rpcPromiseMap.clear();
        off(onMessage);
    }
    function $rejectPendingCalls(handler) {
        const entries = Array.from(_rpcPromiseMap.values());
        const handlerResults = entries.map(({ method: method, reject: reject })=>{
            if (!handler) return reject(new Error(`[birpc]: rejected pending call "${method}".`));
            return handler({
                method: method,
                reject: reject
            });
        });
        _rpcPromiseMap.clear();
        return handlerResults;
    }
    async function onMessage(data, ...extra) {
        let msg;
        try {
            msg = deserialize(data);
        } catch (e) {
            if (options.onGeneralError?.call(rpc, e) !== true) throw e;
            return;
        }
        if (msg.t === $fed955fc41ae7b7d$var$TYPE_REQUEST) {
            const { m: method, a: args, o: optional } = msg;
            let result, error;
            let fn = await (resolver ? resolver.call(rpc, method, $functions[method]) : $functions[method]);
            if (optional) fn ||= ()=>void 0;
            if (!fn) error = new Error(`[birpc] function "${method}" not found`);
            else try {
                result = await fn.apply(bind === "rpc" ? rpc : $functions, args);
            } catch (e) {
                error = e;
            }
            if (msg.i) {
                if (error && options.onError) options.onError.call(rpc, error, method, args);
                if (error && options.onFunctionError) {
                    if (options.onFunctionError.call(rpc, error, method, args) === true) return;
                }
                if (!error) try {
                    await post(serialize({
                        t: $fed955fc41ae7b7d$var$TYPE_RESPONSE,
                        i: msg.i,
                        r: result
                    }), ...extra);
                    return;
                } catch (e) {
                    error = e;
                    if (options.onGeneralError?.call(rpc, e, method, args) !== true) throw e;
                }
                try {
                    await post(serialize({
                        t: $fed955fc41ae7b7d$var$TYPE_RESPONSE,
                        i: msg.i,
                        e: error
                    }), ...extra);
                } catch (e) {
                    if (options.onGeneralError?.call(rpc, e, method, args) !== true) throw e;
                }
            }
        } else {
            const { i: ack, r: result, e: error } = msg;
            const promise = _rpcPromiseMap.get(ack);
            if (promise) {
                $fed955fc41ae7b7d$var$clearTimeout(promise.timeoutId);
                if (error) promise.reject(error);
                else promise.resolve(result);
            }
            _rpcPromiseMap.delete(ack);
        }
    }
    _promiseInit = on(onMessage);
    return rpc;
}
const $fed955fc41ae7b7d$var$cacheMap = /* @__PURE__ */ new WeakMap();
function $fed955fc41ae7b7d$export$c26b4cbcfe84a428(items, fn) {
    return items.map((i)=>{
        let r = $fed955fc41ae7b7d$var$cacheMap.get(i);
        if (!r) {
            r = fn(i);
            $fed955fc41ae7b7d$var$cacheMap.set(i, r);
        }
        return r;
    });
}
function $fed955fc41ae7b7d$export$ec516731f3c62ae5(functions, channels, options = {}) {
    const getChannels = ()=>typeof channels === "function" ? channels() : channels;
    const getClients = (channels2 = getChannels())=>$fed955fc41ae7b7d$export$c26b4cbcfe84a428(channels2, (s)=>$fed955fc41ae7b7d$export$8de909a09ac6851a(functions, {
                ...options,
                ...s
            }));
    function _boardcast(method, args, event, optional) {
        const clients = getClients();
        return Promise.all(clients.map((c)=>c.$callRaw({
                method: method,
                args: args,
                event: event,
                optional: optional
            })));
    }
    function $call(method, ...args) {
        return _boardcast(method, args, false);
    }
    function $callOptional(method, ...args) {
        return _boardcast(method, args, false, true);
    }
    function $callEvent(method, ...args) {
        return _boardcast(method, args, true);
    }
    const broadcastBuiltin = {
        $call: $call,
        $callOptional: $callOptional,
        $callEvent: $callEvent
    };
    const broadcastProxy = new Proxy({}, {
        get (_, method) {
            if (Object.prototype.hasOwnProperty.call(broadcastBuiltin, method)) return broadcastBuiltin[method];
            const client = getClients();
            const callbacks = client.map((c)=>c[method]);
            const sendCall = (...args)=>{
                return Promise.all(callbacks.map((i)=>i(...args)));
            };
            sendCall.asEvent = async (...args)=>{
                await Promise.all(callbacks.map((i)=>i.asEvent(...args)));
            };
            return sendCall;
        }
    });
    function updateChannels(fn) {
        const channels2 = getChannels();
        fn?.(channels2);
        return getClients(channels2);
    }
    getClients();
    return {
        get clients () {
            return getClients();
        },
        functions: functions,
        updateChannels: updateChannels,
        broadcast: broadcastProxy,
        /**
     * @deprecated use `broadcast`
     */ // @ts-expect-error deprecated
        boardcast: broadcastProxy
    };
}
function $fed955fc41ae7b7d$var$createPromiseWithResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
const $fed955fc41ae7b7d$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
function $fed955fc41ae7b7d$var$nanoid(size = 21) {
    let id = "";
    let i = size;
    while(i--)id += $fed955fc41ae7b7d$var$urlAlphabet[$fed955fc41ae7b7d$var$random() * 64 | 0];
    return id;
}

});





//# sourceMappingURL=yakubato-lp.38d24a21.js.map
